// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/UTM/UTMFuturaExtra.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/UTM/UTMFuturaExtra.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/UTM/UTMFuturaExtra.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/UTM/UTMFuturaExtra.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../fonts/UTM/UTMFuturaExtra.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../fonts/helvetica-neue-condensed-regular/helvetica-neue-condensed-regular.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../fonts/helvetica-neue-condensed-regular/helvetica-neue-condensed-regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../fonts/helvetica-neue-condensed-regular/helvetica-neue-condensed-regular.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../fonts/helvetica-neue-condensed-regular/helvetica-neue-condensed-regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../fonts/helvetica-neue-condensed-regular/helvetica-neue-condensed-regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../fonts/helvetica-neue-condensed-bold/helvetica-neue-condensed-bold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../fonts/helvetica-neue-condensed-bold/helvetica-neue-condensed-bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../fonts/helvetica-neue-condensed-bold/helvetica-neue-condensed-bold.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../fonts/helvetica-neue-condensed-bold/helvetica-neue-condensed-bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../fonts/helvetica-neue-condensed-bold/helvetica-neue-condensed-bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../fonts/iconfont/iconfont.eot?mwn8k5", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../fonts/iconfont/iconfont.ttf?mwn8k5", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../fonts/iconfont/iconfont.woff?mwn8k5", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../fonts/iconfont/iconfont.svg?mwn8k5", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../images/photos/photo-default.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../images/seed01.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../images/seed02.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../images/seed03.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("../images/bg-weather.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___, { hash: "#Nunito-ExtraLight" });
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___, { hash: "#helvetica-neue-condensed-regular" });
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___, { hash: "#helvetica-neue-condensed-bold" });
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___, { hash: "#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___, { hash: "#iconfont" });
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'UTMFuturaExtra';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff'),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('svg'),
    url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('embedded-opentype');
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: 'helvetica-neue-condensed-regular';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_7___})
      format('embedded-opentype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_9___})
      format('svg'),
    url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format('truetype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format('woff');
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: 'helvetica-neue-condensed-bold';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format('embedded-opentype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_15___})
      format('svg'),
    url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format('truetype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format('woff');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'iconfont';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_19___}) format('embedded-opentype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_20___}) format('truetype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_21___}) format('woff'),
    url(${___CSS_LOADER_URL_REPLACEMENT_22___}) format('svg');
  font-weight: normal;
  font-style: normal;
  font-display: block;
}

[class^='icon-'],
[class*=' icon-'] {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: 'iconfont' !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;

  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-audio:before {
  content: '\\e950';
}
.icon-order:before {
  content: '\\e951';
}
.icon-present:before {
  content: '\\e952';
}
.icon-prod:before {
  content: '\\e94f';
}
.icon-start-arrow:before {
  content: '\\e94e';
}
.icon-eye-line01:before {
  content: '\\e94d';
}
.icon-arrow-short:before {
  content: '\\e94b';
}
.icon-arrow-long:before {
  content: '\\e94c';
}
.icon-comment-line:before {
  content: '\\e941';
  color: #919191;
}
.icon-comment01:before {
  content: '\\e942';
}
.icon-gift:before {
  content: '\\e943';
}
.icon-like01:before {
  content: '\\e944';
}
.icon-location-solid:before {
  content: '\\e945';
}
.icon-location01:before {
  content: '\\e946';
}
.icon-share01:before {
  content: '\\e947';
}
.icon-share02:before {
  content: '\\e948';
}
.icon-temp:before {
  content: '\\e949';
}
.icon-user01:before {
  content: '\\e94a';
}
.icon-status:before {
  content: '\\e951';
}
.icon-get-gift:before {
  content: '\\e940';
}
.icon-tech-process:before {
  content: '\\e93d';
}
.icon-find-origin:before {
  content: '\\e93e';
}
.icon-mix-npk:before {
  content: '\\e93f';
}
.icon-tiktok:before {
  content: '\\e939';
  color: #540068;
}
.icon-facebook:before {
  content: '\\e93a';
  color: #1863f2;
}
.icon-youtube:before {
  content: '\\e93b';
  color: #ea412c;
}
.icon-zalo:before {
  content: '\\e93c';
  color: #007ac6;
}
.icon-eye-line:before {
  content: '\\e938';
}
.icon-farmer-market:before {
  content: '\\e935';
}
.icon-info-solid:before {
  content: '\\e936';
}
.icon-question-mark:before {
  content: '\\e937';
}
.icon-weather02:before {
  content: '\\e934';
}
.icon-rainpre:before {
  content: '\\e92f';
}
.icon-weather01:before {
  content: '\\e930';
}
.icon-humidity:before {
  content: '\\e931';
}
.icon-sunset:before {
  content: '\\e932';
}
.icon-pinwheel:before {
  content: '\\e933';
}
.icon-contact-channel:before {
  content: '\\e92c';
}
.icon-video-call:before {
  content: '\\e92d';
}
.icon-call:before {
  content: '\\e92e';
}
.icon-bonus:before {
  content: '\\e92b';
}
.icon-chart:before {
  content: '\\e92a';
}
.icon-balance:before {
  content: '\\e926';
  color: #fab70c;
}
.icon-reduce:before {
  content: '\\e927';
  color: #fc4400;
}
.icon-increase:before {
  content: '\\e928';
  color: #1cc619;
}
.icon-time:before {
  content: '\\e929';
  color: #919191;
}
.icon-calendar:before {
  content: '\\e924';
}
.icon-waning:before {
  content: '\\e925';
}
.icon-price-menu:before {
  content: '\\e923';
}
.icon-news01:before {
  content: '\\e910';
}
.icon-user:before {
  content: '\\e912';
}
.icon-home:before {
  content: '\\e913';
}
.icon-store:before {
  content: '\\e918';
}
.icon-triangle-line:before {
  content: '\\e91a';
}
.icon-more-menu:before {
  content: '\\e91b';
}
.icon-news02:before {
  content: '\\e922';
}
.icon-close:before {
  content: '\\e921';
}
.icon-menu-dot:before {
  content: '\\e920';
}
.icon-logout:before {
  content: '\\e91f';
}
.icon-back:before {
  content: '\\e91d';
}
.icon-msgs:before {
  content: '\\e91e';
}
.icon-arrow-black:before {
  content: '\\e900';
}
.icon-arrow-cmt:before {
  content: '\\e901';
}
.icon-arrow-solid:before {
  content: '\\e902';
}
.icon-bell:before {
  content: '\\e903';
}
.icon-camera:before {
  content: '\\e904';
}
.icon-cart:before {
  content: '\\e905';
}
.icon-comment:before {
  content: '\\e906';
}
.icon-currency:before {
  content: '\\e907';
}
.icon-flash:before {
  content: '\\e908';
}
.icon-heart:before {
  content: '\\e909';
}
.icon-library:before {
  content: '\\e90a';
}
.icon-like-fb:before {
  content: '\\e90b';
}
.icon-like:before {
  content: '\\e90c';
}
.icon-liked:before {
  content: '\\f164';
}
.icon-location:before {
  content: '\\e90d';
}
.icon-menu-main:before {
  content: '\\e90e';
}
.icon-menu-sub:before {
  content: '\\e90f';
}
.icon-news-solid:before {
  content: '\\e911';
}
.icon-refresh:before {
  content: '\\e914';
}
.icon-search:before {
  content: '\\e915';
}
.icon-share:before {
  content: '\\e916';
}
.icon-speaker:before {
  content: '\\e917';
}
.icon-tag:before {
  content: '\\e919';
}
.icon-weather:before {
  content: '\\e91c';
}
.icon-bug:before {
  font-family: 'iconfont';
  content: '\\e937';
}

.lst-item [class^='icon-']:before,
.lst-item [class*=' icon-']:before {
  color: #919191;
  font-size: 0.9rem;
}
.lst-item-detail .prod-inf [class^='icon-']:before,
.lst-item-detail .prod-inf [class*=' icon-']:before {
  color: #919191;
  font-size: 1.05rem;
}

.video-play-icon.icon-arrow-solid {
  border-radius: 100px;
  background-color: #00000080;
  opacity: 0.9;
  z-index: 9;
}
.video-play-icon.icon-arrow-solid:before {
  transform: rotate(-90deg);
  display: inline-block;
  color: #fff;
}
a.position-relative,
a .position-relative {
  transition: all 0.5s;
}
a.position-relative:hover .video-play-icon.icon-arrow-solid,
a:hover .position-relative .video-play-icon.icon-arrow-solid {
  background-color: #000;
}
.video-play-icon.md-size {
  width: 36;
  height: 36px;
  line-height: 36px;
  top: calc(50% - 18px);
  left: calc(50% - 18px);
}
.video-play-icon.md-size.icon-arrow-solid:before {
  font-size: 13px;
}
.video-play-icon.sm-size {
  width: 28;
  height: 28px;
  line-height: 28px;
  top: calc(50% - 14px);
  left: calc(50% - 14px);
}
.video-play-icon.sm-size.icon-arrow-solid:before {
  font-size: 9px;
}
.video-play-icon.xs-size {
  width: 24;
  height: 24px;
  line-height: 24px;
  top: calc(50% - 12px);
  left: calc(50% - 12px);
}
.video-play-icon.xs-size.icon-arrow-solid:before {
  font-size: 8px;
}
.fn-helvetica {
  font-family: 'helvetica-neue-condensed-bold';
}
.fn-helvetica {
  font-family: 'helvetica-neue-condensed-bold';
}

.green-clr,
.primary-clr {
  color: #009a59 !important;
}
.second-clr {
  color: #f5a318 !important;
}
.grey-clr {
  color: #6e6e6e !important;
}
.grey-light-clr {
  color: #606060 !important;
}
.red-clr {
  color: #e52f19 !important;
}
.blue-clr {
  color: #0d6efd !important;
}

.primary-bg,
.green-bg {
  background-color: #009a59 !important;
}
.grey-bg {
  background-color: #6e6e6e !important;
}
.grey-light-bg,
.disable-bg {
  background-color: #bcbfc6 !important;
}
.disable-bg [class*=' icon-'],
.disable-bg [class^='icon-'] {
  color: #ffffffad !important;
}

.mrgt-0 {
  margin-top: 0px !important;
}
.mrgt-10 {
  margin-top: 10px !important;
}
.mrgt-20 {
  margin-top: 20px !important;
}
.mrgt28 {
  margin-top: 28px !important;
}
.mrgt-30 {
  margin-top: 30px !important;
}
.mrgt-40 {
  margin-top: 40px !important;
}
.mrgt-50 {
  margin-top: 50px !important;
}

.mrgb-0 {
  margin-bottom: 0px !important;
}
.mrgb-10 {
  margin-bottom: 10px !important;
}
.mrgb-20 {
  margin-bottom: 20px !important;
}
.mrgb-30 {
  margin-bottom: 30px !important;
}
.mrgb-40 {
  margin-bottom: 40px !important;
}
.mrgb-50 {
  margin-bottom: 50px !important;
}

.pdd-left10 {
  padding-left: 10px;
}
.bd-left {
  border-left: 2px solid #dfdfdf;
}
.row-cols-2 > * {
  padding-right: calc(var(--bs-gutter-x) * 0.25) !important;
  padding-left: calc(var(--bs-gutter-x) * 0.25) !important;
}

body {
  padding: 0;
  margin: 0;
  background-color: #f9f9f9 !important;
  font-family: 'Nunito', sans-serif;
  /*font-family: "arial", sans-serif;
  font-family: "Roboto", sans-serif;*/
  color: #282626;
  font-size: 16px;
  font-weight: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  word-wrap: break-word;
}
.row [class^='col-'],
.row [class*=' col-'] {
  padding-right: 8px;
  padding-left: 8px;
}
.row [class^='col-'] .row,
.row [class*=' col-'] .row {
  margin-left: -7px;
  margin-right: -7px;
}

/*body.menu-show {
  overflow: hidden;
  position: fixed;
  height: 100%;
  width: 100%;
}*/
::selection {
  background: #e0fff2;
}
/*.box-shadow{box-shadow: 2px 2px 4px #9e9e9e;}*/
.box-shadow {
  box-shadow: 0 0 0 0.25rem #f1f1f1;
}
.box-shadow:focus {
  box-shadow: 0 0 0 0.25rem rgb(12 171 107 / 15%);
}

.rounded-10 {
  border-radius: 10px;
}
label.alert-invalid {
  font-size: 15px !important;
  color: #e00202 !important;
  font-weight: normal !important;
}
img {
  max-width: 100%;
  width: auto;
  height: auto;
  object-fit: cover;
}
a {
  text-decoration: none !important;
  transition: 0.2s all ease;
  color: inherit !important;
}
a:hover,
a:focus {
  text-decoration: none !important;
  outline: none !important;
  color: #00854e !important;
}

/**, *:before, *:after {
  box-sizing: inherit; }*/

/*// -------------------------------------------------------------
// Typography*/
h1,
p {
  /*font-family: "Nunito", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;*/
}

h1 {
  margin-bottom: 1rem;
  font-size: 4rem;
}

*::placeholder,
select option[value='0'] {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #6a6a6a !important;
  font-size: 15px;
  opacity: 1; /* Firefox */
}
*::-ms-input-placeholder,
select option[value='0'] {
  /* Microsoft Edge */
  color: #6a6a6a !important;
  font-size: 15px;
  opacity: 1;
}
select,
select option {
  color: #000000;
}

select:invalid,
select option[value=''] {
  color: red !important;
}
textarea#message::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #6a6a6a !important;
  font-size: 15px;
  font-style: italic;
  opacity: 1; /* Firefox */
}
textarea#message::-ms-input-placeholder {
  /* Microsoft Edge */
  color: #6a6a6a !important;
  font-size: 15px;
  opacity: 1;
  font-style: italic;
}
/* input[type="file"] {visibility: hidden;} */
.fs-26 {
  font-size: 26px;
  line-height: 30px;
}

.btn-primary {
  text-transform: uppercase;
  font-weight: 500 !important;
  font-size: 0.9rem;
  background-color: #009a59 !important;
  color: #fff !important;
  border-color: #0c9058 !important;
}

.btn-primary:hover {
  background-color: #08975c;
}

.btn-secondary {
  text-transform: uppercase;
  font-weight: 500 !important;
  font-size: 0.9rem;
  background-color: #f8cd50 !important;
  color: #191919 !important;
  border-color: #efbc2f !important;
}
.price-clr {
  color: #ef4923;
  letter-spacing: -0.5px;
  font-weight: 500;
}

.primary-bg {
  background-color: #009a59;
  color: #fff;
}
.green-light-bg {
  background-color: #edf6f2;
}

.btn {
  padding-left: 15px;
  padding-right: 15px;
  font-size: 14px;
}
.d-desktop {
  display: inline-block;
}
.d-mobile {
  display: none;
}
.w-20 {
  width: 20% !important;
}
.w-30 {
  width: 30% !important;
}
.w-40 {
  width: 40% !important;
}
.w-60 {
  width: 60% !important;
}
.w-70 {
  width: 70% !important;
}
.w150 {
  width: 150px;
}
.w160 {
  width: 160px;
}
.w-67 {
  width: 67%;
}
.w-33 {
  width: 33%;
}
.h50 {
  height: 50px;
}
.h52 {
  height: 52px;
}
.h288 {
  height: 288px;
}
.h350 {
  height: 350px;
}
.fs-7 {
  font-size: 0.86rem;
}
.more-btn-fll {
  width: 100%;
  border: none;
  padding: 10px;
  margin-bottom: 10px;
  background-color: #f5f5f5;
  border-radius: 3px;
  font-weight: 500;
  font-size: 0.95rem;
  transition: all 0.5s;
}
.more-btn-fll:after {
  content: '';
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
  display: inline-block;
  color: grey;
  vertical-align: 2px;
  margin-left: 4px;
}
.more-btn-fll:hover {
  text-decoration: underline;
  color: #009a59;
}
.more-btn-fll:hover:after {
  color: #009a59;
}
.bg-img {
  width: 100%;
  background-size: cover !important;
  background-position: center center !important;
  background-repeat: no-repeat !important;
  text-align: center;
}
.bg-img-orgnal {
  display: inline-block;
  width: 100%;
  padding-top: 100%;
  background-size: cover !important;
  background-position: 50% !important;
  background-repeat: no-repeat !important;
  background-color: #e5e5e5;
}
.bg-img.default-img {
  background-size: contain !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_23___}) !important;
}
.bg-img.thumb-pt {
  height: 95px;
}
.bg-img-orgnal.avtar40,
.bg-img-orgnal.avtar45,
.bg-img-orgnal.avtar50,
.bg-img-orgnal.avtar60 {
  margin-right: 10px;
  border-radius: 100px;
  padding-top: inherit;
}
.bg-img-orgnal.avtar45 {
  height: 42px;
  width: 42px;
  left: 15px;
  top: 15px;
  padding-top: 42px;
  border: 1px solid #e9e9e9;
}
.bg-img-orgnal.avtar50 {
  height: 50px;
  width: 50px;
  left: 15px;
  top: 15px;
  padding-top: 50px;
  border: 1px solid #e9e9e9;
}
.bg-img-orgnal.avtar60 {
  height: 60px;
  width: 60px;
  left: 20px;
  top: 20px;
  padding-top: 60px;
  border: 1px solid #e9e9e9;
}
.bg-img-orgnal.avtar100 {
  height: 100px;
  width: 100px;
  left: 20px;
  top: 20px;
  border-radius: 100px;
  border: 1px solid #e9e9e9;
}
.bg-img-orgnal.avtar36 {
  height: 36px;
  width: 36px;
  left: 8px;
  top: 8px;
  padding-top: 36px;
  margin-right: 10px;
  border-radius: 100px;
  border: 1px solid #e9e9e9;
}
.bg-img-orgnal.avtar45 {
  height: 45px;
  width: 45px;
  left: 8px;
  top: 8px;
  padding-top: 43px;
}

.line-clamp-01 {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.line-clamp-02 {
  white-space: normal;
  -webkit-line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis; /*height: 42px;*/
  align-self: center !important;
  line-height: 21px;
}
.line-clamp-03 {
  white-space: normal;
  -webkit-line-clamp: 3;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  /*height:80px;*/
  align-self: center !important;
  line-height: 21px;
  box-sizing: border-box;
}
.title-top div > .text-center {
  margin-bottom: -22px;
}
.btn-style {
  overflow: hidden;
  padding: 0;
  position: relative;
  box-shadow: 2px 2px 6px #cacaca;
  background-color: #fffdf8 !important;
  border-radius: 5px;
  border: none;
  padding-right: 62px;
  margin-bottom: 5px;
}
.btn-style .btn-txt {
  display: inline-block;
  height: 45px;
  line-height: 45px;
  border: none;
  background-color: #009a59;
  padding: 0 0 0 18px;
  text-transform: uppercase;
  z-index: 1;
  display: flex;
  align-items: center;
  position: relative;
  font-size: 1.1rem;
}
.btn-style .btn-txt span {
  z-index: 9;
}
.btn-style span.shape {
  position: absolute;
  right: -74px;
  z-index: 0;
  width: 100px;
  transform: rotate(90deg);
  z-index: 2;
}
.btn-style .shape::before,
.btn-style .shape::after {
  content: '';
  position: absolute;
  top: 0;
  width: 52px;
  height: 80px;
  border-radius: 50px 50px 0 0;
  background-color: #009a59;
}
.btn-style .shape::before {
  left: 50px;
  transform: rotate(-45deg);
  transform-origin: 0 100%;
}
.btn-style .shape::after {
  left: 0;
  transform: rotate(45deg);
  transform-origin: 100% 100%;
}

.btn-style .arrow {
  width: 15px;
  height: 15px;
  box-sizing: border-box;
  position: absolute;
  transform: rotate(45deg);
  position: absolute;
  right: 15px;
  top: 15px;
}
.btn-style .arrow::before {
  content: '';
  width: 100%;
  height: 100%;
  border-width: 3px 3px 0 0;
  border-style: solid;
  border-color: #009a59;
  transition: 0.2s ease;
  display: block;
  transform-origin: 100% 0;
}
.btn-style .arrow:after {
  content: '';
  float: left;
  position: relative;
  top: -100%;
  width: 100%;
  height: 100%;
  border-width: 0 3px 0 0;
  border-style: solid;
  border-color: #009a59;
  transform-origin: 100% 0;
  transition: 0.2s ease;
}
.custom-select {
  position: relative;
}
.custom-select select {
  display: none; /*hide original SELECT element:*/
}
.select-selected {
  color: inherit;
}
/*style the arrow inside the select element:*/
.select-selected:after {
  position: absolute;
  content: '';
  top: 20px;
  right: 15px;
  width: 0;
  height: 0;
  border: 5px solid transparent;
  border-color: #5d5d5d transparent transparent transparent;
}
/*point the arrow upwards when the select box is open (active):*/
.select-selected.select-arrow-active:after {
  border-color: transparent transparent #5d5d5d transparent;
  top: 13px;
}
/*style the items (options), including the selected item:*/
.select-items div,
.select-selected {
  padding: 8px 16px;
  border: 1px solid transparent;
  border-color: transparent transparent rgba(0, 0, 0, 0.06) transparent;
  cursor: pointer;
  user-select: none;
  border-radius: 5px;
  font-size: 1rem;
}
/*style items (options):*/
.select-items {
  position: absolute;
  background-color: #f5f5f5;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 99;
  box-shadow: 1px 1px 2px 0px rgb(0 0 0 / 30%);
  border: 1px solid #ced4da;
}
/*hide the items when the select box is closed:*/
.select-hide {
  display: none;
}
.select-items div:hover,
.same-as-selected {
  background-color: #00a35c14;
}

/*// -------------------------------------------------------------
// Main*/
header .top-sectn {
  background-color: #009a59;
  padding: 8px 0px;
  box-shadow: inset 0 -10px 28px -10px #00000026;
}
header .top-sectn .bg-img-orgnal.avtar36 {
  padding-top: 34px;
}
.search-top {
  position: relative; /*max-width: 480px;*/
}
.search-top form {
  margin-block-end: 0;
}
.search-top input {
  padding-left: 40px;
  border-radius: 100px !important;
  height: calc(1.5em + 0.5rem + 2px);
  border: none;
}
.search-top input.rounded-10 {
  border-radius: 10px !important;
}
.search-top .icon-search {
  position: absolute;
  left: 17px;
  top: 10px;
  z-index: 9;
  opacity: 1;
}
.search-top .icon-search:before {
  font-size: 18px;
  color: #858585;
}
header .top-sectn .side-r .notify-box {
  position: relative;
  display: inline-block;
  margin-right: 40px;
  height: 36px;
}
header .top-sectn .side-r .notify-box .dropdown-toggle:after {
  display: none;
}
header .top-sectn .side-r .notify-box .dropdown-menu.show {
  top: 47px !important;
  width: 280px;
  margin-right: -30px !important;
  padding: 0;
  z-index: 9999999;
}
header .top-sectn .side-r .notify-box ul {
  padding: 20px 10px 10px 25px;
}
header .top-sectn .side-r .notify-box ul li {
  position: relative;
  list-style: none;
  border-bottom: 1px solid #ddd;
  padding-bottom: 8px;
  margin-bottom: 8px;
}
header .top-sectn .side-r .notify-box ul li:last-child {
  padding-bottom: 0;
  margin-bottom: 0;
  border-bottom: none;
}
header .top-sectn .side-r .notify-box ul li small {
  color: #858585;
}
header .top-sectn .side-r .notify-box .top-bg {
  background-color: #cacaca;
  height: 40px;
  line-height: 40px;
  position: relative;
  font-weight: 600;
}
/*header .top-sectn .side-r .notify-box .top-bg:before{content: "\\e902";font-family: 'iconfont' !important;position: absolute;top: -45px;right: 10px;font-size: 13px;transform: rotate(180deg);}
header .top-sectn .side-r .notify-box .top-bg:before{content: "";width: 0;height: 0;border-left: 50px solid transparent;border-right: 50px solid transparent; border-bottom: 100px solid red;}*/
header .top-sectn .side-r .notify-box li .new-circle,
header .top-sectn .side-r .notify-box li .icon-close {
  position: absolute;
}
header .top-sectn .side-r .notify-box li .new-circle {
  left: -12px;
  top: 9px;
  height: 6px;
  width: 6px;
  border-radius: 10px;
  background-color: #009a59;
}
header .top-sectn .side-r .notify-box li .icon-close {
  display: none;
  right: 6px;
  top: 6px;
  font-size: 9px;
  cursor: pointer;
}
header .top-sectn .side-r .notify-box li:hover .icon-close {
  display: inline-block;
}
header .top-sectn .side-r .justify-content-end {
  align-items: center;
}
header .top-sectn .side-r .notify-box .icon-bell {
  color: #ffffff;
  font-size: 24px;
  position: absolute;
  left: 0;
  top: calc(50% - 10px);
}
header .top-sectn .side-r .notify-box .item-numb {
  background-color: red;
  color: white;
  font-size: 9px;
  text-align: center;
  font-weight: bold;
  width: 13px;
  height: 13px;
  line-height: 13px;
  border-radius: 20px;
  position: absolute;
  top: 2px;
  left: 8px;
}
header .top-sectn a.logo img {
  width: 116px;
}
header .top-sectn .side-r .acct-box {
  display: inline-block;
}
header .top-sectn .side-r .acct-box .dropdown-toggle::after {
  color: #fff;
}
header .top-sectn .side-r .acct-box .d-desktop .avatar {
  width: 40px;
  margin-right: 8px;
}
header .top-sectn .side-r .acct-box .user-name {
  color: white;
}
header .top-sectn .side-r .acct-box .user-name.btn-login {
  border-radius: 50px;
  font-size: 18px;
  padding: 2px 20px;
  border: 0.5px solid #ffffff6b;
  box-shadow: 0 2px 4px rgb(0 0 0 / 28%);
  transition: all 0.3s;
  background-color: #008c50;
}
header .top-sectn .side-r .acct-box .user-name.btn-login:hover {
  background-color: #06a062;
}
header .top-sectn .side-r .acct-box .icon-arrow-solid:before {
  font-size: 8px;
  color: white;
  margin-left: 5px;
}
header .top-sectn .side-r .acct-box .dropdown-menu {
  padding: 10px 15px;
  top: 10px !important;
  width: 210px;
  min-height: 66px;
  box-shadow: 0 2px 4px rgb(0 0 0 / 20%);
}
header .top-sectn .side-r .acct-box .dropdown-menu ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
header .top-sectn .side-r .acct-box .dropdown-menu ul li.logout .icon-logout {
  margin-right: 5px;
  color: #0cab6b;
}
header .top-sectn .side-r .acct-box .dropdown-menu ul a {
  color: inherit;
  display: flex;
  align-items: center;
}
header .top-sectn .side-r .acct-box .dropdown-menu ul li.logout {
  margin-top: 10px;
}
header .top-sectn .side-r .acct-box .contain-prof .btn-login button.btn {
  padding: 0;
  font-size: 1rem;
}
header .top-sectn .side-r .acct-box .contain-prof .btn-login button.btn:hover, header .top-sectn .side-r .acct-box .contain-prof .btn-login button.btn:focus, header .top-sectn .side-r .acct-box .contain-prof .btn-login button.btn: active, header .top-sectn .side-r .acct-box .contain-prof .btn-login button.btn:focus-visible {
  background-color: inherit;
  border: none;
}
header .top-sectn .side-r .acct-box .contain-prof .btn-login button.btn:focus,
header .top-sectn .side-r .acct-box .contain-prof .btn-login button.btn:active {
  border-color: transparent;
  background-color: transparent;
  box-shadow: none;
}

/*header .top-sectn .side-r .dropdown-menu.show{inset: 7px auto auto 10px!important;}*/
header .top-sectn .side-r .dropdown-menu.show .dropdown-item {
  width: auto;
}
header .top-sectn .side-r .btn-secondary,
header .side-r .btn-secondary:focus {
  background-color: transparent !important;
  border-color: transparent;
  box-shadow: none;
  padding: 0;
  border: none;
}
header .side-r .btn-secondary:focus,
header .side-r .btn-secondary:focus-visible,
header .side-r .btn-secondary:active {
  outline: none !important;
  border-color: transparent !important;
  box-shadow: none !important;
}
header .cate-sectn {
  background-color: #fff;
  box-shadow: 0 2px 6px rgb(0 0 0 / 20%);
  padding: 9px 0;
  margin-bottom: 5px;
}
header .cate-sectn a {
  color: transparent;
}
header .cate-sectn [class^='icon-'] {
  color: #6f6f6f;
  font-size: 30px;
  padding: 0 80%;
  height: 43px;
  display: flex;
  align-items: center;
  transition: all 0.2s;
}
header .cate-sectn .icon-news02,
header .cate-sectn .icon-home {
  font-size: 39px;
}
header .cate-sectn .icon-price-menu {
  font-size: 42px;
}
header .cate-sectn .icon-news01,
header .cate-sectn .icon-triangle-line {
  font-size: 33px;
}
header .cate-sectn .icon-menu-main,
header .cate-sectn .icon-more-menu {
  /*color: #f6a503;*/
  font-size: 20px;
}

header .cate-sectn a.active [class^='icon-'] {
  color: #f6a503;
}
header .cate-sectn a:hover [class^='icon-'],
header .cate-sectn a.active:hover [class^='icon-'] {
  color: #009a59;
  transition: all 0.2s;
}
header .cate-sectn .contain-sidebar-l {
  display: none;
}
header .cate-sectn a {
  transition: all 0.2s;
}
header .cate-sectn a .mn-tooltip {
  display: none;
  position: absolute;
  top: 52px;
  border-radius: 2px;
  padding: 2px 10px;
  background-color: #2f2f2fcf;
  color: #fff;
  white-space: nowrap;
  transition: all 0.2s;
  font-size: 95%;
  z-index: 1070;
}
header .cate-sectn a:hover .mn-tooltip {
  display: block;
}
header .hashtag-sectn {
  background-color: white;
  box-shadow: 0 4px 6px rgb(0 0 0 / 20%);
  padding: 0;
  margin-bottom: 10px;
}
header .hashtag-sectn .container > .align-items-center {
  height: 50px;
}
header .hashtag-sectn ul {
  margin-bottom: 0;
  align-items: center !important;
  display: flex !important;
  overflow: hidden;
  white-space: nowrap;
  padding-right: 0px;
  padding-left: 0px;
  overflow-x: hidden;
  margin: 0;
  padding: 0;
}
header .hashtag-sectn ul li {
  display: inline-block;
  list-style: none;
  margin: 0 18px;
  padding: 0;
  border-bottom: 3px solid transparent;
}
header .hashtag-sectn ul li a {
  color: #282626;
  text-decoration: none;
  padding: 10px 0px;
  font-size: 17px;
  display: inline-block;
  font-weight: 500;
}
header .hashtag-sectn ul li a span.icon-refresh {
  font-size: 26px;
  color: #8f8f8f;
}
header .hashtag-sectn ul li a span.icon-refresh:hover {
  color: #828282;
}
header .hashtag-sectn .contr-btn {
  margin-left: 28px;
  overflow: inherit;
}
header .hashtag-sectn ul li.active {
  border-bottom: 3px solid #009a59;
}
header .hashtag-sectn ul li.active a {
  color: #009a59 !important;
}
header .hashtag-sectn .icon-arrow-black {
  height: 50px;
  width: 50px;
  display: inline-block;
  text-align: center;
  line-height: 45px;
  color: #9c9c9c;
}
header .hashtag-sectn .icon-arrow-black:hover {
  color: #828282;
}
header .hashtag-sectn .icon-arrow-black.prev-btn {
  transform: rotate(180deg);
  line-height: 52px;
}
.ReactModalPortal .ril__toolbar {
  height: 60px;
}
.sub-news .icon-comment-line:before {
  color: #919191;
}

#page-wrapper {
  padding-top: 13px;
}

#page-wrapper.page-wrapper-custom {
  margin-top: 20px;
}

.img-cover {
  width: 100%;
  object-fit: cover;
}
#id-portal-login-popup .modal-header {
  background-color: #009a59;
  display: flex;
  align-items: center;
  padding: 0.65rem 1rem;
}
#id-portal-login-popup .modal-header .modal-title.logo img {
  width: 115px !important;
}
#id-portal-login-popup .modal-body .form-inline {
  justify-content: center;
  margin: 0;
}
#id-portal-login-popup button.text-white.btn-warning {
  color: #191919 !important;
  font-weight: 500;
  background-color: #ffc108;
  border-color: #dda80c !important;
}
#id-portal-login-popup button.text-white.btn-warning:hover {
  color: #212529;
  background-color: #ffc822;
  border-color: #dcaa15;
}
#id-portal-login-popup button.btn.btn-primary {
  background-color: #009a59;
  color: #fff !important;
  font-weight: 500;
}
#id-portal-login-popup button.btn.btn-primary:hover {
  background-color: #00b669;
}
#id-portal-login-popup a {
  color: #009a59 !important;
  text-decoration: underline !important;
  font-size: 1rem;
}
#id-portal-login-popup a img {
  margin: 0 5px;
}
#id-portal-login-popup #send-otp {
  float: inline-end;
  font-size: small;
  padding: 5px;
}

@media (max-width: 426px) {
  #id-portal-login-popup .modal-body .form-group:nth-child(1) {
    width: 100%;
  }
  #id-portal-login-popup .modal-body .form-group:nth-child(2) {
    margin: 0 !important;
  }
}

/***** Homepage *****/
.news-sectn .tab-content [class^='icon-'],
.home-wrapper .news-sectn .tab-content [class*=' icon-'] {
  color: #919191;
  font-size: 15px;
}
.news-sectn .tab-content .icon-eye-line01 {
  font-size: 12px;
}
.news-sectn [class^='icon-'] + span,
.home-wrapper .news-sectn [class*=' icon-'] + span {
  margin-left: 3px;
  font-size: 0.8rem;
}
.news-sectn .sub-news .img-cover {
  height: 75px;
}
.news-sectn .main-news .img-cover {
  height: 285px;
}
.news-sectn .main-news .line-clamp-02 {
  line-height: 26px;
}
.news-sectn .main-news .inf-box {
  height: 154px;
  background-color: #fff;
}

.news-sectn .cmore {
  font-size: 15px;
}
.news-sectn .icon-arrow-solid {
  display: inline-block;
  font-size: 8px;
  vertical-align: 1px;
}
.news-sectn .nav-tabs .nav-link {
  border: 1px #dedede solid;
  border-radius: 2px;
  font-weight: 500;
  padding: 0.18rem 1.2rem;
  height: 32px;
  margin-right: 0.5rem;
  background-color: #fff;
}
.news-sectn nav .nav-tabs,
.home-wrapper .news-sect .nav-tabs .nav-link.active {
  border: none;
}
.news-sectn .nav-tabs .nav-link.active {
  background-color: #009a59;
  color: #fff !important;
  border: 1px solid #009a59;
}
.news-sectn .main-news {
  border: 1px solid #ccc;
}
.news-sectn .main-news .line-clamp-03 {
  height: 82px;
}
.news-sectn .main-news .line-clamp-03 h5 {
  margin-bottom: 0;
}
.news-sectn .main-news .line-clamp-03 p:first-child {
  margin: 8px 0 5px;
}
.news-sectn .main-news .inf-box p:last-child {
  margin-bottom: 0;
}
.title-line-lt {
  position: relative;
  padding-left: 10px;
}
.title-line-lt:before {
  content: '';
  position: absolute;
  left: 0px;
  top: -1px;
  height: 25px;
  width: 4px;
  background-color: #009a59;
}
.title-line-lt.line-none:before {
  content: none;
}
h4.title-line-lt:before {
  height: 28px;
}
h6.title-line-lt,
h6 .title-line-lt {
  padding-left: 11px;
}
h6.title-line-lt:before,
h6 .title-line-lt:before {
  top: -2px;
  height: 22px;
  width: 3px;
}
.prod-list .item-lst img.img-cover {
  height: 120px;
  border-radius: 2px 2px 0 0;
}
.news-sectn .post .nav-tabs .nav-link.animated-btn {
  border-radius: 6px;
}
.news-sectn .post .nav-tabs .nav-link.animated-btn.active {
  background-image: linear-gradient(#f6a503, #fff0b0);
  border: 1px solid #e5ca91;
  color: #191919 !important;
}

.home-wrapper .posts-sectn {
  margin-bottom: 30px;
}
.home-wrapper .posts-sectn .inf-post {
  background-color: rgba(0, 0, 0, 0.28);
  bottom: 0;
  color: #fff;
}
.home-wrapper .posts-sectn .inf-post a:hover {
  color: inherit !important;
}
.home-wrapper .posts-sectn .inf-post .poster-txt .carousel-caption {
  position: static;
  padding: 0;
}
.home-wrapper .posts-sectn .inf-post .poster-txt .carousel-caption .line-clamp-02.fs-6 {
  line-height: 1.7rem;
  font-size: 1.3rem !important;
  font-weight: 600;
  width: 90%;
  margin: 0 auto;
}
.home-wrapper .posts-sectn .carousel-control-prev,
.home-wrapper .posts-sectn .carousel-control-next {
  opacity: 0.8;
}
.home-wrapper .posts-sectn .inf-post .poster-txt {
  padding: 15px 20px;
}
.home-wrapper .posts-sectn .inf-post .user-act .icon-time:before {
  color: #fff;
  vertical-align: middle;
}
.home-wrapper .posts-sectn .inf-post small * {
  font-size: 90%;
}
.home-wrapper .posts-sectn .inf-post .user-act img.avtar {
  height: 33px;
  width: 33px;
  max-width: 100%;
}
.home-wrapper .posts-sectn .inf-post .user-act {
  border-top: 1px solid rgba(225, 225, 225, 0.18);
  padding: 8px 20px;
}
.home-wrapper .posts-sectn .inf-post .user-act img.like-numb {
  height: 26px;
}
.home-wrapper .posts-sectn .carousel.slide .carousel-indicators {
  display: flex;
  align-items: center;
  margin-bottom: 19px;
  z-index: 9;
}
.home-wrapper .posts-sectn .carousel.slide .carousel-indicators button {
  width: 10px;
  height: 10px;
  border-radius: 50px;
  border: none;
}
.home-wrapper .posts-sectn .carousel.slide .carousel-indicators button.active {
  background-color: #ffb308;
  border: 1px solid #fff;
}

.cate-lst .cate-item {
  display: inline-block;
  width: 100%;
  background-color: #fff;
  color: #191919;
  border: 1px solid transparent;
  height: 100%;
  position: relative;
  padding-bottom: 68px;
  border-radius: 6px;
  box-shadow: 0px 5px 10px #dcdcdc;
  transition: all 1s;
}
.cate-lst .cate-item:hover {
  border: 1px solid #eeeeeef5;
  box-shadow: none;
  color: inherit !important;
}
.cate-lst .row [class^='col-'],
.cate-lst .row [class*=' col-'],
.albums-list.row [class^='col-'],
.albums-list.row [class*=' col-'] {
  padding-left: 6px;
  padding-right: 6px;
}
.cate-lst .cate-item .img-box {
  z-index: 1;
}
.cate-lst .cate-item .img-box img.img-cover {
  height: 100%;
  border-radius: 5px;
  width: 68px;
  border: none;
  outline: none;
}
.cate-lst .cate-item .prod-inf {
  padding: 8px;
  z-index: 2;
  bottom: 0;
  border-radius: rgba(225, 225, 225, 0.28);
  height: 100%;
  transition: all 0.6s;
  width: calc(100% - 68px);
  left: 68px;
}
.cate-lst .cate-item .prod-inf .prod-numb {
  height: 24px;
  width: 24px;
  line-height: 19px;
  border-radius: 100px;
  right: -8px;
  top: -8px;
  background-color: #fff;
  color: #191919;
  border: 2px solid #fff;
  z-index: 3;
  font-size: 12px;
  font-weight: 500;
  transition: all 0.6s;
  display: none;
}
.cate-lst .cate-item .prod-inf .line-clamp-01 {
  width: calc(100% - 0px);
  line-height: 39px;
  font-size: 1.05rem;
  margin-left: 5px;
}
.cate-lst .cate-item:hover .prod-numb {
  background-color: #ffa608;
  border-color: #ffb635;
  color: #fff;
  display: inline-block;
}
.cate-lst .cate-item:hover .prod-inf {
}

.cate-lst.news .cate-item {
  padding-bottom: 80px;
  transition: all 0.3s;
}
.cate-lst.news.album-sectn .cate-item {
  /*padding-bottom: calc(100% - 2px);*/
  padding-bottom: 68px;
}
.cate-lst.news.album-sectn .btn.cate-item:active,
.cate-lst.news.album-sectn .btn.cate-item:focus {
  box-shadow: 0px 5px 10px #dcdcdc;
  border-color: transparent;
}
.cate-lst.news .cate-item .img-box img.img-cover,
.cate-lst.news .cate-item .prod-inf {
  width: 100%;
  left: 0;
}
.cate-lst.news .cate-item .prod-inf .line-clamp-02 {
  margin: 0;
  color: #fff;
}
.cate-lst.news .cate-item .prod-inf {
  background-color: #00000050; /*height: 58px;*/
  height: 100%;
  border-radius: 6px;
  padding: 8px 13px;
  letter-spacing: 0.2;
  text-align: center;
}
.cate-lst.news .cate-item:hover .prod-inf {
  height: 100%;
  border-radius: 6px;
}

.cate-lst.qtkt .cate-item {
  padding-bottom: 168px;
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.8s;
}
.cate-lst.qtkt .cate-item .img-box .wrap-img {
  overflow: hidden;
  width: 100%;
  height: 105px;
  border-radius: 5px;
}
.cate-lst.qtkt .cate-item .img-box .wrap-img:after {
  top: 0;
  content: '';
  width: 100%;
  height: 105px;
  background-color: #00000018;
  display: block;
  position: absolute;
}
.cate-lst.qtkt .cate-item:hover .img-box .wrap-img:after {
  background-color: transparent;
}
.cate-lst.qtkt .cate-item .img-box .wrap-img img.img-cover {
  transform: scale(1);
  width: 100%;
  transition: all 0.8s;
  object-fit: contain;
}
.cate-lst.qtkt .cate-item:hover .img-box .wrap-img img.img-cover {
  transform: scale(1.1);
}
.cate-lst.qtkt .cate-item .prod-inf {
  height: 63px;
  width: 100%;
  left: 0;
  text-align: center;
  font-size: 1.1rem;
}
.cate-lst.qtkt .cate-item .cmore {
  width: 86px;
  font-size: 0.85rem;
  height: 24px;
  line-height: 24px;
  text-align: center;
  background-color: #ffffff9c;
  border-radius: 8px;
  left: calc(50% - 43px);
  top: 38px;
  z-index: 1;
  font-weight: 500;
  display: none;
  transition: all 0.8s;
}
.cate-lst.qtkt .cate-item:hover .cmore {
  display: block;
}

.albums .albums-list {
  margin-bottom: 10px;
}
.albums-list input[type='file']::file-selector-button {
  display: none;
}
.albums-list input[type='file']::-webkit-file-upload-button {
  visibility: hidden;
  position: absolute;
  left: -9999px;
  top: -9999px;
}

/*.albums .albums-list + .row .cate-lst.news.album-sectn .col-md-4{width: 20%;}*/
.cate-lst.news.album-sectn .icon-close:before,
.albums-list .icon-close:before {
  transform: rotate(135deg);
  display: inline-block;
  font-weight: 700;
  font-size: 1.05rem;
  margin-right: 8px;
  color: #ffa608;
}
.albums-list .item-lst .icon-close {
  top: calc(100% - 120px);
  right: calc(100% - 132px);
  text-align: center;
}
.albums-list .item-lst .icon-close:before {
  display: block;
  font-size: 26px;
  color: orange;
  box-shadow: none;
  text-shadow: none;
}
.albums-list .item-lst .icon-close:after {
  content: 'Thêm ảnh';
  display: block;
  font-size: 1rem;
  color: #191919;
  box-shadow: none;
  text-shadow: none;
  font-weight: 600;
  font-family: 'Nunito', sans-serif;
  margin-top: 10px;
}
.albums .more-btn button.dropdown-toggle.btn {
  height: 26px;
  width: 26px;
  background-color: #ffffffa1;
  border: 0.5px solid #fff;
  border-radius: 0 4px 0px 10px;
  z-index: 9;
  position: relative;
}
.albums .more-btn button.dropdown-toggle.btn:before {
  content: '';
  display: inline-block;
  margin-left: -5px;
  border-top: 0.35em solid;
  border-right: 0.35em solid transparent;
  border-bottom: 0;
  border-left: 0.35em solid transparent;
  color: #000;
}
.albums .more-btn button.dropdown-toggle.btn:focus,
.albums button.dropdown-toggle.btn:active {
  box-shadow: none !important;
  background-color: #ffffffa1 !important;
}

.panel-left,
.lt-side,
.rt-side {
  border: 1px solid #efefef;
  border-radius: 6px;
  padding: 5px 15px;
  background-color: #ffffff;
}
.panel-left .title-txt {
  color: #009a59;
  font-size: 1.05rem;
  margin-top: 20px;
  padding: 8px 15px 5px;
  /* background-color: #f2f2f2; */
  border-radius: 2px;
  text-transform: uppercase;
  font-weight: 700;
}
.panel-left ul {
  padding-left: 0;
}
.panel-left ul li {
  margin: 20px 0 22px;
  padding: 0;
  list-style: none;
}
.panel-left ul li a {
  text-decoration: none !important;
  font-size: 1.05rem;
  align-items: center;
  display: flex;
}
.panel-left ul li a [class^='icon-'],
.panel-left ul li a [class*=' icon-'] {
  font-size: 20px;
  width: 40px;
  display: inline-block;
  text-align: center;
  color: #a2a2a2;
}
.panel-left ul li a .icon-present {
  font-size: 18px;
}
.panel-left ul li a .icon-get-gift {
  font-size: 26px;
}
.panel-left ul li a .icon-audio {
  font-size: 22px;
}
.panel-left ul li a .icon-bug {
  font-size: 22px;
}
.panel-left ul li a .icon-tech-process {
  font-size: 21px;
}
.panel-left ul li a .icon-user {
  font-size: 20px;
}
.panel-left ul li a .icon-farmer-market {
  font-size: 16px;
}
.panel-left ul li a .icon-news02 {
  font-size: 21px;
}
.panel-left ul li a .icon-weather {
  font-size: 19px;
}
.panel-left ul li a .icon-triangle-line {
  font-size: 17px;
}
.panel-left ul li a .icon-price-menu {
  font-size: 26px;
}
.panel-left ul li a .icon-weather02 {
  font-size: 24px;
}
.panel-left ul li a .icon-tag,
.panel-left ul li a .icon-video-call {
  font-size: 22px;
}
.panel-left ul li a .icon-arrow-solid {
  vertical-align: 3px;
  width: auto;
  font-size: 9px;
}
.panel-left ul li a .txt {
  vertical-align: 3px;
  font-weight: 500;
}
#page-wrapper .panel-left ul li a.active > span.txt {
  font-weight: 700;
}
.panel-left ul li a:hover {
  color: inherit !important;
}
.panel-left ul li.seemore {
  padding-left: 45px;
}
.panel-left ul li.seemore a {
  color: #191919 !important;
  font-size: 15px;
}
.panel-left .memb-follow .memb-item {
  padding: 10px 0px;
  border-bottom: 1px dashed #f1f1f1;
}
.panel-left .memb-follow .memb-item:last-child {
  border-bottom: none;
}
.panel-left .memb-follow .memb-item .inf-box {
  margin-left: 10px;
}
.panel-left .memb-follow .memb-item .img-cover {
  height: 35px;
  width: 35px;
  border-radius: 100px;
  background-color: #e9e9e9;
  border: 1px solid #e8e8e8;
}
.panel-left .memb-follow .memb-item small.ml-auto.text-secondary {
  font-size: 0.77rem;
}
.cntry-news img {
  width: 644px !important;
  max-width: 100%;
}
.cntry-news p,
.cntry-news span {
  font-size: 1.05rem;
}

.inpt-cntn.cmt-box .bg-img-orgnal.avtar40 {
  left: 40px;
  top: 10px;
  border: 1px solid #f5f5f5;
}
.inpt-cntn .trumbowyg-box {
  min-height: 102px !important;
}
#content.trumbowyg-editor {
  padding-bottom: 36px;
  padding-right: 40;
  background-color: #fff;
  min-height: 102px !important;
  height: auto !important;
  border-radius: 5px;
}
.inpt-cntn .trumbowyg-button-pane {
  background-color: #f5faff;
}
.inpt-cntn .btn-send,
.inpt-cntn .btn-send-trumb,
.inpt-cntn .btn-send-cmt {
  width: 22px;
  height: 22px;
  top: 22px;
  right: 45px;
  cursor: pointer;
  background-size: cover;
}
.inpt-cntn .btn-send-trumb {
  right: 12px !important;
}
.post-box {
  border: 1px solid #e1e1e1 !important;
  border-radius: 5px;
  background-color: #fff;
  margin-bottom: 20px;
  word-wrap: break-word;
  box-shadow: 0 1px 0px rgb(0 0 0 / 15%);
}
.post-box .inpt-cntn {
  position: relative;
}
.post-box .inpt-cntn.cmnt-box {
  margin: 15px 0;
}
.post-box .inpt-cntn textarea {
  height: 115px;
  padding-left: 65px;
  padding-top: 20px;
  border-radius: 0;
  border-top: none;
  border-left: none;
  border-right: none;
}

.post-box .inpt-cntn img,
.post-box .inpt-cntn .avtar {
  position: absolute;
  left: 20px;
  top: 20px;
  height: 60px;
}
.post-box .inpt-cntn .avtar .bg-img-orgnal {
  border-radius: 100px;
}
.post-box .btn-post {
  height: 50px;
  padding: 0 8px;
  position: relative;
}
.post-box input[type='file'] {
  text-indent: -2000;
  background: none;
  border: none;
  width: 28px;
  z-index: 1;
  box-shadow: none;
}
.post-box input[type='file']:focus {
  box-shadow: none;
}
.post-box .btn-post .icon-library {
  font-size: 28px;
  position: absolute;
  left: 8px;
  color: #009a59;
}
.post-box .btn-post .btn {
  text-transform: uppercase;
  font-weight: 600;
  color: #fff;
  background-image: linear-gradient(to right, #009a59, #00ad64, #009a59);
}
.post-box .btn-post .btn:hover {
  background-color: #08975c;
}
.post-box .inpt-cntn.cmnt-box textarea {
  border: 1px solid #dbdbdb;
}
.post-box .pin_droplist {
  align-items: center;
  height: 29px;
}
.post-box .pin_droplist .pin-icon {
  width: 20px;
  transform: rotate(-45deg);
}
.inpt-cntn.cmnt-box textarea {
  border: 1px solid #eeeeee;
  height: 95px;
  margin-bottom: 10px;
  height: 77px;
  padding-left: 60px;
  padding-top: 15px;
}
.inpt-cntn.cmnt-box .btn-solid {
  background-color: #ffbe28;
  border: 1px solid #e49c00;
  text-transform: uppercase;
  font-weight: 600;
}
.inpt-cntn.cmnt-box .btn-solid:hover {
  background-color: #ffb208;
}
.inpt-cntn.cmnt-box .btn-line {
  border: 1px solid #c5ccc9;
  text-transform: uppercase;
  font-weight: 600;
  color: #59635f;
  margin-right: 10px;
  background-color: #f8f8f8;
}
.inpt-cntn.cmnt-box .btn-line:hover {
  background-color: #eaeaea;
}
.inpt-cntn.cmnt-box img,
.inpt-cntn.cmnt-box .avtar {
  height: 50px;
  width: 50px;
  top: 15px;
  left: 15px;
  /* padding-top: 50px; */
}

.user-inf {
  padding: 0px 5px;
  /*border-bottom: 1px dashed #dfdfdf;*/
}

.member_rate_in_month.text-end .icon-start-arrow {
  color: #919191;
}

.post-box .user-inf > a {
  display: flex;
  align-items: center !important;
}
.user-inf img {
  height: 45px;
  width: 45px;
  margin-right: 6px;
  border-radius: 100px;
  border: 1px solid #e9e9e9;
}
.user-inf p {
  line-height: inherit;
  margin-bottom: 0;
}
.user-inf p.user-name {
  font-size: 17px;
  font-weight: 600;
}
.user-inf p.post-time {
  font-size: 13px;
  color: #828282;
}
.post-box .posted-inf {
  padding: 15px 15px 0;
}
/*.post-box .posted-inf .cont-desc{margin-top: 15px;}*/
.post-box .posted-inf .cont-desc .fst-italic {
  font-size: 16px;
  margin-top: 10px;
}
.post-box .posted-inf .cont,
.post-box .posted-inf .cont-desc {
  margin-bottom: 15px;
}
.post-box .posted-inf .fav-inf {
  color: #6b6b6b;
  font-weight: normal;
}
.post-box .posted-inf .fav-inf > div {
  font-size: 14px;
  margin-left: 15px;
}
.post-box .posted-inf .fav-inf > div.like {
  margin: inherit;
  align-items: center;
  display: flex;
}
.post-box .posted-inf .fav-inf .icon-like-fb {
  font-size: 18px;
  margin-right: 4px;
  color: #586fb5;
}
.post-box .posted-inf .fav-inf,
.post-box .posted-inf .fav-ctrl {
  height: 50px;
}

.post-box .posted-inf .fav-inf .like .icon-eye-line01 {
  font-size: 0.68rem;
}
.post-box .posted-inf .fav-ctrl {
  font-size: 15px;
  background-color: #f5f5f5;
  border-bottom: 1px solid #eaeaea;
  margin-bottom: 0px;
  width: calc(100% + 30px);
  margin-left: -15px;
  border-radius: 0 0 5px 5px;
}
.post-box .posted-inf .fav-ctrl .like,
.post-box .posted-inf .fav-ctrl .cmnt,
.post-box .posted-inf .fav-ctrl .share {
  text-decoration: none;
  color: inherit;
  display: inline-block;
  cursor: pointer;
}
.post-box .posted-inf .fav-ctrl .share .post-report .btn.dropdown-toggle {
  margin-left: 0;
}
.post-box .posted-inf .fav-ctrl .share .dropdown-toggle:after {
  display: none;
}
.post-box .posted-inf .fav-ctrl [class^='icon-']:before {
  color: #808080;
}
.post-box .posted-inf .fav-ctrl .icon-like01 {
  font-size: 1.4rem;
}
.post-box .posted-inf .fav-ctrl .icon-get-gift {
  font-size: 1.62rem;
}
.post-box .posted-inf .fav-ctrl .icon-share01 {
  font-size: 1.23rem;
}
.post-box .posted-inf .fav-ctrl .icon-comment-line {
  font-size: 1.26rem;
}
.post-box .posted-inf .fav-ctrl .fw-bold {
  font-weight: 600 !important;
}
.post-box .posted-inf .fav-ctrl .icon-bonus {
  color: #828282;
}
.post-box .posted-inf .fav-ctrl .share button.btn:focus {
  box-shadow: none;
  border-color: transparent;
}
.post-box .posted-inf .fav-ctrl > div:hover span,
.post-box .posted-inf .fav-ctrl > div:hover span:before,
.post-box .posted-inf .fav-ctrl > div.active span,
.post-box .posted-inf .fav-ctrl a:hover,
.post-box .posted-inf .cmt-listing .active.like,
.post-box .posted-inf .cmt-listing .active.like .icon-like,
.post-box .posted-inf .cmt-listing .active.like .icon-like01 {
  color: #009a59;
}
.post-box .posted-inf .cmt-box .user-inf a:hover {
  color: inherit !important;
}
.post-box .posted-inf .cmt-box .user-inf a.active {
  color: #009a59 !important;
}
.post-box .posted-inf .group-img01 .bg-img {
  height: 288px;
}
.post-box .posted-inf .group-img02 .bg-img {
  height: 200px;
}
.post-box .posted-inf .group-img03 .bg-img.main-img {
  height: 268px;
}
.post-box .posted-inf .group-img03 .bg-img.sub-img {
  height: 132px;
}
.post-box .posted-inf .group-img03 .img-plus {
  position: relative;
  display: flex;
  align-items: center;
  text-align: center;
}
.post-box .posted-inf .group-img03 .img-plus:before {
  width: 100%;
  height: 100%;
  background-color: #000;
  position: absolute;
  content: '';
  opacity: 0.4;
}
.post-box .posted-inf .group-img03 .img-plus span {
  position: absolute;
  left: calc(50% - 13px);
  color: #fff;
  font-size: 28px;
  font-weight: bold;
}
.post-box .posted-inf .sharing-post .bg-img {
  height: 288px;
  background-color: #f6f6f6;
}
.post-box .posted-inf .sharing-post .cont-desc .row.align-items-center {
  border-top: 1px dashed #dedede;
  padding-top: 15px;
  margin-top: 4px;
}
.post-box .posted-inf .sharing-post .cont-desc .row.align-items-center:first-child {
  border-top: none !important;
  padding-top: 0;
}
.post-box .posted-inf .sharing-post .author-frm {
  display: flex;
  align-items: center;
  margin-top: 14px;
  margin-bottom: 8px;
  margin-right: 10px;
}
.post-box .posted-inf .sharing-post .author-frm img {
  border-radius: 100px;
  height: 30px;
  width: 30px;
}
.post-box .posted-inf .sharing-post .author-frm .user-name {
  font-size: 15px;
  font-weight: 600;
  margin-left: 10px;
}
.post-box .posted-inf .cont-link {
  margin-bottom: 15px;
}
.post-box .posted-inf .cont-link a {
  color: #009a59 !important;
}
.post-box .posted-inf .cont-link a:hover {
  color: inherit !important;
}
.post-box .post-report .icon-menu-dot {
  font-size: 3.5px;
  color: #818181;
}
.post-box .post-report .btn.dropdown-toggle {
  padding: 5px;
  transition: 0.3s all ease;
  margin-left: 13px;
  border: none;
  height: 32px; /*background-color: #f5f5f5;*/
  border-radius: 5px;
}
.post-box .post-report .btn.dropdown-toggle:focus {
  /*border-color: transparent;border: none;*/
  box-shadow: none;
}
/* .post-box .post-report .dropdown-toggle::after {
  display: none;
} */
.post-box .post-report ul.dropdown-menu-end {
  margin-top: 18px !important;
  text-align: center;
  box-shadow: #cbcbcb 0px 0px 2px;
  border: 1px solid #bfbfbf6b;
  margin-right: -8px !important;
}
.post-box .post-report ul .dropdown-item:hover {
  background-color: #ebebeb;
}
.post-box .post-report ul .dropdown-item {
  border-bottom: 1px solid #e6e6e6;
  padding: 6px;
  font-size: 15px;
}
.post-box .post-report ul .dropdown-item:last-child {
  border-bottom: none;
}
.post-box .post-report ul li:last-child .dropdown-item {
  border-bottom: none;
}
.post-box .post-report .dropdown-toggle:hover .icon-menu-dot {
  color: #666666;
}
.ql-container.ql-snow .ql-tooltip {
  left: auto !important;
  top: auto !important;
}
.ql-container.ql-snow .ql-tooltip.ql-editing input[type='text']:focus,
.products .ql-container.ql-snow .ql-tooltip.ql-editing input[type='text']::focus-visible {
  border-color: #0cab6b;
  box-shadow: 0 0 0 0.25rem rgb(223 229 233);
}

/* .user-inf .actions .dropdown {
  visibility: hidden;
} */

/* .user-inf:hover .dropdown {
  visibility: visible;
} */
.cmt-box .post-report .dropdown-toggle:hover .icon-menu-dot {
  color: #666666;
}
.cmt-box .post-report .dropdown-toggle::after {
  display: none;
}
.cmt-box .post-report .btn.dropdown-toggle:focus {
  border-color: transparent;
  box-shadow: none;
  border: none;
}

/* .cmt-listing .actions:hover .dropdown {
  visibility: visible;
} */

/* .cmt-box .cmt-listing .mt-3:hover .dropdown {
  visibility: visible;
} */

.cmt-box .cmt-listing input {
  width: calc(100% - 54px);
  display: inline-block;
  margin-top: 10px;
  border: 1px solid #dbdbdb;
}
.cmt-box .cmt-listing input:focus,
.cmt-listing .user-inf input:focus-visible {
  border: solid 1px #00800042;
  box-shadow: 0 0 0 0.25rem rgb(223 229 233);
  outline: none;
}

.cmt-box .cmt-listing .icon-like01 {
  font-size: 19px;
  margin-right: 4px;
  color: #919191;
}

.cmt-box .cmt-listing .active.like .icon-like01,
.cmt-box .cmt-listing .like.active {
  color: #009a59 !important;
}

.cmt-box .cmt-listing .icon-comment-line {
  font-size: 16px;
  margin-right: 4px;
}
.cmt-listing .post-report .icon-menu-dot {
  font-size: 5px;
  color: grey;
}
.cmt-listing .post-report .btn:focus {
  box-shadow: none;
  border: none;
}

.post-more {
  text-align: center;
  /*border-top: 1px solid #e9e9e9;*/
  border-bottom: 1px solid #e9e9e9;
  padding: 10px 0;
  margin-top: 40px;
  margin-bottom: 50px;
}
.post-more {
  cursor: pointer;
}
.post-more a {
  color: inherit;
}
.post-more .icon-arrow-solid {
  font-size: 7px;
  margin-left: 4px;
  display: inline-block;
  margin-top: -1px;
  vertical-align: middle;
  color: #5d5d5d;
}

.box-bd {
  border: 1px solid #e1e1e1;
  border-radius: 5px;
  background-color: #fff;
  margin-bottom: 15px;
  padding-bottom: 10px;
  padding: 0 10px;
}
.box-bd.hotnews.position-relative,
.box-bd.newnews.position-relative {
  padding-top: 70px;
}
.box-bd.hotnews.position-relative .bg-img.position-relative,
.box-bd.newnews.position-relative .bg-img.position-relative {
  margin-bottom: 5px;
}
.box-bd .title {
  height: 44px;
  border-bottom: 1px #e2e2e2 solid;
  padding: 0 15px;
  margin-bottom: 15px;
  width: calc(100% + 0px);
  margin-left: -10px;
}
.box-bd.hotnews.position-relative .title,
.box-bd.newnews.position-relative .title {
  position: absolute;
  top: 5px;
}
.box-bd .title .icon-menu-sub:before {
  color: #6d6d6d;
  font-size: 15px;
}
.box-bd .title .txt {
  color: #191919;
  font-size: 19px;
  font-weight: 700;
  text-transform: capitalize;
}
.box-bd .title a.icon-menu-sub {
  color: inherit;
}
.box-bd.hotnews .news-item {
  position: relative;
  margin-bottom: 10px;
  display: block;
  height: 95px;
}
.box-bd.hotnews .news-item img {
  border-radius: 5px;
  box-shadow: 0 2px 4px rgb(0 0 0 / 60%);
}
.box-bd.hotnews .news-item .bg-img {
  height: 95px;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgb(0 0 0 / 60%);
  transition: 0.3s all ease;
}
.box-bd.hotnews .news-item .txt {
  position: absolute;
  bottom: 26px;
  line-height: 19px;
  left: 0px;
  padding: 0 15px 0px 15px;
  color: #fff;
  font-weight: 600;
  text-shadow: 1px 1px 1px #1e1e1e;
}

.box-bd.newnews .news-item {
  background-color: #fff;
  border-radius: 5px;
  transition: all 0.3s ease-in-out;
  transition: 0.3s all ease;
}
.box-bd.newnews .news-item .bg-img {
  height: 114px;
  border-radius: 5px 5px 0 0;
}
.box-bd.newnews .container {
  padding-right: 8px;
  padding-left: 8px;
}
.box-bd.newnews .row-cols-2 > * {
  padding-right: calc(var(--bs-gutter-x) * 0.25);
  padding-left: calc(var(--bs-gutter-x) * 0.25);
  margin-bottom: 0px;
}
.box-bd.newnews a {
  color: inherit;
}
.box-bd.newnews .title-item {
  margin-top: 10px;
}
.box-bd.newnews .title-item .txt-name {
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  margin-bottom: 4px;
  font-size: 16px;
}
.box-bd.newnews .locatn {
  font-size: 13px;
  color: #595959;
  height: 20px;
  display: block;
}
.box-bd.newnews .price-item {
  font-size: 13px;
}
.box-bd.newnews .news-item:hover,
.box-bd.hotnews .news-item:hover .bg-img {
  box-shadow: 0 2px 4px rgb(0 0 0 / 28%);
}
.box-bd.newnews .news-item:hover .txt-name {
  color: initial !important;
}
.box-bd.newnews .news-item a:hover {
  color: inherit !important;
}
.box-bd.newnews .news-item a:hover .red-clr {
  color: #e52f19 !important;
}
.box-bd.newnews .news-item:hover .price-item .red-clr,
.box-bd.newnews .news-item a:hover .red-clr {
  color: #e52f19 !important;
}
.mkt-prod {
  border-radius: 5px;
  margin-bottom: 20px;
  margin-top: 1.2rem;
  background-color: #fff;
  padding-bottom: 2px;
}
.mkt-prod .more-btn-fll {
  width: calc(100% - 20px);
  margin-left: 10px;
}
.mkt-prod > div {
  padding: 13px 8px;
}
.mkt-prod h3 {
  font-size: 1.58rem;
}
.mkt-prod .mkt-title {
  font-size: 19px;
  padding: 0 15px;
  font-weight: 700;
  font-family: 'helvetica-neue-condensed-regular';
  text-transform: capitalize;
}
.mkt-prod .table {
  font-size: 0.85rem;
  margin-bottom: 10px;
}
.mkt-prod .table small {
  font-size: 80%;
}
.mkt-prod .table thead {
  background-color: #ffffff;
  color: #8f979e;
  font-size: 14px;
}
.mkt-prod .table thead th {
  font-weight: normal;
}
.mkt-prod .table .redu-pri,
.mkt-price-details .redu-pri {
  color: #fc4400;
  font-weight: 500;
}
.mkt-prod .table .incr-pri,
.mkt-price-details .incr-pri {
  color: #1cc619;
  font-weight: 500;
}

.mkt-prod .table tr {
  /*border-bottom: 1px solid #e1e1e1;*/
}
.mkt-prod .table td.line-clamp-01 {
  width: 100px;
}

.mkt-prod .table > :not(caption) > * > * {
  border-bottom: none;
  vertical-align: middle;
}
.mkt-prod tr.text-center {
  background-color: #e9e9e9;
}
.mkt-prod .table a .icon-arrow-solid {
  font-size: 6px;
  color: #009a59;
  margin-top: -1px;
  display: inline-block;
  vertical-align: middle;
}
.mkt-prod .table a .txt {
  color: #009a59;
  margin-right: 4px;
}
.mkt-prod .update-time {
  font-size: 13px;
}
.mkt-prod table.table tbody {
  border-top: 2px solid #ededed;
}
.mkt-prod table.table thead tr th {
  padding: 0.8rem 0.5rem;
  color: #191919;
  font-weight: 500;
  background-color: #f5faff;
  border-top: none;
}
.mkt-prod table.table tbody tr td {
  padding: 0.5rem 0.32rem;
  border-top: 1px solid #efefef;
}
.mkt-prod .update-time {
  padding: 0 15px;
  margin: -2px 0 10px;
}
.mkt-prod a.ms-auto {
  background-image: linear-gradient(to right, #ffa908, #fad53b, #ffa908);
  border: none;
  border-radius: 100px;
  height: 24px;
  padding: 1px 9px;
  font-size: 0.85rem;
}
.mkt-prod table .line-clamp-01 {
  width: 100px;
}

.pt-show,
.vd-show {
  margin-right: 12px;
}
.pt-show .bg-img,
.vd-show .bg-img {
  height: 52px;
  width: 77px;
}
.sub_vid .bg-img {
  background-size: cover !important;
  width: 100%;
  padding-top: 62%;
  background-position: 50% !important;
  border-radius: 2px;
}
.box-bd.videonews .container {
  padding: 0;
}
.box-bd.videonews .video-item {
  font-size: 15px;
  color: inherit;
  padding-bottom: 10px;
  margin-bottom: 10px;
  color: inherit;
  border-bottom: 1px solid #dfdfdf;
}
.box-bd.videonews .video-item:last-child {
  border-bottom: none;
  margin-bottom: 0;
}
.box-bd.videonews .video-item > div:last-child {
  padding-left: 0;
}
.box-bd.videonews .video {
  width: 150px;
  margin-right: 12px;
}
.box-bd.videonews .bg-img {
  height: 52px;
}

/*.cont-center .bg-img-orgnal{padding-top: 180px;}*/
.cont-center .hashtag-title {
  font-size: 20px;
  line-height: 25px;
  margin-top: 12px;
}
.news-item,
.video-item {
  padding: 0;
  font-size: 15px;
  color: inherit;
  padding-bottom: 10px;
  margin-bottom: 10px;
  border-bottom: 1px solid #dddada;
}
.news-item:last-child,
.video-item:last-child {
  border-bottom: none;
}
.cont-center .col-md-6 .news-item:last-child {
  border-bottom: none;
}
.cont-center .news-item > div:last-child {
  padding-left: 0;
}
.cont-center .news-item .pt-show {
  margin-right: 12px;
}
.cont-center .trend-sectn {
  padding: 6px 0;
  margin-top: 15px;
  border-top: 1px solid #dddada;
  border-bottom: 1px solid #dddada;
}
.cont-center .trend-sectn ul {
  padding: 0;
  margin: 0;
}
.cont-center .trend-sectn ul li {
  margin: 0;
  padding: 0;
  display: inline-block;
  font-size: 13px;
}
.cont-center .trend-sectn ul li a {
  color: #00509a !important;
  padding: 0 13px;
}
.cont-center .trend-sectn ul li a:hover {
  color: inherit !important;
}
.cont-center .trend-sectn .icon-flash {
  font-size: 20px;
}
.cont-center .news-more {
  margin-top: 15px;
}

.cont-center {
  margin-top: 5px !important;
}
.cont-center .breadcrumb {
  background-color: transparent;
}
.cont-center .breadcrumb a {
  color: #0d6efd !important;
  font-weight: 500;
}
.cont-center .breadcrumb-item + .breadcrumb-item::before {
  display: none;
}
.cont-center .breadcrumb .icon-arrow-black {
  font-size: 0.8rem;
  margin-right: 6px;
  color: #bcbcbc;
}
.cont-center h3 {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 20px;
}
.cont-center h2,
.cont-center h2 {
  margin-top: 20px;
}
.cont-center h3 .icon-menu-sub {
  margin-right: 10px;
}
.cont-center .col-md-6 a .bg-img-orgnal {
  padding-top: 226px;
}

.modal {
  z-index: 999999999;
}
.modal-header {
  background-color: #f1f1f1;
}
.modal-dialog.modal-lg .btn-custm {
  position: absolute;
  right: 5px;
  top: 5px;
  z-index: 9;
}
.modal-dialog.modal-lg .modal-content input {
  background-color: #00a35d;
  color: #fff;
  margin-bottom: 17px;
  padding: 8px 15px;
  border-radius: 6px;
}
.modal-dialog.modal-lg .modal-content input:focus {
  box-shadow: none;
}
.modal-dialog.modal-lg .modal-content input::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #fff !important;
  font-size: 15px;
  opacity: 0.6; /* Firefox */
}
.modal-dialog.modal-lg .modal-content input::-ms-input-placeholder {
  /* Microsoft Edge */
  color: #fff !important;
  font-size: 15px;
  opacity: 0.8;
}
.modal-dialog.modal-lg .modal-content .btn {
  background-color: #939aa0;
  font-size: 13px;
  color: #fff;
  display: block;
  text-transform: none;
  width: 100%;
  padding: 8px 0;
}
.modal-dialog.modal-lg .modal-content .login-form h5 {
  display: block;
  border-bottom: 3px solid #009a59;
  color: #009a59;
  font-weight: bold;
  padding-bottom: 10px;
  text-align: center;
  margin-bottom: 15px;
  font-size: 22px;
  width: calc(100% + 0.75rem);
}
.modal-dialog.modal-lg .modal-content .login-form a.fst-italic {
  text-align: center;
  width: 100%;
  margin-top: 10px;
  color: inherit;
  display: inline-block;
  margin-bottom: 85px;
}
.modal-dialog.modal-lg .modal-content .or-line {
  border-bottom: 1px solid #939aa0;
  position: relative;
  text-align: center;
  margin-left: 10%;
  width: 80%;
  margin-top: 10px;
}
.modal-dialog.modal-lg .modal-content .or-line span {
  display: inline-block;
  padding: 10px 20px;
  background-color: #fff;
  margin-bottom: -19px;
  font-size: 13px;
}
.modal-dialog.modal-lg .modal-content .fa-zalo {
  margin-top: 28px;
}
.modal-dialog.modal-lg .modal-content .fa-zalo a {
  display: inline-block;
  margin: 0 8px;
}
.modal-dialog.modal-lg .modal-content .fa-zalo a img {
  height: 55px;
}
.modal-dialog.modal-lg .modal-content .regist-form {
  position: relative;
}
.modal-dialog.modal-lg .modal-content .regist-form:before {
  content: '';
  display: inline-block;
  width: 3px;
  height: calc(100% - 55px);
  background-color: #eee;
  position: absolute;
  left: 0;
  top: 55px;
}
.modal-dialog.modal-lg .modal-content .regist-form h5 {
  display: block;
  border-bottom: 3px solid #eee;
  font-weight: lighter;
  color: #939aa0;
  padding-bottom: 10px;
  text-align: center;
  margin-bottom: 15px;
  font-size: 22px;
  margin-left: -0.75rem;
}
.modal-dialog.modal-lg .alert-invalid {
  margin-top: -15px;
  margin-bottom: 10px;
}
.profile-page {
  max-width: 68% !important;
  margin: 0px auto 40px;
}
.profile-page form .inf-box {
  padding: 20px;
  border-radius: 6px;
  margin-bottom: 20px;
  background-color: #e9ecef;
  border: 1px solid #e3e3e3;
}
.profile-page .inf-box {
  margin-bottom: 15px;
}
.profile-page .upload-avatar {
  position: relative;
  width: 100px;
  display: inline-block;
}
.profile-page .upload-avatar input[type='file'] {
  text-indent: -20000;
  background: none;
  border: none;
  width: 28px;
  z-index: 1;
  box-shadow: none;
  position: absolute;
  top: 0;
  right: 0;
  margin: 0;
}
.profile-page .upload-avatar img {
  height: 100px;
  height: 100px;
  width: 100px;
  border-radius: 100px;
  box-shadow: 0 0 0 0.25rem #e5e5e5;
  border: 1px solid #dedede;
}
.profile-page .upload-avatar .icon-camera {
  position: absolute;
  top: 10px;
  right: 0;
  font-size: 26px;
  color: #ffa608;
  cursor: pointer;
}
.profile-page .upload-avatar .icon-camera:hover {
  color: #fff;
}
.profile-page p {
  margin-top: 6px;
  font-size: 20px;
  margin-bottom: 0;
}
.profile-page .user-type {
  margin-bottom: 10px;
}
.profile-page .level-box .txt,
.profile-page .bonus-box .txt {
  font-size: 80%;
  color: #6e6e6e;
  vertical-align: 2px;
  margin-right: 8px;
}
.profile-page .level-box .level,
.profile-page .bonus-box .point {
  font-size: 20px;
  color: #009a59;
  font-weight: 600;
}
.profile-page input {
  background-color: #fbfbfb;
  /*box-shadow: 0 0 0 0.25rem #f1f1f1;*/
  height: 38px;
  line-height: 38px;
  margin-bottom: 18px;
  border: 1px solid #dddddd;
}
.profile-page input:focus {
  box-shadow: none;
}
/*.profile-page.container input:focus{box-shadow: 0 0 0 0.25rem rgb(12 171 107 / 15%);}*/
.profile-page label {
  font-size: 14px;
  font-weight: 500;
}
.profile-page label + .react-datepicker-wrapper {
  display: block;
}
.profile-page .alert-invalid {
  margin-top: -15px;
  margin-bottom: 10px;
}
.profile-page form .name-txt {
  font-weight: 600;
}
.profile-page .inf-box a {
  color: #ffa60d !important;
}
.profile-page .inf-box .change-pwd {
  margin-top: 10px;
  margin-left: 6px;
  cursor: pointer;
  font-size: 90%;
}
.profile-page .dropdown-toggle,
.profile-page.container .select-selected,
.custom-select .select-selected {
  width: 100%;
  background-color: #fbfbfb;
  border: none;
  box-shadow: 0 0 0 0.25rem #f1f1f1;
  height: 42px;
  line-height: 30px;
  border: 1px solid #ced4da;
  text-align: left;
  position: relative;
  font-size: 1rem;
}
.form-select:focus {
  border-color: #0cab6b !important;
  box-shadow: 0 0 0 0.25rem rgb(223 229 233) !important;
}
.form-select.form-select-sm {
  font-size: 1rem;
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.profile-page .dropdown-toggle::after {
  position: absolute;
  right: 13px;
  top: 20px;
}
.profile-page .btn.btn-danger {
  text-transform: uppercase;
  font-size: 18px;
  font-weight: 600;
  margin-top: 15px;
  background-image: linear-gradient(to right, #ffa908, #fad53b, #ffa908);
  color: #191919;
  border-color: transparent;
  font-size: 17px;
}
.profile-page .btn.btn-danger:focus,
.profile-page .btn.btn-danger:focus-visible {
  box-shadow: 0 0 0 0.2rem rgb(254 179 24 / 28%);
}
.profile-page .fw-bold {
  color: #515151;
}
.profile-page small {
  color: #515151;
}

.sharing-box {
  margin-bottom: 28px;
}
.sharing-box a span.tags,
.sharing-box a {
  display: inline-block;
}
.sharing-box a {
  color: inherit;
  margin: 2px 0;
}
.sharing-box .icon-tag {
  font-size: 36px;
  margin-right: 5px;
  color: #0c8ecf;
}
.sharing-box img {
  height: 36px;
  margin: 0 3px;
  border-radius: 6px;
  width: auto !important;
}
.sharing-box a:last-child img {
  margin-right: 0;
}
.sharing-box.w160 img {
  height: 26px;
  margin: 0 4px;
  border-radius: 2px;
}
.sharing-box.w160 .icon-tag {
  font-size: 26px;
  margin-right: 0px;
}
.sharing-box .list-socials {
  /*width: 160px;*/
}
.sharing-box .list_tags {
  width: calc(100% - 162px);
}
.sharing-box .list_tags .tags {
  padding: 1px 8px;
  border-radius: 50px;
}
.links a {
  color: #009a59;
}
.links li {
  list-style: none;
}
.links li::before {
  content: '\\2022';
  color: #009a59;
  font-weight: bold;
  display: inline-block;
  width: 1em;
  margin-left: -1em;
}
.cmt-box {
  padding: 0px 0px 20px;
}
.cmt-box textarea {
  padding: 15px;
  margin-top: 20px;
}
.cmt-box textarea::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #cecece !important;
  font-size: 20px;
  font-style: italic !important;
  opacity: 1; /* Firefox */
}
.cmt-box textarea::-ms-input-placeholder {
  /* Microsoft Edge */
  color: #cecece !important;
  font-size: 20px;
  font-style: italic !important;
  opacity: 1;
}
.cmt-box button.btn-scroll-top {
  padding: 8px 13px;
}
.cmt-box button.btn-scroll-top .icon-arrow-black {
  color: #fff;
  transform: rotate(-90deg);
  display: inline-block;
}

.cmt-listing {
  margin-top: 15px;
  /*border-bottom: 1px solid #e5e5e5;*/
  margin-bottom: 28px;
}
.cmt-listing img {
  height: 40px;
  width: 40px;
  border-radius: 50px;
  margin-right: 10px;
}
.cmt-listing img + span {
  font-weight: 600;
}
.cmt-listing p.txt-cmt {
  margin-top: 0px;
  margin-left: 55px;
  margin-top: 0px;
  margin-bottom: 0;
}
.cmt-listing .icon-arrow-solid {
  font-size: 9px;
  padding-left: 5px;
}
.cmt-listing .actions {
  font-size: 14px;
  margin-left: 55px;
}
.cmt-listing .user-inf .actions .dropdown {
  display: none;
}
.user-inf .actions .dropdown button.btn {
  padding: 0;
  margin: 0;
  border: none;
  outline: none;
  box-shadow: none;
  font-size: 15px;
}
.cmt-listing .user-inf .actions .dropdown {
  transition: all 0.3s;
}
.cmt-listing .user-inf:hover .actions .dropdown {
  visibility: visible;
}
.cmt-listing .user-inf .icon-like01 {
  font-size: 19px;
  margin-right: 5px;
  color: #000;
}
.cmt-listing .user-inf .icon-comment {
  font-size: 17px;
  margin-right: 5px;
  color: #000;
}
.cmt-listing .user-inf input {
  width: calc(100% - 54px);
  display: inline-block;
  margin-top: 10px;
  border: 1px solid #dbdbdb;
}
.cmt-listing .user-inf input:focus,
.cmt-listing .user-inf input:focus-visible {
  border: solid 1px #00800042;
  box-shadow: 0 0 0 0.25rem rgb(223 229 233);
  outline: none;
}
.cmt-listing .btn.btn-line,
.cmt-listing .btn.btn-solid {
  font-size: 13px;
  border-radius: 8px;
  padding-left: 13px;
  padding-right: 13px;
  padding: 3px 10px;
}
.cmt-listing .btn.btn-solid {
  background-color: #ffbe28 !important;
  border: 1px solid #e49c00;
}
.cmt-listing [class^='list-sub-comment-'],
.cmt-listing [class*=' list-sub-comment-'] {
  position: relative;
  padding: 2px 0 10px;
  margin-top: 10px;
}
.cmt-listing [class^='list-sub-comment-'] .user-inf,
.cmt-listing [class*=' list-sub-comment-'] .user-inf {
  padding: 5px 15px;
  margin-left: 62px;
}
.cmt-listing [class^='list-sub-comment-']:before,
.cmt-listing [class*=' list-sub-comment-']:before {
  content: '';
  background-color: #fff;
  width: calc(100% - 62px);
  height: calc(100% - 0px);
  position: absolute;
  top: 0;
  left: 62px;
  border-radius: 5px;
}
.cmt-listing [class^='list-sub-comment-'] p.txt-cmt,
.cmt-listing [class^='list-sub-comment-'] .actions {
  margin-left: 56px;
}
/*.cmt-listing [class^="list-sub-comment-"] .img-cmt-box , .cmt-listing [class*=" list-sub-comment-"] .img-cmt-box{transform: translate(70px, -1px);}*/
.cmt-listing .actions-sort-cmt {
  border-bottom: #dcdcdc 1px solid;
}
.cmt-listing .actions-sort-cmt ul {
  margin-bottom: 10px;
}
.cmt-listing .actions-sort-cmt li {
  padding: 0 15px;
  position: relative;
}
.cmt-listing .actions-sort-cmt li.active {
  color: #009a59;
}
.cmt-listing .actions-sort-cmt li:before {
  content: '';
  position: absolute;
  height: 1px;
  width: calc(100% - 30px);
  bottom: -13px;
  left: 15px;
  background-color: transparent;
}
.cmt-listing .actions-sort-cmt li.active:before {
  background-color: #009a59;
}
.cmt-listing .box-child-cmt .text-area-child-cmt {
  margin-left: 54px;
}

.cmt-listing .user-inf .actions .btn.dropdown-toggle {
  padding: 5px !important;
  margin-right: 0;
}
.post-box .cmt-listing .post-report ul.dropdown-menu-end {
  margin-top: 8px !important;
}
.post-box .cmt-listing .post-report ul.dropdown-menu-end li.dropdown-item:last-child {
  border-bottom: none;
}
.post-box .cmt-listing .user-inf .post-report ul .dropdown-item {
  font-size: 15px;
}

.loading-style {
  /*height: 100vh;*/
  height: 100%;
  width: 100%;
  z-index: 9;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f9f9f9;
}
.loading-style span {
  width: 15px;
  height: 27px;
  margin: 0 3px; /*border-radius: 50%;*/
  display: inline-block;
  animation-name: dots;
  animation-duration: 2s;
  animation-iteration-count: infinite;
  animation-timing-function: ease-in-out;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
}
.loading-style span:nth-child(2) {
  animation-delay: 0.4s;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_25___});
}
.loading-style span:nth-child(3) {
  animation-delay: 0.8s;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
}
@keyframes dots {
  50% {
    opacity: 0;
    transform: scale(0.7) translateY(10px);
  }
}

.fire_flame_eff {
  width: 40px;
  height: 50px;
  position: relative;
  transform-origin: center bottom;
  animation-name: flicker;
  animation-duration: 3ms;
  animation-delay: 200ms;
  animation-timing-function: ease-in;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  position: absolute;
  top: -24px;
  right: 1px;
  z-index: 1;
}

.fire_flame_eff .flame {
  bottom: 0;
  position: absolute;
  border-bottom-right-radius: 50%;
  border-bottom-left-radius: 50%;
  border-top-left-radius: 50%;
  transform: rotate(-45deg) scale(0.46, 0.36);
}

.fire_flame_eff .yellow {
  left: 15px;
  width: 30px;
  height: 30px;
  bottom: 2px;
  background: gold;
  box-shadow: 0px 0px 9px 4px gold;
}

.fire_flame_eff .orange {
  left: 10px;
  width: 40px;
  height: 40px;
  background: orange;
  box-shadow: 0px 0px 9px 4px orange;
}

.fire_flame_eff .red {
  left: 5px;
  width: 50px;
  height: 50px;
  background: OrangeRed;
  box-shadow: 0px 0px 5px 4px OrangeRed;
}

.fire_flame_eff .white {
  left: 25px;
  bottom: 10px;
  width: 10px;
  height: 10px;
  background: #ffffffa1;
  box-shadow: 0px 0px 10px 8px #ffffffa1;
}

.fire_flame_eff .circle {
  border-radius: 50%;
  position: absolute;
}

.fire_flame_eff .blue {
  width: 0px;
  height: 0px;
  left: 29px;
  bottom: 15px;
  background: #6a5acd;
  box-shadow: 0px 0px 12px 6px #6a5acd8c;
}

.fire_flame_eff .black {
  width: 40px;
  height: 40px;
  left: 10px;
  bottom: -60px;
  background: black;
  box-shadow: 0px 0px 15px 10px black;
}

@keyframes flicker {
  0% {
    transform: rotate(-1deg);
  }
  20% {
    transform: rotate(1deg);
  }
  40% {
    transform: rotate(-1deg);
  }
  60% {
    transform: rotate(1deg) scaleY(1.04);
  }
  80% {
    transform: rotate(-2deg) scaleY(0.92);
  }
  100% {
    transform: rotate(1deg);
  }
}

/*.news-sectn .nav-tabs .nav-link.animated-btn.active span{display: none;}*/

.news-sectn .nav-tabs .nav-link.animated-btn {
  transition: all 0.2s; /*background: linear-gradient(-30deg, #81d0af 50%, #84dab5 50%)!important;*/
  margin-right: 0.5rem;
  background-image: linear-gradient(#009a59, #e0fff2);
  border: 1px solid #8ac9ac;
  color: #fff !important;
  position: relative;
  overflow: visible;
  padding: 7px 26px;
  display: inline-block;
  -webkit-transform: translate(0%, 0%);
  transform: translate(0%, 0%);
  font-size: 17px;
  letter-spacing: 0.2px;
  text-align: center;
  text-transform: uppercase;
  font-weight: 700;
  border-radius: 2px 15px 15px 15px;
  text-decoration: none;
  height: auto;
  color: #191919 !important;
}
.news-sectn .nav-tabs .nav-link.animated-btn:first-child {
  padding-right: 24px;
}
.news-sectn .nav-tabs .nav-link.animated-btn:hover {
  background-image: linear-gradient(#29a66f, #d5ffe5);
}
.news-sectn .nav-tabs .nav-link.animated-btn.active {
  background-image: linear-gradient(#f6a503, #fff0b0);
  border: 1px solid #e5ca91;
  color: #191919 !important;
  cursor: default;
}
/*.news-sectn .nav-tabs .nav-link.animated-btn.active .fire_flame_eff, .news-sectn .nav-tabs .nav-link.animated-btn.active .flashit{display: none;}*/
.news-sectn .nav-tabs .nav-link.animated-btn.new-btn .flashit {
  position: absolute;
  right: -7px;
  top: -7px;
  font-size: 13px; /*text-transform: uppercase;*/
  font-weight: 700;
  font-family: 'helvetica-neue-condensed-bold'; /*font-family: "UTMFuturaExtra";*/
  text-transform: none;
  background-color: #ff4800;
  border: 0.2px solid #ffffffbf;
  padding: 0px 5px 1px;
  border-radius: 6px;
  letter-spacing: 0.5px;
  color: #fff;
  -webkit-animation: flash linear 1s infinite;
  animation: flash linear 1s infinite;
  animation-direction: normal;
}
.news-sectn .nav-tabs .nav-link.animated-btn.new-btn .flashit p {
  margin-bottom: 0 !important;
  -webkit-animation: new-txt linear 1s infinite;
  animation: new-txt linear 1s infinite;
}
/*@-webkit-keyframes new-txt {
  0% { opacity: 1; }
  50% { opacity: .5; }
  100% { opacity: 1; }
}
@keyframes new-txt {
  0% { opacity: 1; }
  50% { opacity: .5; }
  100% { opacity: 1; }
}*/
@-webkit-keyframes flash {
  0% {
    box-shadow: 0 0px 15px #da251c;
  }
  50% {
    box-shadow: 0 0px 15px transparent;
  }
  100% {
    box-shadow: 0 0px 11px #ff4800;
  }
}
@keyframes flash {
  0% {
    box-shadow: 0 0px 15px #ff4800;
  }
  50% {
    box-shadow: 0 0px 15px transparent;
  }
  100% {
    box-shadow: 0 0px 11px #ff4800;
  }
}

/***** Product Deails *****/
.logo-shop img {
  height: 50px;
  margin-left: 0px;
}
.interve-box {
  border-bottom: 1px solid #dbdbdb;
  padding-bottom: 15px;
  margin-top: 15px;
}
.interve-btn {
  padding: 6px 20px;
  border-radius: 8px;
  background-color: #009a59;
}
.fav-btn {
  padding: 6px 20px;
  border-radius: 8px;
  background-color: #ffa608;
  cursor: pointer;
}
.faved-btn {
  background-color: #fff;
  border: 1px solid #ffa608;
}

.interve-btn [class*=' icon-'],
.fav-btn [class*=' icon-'],
.interve-btn [class^='icon-'],
.fav-btn [class^='icon-'] {
  color: #fff;
  font-size: 20px;
}
.faved-btn [class^='icon-'],
.faved-btn [class^='icon-'] {
  color: #ffa608;
  font-size: 20px;
}
.interve-box a.interve-btn {
  margin: 0 5px;
}
.interve-box a.interve-btn:first-child {
  margin-left: 0;
}
/*.detail-product .user-inf {
  padding: 10px 0;
  margin-top: 0px;
  border-bottom: none;
}
.detail-product .user-inf img {
  width: 40px;
  height: 40px;
  border-radius: 100px;
  margin-right: 6px;
  border: 1px solid #dfdfdf;
}*/
.user-inf .name {
  font-weight: 500;
}
.user-inf .user-name {
  display: flex;
}
.user-inf .user-name small {
  font-size: 11px;
  color: #009a59;
  border: 1px solid #009a59;
  font-weight: bold;
  padding: 0px 8px;
  border-radius: 60px;
  margin-left: 5px;
}
.post-box .follow,
.post-box .not-follow {
  margin-left: 0;
}
.post-box .follow img,
.post-box .not-follow img {
  margin-right: 0;
  margin-top: 1px;
}
.post-box .follow {
  background-color: #ffe68a; /*border: 1px solid #FADF9A;*/
  text-align: center;
  color: #191919;
  font-size: 12px;
  font-weight: bold;
  padding: 1px 8px;
  border-radius: 60px;
  margin-left: 6px;
  position: relative;
  height: 22px;
  margin-left: 0px;
  margin-top: 3px;
}
.post-box .follow span:before {
  content: '\\e921';
  font-family: 'iconfont' !important;
  font-size: 5px;
  display: inline-block;
  transform: rotate(135deg);
  margin-right: 3px;
  vertical-align: 3px;
  font-weight: 700;
}
.post-box a.user-inf {
  position: relative;
  z-index: 0;
}
.post-box a.user-inf .txt-sectn {
  width: calc(100% - 51px);
}
.post-box a.user-inf .user-name {
  position: relative;
  z-index: 0;
}
.post-box a.user-inf .user-name .d-inline-block {
  position: relative;
  z-index: 9;
}
.post-box a.user-inf .user-name img {
  height: auto;
  width: auto;
  border-radius: 0;
  outline: none;
  border: none;
}
/* .post-box a.user-inf .d-inline-block{margin-left: 8px;} */

.wrap-flwing .user-name {
  margin-left: 55px;
}
.wrap-flwing .user-name .txt-limit {
  white-space: nowrap;
  /*overflow: hidden;
  text-overflow: ellipsis;*/
  margin-right: 5px;
  display: inline-block;
  max-width: calc(100% - 0px);
  font-size: 15px !important;
}
.wrap-flwing .d-inline-block a.pointer {
  position: relative;
  z-index: 9;
}
.wrap-flwing a.user-inf img {
  margin-top: -14px;
}
.wrap-flwing .avatar {
  margin-top: -26px;
}

.msg-box {
  border-top: 1px solid #dbdbdb;
  margin-top: 0px;
  padding-top: 10px;
}
.msg-box .icon-msgs {
  margin-right: 5px;
  font-size: 22px;
  color: #009a59;
}
.msg-box input {
  color: #ef4923;
  font-style: italic;
  box-shadow: 2px 2px 2px #9e9e9e;
  margin-bottom: 10px;
  background-color: #efefef;
  border: 2px solid #0cab6b;
  border-radius: 10px;
  margin-top: 10px;
}
input.form-control:focus,
textarea.form-control:focus,
.btn:focus {
  border: #0cab6b 1px solid;
  box-shadow: 0 0 0 0.25rem rgb(223 229 233);
}
.msg-box .btn {
  background-color: #ffc65d;
  border: 1px solid #ffba24;
  font-weight: bold;
  font-size: 18px;
  border-radius: 6px;
  padding: 0.275rem 0.75rem;
}
.msg-box .btn:hover {
  color: #191919 !important;
}
.captn-tag {
  background-color: #009a59;
  padding: 2px 20px;
  border-radius: 10px;
  color: #fff;
  display: inline-block;
  font-size: 15px;
  margin-bottom: 15px;
}
.cate-prod .bg-img {
  position: relative;
  display: inline-block;
  width: 100%;
  padding-top: 100%;
  background-size: cover !important;
  background-position: 50% !important;
  text-align: center;
  z-index: 1;
  overflow: hidden;
  border-radius: 15px;
  box-shadow: 2px 2px 6px #a9a9a9;
}
.cate-prod .bg-img:hover {
  box-shadow: none;
}
.cate-prod .bg-img > div {
  position: absolute;
  /*display: table;*/
  display: flex;
  left: 0;
  height: 100%;
  width: 100%;
  top: 0;
  text-align: center;
  font-weight: bold;
  justify-content: center;
}
.cate-prod .bg-img > div .cate-txt {
  /*display: table-cell;
  vertical-align: middle;*/
  text-shadow: 1px 1px 1px #000000;
  font-family: 'UTMFuturaExtra';
  color: #fff;
  text-transform: uppercase;
  font-size: 19px;
  line-height: 24px;
  padding: 5px;
  align-self: center !important;
}
.cate-prod .accordion .collapse:not(.show) {
  display: block;
}
.cate-prod .accordion .accordion-item {
  border-bottom: none;
}
.see-more {
  margin-top: 20px;
  width: 100%;
  text-align: center;
  color: inherit;
}
.see-more .icon-arrow-solid {
  font-size: 9px;
}
.filter-sectn {
  margin-top: 0px;
  border-top: 1px solid #e1e1e1;
  padding-top: 20px;
}
.price-inp {
  margin-top: 36px;
}
.price-inp label {
  padding: 0 10px;
}
.item-lst {
  border-radius: 5px;
  border: 1px solid #f2f2f2;
  transition: all 0.3s ease-in-out;
  margin-bottom: 15px;
  background-color: #fff;
}
.item-lst:hover {
  box-shadow: 0 2px 4px rgb(0 0 0 / 13%);
  background-color: #fff !important;
  border-color: transparent;
}
.item-lst a:hover {
  color: inherit !important;
}
.item-lst .prod-inf {
  padding: 10px;
  border-radius: 0px 0px 2px 2px;
}
.item-lst .prod-inf .txt-name {
  font-size: 0.96rem;
}
.item-lst .bg-img.thumb-pt {
  border-radius: 4px 4px 0 0;
}
.item-lst .prod-inf .txt-name {
  white-space: normal;
  -webkit-line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 600;
  margin-bottom: 5px;
  line-height: 1.28rem;
  height: 41px;
}
.item-lst .prod-inf .locatn {
  font-size: 0.86rem;
  margin-bottom: 5px;
  height: 20px;
  display: flex;
  align-items: center;
}
.item-lst .prod-inf .locatn .icon-location01 {
  margin-right: 3px;
  color: #919191;
}
.item-lst .prod-inf .price-item {
  font-size: 0.9rem;
}
.item-lst .bg-img-orgnal {
  background-color: #f9f9f9;
  padding-top: 100%;
  border-radius: 4px 4px 0 0;
  border-bottom: 1px solid #f8f8f8;
}
.item-lst:hover .bg-img-orgnal {
  background-color: transparent;
}
.item-lst .prod-inf .price-item .price01 small.text-uppercase,
.item-lst .prod-inf .price-item .price02 small.text-uppercase {
  font-size: 0.8em;
  font-weight: 500;
}
.item-lst .prod-inf .price-item .btn-sm {
  background-color: #ffd166 !important;
  border: 1px solid #eec05e;
  color: #191919;
  border-radius: 50px;
  padding: 0;
  padding: 0px 8px 1px;
  font-size: 0.82rem;
}
.item-lst .prod-inf .price-item .fs-7 {
  margin-top: 2px;
}

.detail-product .prod-list .item-lst .bg-img {
  background-position: center;
  background-size: cover;
  height: 95px;
  background-repeat: no-repeat;
  border-radius: 5px 5px 0 0;
}
.detail-product .post-report .dropdown-toggle::after {
  display: none;
}
.detail-product .post-report .dropdown-menu img {
  height: 22px;
  margin-right: 5px;
}
.item-lst {
  position: relative;
}
.item-lst .icon-close {
  position: absolute;
  top: 8px;
  right: 8px;
  color: #fff;
  font-size: 14px;
  text-shadow: 1px 2px 2px #151515;
  cursor: pointer;
  display: none;
  transition: 0.6s all ease;
}
.item-lst:hover .icon-close {
  display: block;
  transition: all 0.6s;
}

.row.prod-list [class^='col-'],
.row.prod-list [class*=' col-'] {
  padding-right: calc(var(--bs-gutter-x) * 0.25);
  padding-left: calc(var(--bs-gutter-x) * 0.25);
}

.saved-items .nav-tabs {
  border-bottom: 1px #7c9c8fcf solid;
  background-color: #fff;
  border-radius: 5px 5px 0 0;
  margin-top: 2px;
}
.saved-items .nav-tabs .nav-item .nav-link,
.nav-mkt-price .nav-item .nav-link {
  margin-bottom: 0;
  padding: 10px 5px;
  border-bottom: 3px solid transparent;
}
.saved-items .nav-tabs .nav-item .nav-link,
.nav-mkt-price .nav-item .nav-link {
  border: none;
  color: #5d5d5d;
  transition: all 0.6s;
  font-weight: 700;
  font-size: 1.1rem;
}
.saved-items .nav-tabs .nav-item .nav-link.active,
.nav-mkt-price .nav-item .nav-link.active {
  color: #03814e;
  border-bottom: 3px solid #03814ec9;
  width: auto;
}
.saved-items .nav-tabs .nav-item .nav-link:hover,
.nav-mkt-price .nav-item .nav-link:hover {
  color: #000;
}
.bootstrap-tagsinput {
  background-color: #fbfbfb;
  border: 1px solid #ced4da;
  box-shadow: 0 0 0 0.25rem #f1f1f1;
  margin-top: 0px;
  margin-bottom: 18px;
  display: inline-block;
  padding: 4px 6px;
  color: #555;
  vertical-align: middle;
  border-radius: 5px;
  max-width: 100%;
  line-height: 22px;
  cursor: text;
  min-height: 38px;
  width: 100%;
}

.bootstrap-tagsinput .label {
  display: inline;
  padding: 0.2em 0.6em 0.3em;
  font-size: 75%;
  font-weight: 700;
  line-height: 1;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 2px;
}
.label-info {
  background-color: #009a59;
}
.bootstrap-tagsinput .tag {
  margin-right: 2px;
  color: white;
  display: inline-block;
  margin-bottom: 2px;
}
.bootstrap-tagsinput input {
  border: none !important;
  box-shadow: none !important;
  outline: none;
  background-color: transparent !important;
  padding: 0 6px;
  margin: 0;
  width: auto !important;
  max-width: inherit;
  height: auto !important;
  line-height: normal !important;
  margin-bottom: 0 !important;
  margin-top: 0 !important;
}
.bootstrap-tagsinput .tag [data-role='remove']:after {
  content: 'x';
  padding: 0px 2px;
}
.get-app {
  cursor: pointer;
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 99999999;
  background-color: #e4e4e4;
  padding: 10px;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgb(0 0 0 / 28%);
}
.get-app .app-icon {
  height: 50px;
  border-radius: 5px;
  margin-right: 10px;
}
.get-app .btn-open {
  color: #1f1f1f;
  border-radius: 100px;
  padding: 2px 15px;
  font-size: 14px;
  margin-top: 2px;
  display: inline-block;
  background-image: linear-gradient(to right, #f49c18 0%, #ffbb5f 40%, #ffbb5f 60%, #f49c18 100%);
}
#GetApp .btn-close {
  position: absolute;
  right: 10px;
  top: 10px;
  z-index: 9;
}
#GetApp img {
  height: 80px;
}
#GetApp img.go-to-app {
  height: 50px;
  width: auto;
  border-radius: 5px;
  margin-top: 10px;
}
#GetApp .modal-body {
  padding-bottom: 40px;
}
#page-wrapper .articles .bg-img-orgnal {
  /*background-size: 100% 100% !important;*/
  background-position: center center !important;
}
#page-wrapper .articles .video-main {
  box-shadow: 0 2px 3px rgb(0 0 0 / 10%);
  border-radius: 0 0 3px 3px;
}
#page-wrapper .articles .video-main .bg-img-orgnal {
  background-size: cover !important;
  width: 100%;
  padding-top: 50%;
  border-radius: 2px;
  background-position: 50% !important;
}
#page-wrapper .articles .video-main .inf-main {
  bottom: 20px;
  left: 20px;
  color: #000;
  z-index: 9;
  padding: 10px;
}
#page-wrapper .articles .item-lst .prod-inf small {
  font-size: 85%;
}
#page-wrapper .detail-article .cont-center figure.media {
  display: block;
}
.video-sectn .row [class^='col-'],
.video-sectn .row [class*=' col-'] {
  padding-right: 6px;
  padding-left: 6px;
}

/***** quy trinh ky thuat *****/
/*.pro-tech-lst .arg-type img.img-cover{width: 130px; height: 130px; border-radius: 200px; border: 5px solid #fff;margin-bottom: 5px;}*/
.pro-tech-lst {
  margin-bottom: 20px;
  background-color: #fff;
  border-radius: 6px;
  padding: 10px;
  box-shadow: 0 2px 10px rgb(0 0 0 / 5%);
  margin-bottom: 25px;
}
.pro-tech-lst > .position-relative {
  margin-top: calc(15% + 1.5px);
  margin-left: -19px;
}
.pro-tech-lst .arg-type-main .wrap-img {
  position: relative; /*width: 180px;*/
}
.pro-tech-lst .arg-type-main .wrap-img .bg-img-orgnal {
  border-radius: 6px;
}
.pro-tech-lst .arg-type-main .wrap-img + div {
  line-height: 28px;
  padding: 10px 0px;
  font-weight: 600 !important;
}
/*.pro-tech-lst .arg-type-main .wrap-img:before{border-radius: 200px;border: 6px solid #fff;position: absolute;z-index: 2;content:"";top:-6px;left: -6px;width: calc(100% + 12px);height: calc(100% + 12px);box-shadow: 0 2px 6px rgb(0 0 0 / 10%);}
*/
.pro-tech-lst .arg-type-main .bg-img-orgnal.rounded-circle {
  width: calc(100% - 0px);
  padding-top: calc(100% - 12px);
  box-shadow: 0 2px 6px rgb(0 0 0 / 10%);
  border: 6px solid #fff;
  z-index: 9;
}
/*.pro-tech-lst .arg-type-main .bg-img-orgnal.rounded-circle:before{content: "";position: absolute;background-size: contain!important;background-position: top center;background-repeat: no-repeat !important; background-image: url("../images/arrow-line02.png"); width: 66.666666%;height:100%;top: calc(50% + 4px);left: calc(100% + 5px);}*/
/*.pro-tech-lst .arg-type-main .wrap-img:after{content: ""; display: inline-block; background-color: #ddddddbd; border-radius: 12rem 12rem 0 0; width: calc(100% + 18px); height: calc(50% + 18px);position: absolute;top: -9px;left: -9px;z-index: 0;}
*/ /*.pro-tech-lst .arg-type-main .wrap-arrow{display: inline-block;width: 100%;padding-top: calc(50% + 135px);margin-left: 6px;background-size: contain!important;background-position: center center;background-repeat: no-repeat !important; background-image: url("../images/arrow-line02.png");}
.pro-tech-lst .arg-type-main .wrap-arrow >.bg-img-orgnal{background-color: transparent;}*/

/*.pro-tech-lst .arg-type-step{width: 100%;position: absolute;top: calc(50% - 17.5px);left: -22px;}*/
/*.pro-tech-lst .arg-type-step:after{content: "";position: absolute;left: 15px;top: 10%;width: 2px;height: 80%;background-color: #DDDDDD;z-index: 0;}*/
/*.pro-tech-lst .arg-type-step {margin-top: 15px;}*/
.pro-tech-lst .arg-type-step {
  margin-top: 10px;
}
.pro-tech-lst .arg-type-step .step-by-step {
  height: 45px;
  margin-bottom: 5px;
  display: block;
}
/*.pro-tech-lst .arg-type-step .step-by-step:after{content: "";position: absolute;left: 15px;top: 30px;width: 2px;height: 30px;background-color: #DDDDDD;z-index: 0;}
*/
.pro-tech-lst .arg-type-step .step-by-step:last-child {
  margin-bottom: 0;
}
.pro-tech-lst .arg-type-step .step-by-step:last-child:after {
  display: none;
}
.pro-tech-lst .arg-type-step .step-icon {
  /*background-color: #DDDDDD;*/
  border-radius: 0 12rem 12rem 0;
  z-index: 2;
}
/*.pro-tech-lst .arg-type-step .step-icon:before{content: "";position: absolute;background-size: contain!important;background-position: center center;background-repeat: no-repeat !important; background-image: url("../images/arrow-line01.png"); width: 100%;height:10px;top: 18px;left:21px;}
*/
.pro-tech-lst .arg-type-step .step-icon .numb {
  height: 32px;
  line-height: 28px;
  width: 32px;
  font-size: 1.3rem;
  text-align: center;
  border-radius: 100px;
  background-color: #ffffff;
  color: #009a59;
  border: 1px solid #7c9c8fcf;
  box-shadow: 0 2px 6px rgb(0 0 0 / 15%);
  top: 2px;
  right: 2px;
  z-index: 1;
  margin-right: 10px;
}
.pro-tech-lst .arg-type-step .step-icon .numb.active-tab {
  position: static;
}
.pro-tech-lst .arg-type-step .step-by-step.active .numb {
  background-color: #009a59;
  color: #fff;
  border: 1px solid #009a59;
}
.pro-tech-lst .arg-type-step .step-txt {
  top: 6px;
  left: 45px;
  font-size: 1rem;
  text-transform: uppercase;
  font-weight: 650;
}
.pro-tech-lst .arg-type-step .step-by-step.active .step-txt {
  color: #00854e;
}
.pro-tech-lst .arg-type-step {
  transition: 0.1s all ease;
  margin-left: 0 !important;
}

.pro-tech-lst + .saved-items {
  margin-top: -25px;
}
.pro-tech-lst + .saved-items .tab-content {
  padding: 10px;
  background-color: #fff;
  margin-top: 0;
}
.pro-tech-lst + .saved-items .nav-tabs {
}
.pro-tech-lst + .saved-items .nav-tabs .nav-item button {
  background-color: #fff;
  border: 1px solid #7c9c8fcf;
  color: #00854e;
  padding: 0.18rem 1.2rem;
  border-radius: 2px 2px 0 0;
  font-weight: 500;
  font-size: 1.05rem;
  margin-right: 0.5rem;
}
.pro-tech-lst + .saved-items .nav-tabs .nav-item button.active {
  background-color: #009a59;
  color: #fff;
  border: 1px solid #009a59 !important;
}
.ModalViewContainer .NewFeedHeader .NewFeedUserInfo .avatar {
  height: 50px;
  width: 50px;
  border-radius: 100px;
  border: 1px solid #e1e1e1;
}
.ModalViewContainer .NewFeedHeader .NewFeedUserInfo .avatar img {
  width: 100%;
  object-fit: cover;
  border: none;
}
.ModalViewContainer .NewFeedActions {
  font-size: 1rem;
  border-top: 1px solid #cccccc;
  border-bottom: 1px solid #cccccc;
  border-right: none;
  border-left: none;
}
.list-action-business .title-txt {
  background-color: #efefef;
}

/***** NPK page *****/
.npk-frm {
  margin-top: 28px;
  margin-bottom: 50px;
}
.npk-frm label {
  margin-bottom: 8px;
  width: 100%;
  font-weight: 500;
}
.npk-frm .kg-unit {
  position: relative;
}
.npk-frm .kg-unit span {
  position: absolute;
  right: 9px;
  bottom: 9px;
  background-color: #e2e8ed;
  height: 36px;
  line-height: 38px;
  width: 60px;
  text-align: center;
  border-radius: 0 3px 3px 0;
  font-size: 14px;
  font-weight: 500;
}
.npk-frm .kg-unit input {
  text-align: right;
  padding-right: 74px;
}
.npk-frm .kg-unit input:focus + span {
  background-color: #0cab6b;
}
.npk-frm .choice-lst {
  /*background-color: #e2e8ed;*/
  display: flex;
  flex-direction: column;
  padding: 15px;
}
.npk-frm * {
  box-sizing: border-box;
  user-select: none;
}
/* .npk-frm input[type='checkbox']{ height: 0; width: 0; } */
.npk-frm .choice-lst .list-fertilizer {
  margin: 15px 0;
}
.npk-frm .choice-lst .list-fertilizer input[type='checkbox'] {
  -ms-transform: scale(1.4); /* IE */
  -moz-transform: scale(1.4); /* FF */
  -webkit-transform: scale(1.4); /* Safari and Chrome */
  -o-transform: scale(1.4); /* Opera */
  transform: scale(1.4);
  padding: 10px;
  margin-right: 10px;
}
.npk-frm .choice-lst .list-fertilizer input[type='checkbox']:after {
  border: 2px solid red;
}
.npk-frm .choice-lst .list-fertilizer input[type='checkbox']:checked {
  background-color: red;
}
.npk-frm input[type='checkbox'] + label {
  position: relative;
  display: flex;
  margin: 0.6em 0;
  align-items: center;
  color: #191919;
  transition: color 250ms cubic-bezier(0.4, 0, 0.23, 1);
}
.npk-frm input[type='checkbox'] + label > ins {
  position: absolute;
  display: block;
  bottom: 0;
  left: 2.5em;
  height: 0;
  width: 100%;
  overflow: hidden;
  text-decoration: none;
  transition: height 300ms cubic-bezier(0.4, 0, 0.23, 1);
}
.npk-frm input[type='checkbox'] + label > ins > i {
  position: absolute;
  bottom: 1px;
  left: 2px;
  font-style: normal;
  /*color: #009A59;*/
}
.npk-frm input[type='checkbox'] + label > span {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 0.6em;
  width: 1.4em;
  height: 1.4em;
  background: transparent;
  border: 1px solid #bebebe;
  border-radius: 2px;
  cursor: pointer;
  transition: all 250ms cubic-bezier(0.4, 0, 0.23, 1);
}

.npk-frm input[type='checkbox'] + label:hover,
.npk-frm input[type='checkbox']:focus + label {
  /*color: #009A59;*/
}
.npk-frm input[type='checkbox'] + label:hover > span,
.npk-frm input[type='checkbox']:focus + label > span {
  background: rgba(255, 255, 255, 0.1);
}
.npk-frm input[type='checkbox']:checked + label > ins {
  height: 100%;
}

.npk-frm input[type='checkbox']:checked + label > span {
  border: 0.7em solid #ffffff;
  animation: shrink-bounce 200ms cubic-bezier(0.4, 0, 0.23, 1);
  box-shadow: 0px 0px 1px 1px #b2b2b2;
}
.npk-frm input[type='checkbox']:checked + label > span:before {
  content: '';
  position: absolute;
  top: 0.6em;
  left: 0.35em;
  border-right: 3px solid transparent;
  border-bottom: 3px solid transparent;
  transform: rotate(45deg);
  transform-origin: 0% 100%;
  animation: checkbox-check 125ms 250ms cubic-bezier(0.4, 0, 0.23, 1) forwards;
  box-sizing: initial;
}

.fw-semibold {
  font-weight: 500 !important;
}
.fn-temp {
  font-family: 'helvetica-neue-condensed-bold', sans-serif;
}
.weather {
  /*background: linear-gradient(to bottom, #008e50 0%, #00bf6e 100%);*/
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_27___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  position: relative;
  overflow: hidden;
  border-radius: 6px;
  margin-top: 15px;
}
.weather > * {
  z-index: 9;
  position: relative;
}
.weather:before {
  background: linear-gradient(to bottom, #5ed18980 0%, #ffcf7259 100%);
  width: 100%;
  height: 100%;
  content: '';
  z-index: 1;
  left: 0;
  top: 0;
  position: absolute;
}
.weather .text-capitalize {
  font-size: 80%;
  font-weight: 600;
}
.weather .old-green {
  background-color: #ffffff20;
  margin: 0 0 10px !important;
  border-radius: 10px;
  align-items: center;
  display: flex;
  padding: 5px;
  border: 0.5px solid #ffffff28;
}
.weather .old-green .justify-content-around {
  font-weight: 500;
  font-size: 15px;
  border-radius: 6px;
  padding: 2px;
}
.weather .old-green .justify-content-around.select {
  margin-bottom: 2px;
  font-size: 14px;
  font-weight: normal; /* -moz-appearance:none; Firefox */ /* -webkit-appearance:none; Safari and Chrome appearance:none;*/
  background-color: transparent;
  color: #191919;
}
.weather .old-green .justify-content-around.select:focus,
.weather .old-green .justify-content-around.select:focus-visible {
  outline: none;
}
.weather .old-green .justify-content-around small {
  font-weight: normal;
  margin-top: -2px;
  font-size: 77%;
}
.weather .days-lst {
  border-radius: 6px;
  padding: 10px 12px;
  width: 100%;
  margin-bottom: 10px;
  border: 1px solid #ffffff15;
}
.weather .box-gradient-height {
  background-image: none;
  border-bottom: 0.5px solid #ffffff2e;
  width: calc(100% + 24px);
  margin-left: -12px !important;
}
.weather .box-gradient-height:last-child {
  border-bottom: none;
}
/*.weather .weather-stt{background-image: url('../images/rice-icon.png'); background-repeat: no-repeat; background-size: cover; background-position: center center;}*/
.weather .d-sm-block .today {
  font-size: 80%;
  margin-top: -3px;
}
.weather .fst-italic {
  display: inline-block;
  margin-top: -5px;
  font-size: 80%;
}
.weather .col-6.d-block img {
  margin-top: 0px;
}
.weather .days-lst .icon-tranform {
  transform: translateY(8px);
}
.weather .days-lst .icon-tranform img {
  height: auto !important;
  width: 28px;
}
.weather .btn-cmore {
  border: none;
  border-radius: 6px;
  background-color: #ffffff20;
  border: 0.5px solid #ffffff28;
  padding: 5px;
  margin-bottom: 10px;
}
.weather .more-btn-fll.btn-cmore:after {
  color: grey;
}
.weather .d-sm-block sup {
  top: -0.77em;
}

@keyframes shrink-bounce {
  0% {
    transform: scale(1);
  }
  33% {
    transform: scale(0.85);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes checkbox-check {
  0% {
    width: 0;
    height: 0;
    border-color: #212121;
    transform: translate3d(0, 0, 0) rotate(45deg);
  }
  33% {
    width: 0.2em;
    height: 0;
    transform: translate3d(0, 0, 0) rotate(45deg);
  }
  100% {
    width: 0.2em;
    height: 0.5em;
    border-color: #212121;
    transform: translate3d(0, -0.5em, 0) rotate(45deg);
  }
}
.npk-frm .accordion-item {
  border: none;
}
.npk-frm .accordion {
  margin-top: 28px;
  border: none;
}
.npk-frm .accordion-item button[type='button'] {
  border: none;
  background-color: #ffb91f;
  border: 1px solid #e9a000;
  border-radius: 6px;
  padding: 10px 33px;
  font-size: 18px;
  font-weight: 500;
}
.npk-frm .accordion-body .table > :not(:first-child) {
  border-top: 2px solid #ccc;
}
.npk-frm .accordion-body tbody tr th {
  font-weight: 500;
}
.npk-frm .accordion-body {
  margin-top: 15px;
}
.npk-frm .accordion-body .total-npk {
  font-weight: bold;
  background-color: #e2e8ed;
}
.npk-frm .form-control {
  border: 1px solid #c5c5c5;
}

/****** Giá cả thị trường ******/
.nav-mkt-price {
  justify-content: space-evenly !important;
  margin-top: 15px !important;
}
.nav-mkt-price .nav-item {
  text-align: center;
}
.nav-mkt-price .nav-item button.nav-link {
  display: inline-block;
  background-color: transparent;
}
.mkt-price .search-box {
  background-color: #fff;
  padding: 20px 20px 15px;
  box-shadow: 0 1px 1px rgb(0 0 0 / 15%);
  z-index: 1;
  position: relative;
}
.mkt-price .search-box form {
  width: 80%;
  margin: 0 auto;
}
.mkt-price .search-box .row [class^='col-'],
.search-box .row [class*=' col-'] {
  padding-right: 3px;
  padding-left: 3px;
}
.mkt-price .search-box .row .btn-pd[class^='col-'],
.search-box .row .btn-pd[class*=' col-'] {
  padding-right: 8px;
  padding-left: 8px;
}
.mkt-price .search-box form {
  margin-bottom: 0;
}
.mkt-price .search-box form select.form-select {
  background: none;
}
.mkt-price .search-box .icon-location01 {
  right: 10px;
  top: 10px;
}
.mkt-price .search-box .icon-location01:before {
  color: #808081;
  font-size: 1.15rem;
}
.mkt-price .search-box .icon-calendar {
  position: absolute;
  right: 15px;
  top: 11px;
  color: grey;
}
.mkt-price .search-box .btn-box button {
  color: #191919;
  font-weight: 500;
  font-size: 17px;
  padding-left: 26px;
  padding-right: 26px;
}
.mkt-price .search-box .btn-box .btn-secondary {
  background-color: #d1d0d0;
  border-color: #c1bebe;
  text-transform: capitalize;
}
.mkt-price .search-box .btn-box .btn-secondary:focus {
  box-shadow: 0 0 0 0.25rem rgb(209 218 224);
}
.mkt-price .search-box .btn-box .btn-primary {
  margin-left: 15px;
  background-color: #ffc55a;
  border: 1px solid #f8ac06;
  text-transform: none;
}
.mkt-price .search-box .btn-box .btn-primary:focus {
  box-shadow: 0 0 0 0.25rem rgb(255 178 7 / 41%);
}
.mkt-price .tab-content {
  /*padding-top: 20px; max-height: 400px; overflow-y: scroll; overflow-x: hidden;*/
  margin-top: 15px;
}
.mkt-price .tab-content .box-link {
  position: relative;
  z-index: 1;
  transition: all 0.6s;
}
.mkt-price .tab-content .box-link .prod-inf {
  width: calc(100% - 100px);
}
.mkt-price .tab-content .me-2 {
  width: 100px;
  height: 100px;
  background-color: #f5f5f5;
  margin-right: 0.68rem !important;
}
.mkt-price .tab-content .box-link .btn-save {
  height: 20px;
  position: absolute;
  right: 8px;
  top: 10px;
  z-index: 9;
  transition: all 0.6s;
}
.mkt-price .tab-content .box-link .btn-save .icon-tag {
  display: none;
  padding: 3px;
}
.mkt-price .tab-content .box-link .btn-save .icon-tag.active {
  display: block;
}
.mkt-price .tab-content .box-link .btn-save .icon-tag:before {
  font-size: 1.5rem;
}
.mkt-price .tab-content .box-link a:hover {
  color: inherit !important;
}
.mkt-price .tab-content .box-link:hover .btn-save .icon-tag {
  display: block;
}
.mkt-price .tab-content .box-link:hover .btn-save .icon-tag:before {
  color: grey;
}
.mkt-price .tab-content .btn-save:hover .icon-tag.active:before,
.mkt-price .tab-content .btn-save .icon-tag.active:before,
.mkt-price .tab-content .box-link:hover .btn-save .icon-tag.active:before {
  color: #009a59;
}
.mkt-price .tab-content .redu-pri,
.mkt-price .tab-content .incr-pri {
  font-weight: 500;
}
.mkt-price .tab-content .redu-pri {
  color: #fc4400;
}
.mkt-price .tab-content .incr-pri {
  color: #1cc619;
}

.mkt-price .tab-content .tab-pane div .lst-item,
.mkt-price-hist .lst-item {
  /*border-bottom: 1px solid #e1e1e1;*/
  padding: 10px;
  cursor: pointer;
  display: block;
  background-color: #fff;
  margin-bottom: 10px;
  border-radius: 2px;
  box-shadow: 0px 5px 10px #e9e9e9;
  border: 1px solid #eeeeee;
}
.mkt-price .tab-content .tab-pane div .lst-item:hover {
  background-color: #fbfffd;
}
.mkt-price .tab-content .box-link:hover .lst-item {
  /*background-color: #edf6f2;*/
  box-shadow: none;
  background-image: linear-gradient(#fff, #ecf8f2);
}
.mkt-price .tab-content .lst-item img {
  width: 100%;
  border-radius: 2px;
  object-fit: cover;
}
.mkt-price .tab-content .lst-item .line-clamp-01 {
  max-width: 180px;
  padding-right: 2px;
}
.mkt-price .tab-content .lst-item small.align-items-center {
  margin-bottom: 2px;
}
.mkt-price .tab-content .lst-item small.align-items-center:last-child {
  margin-bottom: 0;
}
.mkt-price .tab-content .lst-item .text-right .icon-tag:before {
  font-size: 1.3rem;
}
.mkt-price .tab-content .lst-item small.date .icon-time {
  margin-top: 2px;
}

/*.mkt-price .tab-content .tab-pane div:last-child a .lst-item{border-bottom: none;}*/
.mkt-price .tab-content .lst-item > div {
}
.mkt-price .tab-content .lst-item h6 {
  text-transform: capitalize;
  margin-bottom: 2px;
  white-space: nowrap;
  max-width: calc(100% - 20px);
  overflow: hidden;
  text-overflow: ellipsis;
}
.mkt-price .tab-content .lst-item .grey-light-clr {
  color: #6f6f6f;
}
.mkt-price .tab-content .lst-item .prod-price .red-clr {
  font-weight: 500;
  font-size: 0.95rem;
}
.mkt-price .tab-content .lst-item .prod-price .incr-price,
.mkt-price .tab-content .lst-item .prod-price .redu-price,
.mkt-price .tab-content .lst-item .prod-price small {
  margin-left: 15px;
  font-weight: 500;
}
.mkt-price .tab-content .lst-item .date {
  margin-left: auto !important;
}
.mkt-price .form-control,
.mkt-price .form-select,
.mkt-price .form-control {
  border: 1px solid #c5c8cb;
}
.mkt-price .tab-content a:hover span,
.mkt-price .tab-content a:hover small {
  /*color: #191919;*/
}
.mkt-price .tab-content a:hover .red-clr {
  color: #e52f19;
}
.mkt-price ul.nav-mkt-price {
  background-color: #edf6f2;
  margin: 0;
  border-bottom: none;
  border-top: 1px solid #e6e6e6;
  padding-top: 8px;
}
.btn.contribute {
  border-radius: 1px 25px;
  padding: 3px 17px;
  border: 1px solid #ecc00b;
  background-image: linear-gradient(to right, #f8c90a, #ffd52c, #f8c90a);
  color: #191919 !important;
  font-size: 700;
  font-size: 1.3rem;
  transition: all 0.6s;
  display: flex;
  align-items: center;
  min-width: 150px;
}
.btn.contribute:hover {
  background-image: linear-gradient(to right, #ffd116, #ffdc51, #ffd116);
}
.btn.contribute .txt {
  font-size: 0.96rem;
  line-height: 0.96rem;
  font-weight: 600;
  letter-spacing: 0.2;
  text-transform: uppercase;
  margin-left: 5px;
}
.btn.contribute img {
  height: 28px;
}
.btn.contribute .icon-bonus {
  font-size: 1.35rem;
  margin-right: 5px;
  display: inline-block;
  vertical-align: -2px;
}
.mkt-price-details .like-price-icon,
.mkt-price-details .like-price-icon-active {
  transition: all 0.6s;
}

.mkt-price-details .like-price-icon-active:hover,
.mkt-price-details .like-price-icon:hover {
  background-color: #f9f9f9;
  cursor: pointer;
  color: #009a59;
  border-radius: 5px;
  border: 1px solid #009a59;
}
.mkt-price-details .like-price-icon-active:hover .icon-tag {
  color: #009a59;
}
/*.gctt-detail .col-md-9{position: relative;}*/
.mkt-price-details .row {
  border-bottom: 1px solid #e6e6e6;
  padding-bottom: 10px;
}
.mkt-price-details .img-inf {
  width: 150px;
  border-radius: 5px;
}
.mkt-price-details .pri-detls {
  font-weight: 700;
  font-size: 38px;
  margin-left: 10px;
}
.mkt-price .cont-center ol.breadcrumb * {
  padding: 5px 0;
}

h4.title-line-lt {
  margin-bottom: 0;
  font-size: 1.4rem;
}
h4.title-line-lt:before {
  height: 27px;
}
.mkt-price-details .location {
  margin-bottom: 0px;
}
.mkt-price-details .location span,
.mkt-price-details .time span {
  margin-left: 6px;
}
.mkt-price-details .icon-location01:before,
.mkt-price-details .icon-user01:before {
  color: #919191;
}

.mkt-price-details .chartjs {
  margin-top: 20px;
}
.mkt-price-details .table.table-striped {
  margin-top: 10px;
}
.mkt-price-details .fb-icon {
  width: 36px;
  height: 36px;
}
.mkt-price-details .zalo-icon {
  width: 36px;
  height: 36px;
}
.mkt-price-details .hainong-icon {
  width: 36px;
  height: 36px;
}
.mkt-price-details .hainong-icon img {
  background-color: #009a59;
  border-radius: 4px;
}
.mkt-price-details .detl-title {
  border-bottom: 1px solid #e6e6e6;
}
.mkt-price-details .like-price-icon {
  margin-top: 15px;
}
.mkt-price-details .lst-item-detail .line-clamp-02 {
  max-width: 285px;
  line-height: normal;
}

.mkt-price-hist {
  margin-top: 20px;
}
.mkt-price-hist .icon-chart {
  margin-right: 8px;
  font-size: 33px;
  color: #009a59;
}
.mkt-price-hist .icon-store {
  margin-right: 8px;
  font-size: 33px;
  color: #009a59;
}
.mkt-price-hist .txt {
  font-size: 1.4rem;
  font-weight: 700;
  text-transform: uppercase;
}
.mkt-price-hist .table > :not(:first-child) {
  border-top: 2px solid #d1d1d1;
}
.mkt-price-hist .table > :not(caption) > * > * {
  padding: 0.75rem 0.5rem;
}
.mkt-price-hist .fs-5 {
  font-size: 1.16rem !important;
}
.mkt-price-hist .table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.01);
}
.mkt-price .box-show-all img {
  background-color: rgba(0, 0, 0, 0.05);
  border-radius: 50%;
  padding: 5px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  opacity: 0.5;
  width: 30px;
  height: 30px;
}
.mkt-price .box-show-all {
  min-height: 100px;
  max-height: 200px;
  font-weight: bold;
  cursor: pointer; /* nên có để thể hiện interactivity */
  transition: color 0.2s ease;
}

.mkt-price .box-show-all .link-show-all:hover {
  color: #00854e; /* Áp dụng cho span nếu không bị override */
}

.mkt-price .box-show-all .link-show-all:hover img {
  background-color: #00854e;
  color: #ffffff;
  opacity: 1;
}

.mkt-price .box-show-all .link-show-all:hover span {
  color: #00854e; /* Đảm bảo span thay màu đồng bộ */
}


/*.detail-product *{word-break: break-all;}*/

.call-expert .row-cols-3 {
  margin-left: 0;
}
.call-expert .row-cols-3 > * {
  padding-left: 8px;
  padding-right: 8px;
}
.call-expert .box-cont {
  background-color: #fff;
  box-shadow: 0 1px 20px rgb(0 0 0 / 18%);
  margin-bottom: 15px;
  border-radius: 6px;
  padding: 15px;
  border: 1px solid #dbdbdb;
}
.call-expert .box-cont .avt-img {
  width: 50px;
  height: 50px;
  margin-right: 0.8rem;
  box-shadow: 0 0px 10px rgb(0 0 0 / 28%);
}
.call-expert .box-cont button.btn-link {
  width: 100%;
  text-align: center;
  border: 1px solid #cfd7d3;
  border-radius: 6px;
  font-weight: bold;
  transition: 0.3s all ease;
  margin-top: 10px;
  background-color: #f2f2f2;
}
.call-expert .box-cont button.btn-link:hover {
  background-color: #009a59;
  color: #fff;
  border: 1px solid #009a59;
}
.call-expert .box-cont .text-muted {
  height: 19px;
}
.call-expert .box-cont .expert-spec {
}
.call-expert .box-cont .rating {
  margin-top: 2px;
}
.call-expert .box-cont .rating .fa-star {
  font-size: 10px;
  margin-right: 2px;
  color: #bebebe;
}
.call-expert .box-cont .rating .fa-solid {
  color: #ffd008;
}

/***** Wearther Details page *****/
.weather-details .lt-side {
  padding-top: 10px;
}
.weather-details .lt-side .select-style {
  position: relative;
  background-color: transparent !important;
  border-color: transparent;
  display: inline-block;
}
.weather-details .lt-side .select-style select.form-select {
  background: transparent;
  -webkit-appearance: none;
  width: auto;
  border: none;
  margin-bottom: -7px;
  padding-left: 0;
}
.weather-details .lt-side .select-style select.form-select:focus {
  box-shadow: none !important;
}
.weather-details .lt-side .select-style select.form-select option {
  font-size: 15px !important;
}
.weather-details .lt-side .select-style select.form-select option[selected],
.weather-details .lt-side .select-style select.form-select option:first-child {
  font-size: 20px !important;
}
.weather-details .wth-time .addr-txt {
  width: 100%;
}
.weather-details .wth-time img {
  opacity: 1;
}
.weather-details .lt-side .select-style:after {
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid #5f5f5f;
  position: absolute;
  top: 15px;
  right: 14px;
  content: '';
}
.weather-details .lt-side .weath-img {
  width: 70%;
  margin-left: 10px;
  margin-top: 0px;
  margin-bottom: -10px;
}
.weather-details .lt-side small {
  font-size: 77% !important;
  color: #505050;
}
.weather-details .lt-side .temp {
  font-size: 5rem;
  margin: -10px 0;
}
.weather-details .lt-side .temp sup {
  font-size: 1.5rem;
  top: -2.5rem;
}
.weather-details .lt-side .wth-main {
  margin: 0;
  position: relative;
  overflow: hidden;
  border-radius: 6px;
}
.weather-details .lt-side .wth-main .wth-time,
.weather-details .lt-side .wth-main .inf-cnt {
  z-index: 1;
  position: relative;
  padding: 15px;
}
.weather-details .lt-side .wth-main .wth-time #inputWeather {
  width: 100%;
}
.weather-details .lt-side .wth-main .wth-time .city-selct {
  position: relative;
  padding-right: 15px;
  cursor: pointer;
  margin-top: -5px;
  font-size: 0.9rem;
}
/*.weather-details .lt-side .wth-main .wth-time .city-selct::after{position: absolute;display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
  color: #191919;right: 0;top: 10px;
}*/
.weather-details .lt-side .wth-main .inp-addr {
  border-radius: 6px 0 0 6px;
  border: none;
  padding: 2px 10px;
  width: calc(100% - 44px);
  position: relative;
}
.weather-details .lt-side .wth-main input.inp-addr,
.weather-details .lt-side .wth-main button.btn {
  height: 33px;
}
.weather-details .lt-side .wth-main button.btn {
  padding: 2px 8px;
  font-size: 15px;
  background-color: #ffba40;
  top: 0;
  right: 0;
  border-radius: 0 5px 5px 0;
}
.weather-details .lt-side .wth-main input.inp-addr:focus,
.weather-details .lt-side .wth-main button.btn:focus,
.weather-details .lt-side .wth-main button.btn:active {
  box-shadow: none;
  border: none;
  outline: none;
}
.weather-details .lt-side .wth-main:before {
  background: linear-gradient(to bottom, #4ab672d1 0%, #9cc6467d 100%);
  width: 100%;
  height: 100%;
  content: '';
  z-index: 1;
  left: 0;
  top: 0;
  position: absolute;
  content: ' ';
}
.weather-details .lt-side .icon-weather01,
.weather-details .lt-side .icon-rainpre {
  font-size: 26px;
  margin-right: 5px;
  color: #9e9e9e;
}
.weather-details .lt-side .select-style select.form-select {
  margin-bottom: -10px;
}
.weather-details .lt-side button.btn-input-localtn {
  padding: 5px 10px;
  width: 42px;
  height: 40px;
  border-radius: 5px;
  border: none;
  background-color: transparent;
  /*border: 1px solid #ffffff1f;*/
}
.weather-details .lt-side .btn-audio {
  padding-right: 5px;
}
.weather-details .lt-side button.btn-input-localtn {
  position: relative;
}
.weather-details .lt-side button.btn-input-localtn:after {
  content: '';
  position: absolute;
  width: 2px;
  height: 15px;
  background-color: #0000001c;
  left: 1px;
  top: 11px;
}
.weather-details .lt-side .btn-audio svg {
  margin-top: -3px;
}
.weather-details .lt-side button.btn-input-localtn img {
  width: 19px;
}
.weather-details .temp {
  font-family: 'helvetica-neue-condensed-bold', sans-serif;
}
.weather-details .rt-side .lst-hrs {
  margin-top: 10px;
}
.weather-details .rt-side .lst-hrs img {
  height: 2.2rem;
}
.weather-details .rt-side .lst-hrs .fs-6 {
  color: #555;
  font-size: 0.9rem !important;
}
.weather-details .rt-side .lst-hrs .col {
  text-align: center;
  padding-right: 5px;
  padding-left: 5px;
}
.weather-details .rt-side .lst-hrs .rain-forc {
  margin-top: -5px;
}
.weather-details .rt-side .lst-hrs .rain-forc small {
  font-size: 77% !important;
}
.weather-details .rt-side .lst-hrs .rain-forc small + span {
  font-size: 60% !important;
}
.weather-details .rt-side .lst-hrs .box-cnt,
.weather-details .rt-side .lst-stt .box-cnt {
  box-shadow: 0px 0px 5px 0px #e5e5e5;
  padding: 13px;
  margin-bottom: 10px;
  background-color: #ffffff;
  border-radius: 6px;
  box-shadow: 0 2px 12px #00000026;
  border: 1px solid #eaeaea;
}
.weather-details .rt-side .lst-stt .box-cnt .align-items-center {
  height: 42px;
}
.weather-details .rt-side .lst-stt .col {
  padding-right: 5px;
  padding-left: 5px;
}
.weather-details .rt-side .lst-stt img.high-temp,
.weather-details .rt-side .lst-stt img.low-temp {
  width: 1.3rem;
}
.weather-details .rt-side .lst-stt img.sunrise {
  width: 2.4rem;
}
.weather-details .rt-side .lst-stt .numb {
  font-size: 1.7rem;
  font-weight: 500;
  margin-left: 10px;
}
.weather-details .rt-side .lst-stt .unit {
  font-size: 1rem;
}
.weather-details .rt-side .lst-stt .unit sup {
  top: -0.8rem;
}
.weather-details .rt-side .lst-stt .icon-pinwheel {
  font-size: 2.2rem;
  color: #8b25ae;
}
.weather-details .rt-side .lst-stt .icon-humidity {
  font-size: 2.4rem;
  color: #568a8d;
}
.weather-details .rt-side .lst-stt .icon-sunset {
  font-size: 1.8rem;
  color: #fd8936;
}
/*.weather-details .rt-side .title-line:before {
  position: absolute;
  left: 0;
  height: 1.4rem;
  width: 0.28rem;
  content: "";
  background-color: #009a59;
  top: -0.1rem;
}*/
.weather-details .rt-side table th {
  font-weight: normal;
}

.weather-details .rt-side .table.table-hover > :not(caption) > * > * {
  padding: 0.5rem 0.5rem;
  vertical-align: middle !important;
  border-bottom-width: 1px;
}
.weather-details .rt-side .table.table-hover td,
.weather-details .rt-side .table.table-hover th {
  border-top: none;
}
.weather-details .rt-side .table tr:first-child > * {
  border-top-color: transparent;
}
.weather-details .rt-side .table tr:last-child > * {
  border-bottom-color: transparent;
}

.weather-details .rt-side .table.table-hover tbody tr:hover {
  background-color: #00000000;
}
.weather-details .rt-side .table.table-hover {
  --bs-table-hover-bg: rgba(0, 0, 0, 0.028);
}
.weather-details .rt-side .table.table-hover tbody tr .icon-humidity {
  color: #568a8d;
}
.weather-details .rt-side .table.table-hover tbody tr img {
  height: 1.9rem;
}
.weather-details .rt-side .table.table-hover tbody tr td span.icon-temp {
  color: #e1412a !important;
}

/* s-btn flickering effect */
.button_glowing {
  background-color: #da663b;
  border-radius: 60px;
  border: 5px solid #ffffff1e;
  color: #ffffff !important;
  cursor: pointer;
  display: inline-block;
  font-family: poppins;
  font-weight: 400;
  padding: 6px 25px;
  text-align: center;
  text-decoration: none;
  font-family: 'UTMFuturaExtra';
  text-transform: uppercase;
  font-weight: normal;
  font-size: 1.4rem;
  -webkit-animation: glowing 1500ms infinite;
  -moz-animation: glowing 1500ms infinite;
  -o-animation: glowing 1500ms infinite;
  animation: glowing 1500ms infinite;
}
@-webkit-keyframes glowing {
  0% {
    background-color: #da663b;
    -webkit-box-shadow: 0 0 3px #da663b;
  }
  50% {
    background-color: #da663b;
    -webkit-box-shadow: 0 0 40px #da663b;
  }
  100% {
    background-color: #da663b;
    -webkit-box-shadow: 0 0 3px #da663b;
  }
}

@-moz-keyframes glowing {
  0% {
    background-color: #da663b;
    -moz-box-shadow: 0 0 3px #da663b;
  }
  50% {
    background-color: #da663b;
    -moz-box-shadow: 0 0 40px #ff0000;
  }
  100% {
    background-color: #da663b;
    -moz-box-shadow: 0 0 3px #da663b;
  }
}

@-o-keyframes glowing {
  0% {
    background-color: #da663b;
    box-shadow: 0 0 3px #b20000;
  }
  50% {
    background-color: #ff0000;
    box-shadow: 0 0 40px #ff0000;
  }
  100% {
    background-color: #da663b;
    box-shadow: 0 0 3px #da663b;
  }
}

@keyframes glowing {
  0% {
    background-color: #ffc700;
    box-shadow: 0 0 3px #ffe896;
  }
  50% {
    background-color: #ffc700;
    box-shadow: 0 0 40px #ffdd64;
  }
  100% {
    background-color: #da663b;
    box-shadow: 0 0 3px #e78a68;
  }
}
/* e-btn flickering effect */

.cont-center .gifts .flashit {
  font-weight: 500;
  position: absolute;
  right: 5px;
  top: 5px;
  font-size: 13px;
  text-transform: none;
  background-color: #da251d;
  border: 0.2px solid rgba(255, 255, 255, 0.7490196078);
  padding: 0px 5px 1px;
  border-radius: 6px;
  letter-spacing: 0.5px;
  color: #fff;
}

.arrow-wrapper {
  background-color: rgba(0, 0, 0, 0.05);
  border-radius: 50%;
  padding: 5px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  opacity: 0.5;
  transition:
    background-color 0.3s,
    opacity 0.3s;
  margin: 5px;

  img {
    width: 20px;
    height: 20px;
    object-fit: contain;
  }

  &:hover {
    opacity: 0.7;
    background-color: #00854e;
  }
}


.tab-content > div .mt-3.card .card-body {
  width: 100%;
  overflow: scroll;
}
.tab-content > div .mt-3.card .card-body .table th {
  border-top: none;
}
.tab-content > div .mt-3.card .card-body .table th {
  width: 20%;
}
.tab-content > div .mt-3.card .card-body .table th div {
  width: 100%;
  min-width: 105px;
}

.ModalViewContainer .bg-dark button {
}
.ModalViewContainer .bg-dark button.left-10 svg,
.ModalViewContainer .bg-dark button.right-10 svg {
  position: relative;
  justify-content: center !important;
  align-items: center;
  display: flex;
  top: 0px;
}
.ModalViewContainer .bg-dark button.left-10 svg {
  left: 0px;
}
.ModalViewContainer .bg-dark button.right-10 svg {
  right: 0px;
}
.ModalViewContainer .bg-dark button.left-10 svg path {
  position: absolute;
  left: 5px;
  top: 5px;
}
.ModalViewContainer .bg-dark button.right-10 svg path {
  position: absolute;
  right: 5px;
  top: 5px;
}
.ModalViewContainer .CommentWrapper .avatar {
  height: 50px;
  width: 50px;
  border-radius: 100px;
  border: 1px solid #e1e1e1;
}

footer {
  background-color: #009a59;
  padding: 1.5rem 0;
  color: #fff;
  margin-top: 20px;
}
footer .logo img {
  height: 5rem;
}
footer .social-ico [class^='icon-'] {
  width: 51px;
  height: 51px;
  line-height: 48px;
  border-radius: 100px;
  border-style: solid;
  border-width: 2px;
  text-align: center;
  background-color: #fff;
  display: inline-block;
  margin: 0 10px;
}
footer .social-ico [class^='icon-']:before {
  font-size: 26px;
}
footer .social-ico [class^='icon-']:first-child {
  margin-left: 0;
}
footer .social-ico .icon-facebook {
  border-color: #1863f261;
}
footer .social-ico .icon-youtube {
  border-color: #ea412c40;
}
footer .social-ico .icon-youtube:before {
  font-size: 22px;
}
footer .social-ico .icon-zalo {
  border-color: #007ac669;
}
footer .social-ico .icon-tiktok {
  border-color: #54006830;
}
footer .contact-inf {
  font-size: 18px;
  padding: 0px 15px !important;
}
footer .contact-inf a {
  color: #ffc039 !important;
  font-size: 18px;
}
footer .footer-title {
  font-size: 24px !important;
  font-weight: 700;
}

/*// -------------------------------------------------------------
// Media Queries*/
@media (min-width: 1024px) {
  .weather h2.fn-temp {
    font-size: 1.9rem;
  }
  .weather .d-sm-block .row [class^='col-']:last-child {
    padding-left: 0 !important;
  }
  .weather .d-sm-block .fw-semibold {
    font-size: 0.6rem;
    letter-spacing: -0.5;
    margin-bottom: 2px;
  }
  .weather .fst-italic {
    font-size: 68%;
  }
  .weather .d-sm-block small.fw-normal {
    font-size: 0.8rem;
  }
}
@media (min-width: 1200px) {
  .container,
  .container-lg,
  .container-md,
  .container-sm,
  .container-xl {
    width: 100%;
    max-width: 1140px;
    margin: 0 auto;
  }
  .weather h2.fn-temp {
    font-size: 2.4rem;
  }
  .weather .d-sm-block .fw-semibold {
    font-size: 0.7rem;
  }
  .weather .d-sm-block .fw-semibold {
    font-size: 0.8rem;
  }
  .weather .d-sm-block small.fw-normal {
    font-size: 0.8rem;
  }
}
@media (min-width: 1440px) {
  .container {
    max-width: 1280px;
  }
  .weather h2.fn-temp {
    font-size: 3.1rem;
  }
  .weather .d-sm-block .fw-semibold {
    font-size: 0.9rem;
  }
  .weather .fst-italic {
    font-size: 80%;
  }
  .weather .d-sm-block small.fw-normal {
    font-size: 1rem;
  }
  .col-12p5 {
    flex: 0 0 auto !important;
    width: 20% !important;
    max-width: 9999px;
  }
}
@media (min-width: 1600px) {
  .container {
    max-width: 1440px;
  }
}
@media (min-width: 1800px) {
  .container {
    max-width: 1600px;
  }
}
@media (min-width: 2048px) {
  .container {
    max-width: 1800px;
  }
}
@media (min-width: 2300px) {
  .container {
    max-width: 2048px;
  }
}
@media (min-width: 1024px) and (max-width: 1399px) {
  .interve-btn {
    padding: 6px 15px;
    border-radius: 6px;
  }
  .cate-prod .bg-img {
    border-radius: 15px;
  }
  .cate-prod .bg-img > div .cate-txt {
    font-size: 20px;
    line-height: 24px;
  }
  .mkt-price .search-box form {
    width: 100%;
  }
}
@media (min-width: 767px) and (max-width: 1199px) {
  .container-sm,
  .container {
    max-width: 1160px !important;
  }
  .mkt-price .search-box form {
    width: 100%;
  }
  header .top-sectn .side-r .notify-box li .icon-close {
    display: inline-block;
    color: #858585;
  }
}

@media (max-width: 767px) {
  .post-more {
    margin-top: 20px;
    margin-bottom: 20px;
  }
  header .hashtag-sectn ul {
    /*width: 100%;*/
    text-overflow: ellipsis;
    white-space: pre;
    padding: 0;
    overflow: hidden;
    overflow-x: scroll;
    white-space: nowrap;
    margin-top: 5px;
    margin-bottom: 5px;
  }
  header .hashtag-sectn ul::-webkit-scrollbar-track {
    border-radius: 0px;
    margin-top: 0px;
    background-color: transparent;
  }

  header .hashtag-sectn ul::-webkit-scrollbar {
    height: 0px;
    background-color: transparent;
    margin-top: 0px;
  }

  header .hashtag-sectn ul::-webkit-scrollbar-thumb {
    border-radius: 0px;
    background-color: transparent;
  }

  header .hashtag-sectn ul.list-post-catalogues {
    margin-top: -1px;
  }
  header .hashtag-sectn ul li {
    margin: 0 14px;
  }
  header .hashtag-sectn ul .reset-btn {
    display: none;
  }
  /*header .hashtag-sectn ul.contr-btn{overflow-x:hidden;}*/
  .d-desktop {
    display: none;
  }
  .d-mobile {
    display: inline-block;
  }
  header .contain-prof .icon-user {
    font-size: 24px;
    color: #fff;
  }
  header .contain-prof .dropdown-toggle::after {
    display: none;
  }
  header .contain-prof .dropdown-menu.show {
    top: 8px !important;
  }
  header .top-sectn a.logo img {
    width: 110px;
  }
  header .contain-prof ul {
    padding: 10px 20px;
    margin: 0;
  }
  header .contain-prof ul li {
    list-style: none;
    padding: 13px 0;
    /*border-bottom: 1px solid #e5e5e5;*/
    display: flex;
    align-items: center;
  }
  header .contain-prof ul li.logout {
    border-bottom: none;
  }
  header .contain-prof ul li .avatar {
    height: 30px;
    width: 30px;
    border-radius: 100px;
    margin-right: 5px;
    object-fit: cover;
  }
  header .top-sectn .side-r .acct-box .user-name {
    color: #191919;
  }
  header .top-sectn .side-r .notify-box .item-numb {
    top: 2px;
  }
  header .top-sectn .side-r .acct-box .dropdown-menu {
    top: 14px !important;
  }
  header .contain-prof ul li.logout {
    border-top: 1px solid #eee;
  }
  header .hashtag-sectn {
    position: relative;
    z-index: 9;
  }
  header .cate-sectn {
    position: relative;
    z-index: 999999;
  }
  header .cate-sectn a.d-mobile + .contain-sidebar-l.show {
    display: block !important;
    width: 100%;
    position: absolute;
    top: 40px;
    background-color: #fff;
    padding: 0px 15px 15px;
    box-shadow: 0 3px 3px rgb(0 0 0 / 30%);
    z-index: 999999;
    border-top: 1px solid #dedede;
  }
  /*header .cate-sectn a.d-mobile:hover + .contain-sidebar-l .row{z-index: 999999;position: relative;}*/
  header .cate-sectn a.d-mobile + .contain-sidebar-l.show .title-txt {
    color: #009958;
    font-size: 1.05rem;
    background-color: #e9e9e9;
    padding: 8px 0;
  }
  header .cate-sectn a.d-mobile + .contain-sidebar-l.show ul {
    margin: 0;
    padding: 0;
  }
  header .cate-sectn a.d-mobile + .contain-sidebar-l.show li {
    list-style: none;
    margin: 0;
    padding: 10px 0;
    border-bottom: 1px solid #e9e9e9;
  }
  header .cate-sectn a.d-mobile + .contain-sidebar-l.show ul li:last-child {
    border-bottom: none;
  }
  header .cate-sectn a.d-mobile + .contain-sidebar-l.show li a {
    z-index: 99999;
    position: relative;
    display: block;
    line-height: 20px;
  }
  header .cate-sectn .contain-sidebar-l li.seemore a {
    color: #2a2a2a !important;
    font-size: 15px;
  }
  header .cate-sectn .contain-sidebar-l li.seemore a .icon-arrow-solid {
    font-size: 8px;
  }
  header .cate-sectn {
    padding: 13px 0;
    margin-bottom: 10px;
  }
  header .hashtag-sectn ul li a {
    padding: 0;
  }
  header .cate-sectn .icon-currency {
    font-size: 35px;
  }
  header .top-sectn .side-r .acct-box .dropdown-menu {
    z-index: 1000;
  }
  header .top-sectn .side-r .acct-box .dropdown-menu ul li.logout {
    margin-top: 0;
  }
  header .top-sectn .side-r .acct-box .dropdown-menu ul li.logout a#login-with-two-nong {
    margin-top: 0px;
    font-size: 18px;
    border-radius: 5px;
    padding: 5px 0;
    border: none;
    background-image: linear-gradient(#f6a503, #fff0b0);
    border: 1px solid #e5ca91;
    transition: all 0.3s;
    box-shadow: none;
    width: 100%;
    display: block;
    font-weight: 500;
  }
  header .top-sectn .side-r .notify-box .dropdown-menu.show {
    top: 48px !important;
  }

  header .cate-sectn [class^='icon-'],
  header .cate-sectn [class*=' icon-'] {
    height: 28px;
  }
  header .cate-sectn .active [class^='icon-'],
  header .cate-sectn .active [class*=' icon-'] {
    position: relative;
  }
  header .cate-sectn a:hover [class^='icon-'],
  header .cate-sectn a.active:hover [class^='icon-'] {
    color: #ffa608;
  }
  header .cate-sectn a:hover .mn-tooltip {
    display: none;
  }
  header .cate-sectn .active [class^='icon-']:after,
  header .cate-sectn .active [class*=' icon-']:after {
    position: absolute;
    bottom: -13px;
    content: '';
    height: 2px;
    left: -5px;
    width: calc(100% + 10px);
    background-color: orange;
  }
  header .cate-sectn [class^='icon-'] {
    font-size: 28px;
    padding: 0;
  }
  header .cate-sectn .icon-menu-main,
  header .cate-sectn .icon-more-menu {
    font-size: 28px;
  }
  header .cate-sectn .icon-price-menu {
    font-size: 36px;
  }
  header .cate-sectn .icon-news02 {
    font-size: 34px;
  }
  header .cate-sectn .icon-home,
  header .cate-sectn .icon-news02 {
    font-size: 33px;
  }
  header .cate-sectn .icon-triangle-line,
  header .cate-sectn .icon-farmer-market {
    font-size: 28px;
  }

  header .hashtag-sectn .icon-arrow-black {
    width: 40px;
  }
  header .hashtag-sectn .icon-arrow-black.next-btn {
    margin-right: -10px;
    display: none;
  }
  header .hashtag-sectn .icon-arrow-black.prev-btn {
    margin-left: 0px;
    display: none;
  }
  header .hashtag-sectn ul li {
    line-height: initial;
  }
  header .cate-sectn .container,
  header .hashtag-sectn .container {
    padding: 0;
  }

  h2 {
    font-size: 24px !important;
  }
  .traceability-home .code-box {
    width: 100%;
  }
  .saved-items .nav-tabs .nav-item .nav-link,
  .nav-mkt-price .nav-item .nav-link {
    font-size: 1.05rem;
  }

  .post-box .posted-inf .sharing-post .bg-img {
    /*min-height: 100px;height: auto;*/
    height: 220px;
    margin-top: 10px;
  }
  #box-weather.weather {
    display: none;
  }
  .home-wrapper .news-sectn .main-news .inf-box {
    height: auto;
  }
  .home-wrapper .news-sectn .main-news {
    margin-bottom: 10px;
    padding: 0 !important;
  }
  .home-wrapper .news-sectn .sub-news {
    padding: 0 5px;
  }
  .cmt-box .cmt-listing input {
    width: 100%;
  }
  .cmt-box .actions .dropdown {
    display: inline-block;
  }
  .post-box .posted-inf .fav-ctrl > div:hover span,
  .post-box .posted-inf .fav-ctrl > div:hover span:before {
    color: inherit;
  }
  .box-bd.hotnews .hot-videos .bg-img {
    height: 80px !important;
  }

  /***** Mobile- download app *****/
  .App .d-mobile.sticky-top {
    position: sticky;
    z-index: 1000;
    top: 0;
    transition: top 0.5s ease-in-out 0s;
  }
  .go-to-app {
    background-color: #fff;
    padding: 10px;
    box-shadow: 0 2px 4px rgb(0 0 0 / 28%);
    width: calc(100% - 0px);
    font-size: 15px;
    border-radius: 0 0 10px 10px;
    margin: 0;
  }
  .go-to-app .app-icon {
    height: 60px;
    border-radius: 8px;
    margin-right: 10px;
  }
  .go-to-app .grey-clr {
  }
  .go-to-app .second-clr {
  }
  .go-to-app .btn-open {
    color: #1f1f1f;
    font-weight: 600;
    border-radius: 100px;
    padding: 5px 15px;
    background-image: linear-gradient(to right, #ffa908, #fad53b, #ffa908);
    /* margin-top: 30px; */
  }
  .go-to-app .icon-close {
    top: 10px;
    right: 15px;
    font-size: 13px;
    color: #868686;
  }
  #page-wrapper {
    padding-top: 5px;
    padding-bottom: 20px;
  }

  .bg-img-orgnal.avtar45 {
    left: 0px;
    top: 0px;
  }
  .post-box .btn-post {
    height: 40px;
    padding: 0 0px;
  }
  .post-box .btn-post .icon-library {
    left: 0;
  }
  .post-box .post-report ul .dropdown-item {
    font-size: 14px;
  }
  .cont-center .cntry-news,
  .cont-center .world-news,
  .mrgt28 {
    margin-top: 10px !important;
  }
  .search-top .icon-search {
    left: 12px;
    top: 8px;
    z-index: 9;
    opacity: 1;
  }
  .search-top input {
    padding-top: 3px;
    padding-bottom: 3px;
  }
  .search-top input {
    padding-left: 33px;
    height: 30px;
  }
  .mkt-price {
    margin-top: 10px !important;
  }
  .nav-mkt-price {
    margin-top: 10px !important;
  }
  .mkt-price .tab-content .row-cols-2 > * {
    width: 50%;
  }
  .mkt-price .tab-content {
    margin-top: 10px;
  }
  .mkt-price .tab-content .tab-pane div .lst-item {
    padding: 10px;
  }
  .mkt-price .tab-content .lst-item .line-clamp-01 {
    max-width: 150px;
  }
  .mkt-price .tab-content .lst-item .prod-price .fs-4 {
    font-size: 1.26rem !important;
  }
  .mkt-price .cate-lst.mb-4 {
    margin-bottom: 15px !important;
  }

  .nav-mkt-price .nav-item {
    width: 33.333333%;
  }
  .mkt-price-details .pri-detls {
    font-size: 22px;
  }
  .mkt-price-hist .txt {
    font-size: 20px;
  }
  .mkt-price-hist .icon-chart {
    font-size: 28px;
    margin-right: 6px;
  }
  .mkt-price-details .lst-item-detail .line-clamp-02 {
    max-width: 200px;
    font-size: 1.22rem;
  }
  .user-inf .member_rate_in_month.text-end {
    /*text-align: left !important;
    margin-left: 56px;*/
    margin-top: -35px;
  }
  .mkt-price-details .like-price-icon-active:hover {
    color: #fff;
    background-color: #009958;
    border: 1px solid #009958;
  }
  .post-box .post-report ul.dropdown-menu-end {
    margin-top: 8px !important;
  }
  .weather .days-lst .col-sm {
    flex: 1 0 0%;
  }
  .call-expert .row-cols-3 {
    margin-right: calc(-0.5 * var(--bs-gutter-x));
    margin-left: calc(-0.5 * var(--bs-gutter-x));
  }
  .call-expert .row-cols-3 > * {
    padding-left: 15px;
    padding-right: 15px;
    width: 100%;
  }
  .post-box {
    margin-bottom: 13px;
  }
  .npk-frm .choice-lst .row-cols-2 > * {
    width: 100%;
  }
  .cmt-box {
    padding: 0;
  }
  .mkt-price .search-box .btn-box {
    width: 100%;
  }
  .video-sectn .bg-img.thumb-pt {
    height: 126px;
  }
  .cmt-box .cmt-listing .input-box {
    margin-left: 50px;
    width: calc(100% - 50px) !important;
  }
  .FormAddEditProduct.card .card-body .col-2 {
    width: 33.333333%;
  }
  .sub-news-item.mb-3 {
    margin-bottom: 0.6rem !important;
  }
  header .top-sectn .side-r .notify-box li .icon-close {
    display: inline-block;
    color: #858585;
  }
  header .cate-sectn .contain-sidebar-l [class^='icon-'] {
    font-size: 18px;
    margin-right: 5px;
    color: #009a59;
  }
  header .cate-sectn .contain-sidebar-l .icon-weather02 {
    font-size: 21px;
  }
  header .cate-sectn .contain-sidebar-l .icon-present {
    font-size: 16px;
  }
  header .cate-sectn .contain-sidebar-l .icon-farmer-market,
  header .cate-sectn .contain-sidebar-l .icon-gift {
    font-size: 15px;
  }
  header .cate-sectn .contain-sidebar-l span.txt {
    font-weight: 500;
  }

  footer.footer-sectn {
    text-align: center;
  }
  footer.footer-sectn .d-flex.align-items-center {
    display: block !important;
  }
  footer.footer-sectn .social-ico {
    justify-content: center;
  }
  footer.footer-sectn .row > div {
    margin-bottom: 20px;
  }
  footer.footer-sectn .row > div:last-child {
    margin-bottom: 0;
  }
  .mkt-price .tab-content .box-link .btn-save .icon-tag {
    display: block;
  }
  .inpt-cntn.cmt-box .bg-img-orgnal.avtar40 {
    left: 10px;
  }
  .inpt-cntn .btn-send {
    right: 15px;
  }
  .pro-tech-lst > .position-relative {
    margin-top: calc(15% + 1.5px);
  }
  .pro-tech-lst .arg-type-main .wrap-img .bg-img-orgnal {
    padding-top: 30%;
  }
  .home-wrapper .posts-sectn .inf-post .poster-txt .carousel-caption .line-clamp-02.fs-6 {
    width: 100%;
    font-size: 1.15rem !important;
    line-height: 1.5rem;
  }
  .home-wrapper .posts-sectn .carousel.slide .carousel-control-prev-icon,
  .home-wrapper .posts-sectn .carousel.slide .carousel-control-next-icon {
    display: none;
  }
  .home-wrapper .posts-sectn .inf-post .poster-txt {
    margin-top: 20px;
  }
  .home-wrapper .posts-sectn .inf-post {
    height: 100%;
  }
  .home-wrapper .posts-sectn img.w-100 {
    max-height: 200px !important;
  }
  .btn.contribute {
    padding: 3px 15px;
  }
  .btn.contribute .txt {
    font-size: 0.86rem;
  }
  .btn.contribute img {
    height: 26px;
  }
  .ModalViewContainer .bg-dark button.left-10 svg {
    left: 2px;
    top: 3px;
    position: absolute;
  }
  .ModalViewContainer .bg-dark button.right-10 svg {
    position: absolute;
    top: 3px;
    right: 2px;
    -webkit-top: 5px;
    -webkit-right: 5px;
  }
  .item-lst {
    border: 1px solid #e1e1e1;
  }
}

@media (min-width: 375px) and (max-width: 767px) {
  .container-sm,
  .container {
    max-width: 750px !important;
  }
  .col-xs-3 {
    flex: 0 0 auto;
    width: 25% !important;
  }
  .col-xs-4 {
    flex: 0 0 auto;
    width: 33.33333333% !important;
  }
  .col-xs-7 {
    flex: 0 0 auto;
    width: 58.33333333% !important;
  }
  .col-xs-8 {
    flex: 0 0 auto;
    width: 66.66666667% !important;
  }
  .order-xs-1 {
    order: 1 !important;
  }
  .order-xs-2 {
    order: 2 !important;
  }
  .order-xs-3 {
    order: 3 !important;
  }
  .order-xs-4 {
    order: 4 !important;
  }
  .order-xs-5 {
    order: 5!.cate-prod .accordion .justify-content-evenly important;
  }
  /*.cate-prod .accordion {display: flex;justify-content: space-around!important;}*/
  .cate-prod {
    margin-top: 10px;
    border-bottom: 1px solid #e1e1e1;
    padding-bottom: 20px;
  }
  .cate-prod .accordion .justify-content-evenly {
    justify-content: flex-start !important;
  }
  .cate-prod .accordion .justify-content-evenly h2.accordion-header {
    margin-right: 20px;
  }
  .cate-prod .accordion .accordion-item {
  }
  .cate-prod .accordion .accordion-item .accordion-body {
    padding: 0;
  }
  .cate-prod .accordion .collapse:not(.show) {
    display: none;
  }
  .cate-prod .accordion .accordion-button {
    background-color: #009a59;
    padding: 5px 20px;
    border-radius: 10px;
    color: #fff;
    display: inline-block;
    margin-bottom: 15px;
    font-weight: 500;
    font-size: 18px;
  }
  .cate-prod .accordion .accordion-button:focus {
    box-shadow: 0 0 0 0.25rem rgb(12 171 107 / 25%);
  }
  .cate-prod .accordion .accordion-button.collapsed {
    background-color: transparent;
    color: #009a59;
    border: 1px solid #009a59;
  }
  .cate-prod .accordion .accordion-body .filter-sectn {
    border-top: none;
    margin-top: 0;
    padding-top: 0;
  }
  .price-inp {
    margin-top: 28px;
  }
  .profile-page.container {
    max-width: 100% !important;
    padding: 0 10px;
  }
  .custom-select {
    margin-bottom: 8px;
  }
  .profile-page.container .btn.btn-danger {
    margin-top: 10px;
  }
  .interve-box.justify-content-between {
    justify-content: flex-start !important;
  }
  .interve-box.justify-content-between .interve-btn {
    margin-right: 20px;
  }

  .weather-details .lt-side {
    margin-bottom: 10px;
  } /*
  .weather-details .lt-side .wth-main *{color: #fff;}*/
  .weather-details .lt-side .weath-img {
    width: 38%;
    margin-left: 0;
    margin-top: inherit;
    margin-right: 1.5rem;
  }
  .weather-details .lt-side .wth-main .time-today {
    text-align: left;
  }
  .weather-details .lt-side .select-style:after {
    border-top: 6px solid #d9d9d9;
  }
  /*.weather-details .lt-side .wth-main .text-secondary, .weather-details .lt-side .wth-main .icon-weather01, .weather-details .lt-side .wth-main .icon-rainpre{color:#fff!important;}*/
  .weather-details .lt-side .wth-main .inf-cnt {
    display: flex;
    align-items: center;
  }
  .weather-details .lt-side .wth-main .inf-cnt .temp {
    font-size: 3.5rem;
    margin-bottom: -0.28rem;
  }
  .weather-details .lt-side .temp sup {
    ont-size: 1.5rem;
    top: -2rem;
  }
  .weather-details .rt-side .row-cols-3 > * {
    width: 50%;
  }
  .weather-details .rt-side .lst-stt .numb {
    font-size: 1.5rem;
    margin-left: 6px;
  }
  .weather-details .rt-side .lst-stt .unit {
    font-size: 0.9rem;
  }
  .weather-details .rt-side .lst-stt .unit sup {
    top: -0.6rem;
  }
  .weather-details .rt-side .lst-hrs img {
    height: 1.68rem;
  }
  .weather-details .rt-side .lst-hrs .temp .fs-5 {
    font-size: 1.15rem !important;
  }
  .weather-details .rt-side .lst-hrs .temp small {
    font-size: 70% !important;
  }
  .weather-details .rt-side h5.title-line {
    font-size: 1.16rem;
  }
  .weather-details .rt-side .title-line:before {
    height: 1.5rem;
  }
  .weather-details .rt-side .table th {
    padding-left: 0;
    padding-right: 0;
    font-size: 0.9rem;
  }
  .weather-details .rt-side .table .text-secondary small,
  .weather-details .rt-side .table small.text-secondary {
    font-size: 0.8rem;
  }
  .weather-details .rt-side .table .wth-stt {
    font-size: 0.85rem;
    font-weight: 500;
  }
  .weather-details .rt-side .table.table-hover tbody tr img {
    height: 1.8rem;
  }
  .weather-details .rt-side .fs-6 {
    font-size: 0.9rem !important;
  }
  .weather-details .rt-side .lst-hrs .box-cnt,
  .weather-details .rt-side .lst-stt .box-cnt {
    border-radius: 2px;
    padding: 10px 5px;
    margin-bottom: 5px;
  }
  .weather-details .rt-side .lst-stt .box-cnt .align-items-center {
    height: 36px;
  }
  .weather-details .rt-side .lst-hrs .box-cnt .mb-2,
  .weather-details .rt-side .lst-stt .box-cnt .mb-2 {
    margin-bottom: 0.2rem !important;
  }
  .weather-details .rt-side .lst-stt .icon-pinwheel {
    font-size: 1.8rem;
  }
  .weather-details .rt-side .lst-stt img.sunrise {
    width: 2rem;
  }
  .weather-details .rt-side .lst-stt .icon-humidity {
    font-size: 1.8rem;
  }
  .weather-details .rt-side .lst-stt .icon-sunset {
    font-size: 1.45rem;
  }
  .weather-details .rt-side .lst-stt img.high-temp,
  .weather-details .rt-side .lst-stt img.low-temp {
    width: 1.13rem;
  }
  .title-top {
    margin-top: 5px;
  }
  /*.pro-tech-lst .arg-type-step {margin-top: 0px;}*/
  .news-sectn .main-news .img-cover {
    height: 240px !important;
  }
}

@media (min-width: 326px) and (max-width: 575px) {
  .row > .col-xs-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .row > .col-xs-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .row > .col-xs-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .row > .col-xs-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row > .col-xs-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .row > .col-xs-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .row > .col-xs-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .row > .col-xs-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .row > .col-xs-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .row > .col-xs-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .row > .col-xs-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .row > .col-xs-12 {
    flex: 0 0 auto;
    width: 100%;
  }

  .mkt-price .tab-content .row-cols-2 > * {
    width: 100%;
  }

  .posted-inf .fw-semibold {
    font-weight: 500 !important;
    font-size: 0.86rem;
  }
  /*.post-box .posted-inf .fav-ctrl [class^="icon-"], .post-box .posted-inf .fav-ctrl [class*=" icon-"] {font-size: 18px;}
  .post-box .posted-inf .fav-ctrl .icon-comment-line, .post-box .posted-inf .fav-ctrl .icon-share01{font-size: 15px;}*/

  .post-box .inpt-cntn textarea {
    height: 77px;
    padding-left: 50px;
    padding-top: 10px;
  }
  .bg-img-orgnal.avtar50 {
    height: 35px;
    width: 35px;
    left: 10px;
    top: 10px;
    padding-top: 35px;
  }
  .cmt-listing {
    padding: 0 6px;
  }
  .cmt-listing .bg-img-orgnal.avtar45 {
    height: 35px;
    width: 35px;
    padding-top: 33px;
  }

  .user-inf {
    padding: 0px;
  }
  .cmt-listing .img-cmt-box {
    transform: translate(5px, -1px);
  }
  .cmt-listing .user-inf input {
    width: 100%;
  }
  .cmt-listing p.txt-cmt,
  .cmt-listing .actions,
  .cmt-listing .box-child-cmt .text-area-child-cmt-big,
  .cmt-listing .box-child-cmt .text-area-child-cmt,
  .box-child-edit .text-area-child-cmt-big {
    margin-left: 0;
  }
  .cmt-listing [class^='list-sub-comment-'] p.txt-cmt,
  .cmt-listing [class^='list-sub-comment-'] .actions {
    margin-left: 46px;
  }

  .img-cmt-box {
    transform: translate(8px, -1px);
  }
  .cmt-listing [class^='list-sub-comment-'] .user-inf,
  .cmt-listing [class*=' list-sub-comment-'] .user-inf {
    margin-left: 0px;
  }
  .cmt-listing [class^='list-sub-comment-']:before,
  .cmt-listing [class*=' list-sub-comment-']:before {
    width: calc(100% - 0px);
    left: 0px;
  }
  .cmt-listing .mt-3:first-child {
    margin-top: 0 !important;
  }
  .mkt-price-hist .fs-5 {
    font-size: 1rem !important;
  }
  .mkt-price-hist .table thead th {
    font-size: 0.85rem;
  }
  .mkt-price .btn.contribute,
  .mkt-price .btn.contribute .icon-bonus {
    font-size: 1.15rem;
    min-width: 133px;
  }
  .mkt-price .text-center {
    text-align: left !important;
  }
  .mkt-price .pro-tech-lst .arg-type-main .text-center {
    text-align: center !important;
  }
  .mkt-price button.text-center {
    text-align: center !important;
  }
  .date-picker .react-datepicker-wrapper {
    max-width: 100% !important;
  }

  .home-wrapper .posts-sectn .inf-post .poster-txt,
  .home-wrapper .posts-sectn .inf-post .user-act {
    padding: 10px;
  }
  /*.home-wrapper .posts-sectn .inf-post .user-act img.avtar{display: none;}*/
  .home-wrapper .posts-sectn .inf-post .user-act .ml-auto .ml-3 {
    margin-left: 9px !important;
  }
  .home-wrapper .posts-sectn .carousel.slide .carousel-indicators button {
    width: 8px;
    height: 8px;
  }
  .home-wrapper .posts-sectn .inf-post .user-act .post-inf.d-flex {
    display: block !important;
  }
  .home-wrapper .posts-sectn .inf-post .user-act img.avtar {
    height: 28px;
    width: 28px;
  }
  .home-wrapper .posts-sectn .inf-post .user-act .name-txt {
    display: block;
  }
  .home-wrapper .posts-sectn .inf-post .user-act.d-flex {
    display: block !important;
    z-index: 9;
    position: relative;
  }
  .home-wrapper .posts-sectn .inf-post .user-act.d-flex .ml-auto {
    margin-left: auto !important;
    margin-top: 5px;
  }
  .title-top div > .text-center {
    margin-bottom: -10px;
  }
  .btn-style {
    margin-bottom: 2px;
    padding-right: 50px;
  }
  .btn-style .btn-txt {
    height: 33px;
    line-height: 33px;
    font-size: 0.9rem;
    padding: 0 0 0 13px;
  }
  .btn-style .arrow {
    width: 13px;
    height: 13px;
    right: 13px;
    top: 11px;
  }
  .title-top .fs-3.second-clr {
    font-size: 1.4rem !important;
  }
  .btn-style span.shape {
    right: -68px;
  }
  h5.title-line-lt,
  h4.title-line-lt {
    font-size: 1.16rem;
  }
  h4.title-line-lt:before {
    height: 25px;
    top: -2px;
  }
  .title-line-lt:before {
    height: 25px;
  }
  .ql-container.ql-snow .ql-tooltip {
    position: static;
    margin-bottom: 10px;
  }
  /*.row > .col{margin-right: -8px;margin-left: -8px;}*/
  .member_rate_in_month.text-end {
    margin-top: -35px;
  }
  .member_rate_in_month.text-end + .post-report.ms-auto {
    position: absolute;
    right: 8px;
    top: -75px;
  }
  .ModalViewContainer .bg-dark button.right-10 svg {
    -webkit-position: relative;
  }
  .ModalViewContainer .bg-dark button.right-10 svg path {
    position: absolute;
    right: 0px;
    top: 3px;
    -webkit-top: 3px;
    -webkit-position: absolute; /* Safari specific prefix */
    -webkit-right: 10px; /* Safari specific prefix */
  }
}

@media (min-width: 280px) and (max-width: 440px) {
  .row > .col-2xs-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .row > .col-2xs-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .row > .col-2xs-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .row > .col-2xs-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row > .col-2xs-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .row > .col-2xs-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .row > .col-2xs-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .row > .col-2xs-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .row > .col-2xs-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .row > .col-2xs-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .row > .col-2xs-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .row > .col-2xs-12 {
    flex: 0 0 auto;
    width: 100% !important;
  }
  .mkt-price-details .location.float-end {
    float: left !important;
    margin-top: 10px;
  }
  .mkt-price-hist > .d-flex.align-items-center,
  .sharing-box.d-flex.justify-content-between {
    display: block !important;
  }
  .mkt-price-hist > .d-flex .ms-auto,
  .sharing-box .list-socials {
    margin-top: 10px;
    margin-bottom: 15px;
  }
  .sharing-box .list_tags {
    width: 100%;
  }
  /*header .cate-sectn [class^="icon-"], header .cate-sectn [class*=" icon-"]{height: 30px;}
  header .cate-sectn .active [class^="icon-"], header .cate-sectn .active [class*=" icon-"]{position: relative;}
  header .cate-sectn [class^="icon-"] {font-size: 24px;}
  header .cate-sectn .active [class^="icon-"]:after, header .cate-sectn .active [class*=" icon-"]:after{position: absolute; bottom: -13px;content: "";height: 3px;left: -5px;width: calc(100% + 10px);background-color: orange;}
  header .cate-sectn .icon-menu-main,
  header .cate-sectn .icon-more-menu {font-size: 20px;}
  header .cate-sectn .icon-price-menu {font-size: 32px;}
  header .cate-sectn .icon-news02 {font-size: 30px;}
  header .cate-sectn .icon-price-menu {font-size: 30px;}
  header .cate-sectn .icon-home {font-size: 29px;}
  header .cate-sectn .icon-news02{font-size: 28px;}
  header .cate-sectn .icon-triangle-line{font-size: 24px;}
  header .cate-sectn .icon-farmer-market{font-size: 23px;}*/
  .weather-details .rt-side .lst-hrs .col,
  .weather-details .rt-side .lst-stt .col {
    margin-left: 0;
    margin-right: 0;
  }
  .mkt-price .tab-content .row-cols-2 > * {
    margin-right: 0;
    margin-left: 0;
  }
  .mkt-price .btn.contribute {
    padding: 3px 13px;
  }
  .mkt-price .w-100.text-center h4 {
    font-size: 1.15rem;
  }
  .mkt-price .search-box form {
    width: 100%;
  }
  .mkt-price .search-box .row .btn-pd[class^='col-'],
  .search-box .row .btn-pd[class*=' col-'] {
    padding-right: 4px;
    padding-left: 4px;
  }
  .mkt-price .tab-content .row-cols-2 > * {
    width: 100%;
  }
  .mkt-price .tab-content .lst-item .prod-price .fs-4 {
    font-size: 1.1rem !important;
    font-weight: 600 !important;
  }
  .mkt-price .search-box {
    padding: 15px;
  }
  .saved-items .nav-tabs .nav-item .nav-link,
  .nav-mkt-price .nav-item .nav-link {
    padding: 5px 0px;
    font-size: 0.95rem;
    font-weight: 600;
  }

  .mkt-price-details .share-txt {
    display: none;
  }
  .mkt-price-details .share-txt {
    display: block;
  }
  /*.mkt-price-details h4.title-line-lt{display: none;}*/
  .mkt-price-details .d-flex.align-items-center {
    display: block !important;
  }
  .mkt-price-details .title-line-lt.text-uppercase {
    margin-bottom: 10px;
  }
  .mkt-price-details .prod-gctt-inf {
    padding: 12px 0 15px !important;
  }
  .mkt-price-details .prod-gctt-inf .img-inf {
    display: none;
  }
  .mkt-price-details .prod-gctt-inf .img-inf img {
    height: 70px;
    width: 80px;
  }
  .mkt-price-details .prod-gctt-inf .img-inf.me-3 {
    margin-right: 10px !important;
  }
  .mkt-price-details .prod-gctt-inf .lst-item-detail {
    align-items: center;
  }
  .mkt-price-details .prod-gctt-inf .lst-item-detail .like-price-icon,
  .prod-gctt-inf .lst-item-detail .like-price-icon-active {
    margin-top: 12px;
    font-size: 16px;
    padding: 5px 13px;
  }
  .weather-details .rt-side .table.table-hover tbody td:nth-of-type(1) {
    display: none;
  }
  .weather-details .rt-side .table.table-hover tbody td .icon-temp.fs-5 {
    font-size: 1.1rem !important;
  }

  .search-top input {
    width: calc(100% - 20px);
  }
  .FormAddEditProduct.card .card-body .col-2 {
    width: 50%;
  }
  .NewFeedActions .NewFeedActionButton span {
    display: inline-block;
  }
  .NewFeedActions .NewFeedActionButton:hover {
    background-color: transparent;
  }
  .news-sectn .main-news .img-cover {
    height: 190px !important;
  }
  .post-box .text-end {
    text-align: left !important;
    margin-top: 5px;
  }
  .post-box .pin_droplist {
    position: absolute;
    top: -72px;
    right: 10px;
  }
  .post-box .pin_droplist .pin-icon {
    width: 20px;
  }
}
@media (max-width: 374px) {
  header .cate-sectn [class^='icon-'] {
    font-size: 23px;
  }
  header .cate-sectn .icon-price-menu {
    font-size: 27px;
  }
  header .cate-sectn .icon-home,
  header .cate-sectn .icon-news02 {
    font-size: 28px;
  }
  header .cate-sectn .icon-triangle-line,
  header .cate-sectn .icon-farmer-market {
    font-size: 24px;
  }
  .post-box .posted-inf .fav-ctrl {
    height: 68px;
  }
  .post-box .posted-inf .fav-ctrl div.d-flex.align-items-center {
    display: block !important;
    text-align: center;
    margin-top: 8px;
  }
  .post-box .posted-inf .fav-ctrl div.d-flex.align-items-center span {
    display: block;
    height: 26px;
  }
  .post-box .posted-inf .fav-ctrl div.d-flex.align-items-center span.txt {
    font-size: 13px;
  }
  .post-box .posted-inf .fav-ctrl .share .dropdown button {
    padding: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/normalize.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,4CAA2C;EAC3C;;;;;uEAK2E;EAC3E,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,+CAA+C;EAC/C,4CAA0F;EAC1F;;;;;;;2DAOuG;EACvG,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,4CAA4C;EAC5C,6CAAoF;EACpF;;;;;;2DAMiG;EACjG,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,6CAAiD;EACjD;;;;0DAIqE;EACrE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,+EAA+E;EAC/E,kCAAkC;EAClC,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,cAAc;;EAEd,sCAAsC;EACtC,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,iBAAiB;AACnB;AACA;;EAEE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,2BAA2B;EAC3B,YAAY;EACZ,UAAU;AACZ;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;AACA;;EAEE,oBAAoB;AACtB;AACA;;EAEE,sBAAsB;AACxB;AACA;EACE,SAAS;EACT,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,eAAe;AACjB;AACA;EACE,SAAS;EACT,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,cAAc;AAChB;AACA;EACE,SAAS;EACT,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,cAAc;AAChB;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,4CAA4C;AAC9C;;AAEA;;EAEE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;AACtC;AACA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,yDAAyD;EACzD,wDAAwD;AAC1D;;AAEA;EACE,UAAU;EACV,SAAS;EACT,oCAAoC;EACpC,iCAAiC;EACjC;qCACmC;EACnC,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,mCAAmC;EACnC,kCAAkC;EAClC,qBAAqB;AACvB;AACA;;EAEE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;;EAEE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;;;;EAKE;AACF;EACE,mBAAmB;AACrB;AACA,gDAAgD;AAChD;EACE,iCAAiC;AACnC;AACA;EACE,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,8BAA8B;AAChC;AACA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;;EAEE,gCAAgC;EAChC,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;yBACyB;;AAEzB;cACc;AACd;;EAEE;;sCAEoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;EAEE,yCAAyC;EACzC,yBAAyB;EACzB,eAAe;EACf,UAAU,EAAE,YAAY;AAC1B;AACA;;EAEE,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,UAAU;AACZ;AACA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;AACvB;AACA;EACE,yCAAyC;EACzC,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,UAAU,EAAE,YAAY;AAC1B;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,UAAU;EACV,kBAAkB;AACpB;AACA,6CAA6C;AAC7C;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,iBAAiB;EACjB,oCAAoC;EACpC,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,iBAAiB;EACjB,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;AAClC;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,uBAAuB;EACvB,qCAAqC;EACrC,gBAAgB;EAChB,oCAAoC;EACpC,qBAAqB;EACrB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,iCAAiC;EACjC,6CAA6C;EAC7C,uCAAuC;EACvC,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,iBAAiB;EACjB,iCAAiC;EACjC,mCAAmC;EACnC,uCAAuC;EACvC,yBAAyB;AAC3B;AACA;EACE,mCAAmC;EACnC,qEAAsE;AACxE;AACA;EACE,YAAY;AACd;AACA;;;;EAIE,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;AACtB;AACA;EACE,YAAY;EACZ,WAAW;EACX,UAAU;EACV,SAAS;EACT,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,WAAW;EACX,UAAU;EACV,SAAS;EACT,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,WAAW;EACX,UAAU;EACV,SAAS;EACT,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,YAAY;EACZ,UAAU;EACV,SAAS;EACT,oBAAoB;EACpB,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,WAAW;EACX,SAAS;EACT,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,WAAW;EACX,SAAS;EACT,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;EACpB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB,EAAE,gBAAgB;EACzC,6BAA6B;EAC7B,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;EACpB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,6BAA6B;EAC7B,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,+BAA+B;EAC/B,oCAAoC;EACpC,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,wBAAwB;EACxB,UAAU;AACZ;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,yBAAyB;AAC3B;AACA;EACE,UAAU;EACV,yBAAyB;EACzB,wBAAwB;AAC1B;AACA;EACE,OAAO;EACP,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,wBAAwB;EACxB,qBAAqB;AACvB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa,EAAE,gCAAgC;AACjD;AACA;EACE,cAAc;AAChB;AACA,6CAA6C;AAC7C;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,WAAW;EACX,QAAQ;EACR,SAAS;EACT,6BAA6B;EAC7B,yDAAyD;AAC3D;AACA,gEAAgE;AAChE;EACE,yDAAyD;EACzD,SAAS;AACX;AACA,0DAA0D;AAC1D;;EAEE,iBAAiB;EACjB,6BAA6B;EAC7B,qEAAqE;EACrE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;AACA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,yBAAyB;EACzB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,4CAA4C;EAC5C,yBAAyB;AAC3B;AACA,gDAAgD;AAChD;EACE,aAAa;AACf;AACA;;EAEE,2BAA2B;AAC7B;;AAEA;QACQ;AACR;EACE,yBAAyB;EACzB,gBAAgB;EAChB,8CAA8C;AAChD;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB,EAAE,oBAAoB;AAC1C;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,kCAAkC;EAClC,YAAY;AACd;AACA;EACE,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,UAAU;EACV,UAAU;AACZ;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,oBAAoB;EACpB,YAAY;EACZ,8BAA8B;EAC9B,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;+LAC+L;AAC/L;;EAEE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,QAAQ;EACR,WAAW;EACX,UAAU;EACV,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,UAAU;EACV,QAAQ;EACR,cAAc;EACd,eAAe;AACjB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,OAAO;EACP,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;AACA;EACE,YAAY;AACd;AACA;EACE,qBAAqB;AACvB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,6BAA6B;EAC7B,sCAAsC;EACtC,oBAAoB;EACpB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;EAChB,sCAAsC;AACxC;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,YAAY;AACd;AACA;;EAEE,yBAAyB;EACzB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA,sFAAsF;AACtF;EACE,WAAW;AACb;AACA;;EAEE,wCAAwC;EACxC,yBAAyB;EACzB,gBAAgB;EAChB,UAAU;EACV,YAAY;AACd;AACA;;;EAGE,wBAAwB;EACxB,oCAAoC;EACpC,2BAA2B;AAC7B;AACA;EACE,sBAAsB;EACtB,sCAAsC;EACtC,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;AACA;;EAEE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;;EAEE,eAAe;AACjB;AACA;;EAEE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;AACA;;EAEE,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,aAAa;AACf;AACA;EACE,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,2BAA2B;EAC3B,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;EACd,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,uBAAuB;EACvB,sCAAsC;EACtC,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,UAAU;EACV,oCAAoC;AACtC;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;EACf,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;EACzB,gCAAgC;AAClC;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,qCAAqC;EACrC,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,oBAAoB;EACtB;AACF;;AAEA,qBAAqB;AACrB;;EAEE,cAAc;EACd,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;;EAEE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,oBAAoB;EACpB,sBAAsB;AACxB;AACA;;EAEE,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,YAAY;EACZ,UAAU;EACV,yBAAyB;AAC3B;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;;EAEE,kBAAkB;AACpB;AACA;;EAEE,SAAS;EACT,YAAY;EACZ,UAAU;AACZ;AACA;EACE,aAAa;EACb,0BAA0B;AAC5B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mDAAmD;EACnD,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,qCAAqC;EACrC,SAAS;EACT,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,gBAAgB;EAChB,UAAU;EACV,cAAc;AAChB;AACA;;EAEE,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,sBAAsB;AACxB;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;AACA;EACE,+CAA+C;EAC/C,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,sBAAsB;EACtB,cAAc;EACd,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,gCAAgC;EAChC,kBAAkB;AACpB;AACA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;;;;EAIE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;AACf;AACA;EACE,YAAY;EACZ,UAAU;EACV,SAAS;EACT,wCAAwC;EACxC,YAAY;EACZ,oBAAoB;EACpB,wBAAwB;EACxB,UAAU;AACZ;AACA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,oBAAoB;EACpB,WAAW;EACX,SAAS;EACT,sBAAsB;EACtB,cAAc;EACd,sBAAsB;EACtB,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;AACf;AACA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;EACX,qBAAqB;AACvB;AACA;AACA;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;AACtB;AACA;EACE,oCAAoC;EACpC,oBAAoB;AACtB;AACA;;EAEE,gCAAgC;EAChC,yBAAyB;AAC3B;AACA;;EAEE,WAAW;EACX,OAAO;AACT;AACA;EACE,SAAS;EACT,WAAW;AACb;AACA;EACE,2BAA2B,EAAE,gBAAgB;EAC7C,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,wCAAwC;EACxC,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,MAAM;EACN,WAAW;EACX,WAAW;EACX,aAAa;EACb,2BAA2B;EAC3B,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,WAAW;EACX,OAAO;EACP,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;EAClB,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,oBAAoB;AACtB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,YAAY;AACd;;AAEA,gFAAgF;AAChF;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,iCAAiC;EACjC,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,WAAW;EACX,2BAA2B;EAC3B,wBAAwB;EACxB,6BAA6B;EAC7B,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,iBAAiB;EACjB,wBAAwB;EACxB,sCAAsC;EACtC,gBAAgB;EAChB,qCAAqC;EACrC,WAAW;AACb;AACA;;EAEE,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;;;EAGE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,+BAA+B;EAC/B,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;AACf;AACA;;EAEE,eAAe;EACf,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;;EAEE,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,iCAAiC;AACnC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,WAAW;EACX,oBAAoB;EACpB,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,uBAAuB;EACvB,eAAe;AACjB;AACA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,yBAAyB;AAC3B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,sBAAsB;EACtB,4BAA4B;EAC5B,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA;;;EAGE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,WAAW;EACX,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,sCAAsC;AACxC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,YAAY;AACd;AACA;EACE,oBAAoB;AACtB;AACA;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;EACX,sEAAsE;AACxE;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,YAAY;EACZ,WAAW;EACX,SAAS;EACT,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;AAC3B;AACA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,oBAAoB;AACtB;AACA,sDAAsD;AACtD;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;;EAEE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,gCAAgC;EAChC,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,0BAA0B;AAC5B;AACA;;;EAGE,qBAAqB;EACrB,cAAc;EACd,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;;;;;;;EAOE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,2BAA2B;EAC3B,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,YAAY;EACZ,WAAW;AACb;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,YAAY;EACZ,YAAY,EAAE,6BAA6B;EAC3C,kBAAkB;AACpB;AACA;EACE,0CAA0C;EAC1C,gBAAgB;AAClB;AACA;;GAEG;AACH;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,+BAA+B;EAC/B,2BAA2B;EAC3B,6BAA6B;AAC/B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gCAAgC;EAChC,YAAY;EACZ,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,oBAAoB;AACtB;AACA;;EAEE,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;;GAEG;;AAEH;;GAEG;AACH;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;AACd;;AAEA;;GAEG;;AAEH;;GAEG;;AAEH;EACE,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;;EAEE,2BAA2B;EAC3B,0CAA0C;EAC1C,aAAa;AACf;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;AACjB;AACA;;EAEE,iBAAiB;AACnB;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,gCAAgC;EAChC,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;AACA;;EAEE,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,sCAAsC;AACxC;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;EACtC,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,SAAS;EACT,wBAAwB;EACxB,WAAW;EACX,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gCAAgC;EAChC,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,8CAA8C;EAC9C,6CAA6C;EAC7C,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;EACd,YAAY;EACZ,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;;EAEE,sCAAsC;AACxC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,wBAAwB;EACxB,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,+CAA+C;EAC/C,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,cAAc;EACd,gBAAgB;AAClB;AACA;;EAEE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,sBAAsB;EACtB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,6BAA6B;AAC/B;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,sEAAsE;EACtE,YAAY;EACZ,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;;AAEA;;EAEE,kBAAkB;AACpB;AACA;;EAEE,YAAY;EACZ,WAAW;AACb;AACA;EACE,iCAAiC;EACjC,WAAW;EACX,gBAAgB;EAChB,mCAAmC;EACnC,kBAAkB;AACpB;AACA;EACE,UAAU;AACZ;AACA;EACE,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,gCAAgC;AAClC;AACA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;;AAEA,mDAAmD;AACnD;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;;EAEE,UAAU;EACV,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,gCAAgC;AAClC;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,6BAA6B;EAC7B,gCAAgC;AAClC;AACA;EACE,UAAU;EACV,SAAS;AACX;AACA;EACE,SAAS;EACT,UAAU;EACV,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,UAAU;AACZ;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yCAAyC;EACzC,sBAAsB;EACtB,eAAe;EACf,YAAY,EAAE,YAAY;AAC5B;AACA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,eAAe;EACf,WAAW;EACX,cAAc;EACd,oBAAoB;EACpB,WAAW;EACX,cAAc;AAChB;AACA;EACE,cAAc;EACd,gCAAgC;EAChC,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;EACtB,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,UAAU;EACV,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,OAAO;EACP,SAAS;AACX;AACA;EACE,cAAc;EACd,6BAA6B;EAC7B,oBAAoB;EACpB,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;AACX;AACA;EACE,aAAa;EACb,aAAa;EACb,YAAY;EACZ,oBAAoB;EACpB,iCAAiC;EACjC,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;AACA;;EAEE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,qCAAqC;EACrC,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB;AACA,wFAAwF;AACxF;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;;;EAGE,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,iCAAiC;EACjC,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,gCAAgC;EAChC,qDAAqD;AACvD;AACA;EACE,eAAe;EACf,qBAAqB;EACrB,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;AACA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,sEAAsE;EACtE,cAAc;EACd,yBAAyB;EACzB,eAAe;AACjB;AACA;;EAEE,8CAA8C;AAChD;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;AACA;;EAEE,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,aAAa;AACf;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,qBAAqB;EACrB,UAAU;EACV,iBAAiB;AACnB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,yCAAyC;EACzC,yBAAyB;EACzB,eAAe;EACf,6BAA6B;EAC7B,UAAU,EAAE,YAAY;AAC1B;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,6BAA6B;EAC7B,UAAU;AACZ;AACA;EACE,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;EACV,SAAS;EACT,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;;EAEE,2BAA2B;EAC3B,0CAA0C;EAC1C,aAAa;AACf;AACA;;EAEE,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;AACA;;EAEE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;;EAEE,iBAAiB;EACjB,iBAAiB;AACnB;AACA;;EAEE,WAAW;EACX,sBAAsB;EACtB,wBAAwB;EACxB,wBAAwB;EACxB,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,kBAAkB;AACpB;AACA;;EAEE,iBAAiB;AACnB;AACA,sJAAsJ;AACtJ;EACE,gCAAgC;AAClC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,wBAAwB;EACxB,aAAa;EACb,UAAU;EACV,6BAA6B;AAC/B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa,EAAE,sBAAsB;EACrC,qBAAqB;EACrB,oBAAoB;EACpB,sBAAsB;EACtB,mCAAmC;EACnC,sCAAsC;EACtC,0DAA6C;EAC7C,2BAA2B;EAC3B,wBAAwB;EACxB,4BAA4B;AAC9B;AACA;EACE,qBAAqB;EACrB,0DAA6C;AAC/C;AACA;EACE,qBAAqB;EACrB,0DAA6C;AAC/C;AACA;EACE;IACE,UAAU;IACV,sCAAsC;EACxC;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,uBAAuB;EACvB,uBAAuB;EACvB,sBAAsB;EACtB,kCAAkC;EAClC,mCAAmC;EACnC,8BAA8B;EAC9B,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,+BAA+B;EAC/B,8BAA8B;EAC9B,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,SAAS;EACT,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,aAAa;EACb,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,oCAAoC;EACtC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,uBAAuB;EACzB;AACF;;AAEA,2EAA2E;;AAE3E;EACE,oBAAoB,EAAE,2EAA2E;EACjG,oBAAoB;EACpB,mDAAmD;EACnD,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;EACrB,oCAAoC;EACpC,4BAA4B;EAC5B,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,iCAAiC;EACjC,qBAAqB;EACrB,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mDAAmD;AACrD;AACA;EACE,mDAAmD;EACnD,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;AACjB;AACA,oJAAoJ;AACpJ;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,eAAe,EAAE,6BAA6B;EAC9C,gBAAgB;EAChB,4CAA4C,EAAE,iCAAiC;EAC/E,oBAAoB;EACpB,yBAAyB;EACzB,6BAA6B;EAC7B,oBAAoB;EACpB,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,2CAA2C;EAC3C,mCAAmC;EACnC,2BAA2B;AAC7B;AACA;EACE,2BAA2B;EAC3B,6CAA6C;EAC7C,qCAAqC;AACvC;AACA;;;;;;;;;EASE;AACF;EACE;IACE,8BAA8B;EAChC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,8BAA8B;EAChC;AACF;AACA;EACE;IACE,8BAA8B;EAChC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,8BAA8B;EAChC;AACF;;AAEA,2BAA2B;AAC3B;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,gCAAgC;EAChC,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;;;;EAIE,WAAW;EACX,eAAe;AACjB;AACA;;EAEE,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;;;;;;;;;;;EAWE;AACF;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,eAAe;EACf,eAAe;AACjB;AACA;EACE,yBAAyB,EAAE,6BAA6B;EACxD,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,YAAY;AACd;AACA,4DAA4D;;AAE5D;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB;2BACyB;EACzB,iBAAiB;EACjB,qBAAqB;EACrB,2BAA2B;EAC3B,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;;;EAGE,yBAAyB;EACzB,0CAA0C;AAC5C;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,iBAAiB;EACjB,iCAAiC;EACjC,mCAAmC;EACnC,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;AACjC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,OAAO;EACP,YAAY;EACZ,WAAW;EACX,MAAM;EACN,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE;0BACwB;EACxB,gCAAgC;EAChC,6BAA6B;EAC7B,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,6BAA6B;AAC/B;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,6BAA6B;EAC7B,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gCAAgC;EAChC,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,sCAAsC;EACtC,iCAAiC;EACjC,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;EACpB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,0BAA0B;EAC1B,gCAAgC;AAClC;AACA;EACE,6BAA6B;AAC/B;AACA;;EAEE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,UAAU;EACV,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,YAAY;EACZ,4BAA4B;EAC5B,0BAA0B;AAC5B;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,eAAe;EACf,gCAAgC;EAChC,eAAe;EACf,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;;EAEE,8CAA8C;EAC9C,6CAA6C;AAC/C;;AAEA;EACE,kCAAkC;EAClC,sBAAsB;EACtB,0BAA0B;EAC1B,eAAe;AACjB;AACA;;EAEE,gBAAgB;EAChB,iBAAiB;EACjB,oCAAoC;AACtC;AACA;;EAEE,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;;EAEE,cAAc;EACd,kCAAkC;EAClC,WAAW;AACb;AACA;;EAEE,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,iCAAiC;EACjC,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,aAAa;EACb,wCAAwC;EACxC,cAAc;EACd,SAAS;EACT,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;EACvB,8BAA8B;EAC9B,2BAA2B;EAC3B,wBAAwB;AAC1B;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,eAAe;EACf,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,sCAAsC;AACxC;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB,+FAA+F;AACjG;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,yCAAyC;EACzC,6CAA6C;AAC/C;AACA;EACE,sCAAsC;EACtC,0BAA0B;AAC5B;AACA;EACE,iCAAiC;EACjC,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,mCAAmC;AACrC;AACA;EACE,YAAY;EACZ,UAAU;EACV,WAAW;EACX,UAAU;EACV,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,+BAA+B;AAC/B,uIAAuI;AACvI;EACE,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,sCAAsC;EACtC,mBAAmB;AACrB;AACA;EACE,6BAA6B;EAC7B,kBAAkB;AACpB;AACA;EACE,kBAAkB,EAAE,gBAAgB;AACtC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,2BAA2B;AAC7B;AACA;CACC;AACD;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,sCAAsC;EACtC,sBAAsB;EACtB,UAAU;AACZ;AACA,gVAAgV;AAChV;CACC,EAAE;yFACsF;;AAEzF,oGAAoG;AACpG,sJAAsJ;AACtJ,mDAAmD;AACnD;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;AACA;CACC;AACD;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,UAAU;AACZ;AACA;CACC;AACD;EACE,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,yBAAyB;EACzB,cAAc;EACd,2BAA2B;EAC3B,sCAAsC;EACtC,QAAQ;EACR,UAAU;EACV,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,QAAQ;EACR,UAAU;EACV,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;AACA;AACA;AACA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,cAAc;EACd,uBAAuB;EACvB,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,oCAAoC;AACtC;AACA;EACE,YAAY;EACZ,WAAW;EACX,oBAAoB;EACpB,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,eAAe;EACf,6BAA6B;EAC7B,gCAAgC;EAChC,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,yBAAyB;AAC3B;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;AACA;EACE,sBAAsB;EACtB,iBAAiB;AACnB;AACA,4DAA4D;AAC5D;EACE,cAAc;AAChB;AACA;EACE,yBAAyB,EAAE,OAAO;EAClC,0BAA0B,EAAE,OAAO;EACnC,6BAA6B,EAAE,sBAAsB;EACrD,wBAAwB,EAAE,UAAU;EACpC,qBAAqB;EACrB,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,qDAAqD;AACvD;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,WAAW;EACX,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,mDAAmD;AACrD;;AAEA;;EAEE,kBAAkB;AACpB;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,4DAA4D;EAC5D,mCAAmC;AACrC;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,mCAAmC;EACnC,oCAAoC;EACpC,wBAAwB;EACxB,yBAAyB;EACzB,4EAA4E;EAC5E,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;AACA;EACE,wDAAwD;AAC1D;AACA;EACE,oEAAoE;EACpE,0DAAiD;EACjD,4BAA4B;EAC5B,sBAAsB;EACtB,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,oEAAoE;EACpE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,UAAU;EACV,OAAO;EACP,MAAM;EACN,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,6BAA6B;AAC/B;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB,EAAE,kCAAkC,EAAE,+DAA+D;EACxH,6BAA6B;EAC7B,cAAc;AAChB;AACA;;EAEE,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,sBAAsB;EACtB,oCAAoC;EACpC,wBAAwB;EACxB,6BAA6B;AAC/B;AACA;EACE,mBAAmB;AACrB;AACA,qKAAqK;AACrK;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,6BAA6B;EAC7B,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,QAAQ;IACR,SAAS;IACT,qBAAqB;IACrB,6CAA6C;EAC/C;EACA;IACE,YAAY;IACZ,SAAS;IACT,6CAA6C;EAC/C;EACA;IACE,YAAY;IACZ,aAAa;IACb,qBAAqB;IACrB,kDAAkD;EACpD;AACF;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA,gCAAgC;AAChC;EACE,wCAAwC;EACxC,2BAA2B;AAC7B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,sCAAsC;EACtC,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,cAAc;AAChB;AACA;;EAEE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;;EAEE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,SAAS;AACX;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,WAAW;AACb;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,0BAA0B;AAC5B;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,oBAAoB;AACtB;AACA;EACE,8CAA8C;AAChD;AACA;EACE,gFAAgF;EAChF,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,gCAAgC;AAClC;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;;;EAGE,cAAc;AAChB;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;;EAEE,oCAAoC;EACpC,aAAa;EACb,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,gDAAgD;AAClD;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;;AAEA,qFAAqF;AACrF;AACA;AACA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;EACnB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;;;EAGE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,4BAA4B;AAC9B;AACA;;;EAGE,yBAAyB;AAC3B;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,SAAS;EACT,mBAAmB;EACnB,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,yBAAyB;EACzB,sEAAsE;EACtE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,sEAAsE;AACxE;AACA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,oBAAoB;AACtB;AACA;;EAEE,oBAAoB;AACtB;;AAEA;;EAEE,yBAAyB;EACzB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA,8CAA8C;AAC9C;EACE,gCAAgC;EAChC,oBAAoB;AACtB;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,gBAAgB;AAClB;AACA;;EAEE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,qCAAqC;AACvC;AACA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe,EAAE,qCAAqC;EACtD,2BAA2B;AAC7B;;AAEA;EACE,cAAc,EAAE,2CAA2C;AAC7D;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,cAAc,EAAE,kCAAkC;AACpD;;;AAGA,4CAA4C;;AAE5C;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,uCAAuC;EACvC,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,uCAAuC;AACzC;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,YAAY;AACd;AACA;AACA;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA,kCAAkC;AAClC;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,wCAAwC;EACxC,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,0BAA0B;AAC5B;AACA;;EAEE,0BAA0B;AAC5B;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,6BAA6B;EAC7B,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;AACb;AACA;EACE,UAAU;EACV,iBAAiB;EACjB,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,eAAe;EACf,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;;EAEE,UAAU;EACV,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;;;;;;;;;EASE;AACF;EACE,0BAA0B;EAC1B,YAAY;EACZ,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;AACpB;AACA;;EAEE,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,MAAM;EACN,QAAQ;EACR,0BAA0B;AAC5B;AACA;;;EAGE,gBAAgB;EAChB,YAAY;EACZ,aAAa;AACf;AACA;EACE,oEAAoE;EACpE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,UAAU;EACV,OAAO;EACP,MAAM;EACN,kBAAkB;EAClB,YAAY;AACd;AACA;;EAEE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,6BAA6B;EAC7B,+BAA+B;AACjC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,2BAA2B;EAC3B,SAAS;EACT,SAAS;AACX;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,wDAAwD;AAC1D;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,4BAA4B;AAC9B;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gCAAgC;EAChC,yBAAyB;AAC3B;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;;EAEE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;;;;;;;;EAQE;AACF;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,iCAAiC;EACjC,wBAAwB;AAC1B;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;AAC7B;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;;AAEA,4BAA4B;AAC5B;EACE,yBAAyB;EACzB,mBAAmB;EACnB,2BAA2B;EAC3B,yBAAyB;EACzB,eAAe;EACf,qBAAqB;EACrB,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,6BAA6B;EAC7B,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,0CAA0C;EAC1C,uCAAuC;EACvC,qCAAqC;EACrC,kCAAkC;AACpC;AACA;EACE;IACE,yBAAyB;IACzB,mCAAmC;EACrC;EACA;IACE,yBAAyB;IACzB,oCAAoC;EACtC;EACA;IACE,yBAAyB;IACzB,mCAAmC;EACrC;AACF;;AAEA;EACE;IACE,yBAAyB;IACzB,gCAAgC;EAClC;EACA;IACE,yBAAyB;IACzB,iCAAiC;EACnC;EACA;IACE,yBAAyB;IACzB,gCAAgC;EAClC;AACF;;AAEA;EACE;IACE,yBAAyB;IACzB,2BAA2B;EAC7B;EACA;IACE,yBAAyB;IACzB,4BAA4B;EAC9B;EACA;IACE,yBAAyB;IACzB,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,yBAAyB;IACzB,2BAA2B;EAC7B;EACA;IACE,yBAAyB;IACzB,4BAA4B;EAC9B;EACA;IACE,yBAAyB;IACzB,2BAA2B;EAC7B;AACF;AACA,4BAA4B;;AAE5B;EACE,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,eAAe;EACf,oBAAoB;EACpB,yBAAyB;EACzB,qDAAqD;EACrD,oBAAoB;EACpB,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ;;gBAEc;EACd,WAAW;;EAEX;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,yBAAyB;EAC3B;AACF;;;AAGA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;AACA;AACA;;EAEE,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;EACnB,aAAa;EACb,QAAQ;AACV;AACA;EACE,SAAS;AACX;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;AACV;AACA;EACE,YAAY;EACZ,WAAW;EACX,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,eAAe;AACjB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,4BAA4B;AAC9B;AACA;EACE,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;iBACiB;AACjB;EACE;IACE,iBAAiB;EACnB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;EACpB;EACA;IACE,cAAc;EAChB;EACA;IACE,iBAAiB;EACnB;AACF;AACA;EACE;;;;;IAKE,WAAW;IACX,iBAAiB;IACjB,cAAc;EAChB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,yBAAyB;IACzB,qBAAqB;IACrB,iBAAiB;EACnB;AACF;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,WAAW;EACb;AACF;AACA;EACE;;IAEE,4BAA4B;EAC9B;EACA;IACE,WAAW;EACb;EACA;IACE,qBAAqB;IACrB,cAAc;EAChB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,uBAAuB;IACvB,gBAAgB;IAChB,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,eAAe;IACf,6BAA6B;EAC/B;;EAEA;IACE,WAAW;IACX,6BAA6B;IAC7B,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,6BAA6B;EAC/B;;EAEA;IACE,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA,yDAAyD;EACzD;IACE,aAAa;EACf;EACA;IACE,qBAAqB;EACvB;EACA;IACE,eAAe;IACf,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,mBAAmB;EACrB;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,SAAS;EACX;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,oCAAoC;IACpC,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,WAAW;IACX,oBAAoB;IACpB,iBAAiB;IACjB,iBAAiB;EACnB;EACA;IACE,cAAc;EAChB;EACA;IACE,QAAQ;EACV;EACA;IACE,oBAAoB;EACtB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,kBAAkB;IAClB,UAAU;EACZ;EACA;IACE,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,sBAAsB;IACtB,sBAAsB;IACtB,sCAAsC;IACtC,eAAe;IACf,6BAA6B;EAC/B;EACA,qGAAqG;EACrG;IACE,cAAc;IACd,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;EAChB;EACA;IACE,SAAS;IACT,UAAU;EACZ;EACA;IACE,gBAAgB;IAChB,SAAS;IACT,eAAe;IACf,gCAAgC;EAClC;EACA;IACE,mBAAmB;EACrB;EACA;IACE,cAAc;IACd,kBAAkB;IAClB,cAAc;IACd,iBAAiB;EACnB;EACA;IACE,yBAAyB;IACzB,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,UAAU;EACZ;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,mDAAmD;IACnD,yBAAyB;IACzB,oBAAoB;IACpB,gBAAgB;IAChB,WAAW;IACX,cAAc;IACd,gBAAgB;EAClB;EACA;IACE,oBAAoB;EACtB;;EAEA;;IAEE,YAAY;EACd;EACA;;IAEE,kBAAkB;EACpB;EACA;;IAEE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;;IAEE,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,WAAW;IACX,UAAU;IACV,wBAAwB;IACxB,wBAAwB;EAC1B;EACA;IACE,eAAe;IACf,UAAU;EACZ;EACA;;IAEE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;;IAEE,eAAe;EACjB;EACA;;IAEE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;EACA;IACE,mBAAmB;IACnB,aAAa;EACf;EACA;IACE,gBAAgB;IAChB,aAAa;EACf;EACA;IACE,oBAAoB;EACtB;EACA;;IAEE,UAAU;EACZ;;EAEA;IACE,0BAA0B;EAC5B;EACA;IACE,WAAW;EACb;EACA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,kCAAkC;IAClC,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;EACA;IACE,cAAc;EAChB;EACA;IACE,WAAW;EACb;EACA;IACE,qBAAqB;EACvB;EACA;;IAEE,cAAc;EAChB;EACA;IACE,uBAAuB;EACzB;;EAEA,iCAAiC;EACjC;IACE,gBAAgB;IAChB,aAAa;IACb,MAAM;IACN,mCAAmC;EACrC;EACA;IACE,sBAAsB;IACtB,aAAa;IACb,sCAAsC;IACtC,uBAAuB;IACvB,eAAe;IACf,4BAA4B;IAC5B,SAAS;EACX;EACA;IACE,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;EACpB;EACA;EACA;EACA;EACA;EACA;IACE,cAAc;IACd,gBAAgB;IAChB,oBAAoB;IACpB,iBAAiB;IACjB,sEAAsE;IACtE,sBAAsB;EACxB;EACA;IACE,SAAS;IACT,WAAW;IACX,eAAe;IACf,cAAc;EAChB;EACA;IACE,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA;IACE,SAAS;IACT,QAAQ;EACV;EACA;IACE,YAAY;IACZ,cAAc;EAChB;EACA;IACE,OAAO;EACT;EACA;IACE,eAAe;EACjB;EACA;;;IAGE,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,QAAQ;IACR,UAAU;IACV,UAAU;EACZ;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,YAAY;EACd;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,UAAU;EACZ;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,8BAA8B;EAChC;;EAEA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;EACA;IACE;uBACmB;IACnB,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,yBAAyB;IACzB,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,YAAY;EACd;EACA;IACE,6CAA6C;IAC7C,4CAA4C;EAC9C;EACA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;EACb;EACA;IACE,mBAAmB;EACrB;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,iBAAiB;IACjB,mCAAmC;EACrC;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gCAAgC;EAClC;EACA;IACE,qBAAqB;IACrB,cAAc;EAChB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;;IAEE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,6BAA6B;IAC7B,mBAAmB;EACrB;EACA;;IAEE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,YAAY;EACd;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,YAAY;EACd;EACA;IACE,SAAS;IACT,QAAQ;IACR,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,gBAAgB;IAChB,kBAAkB;EACpB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;;IAEE,2BAA2B;EAC7B;EACA;IACE,cAAc;IACd,qBAAqB;EACvB;EACA;IACE,cAAc;IACd,8BAA8B;EAChC;EACA;IACE,cAAc;IACd,8BAA8B;EAChC;EACA;IACE,cAAc;IACd,8BAA8B;EAChC;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gEAAgE;EAClE;EACA,iFAAiF;EACjF;IACE,gBAAgB;IAChB,gCAAgC;IAChC,oBAAoB;EACtB;EACA;IACE,sCAAsC;EACxC;EACA;IACE,kBAAkB;EACpB;EACA;EACA;EACA;IACE,UAAU;EACZ;EACA;IACE,aAAa;EACf;EACA;IACE,yBAAyB;IACzB,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;IACX,qBAAqB;IACrB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,+CAA+C;EACjD;EACA;IACE,6BAA6B;IAC7B,cAAc;IACd,yBAAyB;EAC3B;EACA;IACE,gBAAgB;IAChB,aAAa;IACb,cAAc;EAChB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,0BAA0B;IAC1B,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,sCAAsC;EACxC;EACA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB,EAAE;sDACkD;EACpD;IACE,UAAU;IACV,cAAc;IACd,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,6BAA6B;EAC/B;EACA,qLAAqL;EACrL;IACE,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,uBAAuB;EACzB;EACA;IACE,gBAAgB;IAChB,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,kBAAkB;EACpB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;EACA;;IAEE,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;EACA;IACE,4BAA4B;EAC9B;EACA;;IAEE,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,YAAY;EACd;EACA;;IAEE,gCAAgC;EAClC;EACA;IACE,iBAAiB;EACnB;EACA;IACE,WAAW;EACb;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;;IAEE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA,kDAAkD;EAClD;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,cAAc;IACd,kBAAkB;EACpB;EACA;IACE,cAAc;IACd,mBAAmB;EACrB;EACA;IACE,cAAc;IACd,UAAU;EACZ;EACA;IACE,cAAc;IACd,mBAAmB;EACrB;EACA;IACE,cAAc;IACd,mBAAmB;EACrB;EACA;IACE,cAAc;IACd,UAAU;EACZ;EACA;IACE,cAAc;IACd,mBAAmB;EACrB;EACA;IACE,cAAc;IACd,mBAAmB;EACrB;EACA;IACE,cAAc;IACd,UAAU;EACZ;EACA;IACE,cAAc;IACd,mBAAmB;EACrB;EACA;IACE,cAAc;IACd,mBAAmB;EACrB;EACA;IACE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,2BAA2B;IAC3B,kBAAkB;EACpB;EACA;sHACoH;;EAEpH;IACE,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;EACnB;EACA;IACE,YAAY;IACZ,WAAW;IACX,UAAU;IACV,SAAS;IACT,iBAAiB;EACnB;EACA;IACE,cAAc;EAChB;EACA;IACE,YAAY;IACZ,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;EACA;IACE,+BAA+B;EACjC;EACA;IACE,WAAW;EACb;EACA;;;;;IAKE,cAAc;EAChB;EACA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,+BAA+B;EACjC;EACA;;IAEE,gBAAgB;EAClB;EACA;;IAEE,uBAAuB;IACvB,SAAS;EACX;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,kBAAkB;EACpB;EACA;;IAEE,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,aAAa;EACf;EACA,2EAA2E;EAC3E;IACE,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,WAAW;EACb;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,cAAc;EAChB;EACA;IACE,yBAAyB;IACzB,UAAU;IACV,kBAAkB;EACpB;EACA;IACE,4BAA4B;IAC5B,eAAe;EACjB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,YAAY;IACZ,WAAW;IACX,SAAS;EACX;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,YAAY;EACd;EACA;;IAEE,kBAAkB;EACpB;EACA;IACE,YAAY;IACZ,SAAS;EACX;EACA;IACE,YAAY;EACd;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA,qDAAqD;EACrD;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,UAAU;EACZ;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,gBAAgB;IAChB,0BAA0B,EAAE,2BAA2B;IACvD,mBAAmB,EAAE,2BAA2B;EAClD;AACF;;AAEA;EACE;IACE,cAAc;IACd,kBAAkB;EACpB;EACA;IACE,cAAc;IACd,mBAAmB;EACrB;EACA;IACE,cAAc;IACd,UAAU;EACZ;EACA;IACE,cAAc;IACd,mBAAmB;EACrB;EACA;IACE,cAAc;IACd,mBAAmB;EACrB;EACA;IACE,cAAc;IACd,UAAU;EACZ;EACA;IACE,cAAc;IACd,mBAAmB;EACrB;EACA;IACE,cAAc;IACd,mBAAmB;EACrB;EACA;IACE,cAAc;IACd,UAAU;EACZ;EACA;IACE,cAAc;IACd,mBAAmB;EACrB;EACA;IACE,cAAc;IACd,mBAAmB;EACrB;EACA;IACE,cAAc;IACd,sBAAsB;EACxB;EACA;IACE,sBAAsB;IACtB,gBAAgB;EAClB;EACA;;IAEE,yBAAyB;EAC3B;EACA;;IAEE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,WAAW;EACb;EACA;;;;;;;;;;;;2DAYyD;EACzD;;IAEE,cAAc;IACd,eAAe;EACjB;EACA;IACE,eAAe;IACf,cAAc;EAChB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;;IAEE,kBAAkB;IAClB,iBAAiB;EACnB;EACA;IACE,WAAW;EACb;EACA;IACE,4BAA4B;IAC5B,2BAA2B;EAC7B;EACA;IACE,aAAa;EACf;EACA;;IAEE,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA,sDAAsD;EACtD;IACE,yBAAyB;EAC3B;EACA;IACE,mBAAmB;EACrB;EACA;IACE,+BAA+B;EACjC;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mBAAmB;EACrB;EACA;;IAEE,gBAAgB;IAChB,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;EACA;IACE,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;EAC1B;EACA;IACE,UAAU;EACZ;EACA;IACE,qBAAqB;EACvB;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;IAC3B,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;EACb;EACA;IACE,WAAW;EACb;AACF;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;;IAEE,eAAe;EACjB;EACA;;IAEE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,cAAc;IACd,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,UAAU;EACZ;AACF","sourcesContent":["@font-face {\r\n  font-family: 'UTMFuturaExtra';\r\n  src: url('../fonts/UTM/UTMFuturaExtra.eot');\r\n  src:\r\n    url('../fonts/UTM/UTMFuturaExtra.woff2') format('woff2'),\r\n    url('../fonts/UTM/UTMFuturaExtra.woff') format('woff'),\r\n    url('../fonts/UTM/UTMFuturaExtra.ttf') format('truetype'),\r\n    url('../fonts/UTM/UTMFuturaExtra.svg#Nunito-ExtraLight') format('svg'),\r\n    url('../fonts/UTM/UTMFuturaExtra.eot?#iefix') format('embedded-opentype');\r\n  font-weight: normal;\r\n  font-style: normal;\r\n}\r\n@font-face {\r\n  font-family: 'helvetica-neue-condensed-regular';\r\n  src: url('../fonts/helvetica-neue-condensed-regular/helvetica-neue-condensed-regular.eot');\r\n  src:\r\n    url('../fonts/helvetica-neue-condensed-regular/helvetica-neue-condensed-regular.eot?#iefix')\r\n      format('embedded-opentype'),\r\n    url('../fonts/helvetica-neue-condensed-regular/helvetica-neue-condensed-regular.woff2') format('woff2'),\r\n    url('../fonts/helvetica-neue-condensed-regular/helvetica-neue-condensed-regular.svg#helvetica-neue-condensed-regular')\r\n      format('svg'),\r\n    url('../fonts/helvetica-neue-condensed-regular/helvetica-neue-condensed-regular.ttf') format('truetype'),\r\n    url('../fonts/helvetica-neue-condensed-regular/helvetica-neue-condensed-regular.woff') format('woff');\r\n  font-weight: normal;\r\n  font-style: normal;\r\n}\r\n@font-face {\r\n  font-family: 'helvetica-neue-condensed-bold';\r\n  src: url('../fonts/helvetica-neue-condensed-bold/helvetica-neue-condensed-bold.eot');\r\n  src:\r\n    url('../fonts/helvetica-neue-condensed-bold/helvetica-neue-condensed-bold.eot?#iefix') format('embedded-opentype'),\r\n    url('../fonts/helvetica-neue-condensed-bold/helvetica-neue-condensed-bold.woff2') format('woff2'),\r\n    url('../fonts/helvetica-neue-condensed-bold/helvetica-neue-condensed-bold.svg#helvetica-neue-condensed-bold')\r\n      format('svg'),\r\n    url('../fonts/helvetica-neue-condensed-bold/helvetica-neue-condensed-bold.ttf') format('truetype'),\r\n    url('../fonts/helvetica-neue-condensed-bold/helvetica-neue-condensed-bold.woff') format('woff');\r\n  font-weight: normal;\r\n  font-style: normal;\r\n}\r\n\r\n@font-face {\r\n  font-family: 'iconfont';\r\n  src: url('../fonts/iconfont/iconfont.eot?mwn8k5');\r\n  src:\r\n    url('../fonts/iconfont/iconfont.eot?mwn8k5#iefix') format('embedded-opentype'),\r\n    url('../fonts/iconfont/iconfont.ttf?mwn8k5') format('truetype'),\r\n    url('../fonts/iconfont/iconfont.woff?mwn8k5') format('woff'),\r\n    url('../fonts/iconfont/iconfont.svg?mwn8k5#iconfont') format('svg');\r\n  font-weight: normal;\r\n  font-style: normal;\r\n  font-display: block;\r\n}\r\n\r\n[class^='icon-'],\r\n[class*=' icon-'] {\r\n  /* use !important to prevent issues with browser extensions that change fonts */\r\n  font-family: 'iconfont' !important;\r\n  speak: never;\r\n  font-style: normal;\r\n  font-weight: normal;\r\n  font-variant: normal;\r\n  text-transform: none;\r\n  line-height: 1;\r\n\r\n  /* Better Font Rendering =========== */\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n}\r\n\r\n.icon-audio:before {\r\n  content: '\\e950';\r\n}\r\n.icon-order:before {\r\n  content: '\\e951';\r\n}\r\n.icon-present:before {\r\n  content: '\\e952';\r\n}\r\n.icon-prod:before {\r\n  content: '\\e94f';\r\n}\r\n.icon-start-arrow:before {\r\n  content: '\\e94e';\r\n}\r\n.icon-eye-line01:before {\r\n  content: '\\e94d';\r\n}\r\n.icon-arrow-short:before {\r\n  content: '\\e94b';\r\n}\r\n.icon-arrow-long:before {\r\n  content: '\\e94c';\r\n}\r\n.icon-comment-line:before {\r\n  content: '\\e941';\r\n  color: #919191;\r\n}\r\n.icon-comment01:before {\r\n  content: '\\e942';\r\n}\r\n.icon-gift:before {\r\n  content: '\\e943';\r\n}\r\n.icon-like01:before {\r\n  content: '\\e944';\r\n}\r\n.icon-location-solid:before {\r\n  content: '\\e945';\r\n}\r\n.icon-location01:before {\r\n  content: '\\e946';\r\n}\r\n.icon-share01:before {\r\n  content: '\\e947';\r\n}\r\n.icon-share02:before {\r\n  content: '\\e948';\r\n}\r\n.icon-temp:before {\r\n  content: '\\e949';\r\n}\r\n.icon-user01:before {\r\n  content: '\\e94a';\r\n}\r\n.icon-status:before {\r\n  content: '\\e951';\r\n}\r\n.icon-get-gift:before {\r\n  content: '\\e940';\r\n}\r\n.icon-tech-process:before {\r\n  content: '\\e93d';\r\n}\r\n.icon-find-origin:before {\r\n  content: '\\e93e';\r\n}\r\n.icon-mix-npk:before {\r\n  content: '\\e93f';\r\n}\r\n.icon-tiktok:before {\r\n  content: '\\e939';\r\n  color: #540068;\r\n}\r\n.icon-facebook:before {\r\n  content: '\\e93a';\r\n  color: #1863f2;\r\n}\r\n.icon-youtube:before {\r\n  content: '\\e93b';\r\n  color: #ea412c;\r\n}\r\n.icon-zalo:before {\r\n  content: '\\e93c';\r\n  color: #007ac6;\r\n}\r\n.icon-eye-line:before {\r\n  content: '\\e938';\r\n}\r\n.icon-farmer-market:before {\r\n  content: '\\e935';\r\n}\r\n.icon-info-solid:before {\r\n  content: '\\e936';\r\n}\r\n.icon-question-mark:before {\r\n  content: '\\e937';\r\n}\r\n.icon-weather02:before {\r\n  content: '\\e934';\r\n}\r\n.icon-rainpre:before {\r\n  content: '\\e92f';\r\n}\r\n.icon-weather01:before {\r\n  content: '\\e930';\r\n}\r\n.icon-humidity:before {\r\n  content: '\\e931';\r\n}\r\n.icon-sunset:before {\r\n  content: '\\e932';\r\n}\r\n.icon-pinwheel:before {\r\n  content: '\\e933';\r\n}\r\n.icon-contact-channel:before {\r\n  content: '\\e92c';\r\n}\r\n.icon-video-call:before {\r\n  content: '\\e92d';\r\n}\r\n.icon-call:before {\r\n  content: '\\e92e';\r\n}\r\n.icon-bonus:before {\r\n  content: '\\e92b';\r\n}\r\n.icon-chart:before {\r\n  content: '\\e92a';\r\n}\r\n.icon-balance:before {\r\n  content: '\\e926';\r\n  color: #fab70c;\r\n}\r\n.icon-reduce:before {\r\n  content: '\\e927';\r\n  color: #fc4400;\r\n}\r\n.icon-increase:before {\r\n  content: '\\e928';\r\n  color: #1cc619;\r\n}\r\n.icon-time:before {\r\n  content: '\\e929';\r\n  color: #919191;\r\n}\r\n.icon-calendar:before {\r\n  content: '\\e924';\r\n}\r\n.icon-waning:before {\r\n  content: '\\e925';\r\n}\r\n.icon-price-menu:before {\r\n  content: '\\e923';\r\n}\r\n.icon-news01:before {\r\n  content: '\\e910';\r\n}\r\n.icon-user:before {\r\n  content: '\\e912';\r\n}\r\n.icon-home:before {\r\n  content: '\\e913';\r\n}\r\n.icon-store:before {\r\n  content: '\\e918';\r\n}\r\n.icon-triangle-line:before {\r\n  content: '\\e91a';\r\n}\r\n.icon-more-menu:before {\r\n  content: '\\e91b';\r\n}\r\n.icon-news02:before {\r\n  content: '\\e922';\r\n}\r\n.icon-close:before {\r\n  content: '\\e921';\r\n}\r\n.icon-menu-dot:before {\r\n  content: '\\e920';\r\n}\r\n.icon-logout:before {\r\n  content: '\\e91f';\r\n}\r\n.icon-back:before {\r\n  content: '\\e91d';\r\n}\r\n.icon-msgs:before {\r\n  content: '\\e91e';\r\n}\r\n.icon-arrow-black:before {\r\n  content: '\\e900';\r\n}\r\n.icon-arrow-cmt:before {\r\n  content: '\\e901';\r\n}\r\n.icon-arrow-solid:before {\r\n  content: '\\e902';\r\n}\r\n.icon-bell:before {\r\n  content: '\\e903';\r\n}\r\n.icon-camera:before {\r\n  content: '\\e904';\r\n}\r\n.icon-cart:before {\r\n  content: '\\e905';\r\n}\r\n.icon-comment:before {\r\n  content: '\\e906';\r\n}\r\n.icon-currency:before {\r\n  content: '\\e907';\r\n}\r\n.icon-flash:before {\r\n  content: '\\e908';\r\n}\r\n.icon-heart:before {\r\n  content: '\\e909';\r\n}\r\n.icon-library:before {\r\n  content: '\\e90a';\r\n}\r\n.icon-like-fb:before {\r\n  content: '\\e90b';\r\n}\r\n.icon-like:before {\r\n  content: '\\e90c';\r\n}\r\n.icon-liked:before {\r\n  content: '\\f164';\r\n}\r\n.icon-location:before {\r\n  content: '\\e90d';\r\n}\r\n.icon-menu-main:before {\r\n  content: '\\e90e';\r\n}\r\n.icon-menu-sub:before {\r\n  content: '\\e90f';\r\n}\r\n.icon-news-solid:before {\r\n  content: '\\e911';\r\n}\r\n.icon-refresh:before {\r\n  content: '\\e914';\r\n}\r\n.icon-search:before {\r\n  content: '\\e915';\r\n}\r\n.icon-share:before {\r\n  content: '\\e916';\r\n}\r\n.icon-speaker:before {\r\n  content: '\\e917';\r\n}\r\n.icon-tag:before {\r\n  content: '\\e919';\r\n}\r\n.icon-weather:before {\r\n  content: '\\e91c';\r\n}\r\n.icon-bug:before {\r\n  font-family: 'iconfont';\r\n  content: '\\e937';\r\n}\r\n\r\n.lst-item [class^='icon-']:before,\r\n.lst-item [class*=' icon-']:before {\r\n  color: #919191;\r\n  font-size: 0.9rem;\r\n}\r\n.lst-item-detail .prod-inf [class^='icon-']:before,\r\n.lst-item-detail .prod-inf [class*=' icon-']:before {\r\n  color: #919191;\r\n  font-size: 1.05rem;\r\n}\r\n\r\n.video-play-icon.icon-arrow-solid {\r\n  border-radius: 100px;\r\n  background-color: #00000080;\r\n  opacity: 0.9;\r\n  z-index: 9;\r\n}\r\n.video-play-icon.icon-arrow-solid:before {\r\n  transform: rotate(-90deg);\r\n  display: inline-block;\r\n  color: #fff;\r\n}\r\na.position-relative,\r\na .position-relative {\r\n  transition: all 0.5s;\r\n}\r\na.position-relative:hover .video-play-icon.icon-arrow-solid,\r\na:hover .position-relative .video-play-icon.icon-arrow-solid {\r\n  background-color: #000;\r\n}\r\n.video-play-icon.md-size {\r\n  width: 36;\r\n  height: 36px;\r\n  line-height: 36px;\r\n  top: calc(50% - 18px);\r\n  left: calc(50% - 18px);\r\n}\r\n.video-play-icon.md-size.icon-arrow-solid:before {\r\n  font-size: 13px;\r\n}\r\n.video-play-icon.sm-size {\r\n  width: 28;\r\n  height: 28px;\r\n  line-height: 28px;\r\n  top: calc(50% - 14px);\r\n  left: calc(50% - 14px);\r\n}\r\n.video-play-icon.sm-size.icon-arrow-solid:before {\r\n  font-size: 9px;\r\n}\r\n.video-play-icon.xs-size {\r\n  width: 24;\r\n  height: 24px;\r\n  line-height: 24px;\r\n  top: calc(50% - 12px);\r\n  left: calc(50% - 12px);\r\n}\r\n.video-play-icon.xs-size.icon-arrow-solid:before {\r\n  font-size: 8px;\r\n}\r\n.fn-helvetica {\r\n  font-family: 'helvetica-neue-condensed-bold';\r\n}\r\n.fn-helvetica {\r\n  font-family: 'helvetica-neue-condensed-bold';\r\n}\r\n\r\n.green-clr,\r\n.primary-clr {\r\n  color: #009a59 !important;\r\n}\r\n.second-clr {\r\n  color: #f5a318 !important;\r\n}\r\n.grey-clr {\r\n  color: #6e6e6e !important;\r\n}\r\n.grey-light-clr {\r\n  color: #606060 !important;\r\n}\r\n.red-clr {\r\n  color: #e52f19 !important;\r\n}\r\n.blue-clr {\r\n  color: #0d6efd !important;\r\n}\r\n\r\n.primary-bg,\r\n.green-bg {\r\n  background-color: #009a59 !important;\r\n}\r\n.grey-bg {\r\n  background-color: #6e6e6e !important;\r\n}\r\n.grey-light-bg,\r\n.disable-bg {\r\n  background-color: #bcbfc6 !important;\r\n}\r\n.disable-bg [class*=' icon-'],\r\n.disable-bg [class^='icon-'] {\r\n  color: #ffffffad !important;\r\n}\r\n\r\n.mrgt-0 {\r\n  margin-top: 0px !important;\r\n}\r\n.mrgt-10 {\r\n  margin-top: 10px !important;\r\n}\r\n.mrgt-20 {\r\n  margin-top: 20px !important;\r\n}\r\n.mrgt28 {\r\n  margin-top: 28px !important;\r\n}\r\n.mrgt-30 {\r\n  margin-top: 30px !important;\r\n}\r\n.mrgt-40 {\r\n  margin-top: 40px !important;\r\n}\r\n.mrgt-50 {\r\n  margin-top: 50px !important;\r\n}\r\n\r\n.mrgb-0 {\r\n  margin-bottom: 0px !important;\r\n}\r\n.mrgb-10 {\r\n  margin-bottom: 10px !important;\r\n}\r\n.mrgb-20 {\r\n  margin-bottom: 20px !important;\r\n}\r\n.mrgb-30 {\r\n  margin-bottom: 30px !important;\r\n}\r\n.mrgb-40 {\r\n  margin-bottom: 40px !important;\r\n}\r\n.mrgb-50 {\r\n  margin-bottom: 50px !important;\r\n}\r\n\r\n.pdd-left10 {\r\n  padding-left: 10px;\r\n}\r\n.bd-left {\r\n  border-left: 2px solid #dfdfdf;\r\n}\r\n.row-cols-2 > * {\r\n  padding-right: calc(var(--bs-gutter-x) * 0.25) !important;\r\n  padding-left: calc(var(--bs-gutter-x) * 0.25) !important;\r\n}\r\n\r\nbody {\r\n  padding: 0;\r\n  margin: 0;\r\n  background-color: #f9f9f9 !important;\r\n  font-family: 'Nunito', sans-serif;\r\n  /*font-family: \"arial\", sans-serif;\r\n  font-family: \"Roboto\", sans-serif;*/\r\n  color: #282626;\r\n  font-size: 16px;\r\n  font-weight: normal;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n  word-wrap: break-word;\r\n}\r\n.row [class^='col-'],\r\n.row [class*=' col-'] {\r\n  padding-right: 8px;\r\n  padding-left: 8px;\r\n}\r\n.row [class^='col-'] .row,\r\n.row [class*=' col-'] .row {\r\n  margin-left: -7px;\r\n  margin-right: -7px;\r\n}\r\n\r\n/*body.menu-show {\r\n  overflow: hidden;\r\n  position: fixed;\r\n  height: 100%;\r\n  width: 100%;\r\n}*/\r\n::selection {\r\n  background: #e0fff2;\r\n}\r\n/*.box-shadow{box-shadow: 2px 2px 4px #9e9e9e;}*/\r\n.box-shadow {\r\n  box-shadow: 0 0 0 0.25rem #f1f1f1;\r\n}\r\n.box-shadow:focus {\r\n  box-shadow: 0 0 0 0.25rem rgb(12 171 107 / 15%);\r\n}\r\n\r\n.rounded-10 {\r\n  border-radius: 10px;\r\n}\r\nlabel.alert-invalid {\r\n  font-size: 15px !important;\r\n  color: #e00202 !important;\r\n  font-weight: normal !important;\r\n}\r\nimg {\r\n  max-width: 100%;\r\n  width: auto;\r\n  height: auto;\r\n  object-fit: cover;\r\n}\r\na {\r\n  text-decoration: none !important;\r\n  transition: 0.2s all ease;\r\n  color: inherit !important;\r\n}\r\na:hover,\r\na:focus {\r\n  text-decoration: none !important;\r\n  outline: none !important;\r\n  color: #00854e !important;\r\n}\r\n\r\n/**, *:before, *:after {\r\n  box-sizing: inherit; }*/\r\n\r\n/*// -------------------------------------------------------------\r\n// Typography*/\r\nh1,\r\np {\r\n  /*font-family: \"Nunito\", sans-serif;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;*/\r\n}\r\n\r\nh1 {\r\n  margin-bottom: 1rem;\r\n  font-size: 4rem;\r\n}\r\n\r\n*::placeholder,\r\nselect option[value='0'] {\r\n  /* Chrome, Firefox, Opera, Safari 10.1+ */\r\n  color: #6a6a6a !important;\r\n  font-size: 15px;\r\n  opacity: 1; /* Firefox */\r\n}\r\n*::-ms-input-placeholder,\r\nselect option[value='0'] {\r\n  /* Microsoft Edge */\r\n  color: #6a6a6a !important;\r\n  font-size: 15px;\r\n  opacity: 1;\r\n}\r\nselect,\r\nselect option {\r\n  color: #000000;\r\n}\r\n\r\nselect:invalid,\r\nselect option[value=''] {\r\n  color: red !important;\r\n}\r\ntextarea#message::placeholder {\r\n  /* Chrome, Firefox, Opera, Safari 10.1+ */\r\n  color: #6a6a6a !important;\r\n  font-size: 15px;\r\n  font-style: italic;\r\n  opacity: 1; /* Firefox */\r\n}\r\ntextarea#message::-ms-input-placeholder {\r\n  /* Microsoft Edge */\r\n  color: #6a6a6a !important;\r\n  font-size: 15px;\r\n  opacity: 1;\r\n  font-style: italic;\r\n}\r\n/* input[type=\"file\"] {visibility: hidden;} */\r\n.fs-26 {\r\n  font-size: 26px;\r\n  line-height: 30px;\r\n}\r\n\r\n.btn-primary {\r\n  text-transform: uppercase;\r\n  font-weight: 500 !important;\r\n  font-size: 0.9rem;\r\n  background-color: #009a59 !important;\r\n  color: #fff !important;\r\n  border-color: #0c9058 !important;\r\n}\r\n\r\n.btn-primary:hover {\r\n  background-color: #08975c;\r\n}\r\n\r\n.btn-secondary {\r\n  text-transform: uppercase;\r\n  font-weight: 500 !important;\r\n  font-size: 0.9rem;\r\n  background-color: #f8cd50 !important;\r\n  color: #191919 !important;\r\n  border-color: #efbc2f !important;\r\n}\r\n.price-clr {\r\n  color: #ef4923;\r\n  letter-spacing: -0.5px;\r\n  font-weight: 500;\r\n}\r\n\r\n.primary-bg {\r\n  background-color: #009a59;\r\n  color: #fff;\r\n}\r\n.green-light-bg {\r\n  background-color: #edf6f2;\r\n}\r\n\r\n.btn {\r\n  padding-left: 15px;\r\n  padding-right: 15px;\r\n  font-size: 14px;\r\n}\r\n.d-desktop {\r\n  display: inline-block;\r\n}\r\n.d-mobile {\r\n  display: none;\r\n}\r\n.w-20 {\r\n  width: 20% !important;\r\n}\r\n.w-30 {\r\n  width: 30% !important;\r\n}\r\n.w-40 {\r\n  width: 40% !important;\r\n}\r\n.w-60 {\r\n  width: 60% !important;\r\n}\r\n.w-70 {\r\n  width: 70% !important;\r\n}\r\n.w150 {\r\n  width: 150px;\r\n}\r\n.w160 {\r\n  width: 160px;\r\n}\r\n.w-67 {\r\n  width: 67%;\r\n}\r\n.w-33 {\r\n  width: 33%;\r\n}\r\n.h50 {\r\n  height: 50px;\r\n}\r\n.h52 {\r\n  height: 52px;\r\n}\r\n.h288 {\r\n  height: 288px;\r\n}\r\n.h350 {\r\n  height: 350px;\r\n}\r\n.fs-7 {\r\n  font-size: 0.86rem;\r\n}\r\n.more-btn-fll {\r\n  width: 100%;\r\n  border: none;\r\n  padding: 10px;\r\n  margin-bottom: 10px;\r\n  background-color: #f5f5f5;\r\n  border-radius: 3px;\r\n  font-weight: 500;\r\n  font-size: 0.95rem;\r\n  transition: all 0.5s;\r\n}\r\n.more-btn-fll:after {\r\n  content: '';\r\n  border-top: 0.3em solid;\r\n  border-right: 0.3em solid transparent;\r\n  border-bottom: 0;\r\n  border-left: 0.3em solid transparent;\r\n  display: inline-block;\r\n  color: grey;\r\n  vertical-align: 2px;\r\n  margin-left: 4px;\r\n}\r\n.more-btn-fll:hover {\r\n  text-decoration: underline;\r\n  color: #009a59;\r\n}\r\n.more-btn-fll:hover:after {\r\n  color: #009a59;\r\n}\r\n.bg-img {\r\n  width: 100%;\r\n  background-size: cover !important;\r\n  background-position: center center !important;\r\n  background-repeat: no-repeat !important;\r\n  text-align: center;\r\n}\r\n.bg-img-orgnal {\r\n  display: inline-block;\r\n  width: 100%;\r\n  padding-top: 100%;\r\n  background-size: cover !important;\r\n  background-position: 50% !important;\r\n  background-repeat: no-repeat !important;\r\n  background-color: #e5e5e5;\r\n}\r\n.bg-img.default-img {\r\n  background-size: contain !important;\r\n  background-image: url('../images/photos/photo-default.png') !important;\r\n}\r\n.bg-img.thumb-pt {\r\n  height: 95px;\r\n}\r\n.bg-img-orgnal.avtar40,\r\n.bg-img-orgnal.avtar45,\r\n.bg-img-orgnal.avtar50,\r\n.bg-img-orgnal.avtar60 {\r\n  margin-right: 10px;\r\n  border-radius: 100px;\r\n  padding-top: inherit;\r\n}\r\n.bg-img-orgnal.avtar45 {\r\n  height: 42px;\r\n  width: 42px;\r\n  left: 15px;\r\n  top: 15px;\r\n  padding-top: 42px;\r\n  border: 1px solid #e9e9e9;\r\n}\r\n.bg-img-orgnal.avtar50 {\r\n  height: 50px;\r\n  width: 50px;\r\n  left: 15px;\r\n  top: 15px;\r\n  padding-top: 50px;\r\n  border: 1px solid #e9e9e9;\r\n}\r\n.bg-img-orgnal.avtar60 {\r\n  height: 60px;\r\n  width: 60px;\r\n  left: 20px;\r\n  top: 20px;\r\n  padding-top: 60px;\r\n  border: 1px solid #e9e9e9;\r\n}\r\n.bg-img-orgnal.avtar100 {\r\n  height: 100px;\r\n  width: 100px;\r\n  left: 20px;\r\n  top: 20px;\r\n  border-radius: 100px;\r\n  border: 1px solid #e9e9e9;\r\n}\r\n.bg-img-orgnal.avtar36 {\r\n  height: 36px;\r\n  width: 36px;\r\n  left: 8px;\r\n  top: 8px;\r\n  padding-top: 36px;\r\n  margin-right: 10px;\r\n  border-radius: 100px;\r\n  border: 1px solid #e9e9e9;\r\n}\r\n.bg-img-orgnal.avtar45 {\r\n  height: 45px;\r\n  width: 45px;\r\n  left: 8px;\r\n  top: 8px;\r\n  padding-top: 43px;\r\n}\r\n\r\n.line-clamp-01 {\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n.line-clamp-02 {\r\n  white-space: normal;\r\n  -webkit-line-clamp: 2;\r\n  display: -webkit-box;\r\n  -webkit-box-orient: vertical;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis; /*height: 42px;*/\r\n  align-self: center !important;\r\n  line-height: 21px;\r\n}\r\n.line-clamp-03 {\r\n  white-space: normal;\r\n  -webkit-line-clamp: 3;\r\n  display: -webkit-box;\r\n  -webkit-box-orient: vertical;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  /*height:80px;*/\r\n  align-self: center !important;\r\n  line-height: 21px;\r\n  box-sizing: border-box;\r\n}\r\n.title-top div > .text-center {\r\n  margin-bottom: -22px;\r\n}\r\n.btn-style {\r\n  overflow: hidden;\r\n  padding: 0;\r\n  position: relative;\r\n  box-shadow: 2px 2px 6px #cacaca;\r\n  background-color: #fffdf8 !important;\r\n  border-radius: 5px;\r\n  border: none;\r\n  padding-right: 62px;\r\n  margin-bottom: 5px;\r\n}\r\n.btn-style .btn-txt {\r\n  display: inline-block;\r\n  height: 45px;\r\n  line-height: 45px;\r\n  border: none;\r\n  background-color: #009a59;\r\n  padding: 0 0 0 18px;\r\n  text-transform: uppercase;\r\n  z-index: 1;\r\n  display: flex;\r\n  align-items: center;\r\n  position: relative;\r\n  font-size: 1.1rem;\r\n}\r\n.btn-style .btn-txt span {\r\n  z-index: 9;\r\n}\r\n.btn-style span.shape {\r\n  position: absolute;\r\n  right: -74px;\r\n  z-index: 0;\r\n  width: 100px;\r\n  transform: rotate(90deg);\r\n  z-index: 2;\r\n}\r\n.btn-style .shape::before,\r\n.btn-style .shape::after {\r\n  content: '';\r\n  position: absolute;\r\n  top: 0;\r\n  width: 52px;\r\n  height: 80px;\r\n  border-radius: 50px 50px 0 0;\r\n  background-color: #009a59;\r\n}\r\n.btn-style .shape::before {\r\n  left: 50px;\r\n  transform: rotate(-45deg);\r\n  transform-origin: 0 100%;\r\n}\r\n.btn-style .shape::after {\r\n  left: 0;\r\n  transform: rotate(45deg);\r\n  transform-origin: 100% 100%;\r\n}\r\n\r\n.btn-style .arrow {\r\n  width: 15px;\r\n  height: 15px;\r\n  box-sizing: border-box;\r\n  position: absolute;\r\n  transform: rotate(45deg);\r\n  position: absolute;\r\n  right: 15px;\r\n  top: 15px;\r\n}\r\n.btn-style .arrow::before {\r\n  content: '';\r\n  width: 100%;\r\n  height: 100%;\r\n  border-width: 3px 3px 0 0;\r\n  border-style: solid;\r\n  border-color: #009a59;\r\n  transition: 0.2s ease;\r\n  display: block;\r\n  transform-origin: 100% 0;\r\n}\r\n.btn-style .arrow:after {\r\n  content: '';\r\n  float: left;\r\n  position: relative;\r\n  top: -100%;\r\n  width: 100%;\r\n  height: 100%;\r\n  border-width: 0 3px 0 0;\r\n  border-style: solid;\r\n  border-color: #009a59;\r\n  transform-origin: 100% 0;\r\n  transition: 0.2s ease;\r\n}\r\n.custom-select {\r\n  position: relative;\r\n}\r\n.custom-select select {\r\n  display: none; /*hide original SELECT element:*/\r\n}\r\n.select-selected {\r\n  color: inherit;\r\n}\r\n/*style the arrow inside the select element:*/\r\n.select-selected:after {\r\n  position: absolute;\r\n  content: '';\r\n  top: 20px;\r\n  right: 15px;\r\n  width: 0;\r\n  height: 0;\r\n  border: 5px solid transparent;\r\n  border-color: #5d5d5d transparent transparent transparent;\r\n}\r\n/*point the arrow upwards when the select box is open (active):*/\r\n.select-selected.select-arrow-active:after {\r\n  border-color: transparent transparent #5d5d5d transparent;\r\n  top: 13px;\r\n}\r\n/*style the items (options), including the selected item:*/\r\n.select-items div,\r\n.select-selected {\r\n  padding: 8px 16px;\r\n  border: 1px solid transparent;\r\n  border-color: transparent transparent rgba(0, 0, 0, 0.06) transparent;\r\n  cursor: pointer;\r\n  user-select: none;\r\n  border-radius: 5px;\r\n  font-size: 1rem;\r\n}\r\n/*style items (options):*/\r\n.select-items {\r\n  position: absolute;\r\n  background-color: #f5f5f5;\r\n  top: 100%;\r\n  left: 0;\r\n  right: 0;\r\n  z-index: 99;\r\n  box-shadow: 1px 1px 2px 0px rgb(0 0 0 / 30%);\r\n  border: 1px solid #ced4da;\r\n}\r\n/*hide the items when the select box is closed:*/\r\n.select-hide {\r\n  display: none;\r\n}\r\n.select-items div:hover,\r\n.same-as-selected {\r\n  background-color: #00a35c14;\r\n}\r\n\r\n/*// -------------------------------------------------------------\r\n// Main*/\r\nheader .top-sectn {\r\n  background-color: #009a59;\r\n  padding: 8px 0px;\r\n  box-shadow: inset 0 -10px 28px -10px #00000026;\r\n}\r\nheader .top-sectn .bg-img-orgnal.avtar36 {\r\n  padding-top: 34px;\r\n}\r\n.search-top {\r\n  position: relative; /*max-width: 480px;*/\r\n}\r\n.search-top form {\r\n  margin-block-end: 0;\r\n}\r\n.search-top input {\r\n  padding-left: 40px;\r\n  border-radius: 100px !important;\r\n  height: calc(1.5em + 0.5rem + 2px);\r\n  border: none;\r\n}\r\n.search-top input.rounded-10 {\r\n  border-radius: 10px !important;\r\n}\r\n.search-top .icon-search {\r\n  position: absolute;\r\n  left: 17px;\r\n  top: 10px;\r\n  z-index: 9;\r\n  opacity: 1;\r\n}\r\n.search-top .icon-search:before {\r\n  font-size: 18px;\r\n  color: #858585;\r\n}\r\nheader .top-sectn .side-r .notify-box {\r\n  position: relative;\r\n  display: inline-block;\r\n  margin-right: 40px;\r\n  height: 36px;\r\n}\r\nheader .top-sectn .side-r .notify-box .dropdown-toggle:after {\r\n  display: none;\r\n}\r\nheader .top-sectn .side-r .notify-box .dropdown-menu.show {\r\n  top: 47px !important;\r\n  width: 280px;\r\n  margin-right: -30px !important;\r\n  padding: 0;\r\n  z-index: 9999999;\r\n}\r\nheader .top-sectn .side-r .notify-box ul {\r\n  padding: 20px 10px 10px 25px;\r\n}\r\nheader .top-sectn .side-r .notify-box ul li {\r\n  position: relative;\r\n  list-style: none;\r\n  border-bottom: 1px solid #ddd;\r\n  padding-bottom: 8px;\r\n  margin-bottom: 8px;\r\n}\r\nheader .top-sectn .side-r .notify-box ul li:last-child {\r\n  padding-bottom: 0;\r\n  margin-bottom: 0;\r\n  border-bottom: none;\r\n}\r\nheader .top-sectn .side-r .notify-box ul li small {\r\n  color: #858585;\r\n}\r\nheader .top-sectn .side-r .notify-box .top-bg {\r\n  background-color: #cacaca;\r\n  height: 40px;\r\n  line-height: 40px;\r\n  position: relative;\r\n  font-weight: 600;\r\n}\r\n/*header .top-sectn .side-r .notify-box .top-bg:before{content: \"\\e902\";font-family: 'iconfont' !important;position: absolute;top: -45px;right: 10px;font-size: 13px;transform: rotate(180deg);}\r\nheader .top-sectn .side-r .notify-box .top-bg:before{content: \"\";width: 0;height: 0;border-left: 50px solid transparent;border-right: 50px solid transparent; border-bottom: 100px solid red;}*/\r\nheader .top-sectn .side-r .notify-box li .new-circle,\r\nheader .top-sectn .side-r .notify-box li .icon-close {\r\n  position: absolute;\r\n}\r\nheader .top-sectn .side-r .notify-box li .new-circle {\r\n  left: -12px;\r\n  top: 9px;\r\n  height: 6px;\r\n  width: 6px;\r\n  border-radius: 10px;\r\n  background-color: #009a59;\r\n}\r\nheader .top-sectn .side-r .notify-box li .icon-close {\r\n  display: none;\r\n  right: 6px;\r\n  top: 6px;\r\n  font-size: 9px;\r\n  cursor: pointer;\r\n}\r\nheader .top-sectn .side-r .notify-box li:hover .icon-close {\r\n  display: inline-block;\r\n}\r\nheader .top-sectn .side-r .justify-content-end {\r\n  align-items: center;\r\n}\r\nheader .top-sectn .side-r .notify-box .icon-bell {\r\n  color: #ffffff;\r\n  font-size: 24px;\r\n  position: absolute;\r\n  left: 0;\r\n  top: calc(50% - 10px);\r\n}\r\nheader .top-sectn .side-r .notify-box .item-numb {\r\n  background-color: red;\r\n  color: white;\r\n  font-size: 9px;\r\n  text-align: center;\r\n  font-weight: bold;\r\n  width: 13px;\r\n  height: 13px;\r\n  line-height: 13px;\r\n  border-radius: 20px;\r\n  position: absolute;\r\n  top: 2px;\r\n  left: 8px;\r\n}\r\nheader .top-sectn a.logo img {\r\n  width: 116px;\r\n}\r\nheader .top-sectn .side-r .acct-box {\r\n  display: inline-block;\r\n}\r\nheader .top-sectn .side-r .acct-box .dropdown-toggle::after {\r\n  color: #fff;\r\n}\r\nheader .top-sectn .side-r .acct-box .d-desktop .avatar {\r\n  width: 40px;\r\n  margin-right: 8px;\r\n}\r\nheader .top-sectn .side-r .acct-box .user-name {\r\n  color: white;\r\n}\r\nheader .top-sectn .side-r .acct-box .user-name.btn-login {\r\n  border-radius: 50px;\r\n  font-size: 18px;\r\n  padding: 2px 20px;\r\n  border: 0.5px solid #ffffff6b;\r\n  box-shadow: 0 2px 4px rgb(0 0 0 / 28%);\r\n  transition: all 0.3s;\r\n  background-color: #008c50;\r\n}\r\nheader .top-sectn .side-r .acct-box .user-name.btn-login:hover {\r\n  background-color: #06a062;\r\n}\r\nheader .top-sectn .side-r .acct-box .icon-arrow-solid:before {\r\n  font-size: 8px;\r\n  color: white;\r\n  margin-left: 5px;\r\n}\r\nheader .top-sectn .side-r .acct-box .dropdown-menu {\r\n  padding: 10px 15px;\r\n  top: 10px !important;\r\n  width: 210px;\r\n  min-height: 66px;\r\n  box-shadow: 0 2px 4px rgb(0 0 0 / 20%);\r\n}\r\nheader .top-sectn .side-r .acct-box .dropdown-menu ul {\r\n  list-style: none;\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\nheader .top-sectn .side-r .acct-box .dropdown-menu ul li.logout .icon-logout {\r\n  margin-right: 5px;\r\n  color: #0cab6b;\r\n}\r\nheader .top-sectn .side-r .acct-box .dropdown-menu ul a {\r\n  color: inherit;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\nheader .top-sectn .side-r .acct-box .dropdown-menu ul li.logout {\r\n  margin-top: 10px;\r\n}\r\nheader .top-sectn .side-r .acct-box .contain-prof .btn-login button.btn {\r\n  padding: 0;\r\n  font-size: 1rem;\r\n}\r\nheader .top-sectn .side-r .acct-box .contain-prof .btn-login button.btn:hover, header .top-sectn .side-r .acct-box .contain-prof .btn-login button.btn:focus, header .top-sectn .side-r .acct-box .contain-prof .btn-login button.btn: active, header .top-sectn .side-r .acct-box .contain-prof .btn-login button.btn:focus-visible {\r\n  background-color: inherit;\r\n  border: none;\r\n}\r\nheader .top-sectn .side-r .acct-box .contain-prof .btn-login button.btn:focus,\r\nheader .top-sectn .side-r .acct-box .contain-prof .btn-login button.btn:active {\r\n  border-color: transparent;\r\n  background-color: transparent;\r\n  box-shadow: none;\r\n}\r\n\r\n/*header .top-sectn .side-r .dropdown-menu.show{inset: 7px auto auto 10px!important;}*/\r\nheader .top-sectn .side-r .dropdown-menu.show .dropdown-item {\r\n  width: auto;\r\n}\r\nheader .top-sectn .side-r .btn-secondary,\r\nheader .side-r .btn-secondary:focus {\r\n  background-color: transparent !important;\r\n  border-color: transparent;\r\n  box-shadow: none;\r\n  padding: 0;\r\n  border: none;\r\n}\r\nheader .side-r .btn-secondary:focus,\r\nheader .side-r .btn-secondary:focus-visible,\r\nheader .side-r .btn-secondary:active {\r\n  outline: none !important;\r\n  border-color: transparent !important;\r\n  box-shadow: none !important;\r\n}\r\nheader .cate-sectn {\r\n  background-color: #fff;\r\n  box-shadow: 0 2px 6px rgb(0 0 0 / 20%);\r\n  padding: 9px 0;\r\n  margin-bottom: 5px;\r\n}\r\nheader .cate-sectn a {\r\n  color: transparent;\r\n}\r\nheader .cate-sectn [class^='icon-'] {\r\n  color: #6f6f6f;\r\n  font-size: 30px;\r\n  padding: 0 80%;\r\n  height: 43px;\r\n  display: flex;\r\n  align-items: center;\r\n  transition: all 0.2s;\r\n}\r\nheader .cate-sectn .icon-news02,\r\nheader .cate-sectn .icon-home {\r\n  font-size: 39px;\r\n}\r\nheader .cate-sectn .icon-price-menu {\r\n  font-size: 42px;\r\n}\r\nheader .cate-sectn .icon-news01,\r\nheader .cate-sectn .icon-triangle-line {\r\n  font-size: 33px;\r\n}\r\nheader .cate-sectn .icon-menu-main,\r\nheader .cate-sectn .icon-more-menu {\r\n  /*color: #f6a503;*/\r\n  font-size: 20px;\r\n}\r\n\r\nheader .cate-sectn a.active [class^='icon-'] {\r\n  color: #f6a503;\r\n}\r\nheader .cate-sectn a:hover [class^='icon-'],\r\nheader .cate-sectn a.active:hover [class^='icon-'] {\r\n  color: #009a59;\r\n  transition: all 0.2s;\r\n}\r\nheader .cate-sectn .contain-sidebar-l {\r\n  display: none;\r\n}\r\nheader .cate-sectn a {\r\n  transition: all 0.2s;\r\n}\r\nheader .cate-sectn a .mn-tooltip {\r\n  display: none;\r\n  position: absolute;\r\n  top: 52px;\r\n  border-radius: 2px;\r\n  padding: 2px 10px;\r\n  background-color: #2f2f2fcf;\r\n  color: #fff;\r\n  white-space: nowrap;\r\n  transition: all 0.2s;\r\n  font-size: 95%;\r\n  z-index: 1070;\r\n}\r\nheader .cate-sectn a:hover .mn-tooltip {\r\n  display: block;\r\n}\r\nheader .hashtag-sectn {\r\n  background-color: white;\r\n  box-shadow: 0 4px 6px rgb(0 0 0 / 20%);\r\n  padding: 0;\r\n  margin-bottom: 10px;\r\n}\r\nheader .hashtag-sectn .container > .align-items-center {\r\n  height: 50px;\r\n}\r\nheader .hashtag-sectn ul {\r\n  margin-bottom: 0;\r\n  align-items: center !important;\r\n  display: flex !important;\r\n  overflow: hidden;\r\n  white-space: nowrap;\r\n  padding-right: 0px;\r\n  padding-left: 0px;\r\n  overflow-x: hidden;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\nheader .hashtag-sectn ul li {\r\n  display: inline-block;\r\n  list-style: none;\r\n  margin: 0 18px;\r\n  padding: 0;\r\n  border-bottom: 3px solid transparent;\r\n}\r\nheader .hashtag-sectn ul li a {\r\n  color: #282626;\r\n  text-decoration: none;\r\n  padding: 10px 0px;\r\n  font-size: 17px;\r\n  display: inline-block;\r\n  font-weight: 500;\r\n}\r\nheader .hashtag-sectn ul li a span.icon-refresh {\r\n  font-size: 26px;\r\n  color: #8f8f8f;\r\n}\r\nheader .hashtag-sectn ul li a span.icon-refresh:hover {\r\n  color: #828282;\r\n}\r\nheader .hashtag-sectn .contr-btn {\r\n  margin-left: 28px;\r\n  overflow: inherit;\r\n}\r\nheader .hashtag-sectn ul li.active {\r\n  border-bottom: 3px solid #009a59;\r\n}\r\nheader .hashtag-sectn ul li.active a {\r\n  color: #009a59 !important;\r\n}\r\nheader .hashtag-sectn .icon-arrow-black {\r\n  height: 50px;\r\n  width: 50px;\r\n  display: inline-block;\r\n  text-align: center;\r\n  line-height: 45px;\r\n  color: #9c9c9c;\r\n}\r\nheader .hashtag-sectn .icon-arrow-black:hover {\r\n  color: #828282;\r\n}\r\nheader .hashtag-sectn .icon-arrow-black.prev-btn {\r\n  transform: rotate(180deg);\r\n  line-height: 52px;\r\n}\r\n.ReactModalPortal .ril__toolbar {\r\n  height: 60px;\r\n}\r\n.sub-news .icon-comment-line:before {\r\n  color: #919191;\r\n}\r\n\r\n#page-wrapper {\r\n  padding-top: 13px;\r\n}\r\n\r\n#page-wrapper.page-wrapper-custom {\r\n  margin-top: 20px;\r\n}\r\n\r\n.img-cover {\r\n  width: 100%;\r\n  object-fit: cover;\r\n}\r\n#id-portal-login-popup .modal-header {\r\n  background-color: #009a59;\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 0.65rem 1rem;\r\n}\r\n#id-portal-login-popup .modal-header .modal-title.logo img {\r\n  width: 115px !important;\r\n}\r\n#id-portal-login-popup .modal-body .form-inline {\r\n  justify-content: center;\r\n  margin: 0;\r\n}\r\n#id-portal-login-popup button.text-white.btn-warning {\r\n  color: #191919 !important;\r\n  font-weight: 500;\r\n  background-color: #ffc108;\r\n  border-color: #dda80c !important;\r\n}\r\n#id-portal-login-popup button.text-white.btn-warning:hover {\r\n  color: #212529;\r\n  background-color: #ffc822;\r\n  border-color: #dcaa15;\r\n}\r\n#id-portal-login-popup button.btn.btn-primary {\r\n  background-color: #009a59;\r\n  color: #fff !important;\r\n  font-weight: 500;\r\n}\r\n#id-portal-login-popup button.btn.btn-primary:hover {\r\n  background-color: #00b669;\r\n}\r\n#id-portal-login-popup a {\r\n  color: #009a59 !important;\r\n  text-decoration: underline !important;\r\n  font-size: 1rem;\r\n}\r\n#id-portal-login-popup a img {\r\n  margin: 0 5px;\r\n}\r\n#id-portal-login-popup #send-otp {\r\n  float: inline-end;\r\n  font-size: small;\r\n  padding: 5px;\r\n}\r\n\r\n@media (max-width: 426px) {\r\n  #id-portal-login-popup .modal-body .form-group:nth-child(1) {\r\n    width: 100%;\r\n  }\r\n  #id-portal-login-popup .modal-body .form-group:nth-child(2) {\r\n    margin: 0 !important;\r\n  }\r\n}\r\n\r\n/***** Homepage *****/\r\n.news-sectn .tab-content [class^='icon-'],\r\n.home-wrapper .news-sectn .tab-content [class*=' icon-'] {\r\n  color: #919191;\r\n  font-size: 15px;\r\n}\r\n.news-sectn .tab-content .icon-eye-line01 {\r\n  font-size: 12px;\r\n}\r\n.news-sectn [class^='icon-'] + span,\r\n.home-wrapper .news-sectn [class*=' icon-'] + span {\r\n  margin-left: 3px;\r\n  font-size: 0.8rem;\r\n}\r\n.news-sectn .sub-news .img-cover {\r\n  height: 75px;\r\n}\r\n.news-sectn .main-news .img-cover {\r\n  height: 285px;\r\n}\r\n.news-sectn .main-news .line-clamp-02 {\r\n  line-height: 26px;\r\n}\r\n.news-sectn .main-news .inf-box {\r\n  height: 154px;\r\n  background-color: #fff;\r\n}\r\n\r\n.news-sectn .cmore {\r\n  font-size: 15px;\r\n}\r\n.news-sectn .icon-arrow-solid {\r\n  display: inline-block;\r\n  font-size: 8px;\r\n  vertical-align: 1px;\r\n}\r\n.news-sectn .nav-tabs .nav-link {\r\n  border: 1px #dedede solid;\r\n  border-radius: 2px;\r\n  font-weight: 500;\r\n  padding: 0.18rem 1.2rem;\r\n  height: 32px;\r\n  margin-right: 0.5rem;\r\n  background-color: #fff;\r\n}\r\n.news-sectn nav .nav-tabs,\r\n.home-wrapper .news-sect .nav-tabs .nav-link.active {\r\n  border: none;\r\n}\r\n.news-sectn .nav-tabs .nav-link.active {\r\n  background-color: #009a59;\r\n  color: #fff !important;\r\n  border: 1px solid #009a59;\r\n}\r\n.news-sectn .main-news {\r\n  border: 1px solid #ccc;\r\n}\r\n.news-sectn .main-news .line-clamp-03 {\r\n  height: 82px;\r\n}\r\n.news-sectn .main-news .line-clamp-03 h5 {\r\n  margin-bottom: 0;\r\n}\r\n.news-sectn .main-news .line-clamp-03 p:first-child {\r\n  margin: 8px 0 5px;\r\n}\r\n.news-sectn .main-news .inf-box p:last-child {\r\n  margin-bottom: 0;\r\n}\r\n.title-line-lt {\r\n  position: relative;\r\n  padding-left: 10px;\r\n}\r\n.title-line-lt:before {\r\n  content: '';\r\n  position: absolute;\r\n  left: 0px;\r\n  top: -1px;\r\n  height: 25px;\r\n  width: 4px;\r\n  background-color: #009a59;\r\n}\r\n.title-line-lt.line-none:before {\r\n  content: none;\r\n}\r\nh4.title-line-lt:before {\r\n  height: 28px;\r\n}\r\nh6.title-line-lt,\r\nh6 .title-line-lt {\r\n  padding-left: 11px;\r\n}\r\nh6.title-line-lt:before,\r\nh6 .title-line-lt:before {\r\n  top: -2px;\r\n  height: 22px;\r\n  width: 3px;\r\n}\r\n.prod-list .item-lst img.img-cover {\r\n  height: 120px;\r\n  border-radius: 2px 2px 0 0;\r\n}\r\n.news-sectn .post .nav-tabs .nav-link.animated-btn {\r\n  border-radius: 6px;\r\n}\r\n.news-sectn .post .nav-tabs .nav-link.animated-btn.active {\r\n  background-image: linear-gradient(#f6a503, #fff0b0);\r\n  border: 1px solid #e5ca91;\r\n  color: #191919 !important;\r\n}\r\n\r\n.home-wrapper .posts-sectn {\r\n  margin-bottom: 30px;\r\n}\r\n.home-wrapper .posts-sectn .inf-post {\r\n  background-color: rgba(0, 0, 0, 0.28);\r\n  bottom: 0;\r\n  color: #fff;\r\n}\r\n.home-wrapper .posts-sectn .inf-post a:hover {\r\n  color: inherit !important;\r\n}\r\n.home-wrapper .posts-sectn .inf-post .poster-txt .carousel-caption {\r\n  position: static;\r\n  padding: 0;\r\n}\r\n.home-wrapper .posts-sectn .inf-post .poster-txt .carousel-caption .line-clamp-02.fs-6 {\r\n  line-height: 1.7rem;\r\n  font-size: 1.3rem !important;\r\n  font-weight: 600;\r\n  width: 90%;\r\n  margin: 0 auto;\r\n}\r\n.home-wrapper .posts-sectn .carousel-control-prev,\r\n.home-wrapper .posts-sectn .carousel-control-next {\r\n  opacity: 0.8;\r\n}\r\n.home-wrapper .posts-sectn .inf-post .poster-txt {\r\n  padding: 15px 20px;\r\n}\r\n.home-wrapper .posts-sectn .inf-post .user-act .icon-time:before {\r\n  color: #fff;\r\n  vertical-align: middle;\r\n}\r\n.home-wrapper .posts-sectn .inf-post small * {\r\n  font-size: 90%;\r\n}\r\n.home-wrapper .posts-sectn .inf-post .user-act img.avtar {\r\n  height: 33px;\r\n  width: 33px;\r\n  max-width: 100%;\r\n}\r\n.home-wrapper .posts-sectn .inf-post .user-act {\r\n  border-top: 1px solid rgba(225, 225, 225, 0.18);\r\n  padding: 8px 20px;\r\n}\r\n.home-wrapper .posts-sectn .inf-post .user-act img.like-numb {\r\n  height: 26px;\r\n}\r\n.home-wrapper .posts-sectn .carousel.slide .carousel-indicators {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-bottom: 19px;\r\n  z-index: 9;\r\n}\r\n.home-wrapper .posts-sectn .carousel.slide .carousel-indicators button {\r\n  width: 10px;\r\n  height: 10px;\r\n  border-radius: 50px;\r\n  border: none;\r\n}\r\n.home-wrapper .posts-sectn .carousel.slide .carousel-indicators button.active {\r\n  background-color: #ffb308;\r\n  border: 1px solid #fff;\r\n}\r\n\r\n.cate-lst .cate-item {\r\n  display: inline-block;\r\n  width: 100%;\r\n  background-color: #fff;\r\n  color: #191919;\r\n  border: 1px solid transparent;\r\n  height: 100%;\r\n  position: relative;\r\n  padding-bottom: 68px;\r\n  border-radius: 6px;\r\n  box-shadow: 0px 5px 10px #dcdcdc;\r\n  transition: all 1s;\r\n}\r\n.cate-lst .cate-item:hover {\r\n  border: 1px solid #eeeeeef5;\r\n  box-shadow: none;\r\n  color: inherit !important;\r\n}\r\n.cate-lst .row [class^='col-'],\r\n.cate-lst .row [class*=' col-'],\r\n.albums-list.row [class^='col-'],\r\n.albums-list.row [class*=' col-'] {\r\n  padding-left: 6px;\r\n  padding-right: 6px;\r\n}\r\n.cate-lst .cate-item .img-box {\r\n  z-index: 1;\r\n}\r\n.cate-lst .cate-item .img-box img.img-cover {\r\n  height: 100%;\r\n  border-radius: 5px;\r\n  width: 68px;\r\n  border: none;\r\n  outline: none;\r\n}\r\n.cate-lst .cate-item .prod-inf {\r\n  padding: 8px;\r\n  z-index: 2;\r\n  bottom: 0;\r\n  border-radius: rgba(225, 225, 225, 0.28);\r\n  height: 100%;\r\n  transition: all 0.6s;\r\n  width: calc(100% - 68px);\r\n  left: 68px;\r\n}\r\n.cate-lst .cate-item .prod-inf .prod-numb {\r\n  height: 24px;\r\n  width: 24px;\r\n  line-height: 19px;\r\n  border-radius: 100px;\r\n  right: -8px;\r\n  top: -8px;\r\n  background-color: #fff;\r\n  color: #191919;\r\n  border: 2px solid #fff;\r\n  z-index: 3;\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n  transition: all 0.6s;\r\n  display: none;\r\n}\r\n.cate-lst .cate-item .prod-inf .line-clamp-01 {\r\n  width: calc(100% - 0px);\r\n  line-height: 39px;\r\n  font-size: 1.05rem;\r\n  margin-left: 5px;\r\n}\r\n.cate-lst .cate-item:hover .prod-numb {\r\n  background-color: #ffa608;\r\n  border-color: #ffb635;\r\n  color: #fff;\r\n  display: inline-block;\r\n}\r\n.cate-lst .cate-item:hover .prod-inf {\r\n}\r\n\r\n.cate-lst.news .cate-item {\r\n  padding-bottom: 80px;\r\n  transition: all 0.3s;\r\n}\r\n.cate-lst.news.album-sectn .cate-item {\r\n  /*padding-bottom: calc(100% - 2px);*/\r\n  padding-bottom: 68px;\r\n}\r\n.cate-lst.news.album-sectn .btn.cate-item:active,\r\n.cate-lst.news.album-sectn .btn.cate-item:focus {\r\n  box-shadow: 0px 5px 10px #dcdcdc;\r\n  border-color: transparent;\r\n}\r\n.cate-lst.news .cate-item .img-box img.img-cover,\r\n.cate-lst.news .cate-item .prod-inf {\r\n  width: 100%;\r\n  left: 0;\r\n}\r\n.cate-lst.news .cate-item .prod-inf .line-clamp-02 {\r\n  margin: 0;\r\n  color: #fff;\r\n}\r\n.cate-lst.news .cate-item .prod-inf {\r\n  background-color: #00000050; /*height: 58px;*/\r\n  height: 100%;\r\n  border-radius: 6px;\r\n  padding: 8px 13px;\r\n  letter-spacing: 0.2;\r\n  text-align: center;\r\n}\r\n.cate-lst.news .cate-item:hover .prod-inf {\r\n  height: 100%;\r\n  border-radius: 6px;\r\n}\r\n\r\n.cate-lst.qtkt .cate-item {\r\n  padding-bottom: 168px;\r\n  -webkit-transition: all 0.3s ease-in-out;\r\n  transition: all 0.8s;\r\n}\r\n.cate-lst.qtkt .cate-item .img-box .wrap-img {\r\n  overflow: hidden;\r\n  width: 100%;\r\n  height: 105px;\r\n  border-radius: 5px;\r\n}\r\n.cate-lst.qtkt .cate-item .img-box .wrap-img:after {\r\n  top: 0;\r\n  content: '';\r\n  width: 100%;\r\n  height: 105px;\r\n  background-color: #00000018;\r\n  display: block;\r\n  position: absolute;\r\n}\r\n.cate-lst.qtkt .cate-item:hover .img-box .wrap-img:after {\r\n  background-color: transparent;\r\n}\r\n.cate-lst.qtkt .cate-item .img-box .wrap-img img.img-cover {\r\n  transform: scale(1);\r\n  width: 100%;\r\n  transition: all 0.8s;\r\n  object-fit: contain;\r\n}\r\n.cate-lst.qtkt .cate-item:hover .img-box .wrap-img img.img-cover {\r\n  transform: scale(1.1);\r\n}\r\n.cate-lst.qtkt .cate-item .prod-inf {\r\n  height: 63px;\r\n  width: 100%;\r\n  left: 0;\r\n  text-align: center;\r\n  font-size: 1.1rem;\r\n}\r\n.cate-lst.qtkt .cate-item .cmore {\r\n  width: 86px;\r\n  font-size: 0.85rem;\r\n  height: 24px;\r\n  line-height: 24px;\r\n  text-align: center;\r\n  background-color: #ffffff9c;\r\n  border-radius: 8px;\r\n  left: calc(50% - 43px);\r\n  top: 38px;\r\n  z-index: 1;\r\n  font-weight: 500;\r\n  display: none;\r\n  transition: all 0.8s;\r\n}\r\n.cate-lst.qtkt .cate-item:hover .cmore {\r\n  display: block;\r\n}\r\n\r\n.albums .albums-list {\r\n  margin-bottom: 10px;\r\n}\r\n.albums-list input[type='file']::file-selector-button {\r\n  display: none;\r\n}\r\n.albums-list input[type='file']::-webkit-file-upload-button {\r\n  visibility: hidden;\r\n  position: absolute;\r\n  left: -9999px;\r\n  top: -9999px;\r\n}\r\n\r\n/*.albums .albums-list + .row .cate-lst.news.album-sectn .col-md-4{width: 20%;}*/\r\n.cate-lst.news.album-sectn .icon-close:before,\r\n.albums-list .icon-close:before {\r\n  transform: rotate(135deg);\r\n  display: inline-block;\r\n  font-weight: 700;\r\n  font-size: 1.05rem;\r\n  margin-right: 8px;\r\n  color: #ffa608;\r\n}\r\n.albums-list .item-lst .icon-close {\r\n  top: calc(100% - 120px);\r\n  right: calc(100% - 132px);\r\n  text-align: center;\r\n}\r\n.albums-list .item-lst .icon-close:before {\r\n  display: block;\r\n  font-size: 26px;\r\n  color: orange;\r\n  box-shadow: none;\r\n  text-shadow: none;\r\n}\r\n.albums-list .item-lst .icon-close:after {\r\n  content: 'Thêm ảnh';\r\n  display: block;\r\n  font-size: 1rem;\r\n  color: #191919;\r\n  box-shadow: none;\r\n  text-shadow: none;\r\n  font-weight: 600;\r\n  font-family: 'Nunito', sans-serif;\r\n  margin-top: 10px;\r\n}\r\n.albums .more-btn button.dropdown-toggle.btn {\r\n  height: 26px;\r\n  width: 26px;\r\n  background-color: #ffffffa1;\r\n  border: 0.5px solid #fff;\r\n  border-radius: 0 4px 0px 10px;\r\n  z-index: 9;\r\n  position: relative;\r\n}\r\n.albums .more-btn button.dropdown-toggle.btn:before {\r\n  content: '';\r\n  display: inline-block;\r\n  margin-left: -5px;\r\n  border-top: 0.35em solid;\r\n  border-right: 0.35em solid transparent;\r\n  border-bottom: 0;\r\n  border-left: 0.35em solid transparent;\r\n  color: #000;\r\n}\r\n.albums .more-btn button.dropdown-toggle.btn:focus,\r\n.albums button.dropdown-toggle.btn:active {\r\n  box-shadow: none !important;\r\n  background-color: #ffffffa1 !important;\r\n}\r\n\r\n.panel-left,\r\n.lt-side,\r\n.rt-side {\r\n  border: 1px solid #efefef;\r\n  border-radius: 6px;\r\n  padding: 5px 15px;\r\n  background-color: #ffffff;\r\n}\r\n.panel-left .title-txt {\r\n  color: #009a59;\r\n  font-size: 1.05rem;\r\n  margin-top: 20px;\r\n  padding: 8px 15px 5px;\r\n  /* background-color: #f2f2f2; */\r\n  border-radius: 2px;\r\n  text-transform: uppercase;\r\n  font-weight: 700;\r\n}\r\n.panel-left ul {\r\n  padding-left: 0;\r\n}\r\n.panel-left ul li {\r\n  margin: 20px 0 22px;\r\n  padding: 0;\r\n  list-style: none;\r\n}\r\n.panel-left ul li a {\r\n  text-decoration: none !important;\r\n  font-size: 1.05rem;\r\n  align-items: center;\r\n  display: flex;\r\n}\r\n.panel-left ul li a [class^='icon-'],\r\n.panel-left ul li a [class*=' icon-'] {\r\n  font-size: 20px;\r\n  width: 40px;\r\n  display: inline-block;\r\n  text-align: center;\r\n  color: #a2a2a2;\r\n}\r\n.panel-left ul li a .icon-present {\r\n  font-size: 18px;\r\n}\r\n.panel-left ul li a .icon-get-gift {\r\n  font-size: 26px;\r\n}\r\n.panel-left ul li a .icon-audio {\r\n  font-size: 22px;\r\n}\r\n.panel-left ul li a .icon-bug {\r\n  font-size: 22px;\r\n}\r\n.panel-left ul li a .icon-tech-process {\r\n  font-size: 21px;\r\n}\r\n.panel-left ul li a .icon-user {\r\n  font-size: 20px;\r\n}\r\n.panel-left ul li a .icon-farmer-market {\r\n  font-size: 16px;\r\n}\r\n.panel-left ul li a .icon-news02 {\r\n  font-size: 21px;\r\n}\r\n.panel-left ul li a .icon-weather {\r\n  font-size: 19px;\r\n}\r\n.panel-left ul li a .icon-triangle-line {\r\n  font-size: 17px;\r\n}\r\n.panel-left ul li a .icon-price-menu {\r\n  font-size: 26px;\r\n}\r\n.panel-left ul li a .icon-weather02 {\r\n  font-size: 24px;\r\n}\r\n.panel-left ul li a .icon-tag,\r\n.panel-left ul li a .icon-video-call {\r\n  font-size: 22px;\r\n}\r\n.panel-left ul li a .icon-arrow-solid {\r\n  vertical-align: 3px;\r\n  width: auto;\r\n  font-size: 9px;\r\n}\r\n.panel-left ul li a .txt {\r\n  vertical-align: 3px;\r\n  font-weight: 500;\r\n}\r\n#page-wrapper .panel-left ul li a.active > span.txt {\r\n  font-weight: 700;\r\n}\r\n.panel-left ul li a:hover {\r\n  color: inherit !important;\r\n}\r\n.panel-left ul li.seemore {\r\n  padding-left: 45px;\r\n}\r\n.panel-left ul li.seemore a {\r\n  color: #191919 !important;\r\n  font-size: 15px;\r\n}\r\n.panel-left .memb-follow .memb-item {\r\n  padding: 10px 0px;\r\n  border-bottom: 1px dashed #f1f1f1;\r\n}\r\n.panel-left .memb-follow .memb-item:last-child {\r\n  border-bottom: none;\r\n}\r\n.panel-left .memb-follow .memb-item .inf-box {\r\n  margin-left: 10px;\r\n}\r\n.panel-left .memb-follow .memb-item .img-cover {\r\n  height: 35px;\r\n  width: 35px;\r\n  border-radius: 100px;\r\n  background-color: #e9e9e9;\r\n  border: 1px solid #e8e8e8;\r\n}\r\n.panel-left .memb-follow .memb-item small.ml-auto.text-secondary {\r\n  font-size: 0.77rem;\r\n}\r\n.cntry-news img {\r\n  width: 644px !important;\r\n  max-width: 100%;\r\n}\r\n.cntry-news p,\r\n.cntry-news span {\r\n  font-size: 1.05rem;\r\n}\r\n\r\n.inpt-cntn.cmt-box .bg-img-orgnal.avtar40 {\r\n  left: 40px;\r\n  top: 10px;\r\n  border: 1px solid #f5f5f5;\r\n}\r\n.inpt-cntn .trumbowyg-box {\r\n  min-height: 102px !important;\r\n}\r\n#content.trumbowyg-editor {\r\n  padding-bottom: 36px;\r\n  padding-right: 40;\r\n  background-color: #fff;\r\n  min-height: 102px !important;\r\n  height: auto !important;\r\n  border-radius: 5px;\r\n}\r\n.inpt-cntn .trumbowyg-button-pane {\r\n  background-color: #f5faff;\r\n}\r\n.inpt-cntn .btn-send,\r\n.inpt-cntn .btn-send-trumb,\r\n.inpt-cntn .btn-send-cmt {\r\n  width: 22px;\r\n  height: 22px;\r\n  top: 22px;\r\n  right: 45px;\r\n  cursor: pointer;\r\n  background-size: cover;\r\n}\r\n.inpt-cntn .btn-send-trumb {\r\n  right: 12px !important;\r\n}\r\n.post-box {\r\n  border: 1px solid #e1e1e1 !important;\r\n  border-radius: 5px;\r\n  background-color: #fff;\r\n  margin-bottom: 20px;\r\n  word-wrap: break-word;\r\n  box-shadow: 0 1px 0px rgb(0 0 0 / 15%);\r\n}\r\n.post-box .inpt-cntn {\r\n  position: relative;\r\n}\r\n.post-box .inpt-cntn.cmnt-box {\r\n  margin: 15px 0;\r\n}\r\n.post-box .inpt-cntn textarea {\r\n  height: 115px;\r\n  padding-left: 65px;\r\n  padding-top: 20px;\r\n  border-radius: 0;\r\n  border-top: none;\r\n  border-left: none;\r\n  border-right: none;\r\n}\r\n\r\n.post-box .inpt-cntn img,\r\n.post-box .inpt-cntn .avtar {\r\n  position: absolute;\r\n  left: 20px;\r\n  top: 20px;\r\n  height: 60px;\r\n}\r\n.post-box .inpt-cntn .avtar .bg-img-orgnal {\r\n  border-radius: 100px;\r\n}\r\n.post-box .btn-post {\r\n  height: 50px;\r\n  padding: 0 8px;\r\n  position: relative;\r\n}\r\n.post-box input[type='file'] {\r\n  text-indent: -2000;\r\n  background: none;\r\n  border: none;\r\n  width: 28px;\r\n  z-index: 1;\r\n  box-shadow: none;\r\n}\r\n.post-box input[type='file']:focus {\r\n  box-shadow: none;\r\n}\r\n.post-box .btn-post .icon-library {\r\n  font-size: 28px;\r\n  position: absolute;\r\n  left: 8px;\r\n  color: #009a59;\r\n}\r\n.post-box .btn-post .btn {\r\n  text-transform: uppercase;\r\n  font-weight: 600;\r\n  color: #fff;\r\n  background-image: linear-gradient(to right, #009a59, #00ad64, #009a59);\r\n}\r\n.post-box .btn-post .btn:hover {\r\n  background-color: #08975c;\r\n}\r\n.post-box .inpt-cntn.cmnt-box textarea {\r\n  border: 1px solid #dbdbdb;\r\n}\r\n.post-box .pin_droplist {\r\n  align-items: center;\r\n  height: 29px;\r\n}\r\n.post-box .pin_droplist .pin-icon {\r\n  width: 20px;\r\n  transform: rotate(-45deg);\r\n}\r\n.inpt-cntn.cmnt-box textarea {\r\n  border: 1px solid #eeeeee;\r\n  height: 95px;\r\n  margin-bottom: 10px;\r\n  height: 77px;\r\n  padding-left: 60px;\r\n  padding-top: 15px;\r\n}\r\n.inpt-cntn.cmnt-box .btn-solid {\r\n  background-color: #ffbe28;\r\n  border: 1px solid #e49c00;\r\n  text-transform: uppercase;\r\n  font-weight: 600;\r\n}\r\n.inpt-cntn.cmnt-box .btn-solid:hover {\r\n  background-color: #ffb208;\r\n}\r\n.inpt-cntn.cmnt-box .btn-line {\r\n  border: 1px solid #c5ccc9;\r\n  text-transform: uppercase;\r\n  font-weight: 600;\r\n  color: #59635f;\r\n  margin-right: 10px;\r\n  background-color: #f8f8f8;\r\n}\r\n.inpt-cntn.cmnt-box .btn-line:hover {\r\n  background-color: #eaeaea;\r\n}\r\n.inpt-cntn.cmnt-box img,\r\n.inpt-cntn.cmnt-box .avtar {\r\n  height: 50px;\r\n  width: 50px;\r\n  top: 15px;\r\n  left: 15px;\r\n  /* padding-top: 50px; */\r\n}\r\n\r\n.user-inf {\r\n  padding: 0px 5px;\r\n  /*border-bottom: 1px dashed #dfdfdf;*/\r\n}\r\n\r\n.member_rate_in_month.text-end .icon-start-arrow {\r\n  color: #919191;\r\n}\r\n\r\n.post-box .user-inf > a {\r\n  display: flex;\r\n  align-items: center !important;\r\n}\r\n.user-inf img {\r\n  height: 45px;\r\n  width: 45px;\r\n  margin-right: 6px;\r\n  border-radius: 100px;\r\n  border: 1px solid #e9e9e9;\r\n}\r\n.user-inf p {\r\n  line-height: inherit;\r\n  margin-bottom: 0;\r\n}\r\n.user-inf p.user-name {\r\n  font-size: 17px;\r\n  font-weight: 600;\r\n}\r\n.user-inf p.post-time {\r\n  font-size: 13px;\r\n  color: #828282;\r\n}\r\n.post-box .posted-inf {\r\n  padding: 15px 15px 0;\r\n}\r\n/*.post-box .posted-inf .cont-desc{margin-top: 15px;}*/\r\n.post-box .posted-inf .cont-desc .fst-italic {\r\n  font-size: 16px;\r\n  margin-top: 10px;\r\n}\r\n.post-box .posted-inf .cont,\r\n.post-box .posted-inf .cont-desc {\r\n  margin-bottom: 15px;\r\n}\r\n.post-box .posted-inf .fav-inf {\r\n  color: #6b6b6b;\r\n  font-weight: normal;\r\n}\r\n.post-box .posted-inf .fav-inf > div {\r\n  font-size: 14px;\r\n  margin-left: 15px;\r\n}\r\n.post-box .posted-inf .fav-inf > div.like {\r\n  margin: inherit;\r\n  align-items: center;\r\n  display: flex;\r\n}\r\n.post-box .posted-inf .fav-inf .icon-like-fb {\r\n  font-size: 18px;\r\n  margin-right: 4px;\r\n  color: #586fb5;\r\n}\r\n.post-box .posted-inf .fav-inf,\r\n.post-box .posted-inf .fav-ctrl {\r\n  height: 50px;\r\n}\r\n\r\n.post-box .posted-inf .fav-inf .like .icon-eye-line01 {\r\n  font-size: 0.68rem;\r\n}\r\n.post-box .posted-inf .fav-ctrl {\r\n  font-size: 15px;\r\n  background-color: #f5f5f5;\r\n  border-bottom: 1px solid #eaeaea;\r\n  margin-bottom: 0px;\r\n  width: calc(100% + 30px);\r\n  margin-left: -15px;\r\n  border-radius: 0 0 5px 5px;\r\n}\r\n.post-box .posted-inf .fav-ctrl .like,\r\n.post-box .posted-inf .fav-ctrl .cmnt,\r\n.post-box .posted-inf .fav-ctrl .share {\r\n  text-decoration: none;\r\n  color: inherit;\r\n  display: inline-block;\r\n  cursor: pointer;\r\n}\r\n.post-box .posted-inf .fav-ctrl .share .post-report .btn.dropdown-toggle {\r\n  margin-left: 0;\r\n}\r\n.post-box .posted-inf .fav-ctrl .share .dropdown-toggle:after {\r\n  display: none;\r\n}\r\n.post-box .posted-inf .fav-ctrl [class^='icon-']:before {\r\n  color: #808080;\r\n}\r\n.post-box .posted-inf .fav-ctrl .icon-like01 {\r\n  font-size: 1.4rem;\r\n}\r\n.post-box .posted-inf .fav-ctrl .icon-get-gift {\r\n  font-size: 1.62rem;\r\n}\r\n.post-box .posted-inf .fav-ctrl .icon-share01 {\r\n  font-size: 1.23rem;\r\n}\r\n.post-box .posted-inf .fav-ctrl .icon-comment-line {\r\n  font-size: 1.26rem;\r\n}\r\n.post-box .posted-inf .fav-ctrl .fw-bold {\r\n  font-weight: 600 !important;\r\n}\r\n.post-box .posted-inf .fav-ctrl .icon-bonus {\r\n  color: #828282;\r\n}\r\n.post-box .posted-inf .fav-ctrl .share button.btn:focus {\r\n  box-shadow: none;\r\n  border-color: transparent;\r\n}\r\n.post-box .posted-inf .fav-ctrl > div:hover span,\r\n.post-box .posted-inf .fav-ctrl > div:hover span:before,\r\n.post-box .posted-inf .fav-ctrl > div.active span,\r\n.post-box .posted-inf .fav-ctrl a:hover,\r\n.post-box .posted-inf .cmt-listing .active.like,\r\n.post-box .posted-inf .cmt-listing .active.like .icon-like,\r\n.post-box .posted-inf .cmt-listing .active.like .icon-like01 {\r\n  color: #009a59;\r\n}\r\n.post-box .posted-inf .cmt-box .user-inf a:hover {\r\n  color: inherit !important;\r\n}\r\n.post-box .posted-inf .cmt-box .user-inf a.active {\r\n  color: #009a59 !important;\r\n}\r\n.post-box .posted-inf .group-img01 .bg-img {\r\n  height: 288px;\r\n}\r\n.post-box .posted-inf .group-img02 .bg-img {\r\n  height: 200px;\r\n}\r\n.post-box .posted-inf .group-img03 .bg-img.main-img {\r\n  height: 268px;\r\n}\r\n.post-box .posted-inf .group-img03 .bg-img.sub-img {\r\n  height: 132px;\r\n}\r\n.post-box .posted-inf .group-img03 .img-plus {\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n  text-align: center;\r\n}\r\n.post-box .posted-inf .group-img03 .img-plus:before {\r\n  width: 100%;\r\n  height: 100%;\r\n  background-color: #000;\r\n  position: absolute;\r\n  content: '';\r\n  opacity: 0.4;\r\n}\r\n.post-box .posted-inf .group-img03 .img-plus span {\r\n  position: absolute;\r\n  left: calc(50% - 13px);\r\n  color: #fff;\r\n  font-size: 28px;\r\n  font-weight: bold;\r\n}\r\n.post-box .posted-inf .sharing-post .bg-img {\r\n  height: 288px;\r\n  background-color: #f6f6f6;\r\n}\r\n.post-box .posted-inf .sharing-post .cont-desc .row.align-items-center {\r\n  border-top: 1px dashed #dedede;\r\n  padding-top: 15px;\r\n  margin-top: 4px;\r\n}\r\n.post-box .posted-inf .sharing-post .cont-desc .row.align-items-center:first-child {\r\n  border-top: none !important;\r\n  padding-top: 0;\r\n}\r\n.post-box .posted-inf .sharing-post .author-frm {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-top: 14px;\r\n  margin-bottom: 8px;\r\n  margin-right: 10px;\r\n}\r\n.post-box .posted-inf .sharing-post .author-frm img {\r\n  border-radius: 100px;\r\n  height: 30px;\r\n  width: 30px;\r\n}\r\n.post-box .posted-inf .sharing-post .author-frm .user-name {\r\n  font-size: 15px;\r\n  font-weight: 600;\r\n  margin-left: 10px;\r\n}\r\n.post-box .posted-inf .cont-link {\r\n  margin-bottom: 15px;\r\n}\r\n.post-box .posted-inf .cont-link a {\r\n  color: #009a59 !important;\r\n}\r\n.post-box .posted-inf .cont-link a:hover {\r\n  color: inherit !important;\r\n}\r\n.post-box .post-report .icon-menu-dot {\r\n  font-size: 3.5px;\r\n  color: #818181;\r\n}\r\n.post-box .post-report .btn.dropdown-toggle {\r\n  padding: 5px;\r\n  transition: 0.3s all ease;\r\n  margin-left: 13px;\r\n  border: none;\r\n  height: 32px; /*background-color: #f5f5f5;*/\r\n  border-radius: 5px;\r\n}\r\n.post-box .post-report .btn.dropdown-toggle:focus {\r\n  /*border-color: transparent;border: none;*/\r\n  box-shadow: none;\r\n}\r\n/* .post-box .post-report .dropdown-toggle::after {\r\n  display: none;\r\n} */\r\n.post-box .post-report ul.dropdown-menu-end {\r\n  margin-top: 18px !important;\r\n  text-align: center;\r\n  box-shadow: #cbcbcb 0px 0px 2px;\r\n  border: 1px solid #bfbfbf6b;\r\n  margin-right: -8px !important;\r\n}\r\n.post-box .post-report ul .dropdown-item:hover {\r\n  background-color: #ebebeb;\r\n}\r\n.post-box .post-report ul .dropdown-item {\r\n  border-bottom: 1px solid #e6e6e6;\r\n  padding: 6px;\r\n  font-size: 15px;\r\n}\r\n.post-box .post-report ul .dropdown-item:last-child {\r\n  border-bottom: none;\r\n}\r\n.post-box .post-report ul li:last-child .dropdown-item {\r\n  border-bottom: none;\r\n}\r\n.post-box .post-report .dropdown-toggle:hover .icon-menu-dot {\r\n  color: #666666;\r\n}\r\n.ql-container.ql-snow .ql-tooltip {\r\n  left: auto !important;\r\n  top: auto !important;\r\n}\r\n.ql-container.ql-snow .ql-tooltip.ql-editing input[type='text']:focus,\r\n.products .ql-container.ql-snow .ql-tooltip.ql-editing input[type='text']::focus-visible {\r\n  border-color: #0cab6b;\r\n  box-shadow: 0 0 0 0.25rem rgb(223 229 233);\r\n}\r\n\r\n/* .user-inf .actions .dropdown {\r\n  visibility: hidden;\r\n} */\r\n\r\n/* .user-inf:hover .dropdown {\r\n  visibility: visible;\r\n} */\r\n.cmt-box .post-report .dropdown-toggle:hover .icon-menu-dot {\r\n  color: #666666;\r\n}\r\n.cmt-box .post-report .dropdown-toggle::after {\r\n  display: none;\r\n}\r\n.cmt-box .post-report .btn.dropdown-toggle:focus {\r\n  border-color: transparent;\r\n  box-shadow: none;\r\n  border: none;\r\n}\r\n\r\n/* .cmt-listing .actions:hover .dropdown {\r\n  visibility: visible;\r\n} */\r\n\r\n/* .cmt-box .cmt-listing .mt-3:hover .dropdown {\r\n  visibility: visible;\r\n} */\r\n\r\n.cmt-box .cmt-listing input {\r\n  width: calc(100% - 54px);\r\n  display: inline-block;\r\n  margin-top: 10px;\r\n  border: 1px solid #dbdbdb;\r\n}\r\n.cmt-box .cmt-listing input:focus,\r\n.cmt-listing .user-inf input:focus-visible {\r\n  border: solid 1px #00800042;\r\n  box-shadow: 0 0 0 0.25rem rgb(223 229 233);\r\n  outline: none;\r\n}\r\n\r\n.cmt-box .cmt-listing .icon-like01 {\r\n  font-size: 19px;\r\n  margin-right: 4px;\r\n  color: #919191;\r\n}\r\n\r\n.cmt-box .cmt-listing .active.like .icon-like01,\r\n.cmt-box .cmt-listing .like.active {\r\n  color: #009a59 !important;\r\n}\r\n\r\n.cmt-box .cmt-listing .icon-comment-line {\r\n  font-size: 16px;\r\n  margin-right: 4px;\r\n}\r\n.cmt-listing .post-report .icon-menu-dot {\r\n  font-size: 5px;\r\n  color: grey;\r\n}\r\n.cmt-listing .post-report .btn:focus {\r\n  box-shadow: none;\r\n  border: none;\r\n}\r\n\r\n.post-more {\r\n  text-align: center;\r\n  /*border-top: 1px solid #e9e9e9;*/\r\n  border-bottom: 1px solid #e9e9e9;\r\n  padding: 10px 0;\r\n  margin-top: 40px;\r\n  margin-bottom: 50px;\r\n}\r\n.post-more {\r\n  cursor: pointer;\r\n}\r\n.post-more a {\r\n  color: inherit;\r\n}\r\n.post-more .icon-arrow-solid {\r\n  font-size: 7px;\r\n  margin-left: 4px;\r\n  display: inline-block;\r\n  margin-top: -1px;\r\n  vertical-align: middle;\r\n  color: #5d5d5d;\r\n}\r\n\r\n.box-bd {\r\n  border: 1px solid #e1e1e1;\r\n  border-radius: 5px;\r\n  background-color: #fff;\r\n  margin-bottom: 15px;\r\n  padding-bottom: 10px;\r\n  padding: 0 10px;\r\n}\r\n.box-bd.hotnews.position-relative,\r\n.box-bd.newnews.position-relative {\r\n  padding-top: 70px;\r\n}\r\n.box-bd.hotnews.position-relative .bg-img.position-relative,\r\n.box-bd.newnews.position-relative .bg-img.position-relative {\r\n  margin-bottom: 5px;\r\n}\r\n.box-bd .title {\r\n  height: 44px;\r\n  border-bottom: 1px #e2e2e2 solid;\r\n  padding: 0 15px;\r\n  margin-bottom: 15px;\r\n  width: calc(100% + 0px);\r\n  margin-left: -10px;\r\n}\r\n.box-bd.hotnews.position-relative .title,\r\n.box-bd.newnews.position-relative .title {\r\n  position: absolute;\r\n  top: 5px;\r\n}\r\n.box-bd .title .icon-menu-sub:before {\r\n  color: #6d6d6d;\r\n  font-size: 15px;\r\n}\r\n.box-bd .title .txt {\r\n  color: #191919;\r\n  font-size: 19px;\r\n  font-weight: 700;\r\n  text-transform: capitalize;\r\n}\r\n.box-bd .title a.icon-menu-sub {\r\n  color: inherit;\r\n}\r\n.box-bd.hotnews .news-item {\r\n  position: relative;\r\n  margin-bottom: 10px;\r\n  display: block;\r\n  height: 95px;\r\n}\r\n.box-bd.hotnews .news-item img {\r\n  border-radius: 5px;\r\n  box-shadow: 0 2px 4px rgb(0 0 0 / 60%);\r\n}\r\n.box-bd.hotnews .news-item .bg-img {\r\n  height: 95px;\r\n  border-radius: 5px;\r\n  box-shadow: 0 2px 4px rgb(0 0 0 / 60%);\r\n  transition: 0.3s all ease;\r\n}\r\n.box-bd.hotnews .news-item .txt {\r\n  position: absolute;\r\n  bottom: 26px;\r\n  line-height: 19px;\r\n  left: 0px;\r\n  padding: 0 15px 0px 15px;\r\n  color: #fff;\r\n  font-weight: 600;\r\n  text-shadow: 1px 1px 1px #1e1e1e;\r\n}\r\n\r\n.box-bd.newnews .news-item {\r\n  background-color: #fff;\r\n  border-radius: 5px;\r\n  transition: all 0.3s ease-in-out;\r\n  transition: 0.3s all ease;\r\n}\r\n.box-bd.newnews .news-item .bg-img {\r\n  height: 114px;\r\n  border-radius: 5px 5px 0 0;\r\n}\r\n.box-bd.newnews .container {\r\n  padding-right: 8px;\r\n  padding-left: 8px;\r\n}\r\n.box-bd.newnews .row-cols-2 > * {\r\n  padding-right: calc(var(--bs-gutter-x) * 0.25);\r\n  padding-left: calc(var(--bs-gutter-x) * 0.25);\r\n  margin-bottom: 0px;\r\n}\r\n.box-bd.newnews a {\r\n  color: inherit;\r\n}\r\n.box-bd.newnews .title-item {\r\n  margin-top: 10px;\r\n}\r\n.box-bd.newnews .title-item .txt-name {\r\n  font-weight: 500;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  display: block;\r\n  margin-bottom: 4px;\r\n  font-size: 16px;\r\n}\r\n.box-bd.newnews .locatn {\r\n  font-size: 13px;\r\n  color: #595959;\r\n  height: 20px;\r\n  display: block;\r\n}\r\n.box-bd.newnews .price-item {\r\n  font-size: 13px;\r\n}\r\n.box-bd.newnews .news-item:hover,\r\n.box-bd.hotnews .news-item:hover .bg-img {\r\n  box-shadow: 0 2px 4px rgb(0 0 0 / 28%);\r\n}\r\n.box-bd.newnews .news-item:hover .txt-name {\r\n  color: initial !important;\r\n}\r\n.box-bd.newnews .news-item a:hover {\r\n  color: inherit !important;\r\n}\r\n.box-bd.newnews .news-item a:hover .red-clr {\r\n  color: #e52f19 !important;\r\n}\r\n.box-bd.newnews .news-item:hover .price-item .red-clr,\r\n.box-bd.newnews .news-item a:hover .red-clr {\r\n  color: #e52f19 !important;\r\n}\r\n.mkt-prod {\r\n  border-radius: 5px;\r\n  margin-bottom: 20px;\r\n  margin-top: 1.2rem;\r\n  background-color: #fff;\r\n  padding-bottom: 2px;\r\n}\r\n.mkt-prod .more-btn-fll {\r\n  width: calc(100% - 20px);\r\n  margin-left: 10px;\r\n}\r\n.mkt-prod > div {\r\n  padding: 13px 8px;\r\n}\r\n.mkt-prod h3 {\r\n  font-size: 1.58rem;\r\n}\r\n.mkt-prod .mkt-title {\r\n  font-size: 19px;\r\n  padding: 0 15px;\r\n  font-weight: 700;\r\n  font-family: 'helvetica-neue-condensed-regular';\r\n  text-transform: capitalize;\r\n}\r\n.mkt-prod .table {\r\n  font-size: 0.85rem;\r\n  margin-bottom: 10px;\r\n}\r\n.mkt-prod .table small {\r\n  font-size: 80%;\r\n}\r\n.mkt-prod .table thead {\r\n  background-color: #ffffff;\r\n  color: #8f979e;\r\n  font-size: 14px;\r\n}\r\n.mkt-prod .table thead th {\r\n  font-weight: normal;\r\n}\r\n.mkt-prod .table .redu-pri,\r\n.mkt-price-details .redu-pri {\r\n  color: #fc4400;\r\n  font-weight: 500;\r\n}\r\n.mkt-prod .table .incr-pri,\r\n.mkt-price-details .incr-pri {\r\n  color: #1cc619;\r\n  font-weight: 500;\r\n}\r\n\r\n.mkt-prod .table tr {\r\n  /*border-bottom: 1px solid #e1e1e1;*/\r\n}\r\n.mkt-prod .table td.line-clamp-01 {\r\n  width: 100px;\r\n}\r\n\r\n.mkt-prod .table > :not(caption) > * > * {\r\n  border-bottom: none;\r\n  vertical-align: middle;\r\n}\r\n.mkt-prod tr.text-center {\r\n  background-color: #e9e9e9;\r\n}\r\n.mkt-prod .table a .icon-arrow-solid {\r\n  font-size: 6px;\r\n  color: #009a59;\r\n  margin-top: -1px;\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n}\r\n.mkt-prod .table a .txt {\r\n  color: #009a59;\r\n  margin-right: 4px;\r\n}\r\n.mkt-prod .update-time {\r\n  font-size: 13px;\r\n}\r\n.mkt-prod table.table tbody {\r\n  border-top: 2px solid #ededed;\r\n}\r\n.mkt-prod table.table thead tr th {\r\n  padding: 0.8rem 0.5rem;\r\n  color: #191919;\r\n  font-weight: 500;\r\n  background-color: #f5faff;\r\n  border-top: none;\r\n}\r\n.mkt-prod table.table tbody tr td {\r\n  padding: 0.5rem 0.32rem;\r\n  border-top: 1px solid #efefef;\r\n}\r\n.mkt-prod .update-time {\r\n  padding: 0 15px;\r\n  margin: -2px 0 10px;\r\n}\r\n.mkt-prod a.ms-auto {\r\n  background-image: linear-gradient(to right, #ffa908, #fad53b, #ffa908);\r\n  border: none;\r\n  border-radius: 100px;\r\n  height: 24px;\r\n  padding: 1px 9px;\r\n  font-size: 0.85rem;\r\n}\r\n.mkt-prod table .line-clamp-01 {\r\n  width: 100px;\r\n}\r\n\r\n.pt-show,\r\n.vd-show {\r\n  margin-right: 12px;\r\n}\r\n.pt-show .bg-img,\r\n.vd-show .bg-img {\r\n  height: 52px;\r\n  width: 77px;\r\n}\r\n.sub_vid .bg-img {\r\n  background-size: cover !important;\r\n  width: 100%;\r\n  padding-top: 62%;\r\n  background-position: 50% !important;\r\n  border-radius: 2px;\r\n}\r\n.box-bd.videonews .container {\r\n  padding: 0;\r\n}\r\n.box-bd.videonews .video-item {\r\n  font-size: 15px;\r\n  color: inherit;\r\n  padding-bottom: 10px;\r\n  margin-bottom: 10px;\r\n  color: inherit;\r\n  border-bottom: 1px solid #dfdfdf;\r\n}\r\n.box-bd.videonews .video-item:last-child {\r\n  border-bottom: none;\r\n  margin-bottom: 0;\r\n}\r\n.box-bd.videonews .video-item > div:last-child {\r\n  padding-left: 0;\r\n}\r\n.box-bd.videonews .video {\r\n  width: 150px;\r\n  margin-right: 12px;\r\n}\r\n.box-bd.videonews .bg-img {\r\n  height: 52px;\r\n}\r\n\r\n/*.cont-center .bg-img-orgnal{padding-top: 180px;}*/\r\n.cont-center .hashtag-title {\r\n  font-size: 20px;\r\n  line-height: 25px;\r\n  margin-top: 12px;\r\n}\r\n.news-item,\r\n.video-item {\r\n  padding: 0;\r\n  font-size: 15px;\r\n  color: inherit;\r\n  padding-bottom: 10px;\r\n  margin-bottom: 10px;\r\n  border-bottom: 1px solid #dddada;\r\n}\r\n.news-item:last-child,\r\n.video-item:last-child {\r\n  border-bottom: none;\r\n}\r\n.cont-center .col-md-6 .news-item:last-child {\r\n  border-bottom: none;\r\n}\r\n.cont-center .news-item > div:last-child {\r\n  padding-left: 0;\r\n}\r\n.cont-center .news-item .pt-show {\r\n  margin-right: 12px;\r\n}\r\n.cont-center .trend-sectn {\r\n  padding: 6px 0;\r\n  margin-top: 15px;\r\n  border-top: 1px solid #dddada;\r\n  border-bottom: 1px solid #dddada;\r\n}\r\n.cont-center .trend-sectn ul {\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n.cont-center .trend-sectn ul li {\r\n  margin: 0;\r\n  padding: 0;\r\n  display: inline-block;\r\n  font-size: 13px;\r\n}\r\n.cont-center .trend-sectn ul li a {\r\n  color: #00509a !important;\r\n  padding: 0 13px;\r\n}\r\n.cont-center .trend-sectn ul li a:hover {\r\n  color: inherit !important;\r\n}\r\n.cont-center .trend-sectn .icon-flash {\r\n  font-size: 20px;\r\n}\r\n.cont-center .news-more {\r\n  margin-top: 15px;\r\n}\r\n\r\n.cont-center {\r\n  margin-top: 5px !important;\r\n}\r\n.cont-center .breadcrumb {\r\n  background-color: transparent;\r\n}\r\n.cont-center .breadcrumb a {\r\n  color: #0d6efd !important;\r\n  font-weight: 500;\r\n}\r\n.cont-center .breadcrumb-item + .breadcrumb-item::before {\r\n  display: none;\r\n}\r\n.cont-center .breadcrumb .icon-arrow-black {\r\n  font-size: 0.8rem;\r\n  margin-right: 6px;\r\n  color: #bcbcbc;\r\n}\r\n.cont-center h3 {\r\n  font-size: 20px;\r\n  font-weight: bold;\r\n  margin-bottom: 20px;\r\n}\r\n.cont-center h2,\r\n.cont-center h2 {\r\n  margin-top: 20px;\r\n}\r\n.cont-center h3 .icon-menu-sub {\r\n  margin-right: 10px;\r\n}\r\n.cont-center .col-md-6 a .bg-img-orgnal {\r\n  padding-top: 226px;\r\n}\r\n\r\n.modal {\r\n  z-index: 999999999;\r\n}\r\n.modal-header {\r\n  background-color: #f1f1f1;\r\n}\r\n.modal-dialog.modal-lg .btn-custm {\r\n  position: absolute;\r\n  right: 5px;\r\n  top: 5px;\r\n  z-index: 9;\r\n}\r\n.modal-dialog.modal-lg .modal-content input {\r\n  background-color: #00a35d;\r\n  color: #fff;\r\n  margin-bottom: 17px;\r\n  padding: 8px 15px;\r\n  border-radius: 6px;\r\n}\r\n.modal-dialog.modal-lg .modal-content input:focus {\r\n  box-shadow: none;\r\n}\r\n.modal-dialog.modal-lg .modal-content input::placeholder {\r\n  /* Chrome, Firefox, Opera, Safari 10.1+ */\r\n  color: #fff !important;\r\n  font-size: 15px;\r\n  opacity: 0.6; /* Firefox */\r\n}\r\n.modal-dialog.modal-lg .modal-content input::-ms-input-placeholder {\r\n  /* Microsoft Edge */\r\n  color: #fff !important;\r\n  font-size: 15px;\r\n  opacity: 0.8;\r\n}\r\n.modal-dialog.modal-lg .modal-content .btn {\r\n  background-color: #939aa0;\r\n  font-size: 13px;\r\n  color: #fff;\r\n  display: block;\r\n  text-transform: none;\r\n  width: 100%;\r\n  padding: 8px 0;\r\n}\r\n.modal-dialog.modal-lg .modal-content .login-form h5 {\r\n  display: block;\r\n  border-bottom: 3px solid #009a59;\r\n  color: #009a59;\r\n  font-weight: bold;\r\n  padding-bottom: 10px;\r\n  text-align: center;\r\n  margin-bottom: 15px;\r\n  font-size: 22px;\r\n  width: calc(100% + 0.75rem);\r\n}\r\n.modal-dialog.modal-lg .modal-content .login-form a.fst-italic {\r\n  text-align: center;\r\n  width: 100%;\r\n  margin-top: 10px;\r\n  color: inherit;\r\n  display: inline-block;\r\n  margin-bottom: 85px;\r\n}\r\n.modal-dialog.modal-lg .modal-content .or-line {\r\n  border-bottom: 1px solid #939aa0;\r\n  position: relative;\r\n  text-align: center;\r\n  margin-left: 10%;\r\n  width: 80%;\r\n  margin-top: 10px;\r\n}\r\n.modal-dialog.modal-lg .modal-content .or-line span {\r\n  display: inline-block;\r\n  padding: 10px 20px;\r\n  background-color: #fff;\r\n  margin-bottom: -19px;\r\n  font-size: 13px;\r\n}\r\n.modal-dialog.modal-lg .modal-content .fa-zalo {\r\n  margin-top: 28px;\r\n}\r\n.modal-dialog.modal-lg .modal-content .fa-zalo a {\r\n  display: inline-block;\r\n  margin: 0 8px;\r\n}\r\n.modal-dialog.modal-lg .modal-content .fa-zalo a img {\r\n  height: 55px;\r\n}\r\n.modal-dialog.modal-lg .modal-content .regist-form {\r\n  position: relative;\r\n}\r\n.modal-dialog.modal-lg .modal-content .regist-form:before {\r\n  content: '';\r\n  display: inline-block;\r\n  width: 3px;\r\n  height: calc(100% - 55px);\r\n  background-color: #eee;\r\n  position: absolute;\r\n  left: 0;\r\n  top: 55px;\r\n}\r\n.modal-dialog.modal-lg .modal-content .regist-form h5 {\r\n  display: block;\r\n  border-bottom: 3px solid #eee;\r\n  font-weight: lighter;\r\n  color: #939aa0;\r\n  padding-bottom: 10px;\r\n  text-align: center;\r\n  margin-bottom: 15px;\r\n  font-size: 22px;\r\n  margin-left: -0.75rem;\r\n}\r\n.modal-dialog.modal-lg .alert-invalid {\r\n  margin-top: -15px;\r\n  margin-bottom: 10px;\r\n}\r\n.profile-page {\r\n  max-width: 68% !important;\r\n  margin: 0px auto 40px;\r\n}\r\n.profile-page form .inf-box {\r\n  padding: 20px;\r\n  border-radius: 6px;\r\n  margin-bottom: 20px;\r\n  background-color: #e9ecef;\r\n  border: 1px solid #e3e3e3;\r\n}\r\n.profile-page .inf-box {\r\n  margin-bottom: 15px;\r\n}\r\n.profile-page .upload-avatar {\r\n  position: relative;\r\n  width: 100px;\r\n  display: inline-block;\r\n}\r\n.profile-page .upload-avatar input[type='file'] {\r\n  text-indent: -20000;\r\n  background: none;\r\n  border: none;\r\n  width: 28px;\r\n  z-index: 1;\r\n  box-shadow: none;\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  margin: 0;\r\n}\r\n.profile-page .upload-avatar img {\r\n  height: 100px;\r\n  height: 100px;\r\n  width: 100px;\r\n  border-radius: 100px;\r\n  box-shadow: 0 0 0 0.25rem #e5e5e5;\r\n  border: 1px solid #dedede;\r\n}\r\n.profile-page .upload-avatar .icon-camera {\r\n  position: absolute;\r\n  top: 10px;\r\n  right: 0;\r\n  font-size: 26px;\r\n  color: #ffa608;\r\n  cursor: pointer;\r\n}\r\n.profile-page .upload-avatar .icon-camera:hover {\r\n  color: #fff;\r\n}\r\n.profile-page p {\r\n  margin-top: 6px;\r\n  font-size: 20px;\r\n  margin-bottom: 0;\r\n}\r\n.profile-page .user-type {\r\n  margin-bottom: 10px;\r\n}\r\n.profile-page .level-box .txt,\r\n.profile-page .bonus-box .txt {\r\n  font-size: 80%;\r\n  color: #6e6e6e;\r\n  vertical-align: 2px;\r\n  margin-right: 8px;\r\n}\r\n.profile-page .level-box .level,\r\n.profile-page .bonus-box .point {\r\n  font-size: 20px;\r\n  color: #009a59;\r\n  font-weight: 600;\r\n}\r\n.profile-page input {\r\n  background-color: #fbfbfb;\r\n  /*box-shadow: 0 0 0 0.25rem #f1f1f1;*/\r\n  height: 38px;\r\n  line-height: 38px;\r\n  margin-bottom: 18px;\r\n  border: 1px solid #dddddd;\r\n}\r\n.profile-page input:focus {\r\n  box-shadow: none;\r\n}\r\n/*.profile-page.container input:focus{box-shadow: 0 0 0 0.25rem rgb(12 171 107 / 15%);}*/\r\n.profile-page label {\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n}\r\n.profile-page label + .react-datepicker-wrapper {\r\n  display: block;\r\n}\r\n.profile-page .alert-invalid {\r\n  margin-top: -15px;\r\n  margin-bottom: 10px;\r\n}\r\n.profile-page form .name-txt {\r\n  font-weight: 600;\r\n}\r\n.profile-page .inf-box a {\r\n  color: #ffa60d !important;\r\n}\r\n.profile-page .inf-box .change-pwd {\r\n  margin-top: 10px;\r\n  margin-left: 6px;\r\n  cursor: pointer;\r\n  font-size: 90%;\r\n}\r\n.profile-page .dropdown-toggle,\r\n.profile-page.container .select-selected,\r\n.custom-select .select-selected {\r\n  width: 100%;\r\n  background-color: #fbfbfb;\r\n  border: none;\r\n  box-shadow: 0 0 0 0.25rem #f1f1f1;\r\n  height: 42px;\r\n  line-height: 30px;\r\n  border: 1px solid #ced4da;\r\n  text-align: left;\r\n  position: relative;\r\n  font-size: 1rem;\r\n}\r\n.form-select:focus {\r\n  border-color: #0cab6b !important;\r\n  box-shadow: 0 0 0 0.25rem rgb(223 229 233) !important;\r\n}\r\n.form-select.form-select-sm {\r\n  font-size: 1rem;\r\n  padding-top: 0.375rem;\r\n  padding-bottom: 0.375rem;\r\n}\r\n.profile-page .dropdown-toggle::after {\r\n  position: absolute;\r\n  right: 13px;\r\n  top: 20px;\r\n}\r\n.profile-page .btn.btn-danger {\r\n  text-transform: uppercase;\r\n  font-size: 18px;\r\n  font-weight: 600;\r\n  margin-top: 15px;\r\n  background-image: linear-gradient(to right, #ffa908, #fad53b, #ffa908);\r\n  color: #191919;\r\n  border-color: transparent;\r\n  font-size: 17px;\r\n}\r\n.profile-page .btn.btn-danger:focus,\r\n.profile-page .btn.btn-danger:focus-visible {\r\n  box-shadow: 0 0 0 0.2rem rgb(254 179 24 / 28%);\r\n}\r\n.profile-page .fw-bold {\r\n  color: #515151;\r\n}\r\n.profile-page small {\r\n  color: #515151;\r\n}\r\n\r\n.sharing-box {\r\n  margin-bottom: 28px;\r\n}\r\n.sharing-box a span.tags,\r\n.sharing-box a {\r\n  display: inline-block;\r\n}\r\n.sharing-box a {\r\n  color: inherit;\r\n  margin: 2px 0;\r\n}\r\n.sharing-box .icon-tag {\r\n  font-size: 36px;\r\n  margin-right: 5px;\r\n  color: #0c8ecf;\r\n}\r\n.sharing-box img {\r\n  height: 36px;\r\n  margin: 0 3px;\r\n  border-radius: 6px;\r\n  width: auto !important;\r\n}\r\n.sharing-box a:last-child img {\r\n  margin-right: 0;\r\n}\r\n.sharing-box.w160 img {\r\n  height: 26px;\r\n  margin: 0 4px;\r\n  border-radius: 2px;\r\n}\r\n.sharing-box.w160 .icon-tag {\r\n  font-size: 26px;\r\n  margin-right: 0px;\r\n}\r\n.sharing-box .list-socials {\r\n  /*width: 160px;*/\r\n}\r\n.sharing-box .list_tags {\r\n  width: calc(100% - 162px);\r\n}\r\n.sharing-box .list_tags .tags {\r\n  padding: 1px 8px;\r\n  border-radius: 50px;\r\n}\r\n.links a {\r\n  color: #009a59;\r\n}\r\n.links li {\r\n  list-style: none;\r\n}\r\n.links li::before {\r\n  content: '\\2022';\r\n  color: #009a59;\r\n  font-weight: bold;\r\n  display: inline-block;\r\n  width: 1em;\r\n  margin-left: -1em;\r\n}\r\n.cmt-box {\r\n  padding: 0px 0px 20px;\r\n}\r\n.cmt-box textarea {\r\n  padding: 15px;\r\n  margin-top: 20px;\r\n}\r\n.cmt-box textarea::placeholder {\r\n  /* Chrome, Firefox, Opera, Safari 10.1+ */\r\n  color: #cecece !important;\r\n  font-size: 20px;\r\n  font-style: italic !important;\r\n  opacity: 1; /* Firefox */\r\n}\r\n.cmt-box textarea::-ms-input-placeholder {\r\n  /* Microsoft Edge */\r\n  color: #cecece !important;\r\n  font-size: 20px;\r\n  font-style: italic !important;\r\n  opacity: 1;\r\n}\r\n.cmt-box button.btn-scroll-top {\r\n  padding: 8px 13px;\r\n}\r\n.cmt-box button.btn-scroll-top .icon-arrow-black {\r\n  color: #fff;\r\n  transform: rotate(-90deg);\r\n  display: inline-block;\r\n}\r\n\r\n.cmt-listing {\r\n  margin-top: 15px;\r\n  /*border-bottom: 1px solid #e5e5e5;*/\r\n  margin-bottom: 28px;\r\n}\r\n.cmt-listing img {\r\n  height: 40px;\r\n  width: 40px;\r\n  border-radius: 50px;\r\n  margin-right: 10px;\r\n}\r\n.cmt-listing img + span {\r\n  font-weight: 600;\r\n}\r\n.cmt-listing p.txt-cmt {\r\n  margin-top: 0px;\r\n  margin-left: 55px;\r\n  margin-top: 0px;\r\n  margin-bottom: 0;\r\n}\r\n.cmt-listing .icon-arrow-solid {\r\n  font-size: 9px;\r\n  padding-left: 5px;\r\n}\r\n.cmt-listing .actions {\r\n  font-size: 14px;\r\n  margin-left: 55px;\r\n}\r\n.cmt-listing .user-inf .actions .dropdown {\r\n  display: none;\r\n}\r\n.user-inf .actions .dropdown button.btn {\r\n  padding: 0;\r\n  margin: 0;\r\n  border: none;\r\n  outline: none;\r\n  box-shadow: none;\r\n  font-size: 15px;\r\n}\r\n.cmt-listing .user-inf .actions .dropdown {\r\n  transition: all 0.3s;\r\n}\r\n.cmt-listing .user-inf:hover .actions .dropdown {\r\n  visibility: visible;\r\n}\r\n.cmt-listing .user-inf .icon-like01 {\r\n  font-size: 19px;\r\n  margin-right: 5px;\r\n  color: #000;\r\n}\r\n.cmt-listing .user-inf .icon-comment {\r\n  font-size: 17px;\r\n  margin-right: 5px;\r\n  color: #000;\r\n}\r\n.cmt-listing .user-inf input {\r\n  width: calc(100% - 54px);\r\n  display: inline-block;\r\n  margin-top: 10px;\r\n  border: 1px solid #dbdbdb;\r\n}\r\n.cmt-listing .user-inf input:focus,\r\n.cmt-listing .user-inf input:focus-visible {\r\n  border: solid 1px #00800042;\r\n  box-shadow: 0 0 0 0.25rem rgb(223 229 233);\r\n  outline: none;\r\n}\r\n.cmt-listing .btn.btn-line,\r\n.cmt-listing .btn.btn-solid {\r\n  font-size: 13px;\r\n  border-radius: 8px;\r\n  padding-left: 13px;\r\n  padding-right: 13px;\r\n  padding: 3px 10px;\r\n}\r\n.cmt-listing .btn.btn-solid {\r\n  background-color: #ffbe28 !important;\r\n  border: 1px solid #e49c00;\r\n}\r\n.cmt-listing [class^='list-sub-comment-'],\r\n.cmt-listing [class*=' list-sub-comment-'] {\r\n  position: relative;\r\n  padding: 2px 0 10px;\r\n  margin-top: 10px;\r\n}\r\n.cmt-listing [class^='list-sub-comment-'] .user-inf,\r\n.cmt-listing [class*=' list-sub-comment-'] .user-inf {\r\n  padding: 5px 15px;\r\n  margin-left: 62px;\r\n}\r\n.cmt-listing [class^='list-sub-comment-']:before,\r\n.cmt-listing [class*=' list-sub-comment-']:before {\r\n  content: '';\r\n  background-color: #fff;\r\n  width: calc(100% - 62px);\r\n  height: calc(100% - 0px);\r\n  position: absolute;\r\n  top: 0;\r\n  left: 62px;\r\n  border-radius: 5px;\r\n}\r\n.cmt-listing [class^='list-sub-comment-'] p.txt-cmt,\r\n.cmt-listing [class^='list-sub-comment-'] .actions {\r\n  margin-left: 56px;\r\n}\r\n/*.cmt-listing [class^=\"list-sub-comment-\"] .img-cmt-box , .cmt-listing [class*=\" list-sub-comment-\"] .img-cmt-box{transform: translate(70px, -1px);}*/\r\n.cmt-listing .actions-sort-cmt {\r\n  border-bottom: #dcdcdc 1px solid;\r\n}\r\n.cmt-listing .actions-sort-cmt ul {\r\n  margin-bottom: 10px;\r\n}\r\n.cmt-listing .actions-sort-cmt li {\r\n  padding: 0 15px;\r\n  position: relative;\r\n}\r\n.cmt-listing .actions-sort-cmt li.active {\r\n  color: #009a59;\r\n}\r\n.cmt-listing .actions-sort-cmt li:before {\r\n  content: '';\r\n  position: absolute;\r\n  height: 1px;\r\n  width: calc(100% - 30px);\r\n  bottom: -13px;\r\n  left: 15px;\r\n  background-color: transparent;\r\n}\r\n.cmt-listing .actions-sort-cmt li.active:before {\r\n  background-color: #009a59;\r\n}\r\n.cmt-listing .box-child-cmt .text-area-child-cmt {\r\n  margin-left: 54px;\r\n}\r\n\r\n.cmt-listing .user-inf .actions .btn.dropdown-toggle {\r\n  padding: 5px !important;\r\n  margin-right: 0;\r\n}\r\n.post-box .cmt-listing .post-report ul.dropdown-menu-end {\r\n  margin-top: 8px !important;\r\n}\r\n.post-box .cmt-listing .post-report ul.dropdown-menu-end li.dropdown-item:last-child {\r\n  border-bottom: none;\r\n}\r\n.post-box .cmt-listing .user-inf .post-report ul .dropdown-item {\r\n  font-size: 15px;\r\n}\r\n\r\n.loading-style {\r\n  /*height: 100vh;*/\r\n  height: 100%;\r\n  width: 100%;\r\n  z-index: 9;\r\n  border-radius: 6px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background-color: #f9f9f9;\r\n}\r\n.loading-style span {\r\n  width: 15px;\r\n  height: 27px;\r\n  margin: 0 3px; /*border-radius: 50%;*/\r\n  display: inline-block;\r\n  animation-name: dots;\r\n  animation-duration: 2s;\r\n  animation-iteration-count: infinite;\r\n  animation-timing-function: ease-in-out;\r\n  background-image: url('../images/seed01.png');\r\n  background-position: center;\r\n  background-size: contain;\r\n  background-repeat: no-repeat;\r\n}\r\n.loading-style span:nth-child(2) {\r\n  animation-delay: 0.4s;\r\n  background-image: url('../images/seed02.png');\r\n}\r\n.loading-style span:nth-child(3) {\r\n  animation-delay: 0.8s;\r\n  background-image: url('../images/seed03.png');\r\n}\r\n@keyframes dots {\r\n  50% {\r\n    opacity: 0;\r\n    transform: scale(0.7) translateY(10px);\r\n  }\r\n}\r\n\r\n.fire_flame_eff {\r\n  width: 40px;\r\n  height: 50px;\r\n  position: relative;\r\n  transform-origin: center bottom;\r\n  animation-name: flicker;\r\n  animation-duration: 3ms;\r\n  animation-delay: 200ms;\r\n  animation-timing-function: ease-in;\r\n  animation-iteration-count: infinite;\r\n  animation-direction: alternate;\r\n  position: absolute;\r\n  top: -24px;\r\n  right: 1px;\r\n  z-index: 1;\r\n}\r\n\r\n.fire_flame_eff .flame {\r\n  bottom: 0;\r\n  position: absolute;\r\n  border-bottom-right-radius: 50%;\r\n  border-bottom-left-radius: 50%;\r\n  border-top-left-radius: 50%;\r\n  transform: rotate(-45deg) scale(0.46, 0.36);\r\n}\r\n\r\n.fire_flame_eff .yellow {\r\n  left: 15px;\r\n  width: 30px;\r\n  height: 30px;\r\n  bottom: 2px;\r\n  background: gold;\r\n  box-shadow: 0px 0px 9px 4px gold;\r\n}\r\n\r\n.fire_flame_eff .orange {\r\n  left: 10px;\r\n  width: 40px;\r\n  height: 40px;\r\n  background: orange;\r\n  box-shadow: 0px 0px 9px 4px orange;\r\n}\r\n\r\n.fire_flame_eff .red {\r\n  left: 5px;\r\n  width: 50px;\r\n  height: 50px;\r\n  background: OrangeRed;\r\n  box-shadow: 0px 0px 5px 4px OrangeRed;\r\n}\r\n\r\n.fire_flame_eff .white {\r\n  left: 25px;\r\n  bottom: 10px;\r\n  width: 10px;\r\n  height: 10px;\r\n  background: #ffffffa1;\r\n  box-shadow: 0px 0px 10px 8px #ffffffa1;\r\n}\r\n\r\n.fire_flame_eff .circle {\r\n  border-radius: 50%;\r\n  position: absolute;\r\n}\r\n\r\n.fire_flame_eff .blue {\r\n  width: 0px;\r\n  height: 0px;\r\n  left: 29px;\r\n  bottom: 15px;\r\n  background: #6a5acd;\r\n  box-shadow: 0px 0px 12px 6px #6a5acd8c;\r\n}\r\n\r\n.fire_flame_eff .black {\r\n  width: 40px;\r\n  height: 40px;\r\n  left: 10px;\r\n  bottom: -60px;\r\n  background: black;\r\n  box-shadow: 0px 0px 15px 10px black;\r\n}\r\n\r\n@keyframes flicker {\r\n  0% {\r\n    transform: rotate(-1deg);\r\n  }\r\n  20% {\r\n    transform: rotate(1deg);\r\n  }\r\n  40% {\r\n    transform: rotate(-1deg);\r\n  }\r\n  60% {\r\n    transform: rotate(1deg) scaleY(1.04);\r\n  }\r\n  80% {\r\n    transform: rotate(-2deg) scaleY(0.92);\r\n  }\r\n  100% {\r\n    transform: rotate(1deg);\r\n  }\r\n}\r\n\r\n/*.news-sectn .nav-tabs .nav-link.animated-btn.active span{display: none;}*/\r\n\r\n.news-sectn .nav-tabs .nav-link.animated-btn {\r\n  transition: all 0.2s; /*background: linear-gradient(-30deg, #81d0af 50%, #84dab5 50%)!important;*/\r\n  margin-right: 0.5rem;\r\n  background-image: linear-gradient(#009a59, #e0fff2);\r\n  border: 1px solid #8ac9ac;\r\n  color: #fff !important;\r\n  position: relative;\r\n  overflow: visible;\r\n  padding: 7px 26px;\r\n  display: inline-block;\r\n  -webkit-transform: translate(0%, 0%);\r\n  transform: translate(0%, 0%);\r\n  font-size: 17px;\r\n  letter-spacing: 0.2px;\r\n  text-align: center;\r\n  text-transform: uppercase;\r\n  font-weight: 700;\r\n  border-radius: 2px 15px 15px 15px;\r\n  text-decoration: none;\r\n  height: auto;\r\n  color: #191919 !important;\r\n}\r\n.news-sectn .nav-tabs .nav-link.animated-btn:first-child {\r\n  padding-right: 24px;\r\n}\r\n.news-sectn .nav-tabs .nav-link.animated-btn:hover {\r\n  background-image: linear-gradient(#29a66f, #d5ffe5);\r\n}\r\n.news-sectn .nav-tabs .nav-link.animated-btn.active {\r\n  background-image: linear-gradient(#f6a503, #fff0b0);\r\n  border: 1px solid #e5ca91;\r\n  color: #191919 !important;\r\n  cursor: default;\r\n}\r\n/*.news-sectn .nav-tabs .nav-link.animated-btn.active .fire_flame_eff, .news-sectn .nav-tabs .nav-link.animated-btn.active .flashit{display: none;}*/\r\n.news-sectn .nav-tabs .nav-link.animated-btn.new-btn .flashit {\r\n  position: absolute;\r\n  right: -7px;\r\n  top: -7px;\r\n  font-size: 13px; /*text-transform: uppercase;*/\r\n  font-weight: 700;\r\n  font-family: 'helvetica-neue-condensed-bold'; /*font-family: \"UTMFuturaExtra\";*/\r\n  text-transform: none;\r\n  background-color: #ff4800;\r\n  border: 0.2px solid #ffffffbf;\r\n  padding: 0px 5px 1px;\r\n  border-radius: 6px;\r\n  letter-spacing: 0.5px;\r\n  color: #fff;\r\n  -webkit-animation: flash linear 1s infinite;\r\n  animation: flash linear 1s infinite;\r\n  animation-direction: normal;\r\n}\r\n.news-sectn .nav-tabs .nav-link.animated-btn.new-btn .flashit p {\r\n  margin-bottom: 0 !important;\r\n  -webkit-animation: new-txt linear 1s infinite;\r\n  animation: new-txt linear 1s infinite;\r\n}\r\n/*@-webkit-keyframes new-txt {\r\n  0% { opacity: 1; }\r\n  50% { opacity: .5; }\r\n  100% { opacity: 1; }\r\n}\r\n@keyframes new-txt {\r\n  0% { opacity: 1; }\r\n  50% { opacity: .5; }\r\n  100% { opacity: 1; }\r\n}*/\r\n@-webkit-keyframes flash {\r\n  0% {\r\n    box-shadow: 0 0px 15px #da251c;\r\n  }\r\n  50% {\r\n    box-shadow: 0 0px 15px transparent;\r\n  }\r\n  100% {\r\n    box-shadow: 0 0px 11px #ff4800;\r\n  }\r\n}\r\n@keyframes flash {\r\n  0% {\r\n    box-shadow: 0 0px 15px #ff4800;\r\n  }\r\n  50% {\r\n    box-shadow: 0 0px 15px transparent;\r\n  }\r\n  100% {\r\n    box-shadow: 0 0px 11px #ff4800;\r\n  }\r\n}\r\n\r\n/***** Product Deails *****/\r\n.logo-shop img {\r\n  height: 50px;\r\n  margin-left: 0px;\r\n}\r\n.interve-box {\r\n  border-bottom: 1px solid #dbdbdb;\r\n  padding-bottom: 15px;\r\n  margin-top: 15px;\r\n}\r\n.interve-btn {\r\n  padding: 6px 20px;\r\n  border-radius: 8px;\r\n  background-color: #009a59;\r\n}\r\n.fav-btn {\r\n  padding: 6px 20px;\r\n  border-radius: 8px;\r\n  background-color: #ffa608;\r\n  cursor: pointer;\r\n}\r\n.faved-btn {\r\n  background-color: #fff;\r\n  border: 1px solid #ffa608;\r\n}\r\n\r\n.interve-btn [class*=' icon-'],\r\n.fav-btn [class*=' icon-'],\r\n.interve-btn [class^='icon-'],\r\n.fav-btn [class^='icon-'] {\r\n  color: #fff;\r\n  font-size: 20px;\r\n}\r\n.faved-btn [class^='icon-'],\r\n.faved-btn [class^='icon-'] {\r\n  color: #ffa608;\r\n  font-size: 20px;\r\n}\r\n.interve-box a.interve-btn {\r\n  margin: 0 5px;\r\n}\r\n.interve-box a.interve-btn:first-child {\r\n  margin-left: 0;\r\n}\r\n/*.detail-product .user-inf {\r\n  padding: 10px 0;\r\n  margin-top: 0px;\r\n  border-bottom: none;\r\n}\r\n.detail-product .user-inf img {\r\n  width: 40px;\r\n  height: 40px;\r\n  border-radius: 100px;\r\n  margin-right: 6px;\r\n  border: 1px solid #dfdfdf;\r\n}*/\r\n.user-inf .name {\r\n  font-weight: 500;\r\n}\r\n.user-inf .user-name {\r\n  display: flex;\r\n}\r\n.user-inf .user-name small {\r\n  font-size: 11px;\r\n  color: #009a59;\r\n  border: 1px solid #009a59;\r\n  font-weight: bold;\r\n  padding: 0px 8px;\r\n  border-radius: 60px;\r\n  margin-left: 5px;\r\n}\r\n.post-box .follow,\r\n.post-box .not-follow {\r\n  margin-left: 0;\r\n}\r\n.post-box .follow img,\r\n.post-box .not-follow img {\r\n  margin-right: 0;\r\n  margin-top: 1px;\r\n}\r\n.post-box .follow {\r\n  background-color: #ffe68a; /*border: 1px solid #FADF9A;*/\r\n  text-align: center;\r\n  color: #191919;\r\n  font-size: 12px;\r\n  font-weight: bold;\r\n  padding: 1px 8px;\r\n  border-radius: 60px;\r\n  margin-left: 6px;\r\n  position: relative;\r\n  height: 22px;\r\n  margin-left: 0px;\r\n  margin-top: 3px;\r\n}\r\n.post-box .follow span:before {\r\n  content: '\\e921';\r\n  font-family: 'iconfont' !important;\r\n  font-size: 5px;\r\n  display: inline-block;\r\n  transform: rotate(135deg);\r\n  margin-right: 3px;\r\n  vertical-align: 3px;\r\n  font-weight: 700;\r\n}\r\n.post-box a.user-inf {\r\n  position: relative;\r\n  z-index: 0;\r\n}\r\n.post-box a.user-inf .txt-sectn {\r\n  width: calc(100% - 51px);\r\n}\r\n.post-box a.user-inf .user-name {\r\n  position: relative;\r\n  z-index: 0;\r\n}\r\n.post-box a.user-inf .user-name .d-inline-block {\r\n  position: relative;\r\n  z-index: 9;\r\n}\r\n.post-box a.user-inf .user-name img {\r\n  height: auto;\r\n  width: auto;\r\n  border-radius: 0;\r\n  outline: none;\r\n  border: none;\r\n}\r\n/* .post-box a.user-inf .d-inline-block{margin-left: 8px;} */\r\n\r\n.wrap-flwing .user-name {\r\n  margin-left: 55px;\r\n}\r\n.wrap-flwing .user-name .txt-limit {\r\n  white-space: nowrap;\r\n  /*overflow: hidden;\r\n  text-overflow: ellipsis;*/\r\n  margin-right: 5px;\r\n  display: inline-block;\r\n  max-width: calc(100% - 0px);\r\n  font-size: 15px !important;\r\n}\r\n.wrap-flwing .d-inline-block a.pointer {\r\n  position: relative;\r\n  z-index: 9;\r\n}\r\n.wrap-flwing a.user-inf img {\r\n  margin-top: -14px;\r\n}\r\n.wrap-flwing .avatar {\r\n  margin-top: -26px;\r\n}\r\n\r\n.msg-box {\r\n  border-top: 1px solid #dbdbdb;\r\n  margin-top: 0px;\r\n  padding-top: 10px;\r\n}\r\n.msg-box .icon-msgs {\r\n  margin-right: 5px;\r\n  font-size: 22px;\r\n  color: #009a59;\r\n}\r\n.msg-box input {\r\n  color: #ef4923;\r\n  font-style: italic;\r\n  box-shadow: 2px 2px 2px #9e9e9e;\r\n  margin-bottom: 10px;\r\n  background-color: #efefef;\r\n  border: 2px solid #0cab6b;\r\n  border-radius: 10px;\r\n  margin-top: 10px;\r\n}\r\ninput.form-control:focus,\r\ntextarea.form-control:focus,\r\n.btn:focus {\r\n  border: #0cab6b 1px solid;\r\n  box-shadow: 0 0 0 0.25rem rgb(223 229 233);\r\n}\r\n.msg-box .btn {\r\n  background-color: #ffc65d;\r\n  border: 1px solid #ffba24;\r\n  font-weight: bold;\r\n  font-size: 18px;\r\n  border-radius: 6px;\r\n  padding: 0.275rem 0.75rem;\r\n}\r\n.msg-box .btn:hover {\r\n  color: #191919 !important;\r\n}\r\n.captn-tag {\r\n  background-color: #009a59;\r\n  padding: 2px 20px;\r\n  border-radius: 10px;\r\n  color: #fff;\r\n  display: inline-block;\r\n  font-size: 15px;\r\n  margin-bottom: 15px;\r\n}\r\n.cate-prod .bg-img {\r\n  position: relative;\r\n  display: inline-block;\r\n  width: 100%;\r\n  padding-top: 100%;\r\n  background-size: cover !important;\r\n  background-position: 50% !important;\r\n  text-align: center;\r\n  z-index: 1;\r\n  overflow: hidden;\r\n  border-radius: 15px;\r\n  box-shadow: 2px 2px 6px #a9a9a9;\r\n}\r\n.cate-prod .bg-img:hover {\r\n  box-shadow: none;\r\n}\r\n.cate-prod .bg-img > div {\r\n  position: absolute;\r\n  /*display: table;*/\r\n  display: flex;\r\n  left: 0;\r\n  height: 100%;\r\n  width: 100%;\r\n  top: 0;\r\n  text-align: center;\r\n  font-weight: bold;\r\n  justify-content: center;\r\n}\r\n.cate-prod .bg-img > div .cate-txt {\r\n  /*display: table-cell;\r\n  vertical-align: middle;*/\r\n  text-shadow: 1px 1px 1px #000000;\r\n  font-family: 'UTMFuturaExtra';\r\n  color: #fff;\r\n  text-transform: uppercase;\r\n  font-size: 19px;\r\n  line-height: 24px;\r\n  padding: 5px;\r\n  align-self: center !important;\r\n}\r\n.cate-prod .accordion .collapse:not(.show) {\r\n  display: block;\r\n}\r\n.cate-prod .accordion .accordion-item {\r\n  border-bottom: none;\r\n}\r\n.see-more {\r\n  margin-top: 20px;\r\n  width: 100%;\r\n  text-align: center;\r\n  color: inherit;\r\n}\r\n.see-more .icon-arrow-solid {\r\n  font-size: 9px;\r\n}\r\n.filter-sectn {\r\n  margin-top: 0px;\r\n  border-top: 1px solid #e1e1e1;\r\n  padding-top: 20px;\r\n}\r\n.price-inp {\r\n  margin-top: 36px;\r\n}\r\n.price-inp label {\r\n  padding: 0 10px;\r\n}\r\n.item-lst {\r\n  border-radius: 5px;\r\n  border: 1px solid #f2f2f2;\r\n  transition: all 0.3s ease-in-out;\r\n  margin-bottom: 15px;\r\n  background-color: #fff;\r\n}\r\n.item-lst:hover {\r\n  box-shadow: 0 2px 4px rgb(0 0 0 / 13%);\r\n  background-color: #fff !important;\r\n  border-color: transparent;\r\n}\r\n.item-lst a:hover {\r\n  color: inherit !important;\r\n}\r\n.item-lst .prod-inf {\r\n  padding: 10px;\r\n  border-radius: 0px 0px 2px 2px;\r\n}\r\n.item-lst .prod-inf .txt-name {\r\n  font-size: 0.96rem;\r\n}\r\n.item-lst .bg-img.thumb-pt {\r\n  border-radius: 4px 4px 0 0;\r\n}\r\n.item-lst .prod-inf .txt-name {\r\n  white-space: normal;\r\n  -webkit-line-clamp: 2;\r\n  display: -webkit-box;\r\n  -webkit-box-orient: vertical;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  font-weight: 600;\r\n  margin-bottom: 5px;\r\n  line-height: 1.28rem;\r\n  height: 41px;\r\n}\r\n.item-lst .prod-inf .locatn {\r\n  font-size: 0.86rem;\r\n  margin-bottom: 5px;\r\n  height: 20px;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n.item-lst .prod-inf .locatn .icon-location01 {\r\n  margin-right: 3px;\r\n  color: #919191;\r\n}\r\n.item-lst .prod-inf .price-item {\r\n  font-size: 0.9rem;\r\n}\r\n.item-lst .bg-img-orgnal {\r\n  background-color: #f9f9f9;\r\n  padding-top: 100%;\r\n  border-radius: 4px 4px 0 0;\r\n  border-bottom: 1px solid #f8f8f8;\r\n}\r\n.item-lst:hover .bg-img-orgnal {\r\n  background-color: transparent;\r\n}\r\n.item-lst .prod-inf .price-item .price01 small.text-uppercase,\r\n.item-lst .prod-inf .price-item .price02 small.text-uppercase {\r\n  font-size: 0.8em;\r\n  font-weight: 500;\r\n}\r\n.item-lst .prod-inf .price-item .btn-sm {\r\n  background-color: #ffd166 !important;\r\n  border: 1px solid #eec05e;\r\n  color: #191919;\r\n  border-radius: 50px;\r\n  padding: 0;\r\n  padding: 0px 8px 1px;\r\n  font-size: 0.82rem;\r\n}\r\n.item-lst .prod-inf .price-item .fs-7 {\r\n  margin-top: 2px;\r\n}\r\n\r\n.detail-product .prod-list .item-lst .bg-img {\r\n  background-position: center;\r\n  background-size: cover;\r\n  height: 95px;\r\n  background-repeat: no-repeat;\r\n  border-radius: 5px 5px 0 0;\r\n}\r\n.detail-product .post-report .dropdown-toggle::after {\r\n  display: none;\r\n}\r\n.detail-product .post-report .dropdown-menu img {\r\n  height: 22px;\r\n  margin-right: 5px;\r\n}\r\n.item-lst {\r\n  position: relative;\r\n}\r\n.item-lst .icon-close {\r\n  position: absolute;\r\n  top: 8px;\r\n  right: 8px;\r\n  color: #fff;\r\n  font-size: 14px;\r\n  text-shadow: 1px 2px 2px #151515;\r\n  cursor: pointer;\r\n  display: none;\r\n  transition: 0.6s all ease;\r\n}\r\n.item-lst:hover .icon-close {\r\n  display: block;\r\n  transition: all 0.6s;\r\n}\r\n\r\n.row.prod-list [class^='col-'],\r\n.row.prod-list [class*=' col-'] {\r\n  padding-right: calc(var(--bs-gutter-x) * 0.25);\r\n  padding-left: calc(var(--bs-gutter-x) * 0.25);\r\n}\r\n\r\n.saved-items .nav-tabs {\r\n  border-bottom: 1px #7c9c8fcf solid;\r\n  background-color: #fff;\r\n  border-radius: 5px 5px 0 0;\r\n  margin-top: 2px;\r\n}\r\n.saved-items .nav-tabs .nav-item .nav-link,\r\n.nav-mkt-price .nav-item .nav-link {\r\n  margin-bottom: 0;\r\n  padding: 10px 5px;\r\n  border-bottom: 3px solid transparent;\r\n}\r\n.saved-items .nav-tabs .nav-item .nav-link,\r\n.nav-mkt-price .nav-item .nav-link {\r\n  border: none;\r\n  color: #5d5d5d;\r\n  transition: all 0.6s;\r\n  font-weight: 700;\r\n  font-size: 1.1rem;\r\n}\r\n.saved-items .nav-tabs .nav-item .nav-link.active,\r\n.nav-mkt-price .nav-item .nav-link.active {\r\n  color: #03814e;\r\n  border-bottom: 3px solid #03814ec9;\r\n  width: auto;\r\n}\r\n.saved-items .nav-tabs .nav-item .nav-link:hover,\r\n.nav-mkt-price .nav-item .nav-link:hover {\r\n  color: #000;\r\n}\r\n.bootstrap-tagsinput {\r\n  background-color: #fbfbfb;\r\n  border: 1px solid #ced4da;\r\n  box-shadow: 0 0 0 0.25rem #f1f1f1;\r\n  margin-top: 0px;\r\n  margin-bottom: 18px;\r\n  display: inline-block;\r\n  padding: 4px 6px;\r\n  color: #555;\r\n  vertical-align: middle;\r\n  border-radius: 5px;\r\n  max-width: 100%;\r\n  line-height: 22px;\r\n  cursor: text;\r\n  min-height: 38px;\r\n  width: 100%;\r\n}\r\n\r\n.bootstrap-tagsinput .label {\r\n  display: inline;\r\n  padding: 0.2em 0.6em 0.3em;\r\n  font-size: 75%;\r\n  font-weight: 700;\r\n  line-height: 1;\r\n  color: #fff;\r\n  text-align: center;\r\n  white-space: nowrap;\r\n  vertical-align: baseline;\r\n  border-radius: 2px;\r\n}\r\n.label-info {\r\n  background-color: #009a59;\r\n}\r\n.bootstrap-tagsinput .tag {\r\n  margin-right: 2px;\r\n  color: white;\r\n  display: inline-block;\r\n  margin-bottom: 2px;\r\n}\r\n.bootstrap-tagsinput input {\r\n  border: none !important;\r\n  box-shadow: none !important;\r\n  outline: none;\r\n  background-color: transparent !important;\r\n  padding: 0 6px;\r\n  margin: 0;\r\n  width: auto !important;\r\n  max-width: inherit;\r\n  height: auto !important;\r\n  line-height: normal !important;\r\n  margin-bottom: 0 !important;\r\n  margin-top: 0 !important;\r\n}\r\n.bootstrap-tagsinput .tag [data-role='remove']:after {\r\n  content: 'x';\r\n  padding: 0px 2px;\r\n}\r\n.get-app {\r\n  cursor: pointer;\r\n  position: fixed;\r\n  right: 20px;\r\n  bottom: 20px;\r\n  z-index: 99999999;\r\n  background-color: #e4e4e4;\r\n  padding: 10px;\r\n  border-radius: 5px;\r\n  box-shadow: 0 2px 4px rgb(0 0 0 / 28%);\r\n}\r\n.get-app .app-icon {\r\n  height: 50px;\r\n  border-radius: 5px;\r\n  margin-right: 10px;\r\n}\r\n.get-app .btn-open {\r\n  color: #1f1f1f;\r\n  border-radius: 100px;\r\n  padding: 2px 15px;\r\n  font-size: 14px;\r\n  margin-top: 2px;\r\n  display: inline-block;\r\n  background-image: linear-gradient(to right, #f49c18 0%, #ffbb5f 40%, #ffbb5f 60%, #f49c18 100%);\r\n}\r\n#GetApp .btn-close {\r\n  position: absolute;\r\n  right: 10px;\r\n  top: 10px;\r\n  z-index: 9;\r\n}\r\n#GetApp img {\r\n  height: 80px;\r\n}\r\n#GetApp img.go-to-app {\r\n  height: 50px;\r\n  width: auto;\r\n  border-radius: 5px;\r\n  margin-top: 10px;\r\n}\r\n#GetApp .modal-body {\r\n  padding-bottom: 40px;\r\n}\r\n#page-wrapper .articles .bg-img-orgnal {\r\n  /*background-size: 100% 100% !important;*/\r\n  background-position: center center !important;\r\n}\r\n#page-wrapper .articles .video-main {\r\n  box-shadow: 0 2px 3px rgb(0 0 0 / 10%);\r\n  border-radius: 0 0 3px 3px;\r\n}\r\n#page-wrapper .articles .video-main .bg-img-orgnal {\r\n  background-size: cover !important;\r\n  width: 100%;\r\n  padding-top: 50%;\r\n  border-radius: 2px;\r\n  background-position: 50% !important;\r\n}\r\n#page-wrapper .articles .video-main .inf-main {\r\n  bottom: 20px;\r\n  left: 20px;\r\n  color: #000;\r\n  z-index: 9;\r\n  padding: 10px;\r\n}\r\n#page-wrapper .articles .item-lst .prod-inf small {\r\n  font-size: 85%;\r\n}\r\n#page-wrapper .detail-article .cont-center figure.media {\r\n  display: block;\r\n}\r\n.video-sectn .row [class^='col-'],\r\n.video-sectn .row [class*=' col-'] {\r\n  padding-right: 6px;\r\n  padding-left: 6px;\r\n}\r\n\r\n/***** quy trinh ky thuat *****/\r\n/*.pro-tech-lst .arg-type img.img-cover{width: 130px; height: 130px; border-radius: 200px; border: 5px solid #fff;margin-bottom: 5px;}*/\r\n.pro-tech-lst {\r\n  margin-bottom: 20px;\r\n  background-color: #fff;\r\n  border-radius: 6px;\r\n  padding: 10px;\r\n  box-shadow: 0 2px 10px rgb(0 0 0 / 5%);\r\n  margin-bottom: 25px;\r\n}\r\n.pro-tech-lst > .position-relative {\r\n  margin-top: calc(15% + 1.5px);\r\n  margin-left: -19px;\r\n}\r\n.pro-tech-lst .arg-type-main .wrap-img {\r\n  position: relative; /*width: 180px;*/\r\n}\r\n.pro-tech-lst .arg-type-main .wrap-img .bg-img-orgnal {\r\n  border-radius: 6px;\r\n}\r\n.pro-tech-lst .arg-type-main .wrap-img + div {\r\n  line-height: 28px;\r\n  padding: 10px 0px;\r\n  font-weight: 600 !important;\r\n}\r\n/*.pro-tech-lst .arg-type-main .wrap-img:before{border-radius: 200px;border: 6px solid #fff;position: absolute;z-index: 2;content:\"\";top:-6px;left: -6px;width: calc(100% + 12px);height: calc(100% + 12px);box-shadow: 0 2px 6px rgb(0 0 0 / 10%);}\r\n*/\r\n.pro-tech-lst .arg-type-main .bg-img-orgnal.rounded-circle {\r\n  width: calc(100% - 0px);\r\n  padding-top: calc(100% - 12px);\r\n  box-shadow: 0 2px 6px rgb(0 0 0 / 10%);\r\n  border: 6px solid #fff;\r\n  z-index: 9;\r\n}\r\n/*.pro-tech-lst .arg-type-main .bg-img-orgnal.rounded-circle:before{content: \"\";position: absolute;background-size: contain!important;background-position: top center;background-repeat: no-repeat !important; background-image: url(\"../images/arrow-line02.png\"); width: 66.666666%;height:100%;top: calc(50% + 4px);left: calc(100% + 5px);}*/\r\n/*.pro-tech-lst .arg-type-main .wrap-img:after{content: \"\"; display: inline-block; background-color: #ddddddbd; border-radius: 12rem 12rem 0 0; width: calc(100% + 18px); height: calc(50% + 18px);position: absolute;top: -9px;left: -9px;z-index: 0;}\r\n*/ /*.pro-tech-lst .arg-type-main .wrap-arrow{display: inline-block;width: 100%;padding-top: calc(50% + 135px);margin-left: 6px;background-size: contain!important;background-position: center center;background-repeat: no-repeat !important; background-image: url(\"../images/arrow-line02.png\");}\r\n.pro-tech-lst .arg-type-main .wrap-arrow >.bg-img-orgnal{background-color: transparent;}*/\r\n\r\n/*.pro-tech-lst .arg-type-step{width: 100%;position: absolute;top: calc(50% - 17.5px);left: -22px;}*/\r\n/*.pro-tech-lst .arg-type-step:after{content: \"\";position: absolute;left: 15px;top: 10%;width: 2px;height: 80%;background-color: #DDDDDD;z-index: 0;}*/\r\n/*.pro-tech-lst .arg-type-step {margin-top: 15px;}*/\r\n.pro-tech-lst .arg-type-step {\r\n  margin-top: 10px;\r\n}\r\n.pro-tech-lst .arg-type-step .step-by-step {\r\n  height: 45px;\r\n  margin-bottom: 5px;\r\n  display: block;\r\n}\r\n/*.pro-tech-lst .arg-type-step .step-by-step:after{content: \"\";position: absolute;left: 15px;top: 30px;width: 2px;height: 30px;background-color: #DDDDDD;z-index: 0;}\r\n*/\r\n.pro-tech-lst .arg-type-step .step-by-step:last-child {\r\n  margin-bottom: 0;\r\n}\r\n.pro-tech-lst .arg-type-step .step-by-step:last-child:after {\r\n  display: none;\r\n}\r\n.pro-tech-lst .arg-type-step .step-icon {\r\n  /*background-color: #DDDDDD;*/\r\n  border-radius: 0 12rem 12rem 0;\r\n  z-index: 2;\r\n}\r\n/*.pro-tech-lst .arg-type-step .step-icon:before{content: \"\";position: absolute;background-size: contain!important;background-position: center center;background-repeat: no-repeat !important; background-image: url(\"../images/arrow-line01.png\"); width: 100%;height:10px;top: 18px;left:21px;}\r\n*/\r\n.pro-tech-lst .arg-type-step .step-icon .numb {\r\n  height: 32px;\r\n  line-height: 28px;\r\n  width: 32px;\r\n  font-size: 1.3rem;\r\n  text-align: center;\r\n  border-radius: 100px;\r\n  background-color: #ffffff;\r\n  color: #009a59;\r\n  border: 1px solid #7c9c8fcf;\r\n  box-shadow: 0 2px 6px rgb(0 0 0 / 15%);\r\n  top: 2px;\r\n  right: 2px;\r\n  z-index: 1;\r\n  margin-right: 10px;\r\n}\r\n.pro-tech-lst .arg-type-step .step-icon .numb.active-tab {\r\n  position: static;\r\n}\r\n.pro-tech-lst .arg-type-step .step-by-step.active .numb {\r\n  background-color: #009a59;\r\n  color: #fff;\r\n  border: 1px solid #009a59;\r\n}\r\n.pro-tech-lst .arg-type-step .step-txt {\r\n  top: 6px;\r\n  left: 45px;\r\n  font-size: 1rem;\r\n  text-transform: uppercase;\r\n  font-weight: 650;\r\n}\r\n.pro-tech-lst .arg-type-step .step-by-step.active .step-txt {\r\n  color: #00854e;\r\n}\r\n.pro-tech-lst .arg-type-step {\r\n  transition: 0.1s all ease;\r\n  margin-left: 0 !important;\r\n}\r\n\r\n.pro-tech-lst + .saved-items {\r\n  margin-top: -25px;\r\n}\r\n.pro-tech-lst + .saved-items .tab-content {\r\n  padding: 10px;\r\n  background-color: #fff;\r\n  margin-top: 0;\r\n}\r\n.pro-tech-lst + .saved-items .nav-tabs {\r\n}\r\n.pro-tech-lst + .saved-items .nav-tabs .nav-item button {\r\n  background-color: #fff;\r\n  border: 1px solid #7c9c8fcf;\r\n  color: #00854e;\r\n  padding: 0.18rem 1.2rem;\r\n  border-radius: 2px 2px 0 0;\r\n  font-weight: 500;\r\n  font-size: 1.05rem;\r\n  margin-right: 0.5rem;\r\n}\r\n.pro-tech-lst + .saved-items .nav-tabs .nav-item button.active {\r\n  background-color: #009a59;\r\n  color: #fff;\r\n  border: 1px solid #009a59 !important;\r\n}\r\n.ModalViewContainer .NewFeedHeader .NewFeedUserInfo .avatar {\r\n  height: 50px;\r\n  width: 50px;\r\n  border-radius: 100px;\r\n  border: 1px solid #e1e1e1;\r\n}\r\n.ModalViewContainer .NewFeedHeader .NewFeedUserInfo .avatar img {\r\n  width: 100%;\r\n  object-fit: cover;\r\n  border: none;\r\n}\r\n.ModalViewContainer .NewFeedActions {\r\n  font-size: 1rem;\r\n  border-top: 1px solid #cccccc;\r\n  border-bottom: 1px solid #cccccc;\r\n  border-right: none;\r\n  border-left: none;\r\n}\r\n.list-action-business .title-txt {\r\n  background-color: #efefef;\r\n}\r\n\r\n/***** NPK page *****/\r\n.npk-frm {\r\n  margin-top: 28px;\r\n  margin-bottom: 50px;\r\n}\r\n.npk-frm label {\r\n  margin-bottom: 8px;\r\n  width: 100%;\r\n  font-weight: 500;\r\n}\r\n.npk-frm .kg-unit {\r\n  position: relative;\r\n}\r\n.npk-frm .kg-unit span {\r\n  position: absolute;\r\n  right: 9px;\r\n  bottom: 9px;\r\n  background-color: #e2e8ed;\r\n  height: 36px;\r\n  line-height: 38px;\r\n  width: 60px;\r\n  text-align: center;\r\n  border-radius: 0 3px 3px 0;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n}\r\n.npk-frm .kg-unit input {\r\n  text-align: right;\r\n  padding-right: 74px;\r\n}\r\n.npk-frm .kg-unit input:focus + span {\r\n  background-color: #0cab6b;\r\n}\r\n.npk-frm .choice-lst {\r\n  /*background-color: #e2e8ed;*/\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 15px;\r\n}\r\n.npk-frm * {\r\n  box-sizing: border-box;\r\n  user-select: none;\r\n}\r\n/* .npk-frm input[type='checkbox']{ height: 0; width: 0; } */\r\n.npk-frm .choice-lst .list-fertilizer {\r\n  margin: 15px 0;\r\n}\r\n.npk-frm .choice-lst .list-fertilizer input[type='checkbox'] {\r\n  -ms-transform: scale(1.4); /* IE */\r\n  -moz-transform: scale(1.4); /* FF */\r\n  -webkit-transform: scale(1.4); /* Safari and Chrome */\r\n  -o-transform: scale(1.4); /* Opera */\r\n  transform: scale(1.4);\r\n  padding: 10px;\r\n  margin-right: 10px;\r\n}\r\n.npk-frm .choice-lst .list-fertilizer input[type='checkbox']:after {\r\n  border: 2px solid red;\r\n}\r\n.npk-frm .choice-lst .list-fertilizer input[type='checkbox']:checked {\r\n  background-color: red;\r\n}\r\n.npk-frm input[type='checkbox'] + label {\r\n  position: relative;\r\n  display: flex;\r\n  margin: 0.6em 0;\r\n  align-items: center;\r\n  color: #191919;\r\n  transition: color 250ms cubic-bezier(0.4, 0, 0.23, 1);\r\n}\r\n.npk-frm input[type='checkbox'] + label > ins {\r\n  position: absolute;\r\n  display: block;\r\n  bottom: 0;\r\n  left: 2.5em;\r\n  height: 0;\r\n  width: 100%;\r\n  overflow: hidden;\r\n  text-decoration: none;\r\n  transition: height 300ms cubic-bezier(0.4, 0, 0.23, 1);\r\n}\r\n.npk-frm input[type='checkbox'] + label > ins > i {\r\n  position: absolute;\r\n  bottom: 1px;\r\n  left: 2px;\r\n  font-style: normal;\r\n  /*color: #009A59;*/\r\n}\r\n.npk-frm input[type='checkbox'] + label > span {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  margin-right: 0.6em;\r\n  width: 1.4em;\r\n  height: 1.4em;\r\n  background: transparent;\r\n  border: 1px solid #bebebe;\r\n  border-radius: 2px;\r\n  cursor: pointer;\r\n  transition: all 250ms cubic-bezier(0.4, 0, 0.23, 1);\r\n}\r\n\r\n.npk-frm input[type='checkbox'] + label:hover,\r\n.npk-frm input[type='checkbox']:focus + label {\r\n  /*color: #009A59;*/\r\n}\r\n.npk-frm input[type='checkbox'] + label:hover > span,\r\n.npk-frm input[type='checkbox']:focus + label > span {\r\n  background: rgba(255, 255, 255, 0.1);\r\n}\r\n.npk-frm input[type='checkbox']:checked + label > ins {\r\n  height: 100%;\r\n}\r\n\r\n.npk-frm input[type='checkbox']:checked + label > span {\r\n  border: 0.7em solid #ffffff;\r\n  animation: shrink-bounce 200ms cubic-bezier(0.4, 0, 0.23, 1);\r\n  box-shadow: 0px 0px 1px 1px #b2b2b2;\r\n}\r\n.npk-frm input[type='checkbox']:checked + label > span:before {\r\n  content: '';\r\n  position: absolute;\r\n  top: 0.6em;\r\n  left: 0.35em;\r\n  border-right: 3px solid transparent;\r\n  border-bottom: 3px solid transparent;\r\n  transform: rotate(45deg);\r\n  transform-origin: 0% 100%;\r\n  animation: checkbox-check 125ms 250ms cubic-bezier(0.4, 0, 0.23, 1) forwards;\r\n  box-sizing: initial;\r\n}\r\n\r\n.fw-semibold {\r\n  font-weight: 500 !important;\r\n}\r\n.fn-temp {\r\n  font-family: 'helvetica-neue-condensed-bold', sans-serif;\r\n}\r\n.weather {\r\n  /*background: linear-gradient(to bottom, #008e50 0%, #00bf6e 100%);*/\r\n  background-image: url('../images/bg-weather.jpg');\r\n  background-repeat: no-repeat;\r\n  background-size: cover;\r\n  background-position: center center;\r\n  position: relative;\r\n  overflow: hidden;\r\n  border-radius: 6px;\r\n  margin-top: 15px;\r\n}\r\n.weather > * {\r\n  z-index: 9;\r\n  position: relative;\r\n}\r\n.weather:before {\r\n  background: linear-gradient(to bottom, #5ed18980 0%, #ffcf7259 100%);\r\n  width: 100%;\r\n  height: 100%;\r\n  content: '';\r\n  z-index: 1;\r\n  left: 0;\r\n  top: 0;\r\n  position: absolute;\r\n}\r\n.weather .text-capitalize {\r\n  font-size: 80%;\r\n  font-weight: 600;\r\n}\r\n.weather .old-green {\r\n  background-color: #ffffff20;\r\n  margin: 0 0 10px !important;\r\n  border-radius: 10px;\r\n  align-items: center;\r\n  display: flex;\r\n  padding: 5px;\r\n  border: 0.5px solid #ffffff28;\r\n}\r\n.weather .old-green .justify-content-around {\r\n  font-weight: 500;\r\n  font-size: 15px;\r\n  border-radius: 6px;\r\n  padding: 2px;\r\n}\r\n.weather .old-green .justify-content-around.select {\r\n  margin-bottom: 2px;\r\n  font-size: 14px;\r\n  font-weight: normal; /* -moz-appearance:none; Firefox */ /* -webkit-appearance:none; Safari and Chrome appearance:none;*/\r\n  background-color: transparent;\r\n  color: #191919;\r\n}\r\n.weather .old-green .justify-content-around.select:focus,\r\n.weather .old-green .justify-content-around.select:focus-visible {\r\n  outline: none;\r\n}\r\n.weather .old-green .justify-content-around small {\r\n  font-weight: normal;\r\n  margin-top: -2px;\r\n  font-size: 77%;\r\n}\r\n.weather .days-lst {\r\n  border-radius: 6px;\r\n  padding: 10px 12px;\r\n  width: 100%;\r\n  margin-bottom: 10px;\r\n  border: 1px solid #ffffff15;\r\n}\r\n.weather .box-gradient-height {\r\n  background-image: none;\r\n  border-bottom: 0.5px solid #ffffff2e;\r\n  width: calc(100% + 24px);\r\n  margin-left: -12px !important;\r\n}\r\n.weather .box-gradient-height:last-child {\r\n  border-bottom: none;\r\n}\r\n/*.weather .weather-stt{background-image: url('../images/rice-icon.png'); background-repeat: no-repeat; background-size: cover; background-position: center center;}*/\r\n.weather .d-sm-block .today {\r\n  font-size: 80%;\r\n  margin-top: -3px;\r\n}\r\n.weather .fst-italic {\r\n  display: inline-block;\r\n  margin-top: -5px;\r\n  font-size: 80%;\r\n}\r\n.weather .col-6.d-block img {\r\n  margin-top: 0px;\r\n}\r\n.weather .days-lst .icon-tranform {\r\n  transform: translateY(8px);\r\n}\r\n.weather .days-lst .icon-tranform img {\r\n  height: auto !important;\r\n  width: 28px;\r\n}\r\n.weather .btn-cmore {\r\n  border: none;\r\n  border-radius: 6px;\r\n  background-color: #ffffff20;\r\n  border: 0.5px solid #ffffff28;\r\n  padding: 5px;\r\n  margin-bottom: 10px;\r\n}\r\n.weather .more-btn-fll.btn-cmore:after {\r\n  color: grey;\r\n}\r\n.weather .d-sm-block sup {\r\n  top: -0.77em;\r\n}\r\n\r\n@keyframes shrink-bounce {\r\n  0% {\r\n    transform: scale(1);\r\n  }\r\n  33% {\r\n    transform: scale(0.85);\r\n  }\r\n  100% {\r\n    transform: scale(1);\r\n  }\r\n}\r\n@keyframes checkbox-check {\r\n  0% {\r\n    width: 0;\r\n    height: 0;\r\n    border-color: #212121;\r\n    transform: translate3d(0, 0, 0) rotate(45deg);\r\n  }\r\n  33% {\r\n    width: 0.2em;\r\n    height: 0;\r\n    transform: translate3d(0, 0, 0) rotate(45deg);\r\n  }\r\n  100% {\r\n    width: 0.2em;\r\n    height: 0.5em;\r\n    border-color: #212121;\r\n    transform: translate3d(0, -0.5em, 0) rotate(45deg);\r\n  }\r\n}\r\n.npk-frm .accordion-item {\r\n  border: none;\r\n}\r\n.npk-frm .accordion {\r\n  margin-top: 28px;\r\n  border: none;\r\n}\r\n.npk-frm .accordion-item button[type='button'] {\r\n  border: none;\r\n  background-color: #ffb91f;\r\n  border: 1px solid #e9a000;\r\n  border-radius: 6px;\r\n  padding: 10px 33px;\r\n  font-size: 18px;\r\n  font-weight: 500;\r\n}\r\n.npk-frm .accordion-body .table > :not(:first-child) {\r\n  border-top: 2px solid #ccc;\r\n}\r\n.npk-frm .accordion-body tbody tr th {\r\n  font-weight: 500;\r\n}\r\n.npk-frm .accordion-body {\r\n  margin-top: 15px;\r\n}\r\n.npk-frm .accordion-body .total-npk {\r\n  font-weight: bold;\r\n  background-color: #e2e8ed;\r\n}\r\n.npk-frm .form-control {\r\n  border: 1px solid #c5c5c5;\r\n}\r\n\r\n/****** Giá cả thị trường ******/\r\n.nav-mkt-price {\r\n  justify-content: space-evenly !important;\r\n  margin-top: 15px !important;\r\n}\r\n.nav-mkt-price .nav-item {\r\n  text-align: center;\r\n}\r\n.nav-mkt-price .nav-item button.nav-link {\r\n  display: inline-block;\r\n  background-color: transparent;\r\n}\r\n.mkt-price .search-box {\r\n  background-color: #fff;\r\n  padding: 20px 20px 15px;\r\n  box-shadow: 0 1px 1px rgb(0 0 0 / 15%);\r\n  z-index: 1;\r\n  position: relative;\r\n}\r\n.mkt-price .search-box form {\r\n  width: 80%;\r\n  margin: 0 auto;\r\n}\r\n.mkt-price .search-box .row [class^='col-'],\r\n.search-box .row [class*=' col-'] {\r\n  padding-right: 3px;\r\n  padding-left: 3px;\r\n}\r\n.mkt-price .search-box .row .btn-pd[class^='col-'],\r\n.search-box .row .btn-pd[class*=' col-'] {\r\n  padding-right: 8px;\r\n  padding-left: 8px;\r\n}\r\n.mkt-price .search-box form {\r\n  margin-bottom: 0;\r\n}\r\n.mkt-price .search-box form select.form-select {\r\n  background: none;\r\n}\r\n.mkt-price .search-box .icon-location01 {\r\n  right: 10px;\r\n  top: 10px;\r\n}\r\n.mkt-price .search-box .icon-location01:before {\r\n  color: #808081;\r\n  font-size: 1.15rem;\r\n}\r\n.mkt-price .search-box .icon-calendar {\r\n  position: absolute;\r\n  right: 15px;\r\n  top: 11px;\r\n  color: grey;\r\n}\r\n.mkt-price .search-box .btn-box button {\r\n  color: #191919;\r\n  font-weight: 500;\r\n  font-size: 17px;\r\n  padding-left: 26px;\r\n  padding-right: 26px;\r\n}\r\n.mkt-price .search-box .btn-box .btn-secondary {\r\n  background-color: #d1d0d0;\r\n  border-color: #c1bebe;\r\n  text-transform: capitalize;\r\n}\r\n.mkt-price .search-box .btn-box .btn-secondary:focus {\r\n  box-shadow: 0 0 0 0.25rem rgb(209 218 224);\r\n}\r\n.mkt-price .search-box .btn-box .btn-primary {\r\n  margin-left: 15px;\r\n  background-color: #ffc55a;\r\n  border: 1px solid #f8ac06;\r\n  text-transform: none;\r\n}\r\n.mkt-price .search-box .btn-box .btn-primary:focus {\r\n  box-shadow: 0 0 0 0.25rem rgb(255 178 7 / 41%);\r\n}\r\n.mkt-price .tab-content {\r\n  /*padding-top: 20px; max-height: 400px; overflow-y: scroll; overflow-x: hidden;*/\r\n  margin-top: 15px;\r\n}\r\n.mkt-price .tab-content .box-link {\r\n  position: relative;\r\n  z-index: 1;\r\n  transition: all 0.6s;\r\n}\r\n.mkt-price .tab-content .box-link .prod-inf {\r\n  width: calc(100% - 100px);\r\n}\r\n.mkt-price .tab-content .me-2 {\r\n  width: 100px;\r\n  height: 100px;\r\n  background-color: #f5f5f5;\r\n  margin-right: 0.68rem !important;\r\n}\r\n.mkt-price .tab-content .box-link .btn-save {\r\n  height: 20px;\r\n  position: absolute;\r\n  right: 8px;\r\n  top: 10px;\r\n  z-index: 9;\r\n  transition: all 0.6s;\r\n}\r\n.mkt-price .tab-content .box-link .btn-save .icon-tag {\r\n  display: none;\r\n  padding: 3px;\r\n}\r\n.mkt-price .tab-content .box-link .btn-save .icon-tag.active {\r\n  display: block;\r\n}\r\n.mkt-price .tab-content .box-link .btn-save .icon-tag:before {\r\n  font-size: 1.5rem;\r\n}\r\n.mkt-price .tab-content .box-link a:hover {\r\n  color: inherit !important;\r\n}\r\n.mkt-price .tab-content .box-link:hover .btn-save .icon-tag {\r\n  display: block;\r\n}\r\n.mkt-price .tab-content .box-link:hover .btn-save .icon-tag:before {\r\n  color: grey;\r\n}\r\n.mkt-price .tab-content .btn-save:hover .icon-tag.active:before,\r\n.mkt-price .tab-content .btn-save .icon-tag.active:before,\r\n.mkt-price .tab-content .box-link:hover .btn-save .icon-tag.active:before {\r\n  color: #009a59;\r\n}\r\n.mkt-price .tab-content .redu-pri,\r\n.mkt-price .tab-content .incr-pri {\r\n  font-weight: 500;\r\n}\r\n.mkt-price .tab-content .redu-pri {\r\n  color: #fc4400;\r\n}\r\n.mkt-price .tab-content .incr-pri {\r\n  color: #1cc619;\r\n}\r\n\r\n.mkt-price .tab-content .tab-pane div .lst-item,\r\n.mkt-price-hist .lst-item {\r\n  /*border-bottom: 1px solid #e1e1e1;*/\r\n  padding: 10px;\r\n  cursor: pointer;\r\n  display: block;\r\n  background-color: #fff;\r\n  margin-bottom: 10px;\r\n  border-radius: 2px;\r\n  box-shadow: 0px 5px 10px #e9e9e9;\r\n  border: 1px solid #eeeeee;\r\n}\r\n.mkt-price .tab-content .tab-pane div .lst-item:hover {\r\n  background-color: #fbfffd;\r\n}\r\n.mkt-price .tab-content .box-link:hover .lst-item {\r\n  /*background-color: #edf6f2;*/\r\n  box-shadow: none;\r\n  background-image: linear-gradient(#fff, #ecf8f2);\r\n}\r\n.mkt-price .tab-content .lst-item img {\r\n  width: 100%;\r\n  border-radius: 2px;\r\n  object-fit: cover;\r\n}\r\n.mkt-price .tab-content .lst-item .line-clamp-01 {\r\n  max-width: 180px;\r\n  padding-right: 2px;\r\n}\r\n.mkt-price .tab-content .lst-item small.align-items-center {\r\n  margin-bottom: 2px;\r\n}\r\n.mkt-price .tab-content .lst-item small.align-items-center:last-child {\r\n  margin-bottom: 0;\r\n}\r\n.mkt-price .tab-content .lst-item .text-right .icon-tag:before {\r\n  font-size: 1.3rem;\r\n}\r\n.mkt-price .tab-content .lst-item small.date .icon-time {\r\n  margin-top: 2px;\r\n}\r\n\r\n/*.mkt-price .tab-content .tab-pane div:last-child a .lst-item{border-bottom: none;}*/\r\n.mkt-price .tab-content .lst-item > div {\r\n}\r\n.mkt-price .tab-content .lst-item h6 {\r\n  text-transform: capitalize;\r\n  margin-bottom: 2px;\r\n  white-space: nowrap;\r\n  max-width: calc(100% - 20px);\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n.mkt-price .tab-content .lst-item .grey-light-clr {\r\n  color: #6f6f6f;\r\n}\r\n.mkt-price .tab-content .lst-item .prod-price .red-clr {\r\n  font-weight: 500;\r\n  font-size: 0.95rem;\r\n}\r\n.mkt-price .tab-content .lst-item .prod-price .incr-price,\r\n.mkt-price .tab-content .lst-item .prod-price .redu-price,\r\n.mkt-price .tab-content .lst-item .prod-price small {\r\n  margin-left: 15px;\r\n  font-weight: 500;\r\n}\r\n.mkt-price .tab-content .lst-item .date {\r\n  margin-left: auto !important;\r\n}\r\n.mkt-price .form-control,\r\n.mkt-price .form-select,\r\n.mkt-price .form-control {\r\n  border: 1px solid #c5c8cb;\r\n}\r\n.mkt-price .tab-content a:hover span,\r\n.mkt-price .tab-content a:hover small {\r\n  /*color: #191919;*/\r\n}\r\n.mkt-price .tab-content a:hover .red-clr {\r\n  color: #e52f19;\r\n}\r\n.mkt-price ul.nav-mkt-price {\r\n  background-color: #edf6f2;\r\n  margin: 0;\r\n  border-bottom: none;\r\n  border-top: 1px solid #e6e6e6;\r\n  padding-top: 8px;\r\n}\r\n.btn.contribute {\r\n  border-radius: 1px 25px;\r\n  padding: 3px 17px;\r\n  border: 1px solid #ecc00b;\r\n  background-image: linear-gradient(to right, #f8c90a, #ffd52c, #f8c90a);\r\n  color: #191919 !important;\r\n  font-size: 700;\r\n  font-size: 1.3rem;\r\n  transition: all 0.6s;\r\n  display: flex;\r\n  align-items: center;\r\n  min-width: 150px;\r\n}\r\n.btn.contribute:hover {\r\n  background-image: linear-gradient(to right, #ffd116, #ffdc51, #ffd116);\r\n}\r\n.btn.contribute .txt {\r\n  font-size: 0.96rem;\r\n  line-height: 0.96rem;\r\n  font-weight: 600;\r\n  letter-spacing: 0.2;\r\n  text-transform: uppercase;\r\n  margin-left: 5px;\r\n}\r\n.btn.contribute img {\r\n  height: 28px;\r\n}\r\n.btn.contribute .icon-bonus {\r\n  font-size: 1.35rem;\r\n  margin-right: 5px;\r\n  display: inline-block;\r\n  vertical-align: -2px;\r\n}\r\n.mkt-price-details .like-price-icon,\r\n.mkt-price-details .like-price-icon-active {\r\n  transition: all 0.6s;\r\n}\r\n\r\n.mkt-price-details .like-price-icon-active:hover,\r\n.mkt-price-details .like-price-icon:hover {\r\n  background-color: #f9f9f9;\r\n  cursor: pointer;\r\n  color: #009a59;\r\n  border-radius: 5px;\r\n  border: 1px solid #009a59;\r\n}\r\n.mkt-price-details .like-price-icon-active:hover .icon-tag {\r\n  color: #009a59;\r\n}\r\n/*.gctt-detail .col-md-9{position: relative;}*/\r\n.mkt-price-details .row {\r\n  border-bottom: 1px solid #e6e6e6;\r\n  padding-bottom: 10px;\r\n}\r\n.mkt-price-details .img-inf {\r\n  width: 150px;\r\n  border-radius: 5px;\r\n}\r\n.mkt-price-details .pri-detls {\r\n  font-weight: 700;\r\n  font-size: 38px;\r\n  margin-left: 10px;\r\n}\r\n.mkt-price .cont-center ol.breadcrumb * {\r\n  padding: 5px 0;\r\n}\r\n\r\nh4.title-line-lt {\r\n  margin-bottom: 0;\r\n  font-size: 1.4rem;\r\n}\r\nh4.title-line-lt:before {\r\n  height: 27px;\r\n}\r\n.mkt-price-details .location {\r\n  margin-bottom: 0px;\r\n}\r\n.mkt-price-details .location span,\r\n.mkt-price-details .time span {\r\n  margin-left: 6px;\r\n}\r\n.mkt-price-details .icon-location01:before,\r\n.mkt-price-details .icon-user01:before {\r\n  color: #919191;\r\n}\r\n\r\n.mkt-price-details .chartjs {\r\n  margin-top: 20px;\r\n}\r\n.mkt-price-details .table.table-striped {\r\n  margin-top: 10px;\r\n}\r\n.mkt-price-details .fb-icon {\r\n  width: 36px;\r\n  height: 36px;\r\n}\r\n.mkt-price-details .zalo-icon {\r\n  width: 36px;\r\n  height: 36px;\r\n}\r\n.mkt-price-details .hainong-icon {\r\n  width: 36px;\r\n  height: 36px;\r\n}\r\n.mkt-price-details .hainong-icon img {\r\n  background-color: #009a59;\r\n  border-radius: 4px;\r\n}\r\n.mkt-price-details .detl-title {\r\n  border-bottom: 1px solid #e6e6e6;\r\n}\r\n.mkt-price-details .like-price-icon {\r\n  margin-top: 15px;\r\n}\r\n.mkt-price-details .lst-item-detail .line-clamp-02 {\r\n  max-width: 285px;\r\n  line-height: normal;\r\n}\r\n\r\n.mkt-price-hist {\r\n  margin-top: 20px;\r\n}\r\n.mkt-price-hist .icon-chart {\r\n  margin-right: 8px;\r\n  font-size: 33px;\r\n  color: #009a59;\r\n}\r\n.mkt-price-hist .icon-store {\r\n  margin-right: 8px;\r\n  font-size: 33px;\r\n  color: #009a59;\r\n}\r\n.mkt-price-hist .txt {\r\n  font-size: 1.4rem;\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n}\r\n.mkt-price-hist .table > :not(:first-child) {\r\n  border-top: 2px solid #d1d1d1;\r\n}\r\n.mkt-price-hist .table > :not(caption) > * > * {\r\n  padding: 0.75rem 0.5rem;\r\n}\r\n.mkt-price-hist .fs-5 {\r\n  font-size: 1.16rem !important;\r\n}\r\n.mkt-price-hist .table-striped tbody tr:nth-of-type(odd) {\r\n  background-color: rgba(0, 0, 0, 0.01);\r\n}\r\n.mkt-price .box-show-all img {\r\n  background-color: rgba(0, 0, 0, 0.05);\r\n  border-radius: 50%;\r\n  padding: 5px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  opacity: 0.5;\r\n  width: 30px;\r\n  height: 30px;\r\n}\r\n.mkt-price .box-show-all {\r\n  min-height: 100px;\r\n  max-height: 200px;\r\n  font-weight: bold;\r\n  cursor: pointer; /* nên có để thể hiện interactivity */\r\n  transition: color 0.2s ease;\r\n}\r\n\r\n.mkt-price .box-show-all .link-show-all:hover {\r\n  color: #00854e; /* Áp dụng cho span nếu không bị override */\r\n}\r\n\r\n.mkt-price .box-show-all .link-show-all:hover img {\r\n  background-color: #00854e;\r\n  color: #ffffff;\r\n  opacity: 1;\r\n}\r\n\r\n.mkt-price .box-show-all .link-show-all:hover span {\r\n  color: #00854e; /* Đảm bảo span thay màu đồng bộ */\r\n}\r\n\r\n\r\n/*.detail-product *{word-break: break-all;}*/\r\n\r\n.call-expert .row-cols-3 {\r\n  margin-left: 0;\r\n}\r\n.call-expert .row-cols-3 > * {\r\n  padding-left: 8px;\r\n  padding-right: 8px;\r\n}\r\n.call-expert .box-cont {\r\n  background-color: #fff;\r\n  box-shadow: 0 1px 20px rgb(0 0 0 / 18%);\r\n  margin-bottom: 15px;\r\n  border-radius: 6px;\r\n  padding: 15px;\r\n  border: 1px solid #dbdbdb;\r\n}\r\n.call-expert .box-cont .avt-img {\r\n  width: 50px;\r\n  height: 50px;\r\n  margin-right: 0.8rem;\r\n  box-shadow: 0 0px 10px rgb(0 0 0 / 28%);\r\n}\r\n.call-expert .box-cont button.btn-link {\r\n  width: 100%;\r\n  text-align: center;\r\n  border: 1px solid #cfd7d3;\r\n  border-radius: 6px;\r\n  font-weight: bold;\r\n  transition: 0.3s all ease;\r\n  margin-top: 10px;\r\n  background-color: #f2f2f2;\r\n}\r\n.call-expert .box-cont button.btn-link:hover {\r\n  background-color: #009a59;\r\n  color: #fff;\r\n  border: 1px solid #009a59;\r\n}\r\n.call-expert .box-cont .text-muted {\r\n  height: 19px;\r\n}\r\n.call-expert .box-cont .expert-spec {\r\n}\r\n.call-expert .box-cont .rating {\r\n  margin-top: 2px;\r\n}\r\n.call-expert .box-cont .rating .fa-star {\r\n  font-size: 10px;\r\n  margin-right: 2px;\r\n  color: #bebebe;\r\n}\r\n.call-expert .box-cont .rating .fa-solid {\r\n  color: #ffd008;\r\n}\r\n\r\n/***** Wearther Details page *****/\r\n.weather-details .lt-side {\r\n  padding-top: 10px;\r\n}\r\n.weather-details .lt-side .select-style {\r\n  position: relative;\r\n  background-color: transparent !important;\r\n  border-color: transparent;\r\n  display: inline-block;\r\n}\r\n.weather-details .lt-side .select-style select.form-select {\r\n  background: transparent;\r\n  -webkit-appearance: none;\r\n  width: auto;\r\n  border: none;\r\n  margin-bottom: -7px;\r\n  padding-left: 0;\r\n}\r\n.weather-details .lt-side .select-style select.form-select:focus {\r\n  box-shadow: none !important;\r\n}\r\n.weather-details .lt-side .select-style select.form-select option {\r\n  font-size: 15px !important;\r\n}\r\n.weather-details .lt-side .select-style select.form-select option[selected],\r\n.weather-details .lt-side .select-style select.form-select option:first-child {\r\n  font-size: 20px !important;\r\n}\r\n.weather-details .wth-time .addr-txt {\r\n  width: 100%;\r\n}\r\n.weather-details .wth-time img {\r\n  opacity: 1;\r\n}\r\n.weather-details .lt-side .select-style:after {\r\n  width: 0;\r\n  height: 0;\r\n  border-left: 6px solid transparent;\r\n  border-right: 6px solid transparent;\r\n  border-top: 6px solid #5f5f5f;\r\n  position: absolute;\r\n  top: 15px;\r\n  right: 14px;\r\n  content: '';\r\n}\r\n.weather-details .lt-side .weath-img {\r\n  width: 70%;\r\n  margin-left: 10px;\r\n  margin-top: 0px;\r\n  margin-bottom: -10px;\r\n}\r\n.weather-details .lt-side small {\r\n  font-size: 77% !important;\r\n  color: #505050;\r\n}\r\n.weather-details .lt-side .temp {\r\n  font-size: 5rem;\r\n  margin: -10px 0;\r\n}\r\n.weather-details .lt-side .temp sup {\r\n  font-size: 1.5rem;\r\n  top: -2.5rem;\r\n}\r\n.weather-details .lt-side .wth-main {\r\n  margin: 0;\r\n  position: relative;\r\n  overflow: hidden;\r\n  border-radius: 6px;\r\n}\r\n.weather-details .lt-side .wth-main .wth-time,\r\n.weather-details .lt-side .wth-main .inf-cnt {\r\n  z-index: 1;\r\n  position: relative;\r\n  padding: 15px;\r\n}\r\n.weather-details .lt-side .wth-main .wth-time #inputWeather {\r\n  width: 100%;\r\n}\r\n.weather-details .lt-side .wth-main .wth-time .city-selct {\r\n  position: relative;\r\n  padding-right: 15px;\r\n  cursor: pointer;\r\n  margin-top: -5px;\r\n  font-size: 0.9rem;\r\n}\r\n/*.weather-details .lt-side .wth-main .wth-time .city-selct::after{position: absolute;display: inline-block;\r\n  margin-left: 0.255em;\r\n  vertical-align: 0.255em;\r\n  content: \"\";\r\n  border-top: 0.3em solid;\r\n  border-right: 0.3em solid transparent;\r\n  border-bottom: 0;\r\n  border-left: 0.3em solid transparent;\r\n  color: #191919;right: 0;top: 10px;\r\n}*/\r\n.weather-details .lt-side .wth-main .inp-addr {\r\n  border-radius: 6px 0 0 6px;\r\n  border: none;\r\n  padding: 2px 10px;\r\n  width: calc(100% - 44px);\r\n  position: relative;\r\n}\r\n.weather-details .lt-side .wth-main input.inp-addr,\r\n.weather-details .lt-side .wth-main button.btn {\r\n  height: 33px;\r\n}\r\n.weather-details .lt-side .wth-main button.btn {\r\n  padding: 2px 8px;\r\n  font-size: 15px;\r\n  background-color: #ffba40;\r\n  top: 0;\r\n  right: 0;\r\n  border-radius: 0 5px 5px 0;\r\n}\r\n.weather-details .lt-side .wth-main input.inp-addr:focus,\r\n.weather-details .lt-side .wth-main button.btn:focus,\r\n.weather-details .lt-side .wth-main button.btn:active {\r\n  box-shadow: none;\r\n  border: none;\r\n  outline: none;\r\n}\r\n.weather-details .lt-side .wth-main:before {\r\n  background: linear-gradient(to bottom, #4ab672d1 0%, #9cc6467d 100%);\r\n  width: 100%;\r\n  height: 100%;\r\n  content: '';\r\n  z-index: 1;\r\n  left: 0;\r\n  top: 0;\r\n  position: absolute;\r\n  content: ' ';\r\n}\r\n.weather-details .lt-side .icon-weather01,\r\n.weather-details .lt-side .icon-rainpre {\r\n  font-size: 26px;\r\n  margin-right: 5px;\r\n  color: #9e9e9e;\r\n}\r\n.weather-details .lt-side .select-style select.form-select {\r\n  margin-bottom: -10px;\r\n}\r\n.weather-details .lt-side button.btn-input-localtn {\r\n  padding: 5px 10px;\r\n  width: 42px;\r\n  height: 40px;\r\n  border-radius: 5px;\r\n  border: none;\r\n  background-color: transparent;\r\n  /*border: 1px solid #ffffff1f;*/\r\n}\r\n.weather-details .lt-side .btn-audio {\r\n  padding-right: 5px;\r\n}\r\n.weather-details .lt-side button.btn-input-localtn {\r\n  position: relative;\r\n}\r\n.weather-details .lt-side button.btn-input-localtn:after {\r\n  content: '';\r\n  position: absolute;\r\n  width: 2px;\r\n  height: 15px;\r\n  background-color: #0000001c;\r\n  left: 1px;\r\n  top: 11px;\r\n}\r\n.weather-details .lt-side .btn-audio svg {\r\n  margin-top: -3px;\r\n}\r\n.weather-details .lt-side button.btn-input-localtn img {\r\n  width: 19px;\r\n}\r\n.weather-details .temp {\r\n  font-family: 'helvetica-neue-condensed-bold', sans-serif;\r\n}\r\n.weather-details .rt-side .lst-hrs {\r\n  margin-top: 10px;\r\n}\r\n.weather-details .rt-side .lst-hrs img {\r\n  height: 2.2rem;\r\n}\r\n.weather-details .rt-side .lst-hrs .fs-6 {\r\n  color: #555;\r\n  font-size: 0.9rem !important;\r\n}\r\n.weather-details .rt-side .lst-hrs .col {\r\n  text-align: center;\r\n  padding-right: 5px;\r\n  padding-left: 5px;\r\n}\r\n.weather-details .rt-side .lst-hrs .rain-forc {\r\n  margin-top: -5px;\r\n}\r\n.weather-details .rt-side .lst-hrs .rain-forc small {\r\n  font-size: 77% !important;\r\n}\r\n.weather-details .rt-side .lst-hrs .rain-forc small + span {\r\n  font-size: 60% !important;\r\n}\r\n.weather-details .rt-side .lst-hrs .box-cnt,\r\n.weather-details .rt-side .lst-stt .box-cnt {\r\n  box-shadow: 0px 0px 5px 0px #e5e5e5;\r\n  padding: 13px;\r\n  margin-bottom: 10px;\r\n  background-color: #ffffff;\r\n  border-radius: 6px;\r\n  box-shadow: 0 2px 12px #00000026;\r\n  border: 1px solid #eaeaea;\r\n}\r\n.weather-details .rt-side .lst-stt .box-cnt .align-items-center {\r\n  height: 42px;\r\n}\r\n.weather-details .rt-side .lst-stt .col {\r\n  padding-right: 5px;\r\n  padding-left: 5px;\r\n}\r\n.weather-details .rt-side .lst-stt img.high-temp,\r\n.weather-details .rt-side .lst-stt img.low-temp {\r\n  width: 1.3rem;\r\n}\r\n.weather-details .rt-side .lst-stt img.sunrise {\r\n  width: 2.4rem;\r\n}\r\n.weather-details .rt-side .lst-stt .numb {\r\n  font-size: 1.7rem;\r\n  font-weight: 500;\r\n  margin-left: 10px;\r\n}\r\n.weather-details .rt-side .lst-stt .unit {\r\n  font-size: 1rem;\r\n}\r\n.weather-details .rt-side .lst-stt .unit sup {\r\n  top: -0.8rem;\r\n}\r\n.weather-details .rt-side .lst-stt .icon-pinwheel {\r\n  font-size: 2.2rem;\r\n  color: #8b25ae;\r\n}\r\n.weather-details .rt-side .lst-stt .icon-humidity {\r\n  font-size: 2.4rem;\r\n  color: #568a8d;\r\n}\r\n.weather-details .rt-side .lst-stt .icon-sunset {\r\n  font-size: 1.8rem;\r\n  color: #fd8936;\r\n}\r\n/*.weather-details .rt-side .title-line:before {\r\n  position: absolute;\r\n  left: 0;\r\n  height: 1.4rem;\r\n  width: 0.28rem;\r\n  content: \"\";\r\n  background-color: #009a59;\r\n  top: -0.1rem;\r\n}*/\r\n.weather-details .rt-side table th {\r\n  font-weight: normal;\r\n}\r\n\r\n.weather-details .rt-side .table.table-hover > :not(caption) > * > * {\r\n  padding: 0.5rem 0.5rem;\r\n  vertical-align: middle !important;\r\n  border-bottom-width: 1px;\r\n}\r\n.weather-details .rt-side .table.table-hover td,\r\n.weather-details .rt-side .table.table-hover th {\r\n  border-top: none;\r\n}\r\n.weather-details .rt-side .table tr:first-child > * {\r\n  border-top-color: transparent;\r\n}\r\n.weather-details .rt-side .table tr:last-child > * {\r\n  border-bottom-color: transparent;\r\n}\r\n\r\n.weather-details .rt-side .table.table-hover tbody tr:hover {\r\n  background-color: #00000000;\r\n}\r\n.weather-details .rt-side .table.table-hover {\r\n  --bs-table-hover-bg: rgba(0, 0, 0, 0.028);\r\n}\r\n.weather-details .rt-side .table.table-hover tbody tr .icon-humidity {\r\n  color: #568a8d;\r\n}\r\n.weather-details .rt-side .table.table-hover tbody tr img {\r\n  height: 1.9rem;\r\n}\r\n.weather-details .rt-side .table.table-hover tbody tr td span.icon-temp {\r\n  color: #e1412a !important;\r\n}\r\n\r\n/* s-btn flickering effect */\r\n.button_glowing {\r\n  background-color: #da663b;\r\n  border-radius: 60px;\r\n  border: 5px solid #ffffff1e;\r\n  color: #ffffff !important;\r\n  cursor: pointer;\r\n  display: inline-block;\r\n  font-family: poppins;\r\n  font-weight: 400;\r\n  padding: 6px 25px;\r\n  text-align: center;\r\n  text-decoration: none;\r\n  font-family: 'UTMFuturaExtra';\r\n  text-transform: uppercase;\r\n  font-weight: normal;\r\n  font-size: 1.4rem;\r\n  -webkit-animation: glowing 1500ms infinite;\r\n  -moz-animation: glowing 1500ms infinite;\r\n  -o-animation: glowing 1500ms infinite;\r\n  animation: glowing 1500ms infinite;\r\n}\r\n@-webkit-keyframes glowing {\r\n  0% {\r\n    background-color: #da663b;\r\n    -webkit-box-shadow: 0 0 3px #da663b;\r\n  }\r\n  50% {\r\n    background-color: #da663b;\r\n    -webkit-box-shadow: 0 0 40px #da663b;\r\n  }\r\n  100% {\r\n    background-color: #da663b;\r\n    -webkit-box-shadow: 0 0 3px #da663b;\r\n  }\r\n}\r\n\r\n@-moz-keyframes glowing {\r\n  0% {\r\n    background-color: #da663b;\r\n    -moz-box-shadow: 0 0 3px #da663b;\r\n  }\r\n  50% {\r\n    background-color: #da663b;\r\n    -moz-box-shadow: 0 0 40px #ff0000;\r\n  }\r\n  100% {\r\n    background-color: #da663b;\r\n    -moz-box-shadow: 0 0 3px #da663b;\r\n  }\r\n}\r\n\r\n@-o-keyframes glowing {\r\n  0% {\r\n    background-color: #da663b;\r\n    box-shadow: 0 0 3px #b20000;\r\n  }\r\n  50% {\r\n    background-color: #ff0000;\r\n    box-shadow: 0 0 40px #ff0000;\r\n  }\r\n  100% {\r\n    background-color: #da663b;\r\n    box-shadow: 0 0 3px #da663b;\r\n  }\r\n}\r\n\r\n@keyframes glowing {\r\n  0% {\r\n    background-color: #ffc700;\r\n    box-shadow: 0 0 3px #ffe896;\r\n  }\r\n  50% {\r\n    background-color: #ffc700;\r\n    box-shadow: 0 0 40px #ffdd64;\r\n  }\r\n  100% {\r\n    background-color: #da663b;\r\n    box-shadow: 0 0 3px #e78a68;\r\n  }\r\n}\r\n/* e-btn flickering effect */\r\n\r\n.cont-center .gifts .flashit {\r\n  font-weight: 500;\r\n  position: absolute;\r\n  right: 5px;\r\n  top: 5px;\r\n  font-size: 13px;\r\n  text-transform: none;\r\n  background-color: #da251d;\r\n  border: 0.2px solid rgba(255, 255, 255, 0.7490196078);\r\n  padding: 0px 5px 1px;\r\n  border-radius: 6px;\r\n  letter-spacing: 0.5px;\r\n  color: #fff;\r\n}\r\n\r\n.arrow-wrapper {\r\n  background-color: rgba(0, 0, 0, 0.05);\r\n  border-radius: 50%;\r\n  padding: 5px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  opacity: 0.5;\r\n  transition:\r\n    background-color 0.3s,\r\n    opacity 0.3s;\r\n  margin: 5px;\r\n\r\n  img {\r\n    width: 20px;\r\n    height: 20px;\r\n    object-fit: contain;\r\n  }\r\n\r\n  &:hover {\r\n    opacity: 0.7;\r\n    background-color: #00854e;\r\n  }\r\n}\r\n\r\n\r\n.tab-content > div .mt-3.card .card-body {\r\n  width: 100%;\r\n  overflow: scroll;\r\n}\r\n.tab-content > div .mt-3.card .card-body .table th {\r\n  border-top: none;\r\n}\r\n.tab-content > div .mt-3.card .card-body .table th {\r\n  width: 20%;\r\n}\r\n.tab-content > div .mt-3.card .card-body .table th div {\r\n  width: 100%;\r\n  min-width: 105px;\r\n}\r\n\r\n.ModalViewContainer .bg-dark button {\r\n}\r\n.ModalViewContainer .bg-dark button.left-10 svg,\r\n.ModalViewContainer .bg-dark button.right-10 svg {\r\n  position: relative;\r\n  justify-content: center !important;\r\n  align-items: center;\r\n  display: flex;\r\n  top: 0px;\r\n}\r\n.ModalViewContainer .bg-dark button.left-10 svg {\r\n  left: 0px;\r\n}\r\n.ModalViewContainer .bg-dark button.right-10 svg {\r\n  right: 0px;\r\n}\r\n.ModalViewContainer .bg-dark button.left-10 svg path {\r\n  position: absolute;\r\n  left: 5px;\r\n  top: 5px;\r\n}\r\n.ModalViewContainer .bg-dark button.right-10 svg path {\r\n  position: absolute;\r\n  right: 5px;\r\n  top: 5px;\r\n}\r\n.ModalViewContainer .CommentWrapper .avatar {\r\n  height: 50px;\r\n  width: 50px;\r\n  border-radius: 100px;\r\n  border: 1px solid #e1e1e1;\r\n}\r\n\r\nfooter {\r\n  background-color: #009a59;\r\n  padding: 1.5rem 0;\r\n  color: #fff;\r\n  margin-top: 20px;\r\n}\r\nfooter .logo img {\r\n  height: 5rem;\r\n}\r\nfooter .social-ico [class^='icon-'] {\r\n  width: 51px;\r\n  height: 51px;\r\n  line-height: 48px;\r\n  border-radius: 100px;\r\n  border-style: solid;\r\n  border-width: 2px;\r\n  text-align: center;\r\n  background-color: #fff;\r\n  display: inline-block;\r\n  margin: 0 10px;\r\n}\r\nfooter .social-ico [class^='icon-']:before {\r\n  font-size: 26px;\r\n}\r\nfooter .social-ico [class^='icon-']:first-child {\r\n  margin-left: 0;\r\n}\r\nfooter .social-ico .icon-facebook {\r\n  border-color: #1863f261;\r\n}\r\nfooter .social-ico .icon-youtube {\r\n  border-color: #ea412c40;\r\n}\r\nfooter .social-ico .icon-youtube:before {\r\n  font-size: 22px;\r\n}\r\nfooter .social-ico .icon-zalo {\r\n  border-color: #007ac669;\r\n}\r\nfooter .social-ico .icon-tiktok {\r\n  border-color: #54006830;\r\n}\r\nfooter .contact-inf {\r\n  font-size: 18px;\r\n  padding: 0px 15px !important;\r\n}\r\nfooter .contact-inf a {\r\n  color: #ffc039 !important;\r\n  font-size: 18px;\r\n}\r\nfooter .footer-title {\r\n  font-size: 24px !important;\r\n  font-weight: 700;\r\n}\r\n\r\n/*// -------------------------------------------------------------\r\n// Media Queries*/\r\n@media (min-width: 1024px) {\r\n  .weather h2.fn-temp {\r\n    font-size: 1.9rem;\r\n  }\r\n  .weather .d-sm-block .row [class^='col-']:last-child {\r\n    padding-left: 0 !important;\r\n  }\r\n  .weather .d-sm-block .fw-semibold {\r\n    font-size: 0.6rem;\r\n    letter-spacing: -0.5;\r\n    margin-bottom: 2px;\r\n  }\r\n  .weather .fst-italic {\r\n    font-size: 68%;\r\n  }\r\n  .weather .d-sm-block small.fw-normal {\r\n    font-size: 0.8rem;\r\n  }\r\n}\r\n@media (min-width: 1200px) {\r\n  .container,\r\n  .container-lg,\r\n  .container-md,\r\n  .container-sm,\r\n  .container-xl {\r\n    width: 100%;\r\n    max-width: 1140px;\r\n    margin: 0 auto;\r\n  }\r\n  .weather h2.fn-temp {\r\n    font-size: 2.4rem;\r\n  }\r\n  .weather .d-sm-block .fw-semibold {\r\n    font-size: 0.7rem;\r\n  }\r\n  .weather .d-sm-block .fw-semibold {\r\n    font-size: 0.8rem;\r\n  }\r\n  .weather .d-sm-block small.fw-normal {\r\n    font-size: 0.8rem;\r\n  }\r\n}\r\n@media (min-width: 1440px) {\r\n  .container {\r\n    max-width: 1280px;\r\n  }\r\n  .weather h2.fn-temp {\r\n    font-size: 3.1rem;\r\n  }\r\n  .weather .d-sm-block .fw-semibold {\r\n    font-size: 0.9rem;\r\n  }\r\n  .weather .fst-italic {\r\n    font-size: 80%;\r\n  }\r\n  .weather .d-sm-block small.fw-normal {\r\n    font-size: 1rem;\r\n  }\r\n  .col-12p5 {\r\n    flex: 0 0 auto !important;\r\n    width: 20% !important;\r\n    max-width: 9999px;\r\n  }\r\n}\r\n@media (min-width: 1600px) {\r\n  .container {\r\n    max-width: 1440px;\r\n  }\r\n}\r\n@media (min-width: 1800px) {\r\n  .container {\r\n    max-width: 1600px;\r\n  }\r\n}\r\n@media (min-width: 2048px) {\r\n  .container {\r\n    max-width: 1800px;\r\n  }\r\n}\r\n@media (min-width: 2300px) {\r\n  .container {\r\n    max-width: 2048px;\r\n  }\r\n}\r\n@media (min-width: 1024px) and (max-width: 1399px) {\r\n  .interve-btn {\r\n    padding: 6px 15px;\r\n    border-radius: 6px;\r\n  }\r\n  .cate-prod .bg-img {\r\n    border-radius: 15px;\r\n  }\r\n  .cate-prod .bg-img > div .cate-txt {\r\n    font-size: 20px;\r\n    line-height: 24px;\r\n  }\r\n  .mkt-price .search-box form {\r\n    width: 100%;\r\n  }\r\n}\r\n@media (min-width: 767px) and (max-width: 1199px) {\r\n  .container-sm,\r\n  .container {\r\n    max-width: 1160px !important;\r\n  }\r\n  .mkt-price .search-box form {\r\n    width: 100%;\r\n  }\r\n  header .top-sectn .side-r .notify-box li .icon-close {\r\n    display: inline-block;\r\n    color: #858585;\r\n  }\r\n}\r\n\r\n@media (max-width: 767px) {\r\n  .post-more {\r\n    margin-top: 20px;\r\n    margin-bottom: 20px;\r\n  }\r\n  header .hashtag-sectn ul {\r\n    /*width: 100%;*/\r\n    text-overflow: ellipsis;\r\n    white-space: pre;\r\n    padding: 0;\r\n    overflow: hidden;\r\n    overflow-x: scroll;\r\n    white-space: nowrap;\r\n    margin-top: 5px;\r\n    margin-bottom: 5px;\r\n  }\r\n  header .hashtag-sectn ul::-webkit-scrollbar-track {\r\n    border-radius: 0px;\r\n    margin-top: 0px;\r\n    background-color: transparent;\r\n  }\r\n\r\n  header .hashtag-sectn ul::-webkit-scrollbar {\r\n    height: 0px;\r\n    background-color: transparent;\r\n    margin-top: 0px;\r\n  }\r\n\r\n  header .hashtag-sectn ul::-webkit-scrollbar-thumb {\r\n    border-radius: 0px;\r\n    background-color: transparent;\r\n  }\r\n\r\n  header .hashtag-sectn ul.list-post-catalogues {\r\n    margin-top: -1px;\r\n  }\r\n  header .hashtag-sectn ul li {\r\n    margin: 0 14px;\r\n  }\r\n  header .hashtag-sectn ul .reset-btn {\r\n    display: none;\r\n  }\r\n  /*header .hashtag-sectn ul.contr-btn{overflow-x:hidden;}*/\r\n  .d-desktop {\r\n    display: none;\r\n  }\r\n  .d-mobile {\r\n    display: inline-block;\r\n  }\r\n  header .contain-prof .icon-user {\r\n    font-size: 24px;\r\n    color: #fff;\r\n  }\r\n  header .contain-prof .dropdown-toggle::after {\r\n    display: none;\r\n  }\r\n  header .contain-prof .dropdown-menu.show {\r\n    top: 8px !important;\r\n  }\r\n  header .top-sectn a.logo img {\r\n    width: 110px;\r\n  }\r\n  header .contain-prof ul {\r\n    padding: 10px 20px;\r\n    margin: 0;\r\n  }\r\n  header .contain-prof ul li {\r\n    list-style: none;\r\n    padding: 13px 0;\r\n    /*border-bottom: 1px solid #e5e5e5;*/\r\n    display: flex;\r\n    align-items: center;\r\n  }\r\n  header .contain-prof ul li.logout {\r\n    border-bottom: none;\r\n  }\r\n  header .contain-prof ul li .avatar {\r\n    height: 30px;\r\n    width: 30px;\r\n    border-radius: 100px;\r\n    margin-right: 5px;\r\n    object-fit: cover;\r\n  }\r\n  header .top-sectn .side-r .acct-box .user-name {\r\n    color: #191919;\r\n  }\r\n  header .top-sectn .side-r .notify-box .item-numb {\r\n    top: 2px;\r\n  }\r\n  header .top-sectn .side-r .acct-box .dropdown-menu {\r\n    top: 14px !important;\r\n  }\r\n  header .contain-prof ul li.logout {\r\n    border-top: 1px solid #eee;\r\n  }\r\n  header .hashtag-sectn {\r\n    position: relative;\r\n    z-index: 9;\r\n  }\r\n  header .cate-sectn {\r\n    position: relative;\r\n    z-index: 999999;\r\n  }\r\n  header .cate-sectn a.d-mobile + .contain-sidebar-l.show {\r\n    display: block !important;\r\n    width: 100%;\r\n    position: absolute;\r\n    top: 40px;\r\n    background-color: #fff;\r\n    padding: 0px 15px 15px;\r\n    box-shadow: 0 3px 3px rgb(0 0 0 / 30%);\r\n    z-index: 999999;\r\n    border-top: 1px solid #dedede;\r\n  }\r\n  /*header .cate-sectn a.d-mobile:hover + .contain-sidebar-l .row{z-index: 999999;position: relative;}*/\r\n  header .cate-sectn a.d-mobile + .contain-sidebar-l.show .title-txt {\r\n    color: #009958;\r\n    font-size: 1.05rem;\r\n    background-color: #e9e9e9;\r\n    padding: 8px 0;\r\n  }\r\n  header .cate-sectn a.d-mobile + .contain-sidebar-l.show ul {\r\n    margin: 0;\r\n    padding: 0;\r\n  }\r\n  header .cate-sectn a.d-mobile + .contain-sidebar-l.show li {\r\n    list-style: none;\r\n    margin: 0;\r\n    padding: 10px 0;\r\n    border-bottom: 1px solid #e9e9e9;\r\n  }\r\n  header .cate-sectn a.d-mobile + .contain-sidebar-l.show ul li:last-child {\r\n    border-bottom: none;\r\n  }\r\n  header .cate-sectn a.d-mobile + .contain-sidebar-l.show li a {\r\n    z-index: 99999;\r\n    position: relative;\r\n    display: block;\r\n    line-height: 20px;\r\n  }\r\n  header .cate-sectn .contain-sidebar-l li.seemore a {\r\n    color: #2a2a2a !important;\r\n    font-size: 15px;\r\n  }\r\n  header .cate-sectn .contain-sidebar-l li.seemore a .icon-arrow-solid {\r\n    font-size: 8px;\r\n  }\r\n  header .cate-sectn {\r\n    padding: 13px 0;\r\n    margin-bottom: 10px;\r\n  }\r\n  header .hashtag-sectn ul li a {\r\n    padding: 0;\r\n  }\r\n  header .cate-sectn .icon-currency {\r\n    font-size: 35px;\r\n  }\r\n  header .top-sectn .side-r .acct-box .dropdown-menu {\r\n    z-index: 1000;\r\n  }\r\n  header .top-sectn .side-r .acct-box .dropdown-menu ul li.logout {\r\n    margin-top: 0;\r\n  }\r\n  header .top-sectn .side-r .acct-box .dropdown-menu ul li.logout a#login-with-two-nong {\r\n    margin-top: 0px;\r\n    font-size: 18px;\r\n    border-radius: 5px;\r\n    padding: 5px 0;\r\n    border: none;\r\n    background-image: linear-gradient(#f6a503, #fff0b0);\r\n    border: 1px solid #e5ca91;\r\n    transition: all 0.3s;\r\n    box-shadow: none;\r\n    width: 100%;\r\n    display: block;\r\n    font-weight: 500;\r\n  }\r\n  header .top-sectn .side-r .notify-box .dropdown-menu.show {\r\n    top: 48px !important;\r\n  }\r\n\r\n  header .cate-sectn [class^='icon-'],\r\n  header .cate-sectn [class*=' icon-'] {\r\n    height: 28px;\r\n  }\r\n  header .cate-sectn .active [class^='icon-'],\r\n  header .cate-sectn .active [class*=' icon-'] {\r\n    position: relative;\r\n  }\r\n  header .cate-sectn a:hover [class^='icon-'],\r\n  header .cate-sectn a.active:hover [class^='icon-'] {\r\n    color: #ffa608;\r\n  }\r\n  header .cate-sectn a:hover .mn-tooltip {\r\n    display: none;\r\n  }\r\n  header .cate-sectn .active [class^='icon-']:after,\r\n  header .cate-sectn .active [class*=' icon-']:after {\r\n    position: absolute;\r\n    bottom: -13px;\r\n    content: '';\r\n    height: 2px;\r\n    left: -5px;\r\n    width: calc(100% + 10px);\r\n    background-color: orange;\r\n  }\r\n  header .cate-sectn [class^='icon-'] {\r\n    font-size: 28px;\r\n    padding: 0;\r\n  }\r\n  header .cate-sectn .icon-menu-main,\r\n  header .cate-sectn .icon-more-menu {\r\n    font-size: 28px;\r\n  }\r\n  header .cate-sectn .icon-price-menu {\r\n    font-size: 36px;\r\n  }\r\n  header .cate-sectn .icon-news02 {\r\n    font-size: 34px;\r\n  }\r\n  header .cate-sectn .icon-home,\r\n  header .cate-sectn .icon-news02 {\r\n    font-size: 33px;\r\n  }\r\n  header .cate-sectn .icon-triangle-line,\r\n  header .cate-sectn .icon-farmer-market {\r\n    font-size: 28px;\r\n  }\r\n\r\n  header .hashtag-sectn .icon-arrow-black {\r\n    width: 40px;\r\n  }\r\n  header .hashtag-sectn .icon-arrow-black.next-btn {\r\n    margin-right: -10px;\r\n    display: none;\r\n  }\r\n  header .hashtag-sectn .icon-arrow-black.prev-btn {\r\n    margin-left: 0px;\r\n    display: none;\r\n  }\r\n  header .hashtag-sectn ul li {\r\n    line-height: initial;\r\n  }\r\n  header .cate-sectn .container,\r\n  header .hashtag-sectn .container {\r\n    padding: 0;\r\n  }\r\n\r\n  h2 {\r\n    font-size: 24px !important;\r\n  }\r\n  .traceability-home .code-box {\r\n    width: 100%;\r\n  }\r\n  .saved-items .nav-tabs .nav-item .nav-link,\r\n  .nav-mkt-price .nav-item .nav-link {\r\n    font-size: 1.05rem;\r\n  }\r\n\r\n  .post-box .posted-inf .sharing-post .bg-img {\r\n    /*min-height: 100px;height: auto;*/\r\n    height: 220px;\r\n    margin-top: 10px;\r\n  }\r\n  #box-weather.weather {\r\n    display: none;\r\n  }\r\n  .home-wrapper .news-sectn .main-news .inf-box {\r\n    height: auto;\r\n  }\r\n  .home-wrapper .news-sectn .main-news {\r\n    margin-bottom: 10px;\r\n    padding: 0 !important;\r\n  }\r\n  .home-wrapper .news-sectn .sub-news {\r\n    padding: 0 5px;\r\n  }\r\n  .cmt-box .cmt-listing input {\r\n    width: 100%;\r\n  }\r\n  .cmt-box .actions .dropdown {\r\n    display: inline-block;\r\n  }\r\n  .post-box .posted-inf .fav-ctrl > div:hover span,\r\n  .post-box .posted-inf .fav-ctrl > div:hover span:before {\r\n    color: inherit;\r\n  }\r\n  .box-bd.hotnews .hot-videos .bg-img {\r\n    height: 80px !important;\r\n  }\r\n\r\n  /***** Mobile- download app *****/\r\n  .App .d-mobile.sticky-top {\r\n    position: sticky;\r\n    z-index: 1000;\r\n    top: 0;\r\n    transition: top 0.5s ease-in-out 0s;\r\n  }\r\n  .go-to-app {\r\n    background-color: #fff;\r\n    padding: 10px;\r\n    box-shadow: 0 2px 4px rgb(0 0 0 / 28%);\r\n    width: calc(100% - 0px);\r\n    font-size: 15px;\r\n    border-radius: 0 0 10px 10px;\r\n    margin: 0;\r\n  }\r\n  .go-to-app .app-icon {\r\n    height: 60px;\r\n    border-radius: 8px;\r\n    margin-right: 10px;\r\n  }\r\n  .go-to-app .grey-clr {\r\n  }\r\n  .go-to-app .second-clr {\r\n  }\r\n  .go-to-app .btn-open {\r\n    color: #1f1f1f;\r\n    font-weight: 600;\r\n    border-radius: 100px;\r\n    padding: 5px 15px;\r\n    background-image: linear-gradient(to right, #ffa908, #fad53b, #ffa908);\r\n    /* margin-top: 30px; */\r\n  }\r\n  .go-to-app .icon-close {\r\n    top: 10px;\r\n    right: 15px;\r\n    font-size: 13px;\r\n    color: #868686;\r\n  }\r\n  #page-wrapper {\r\n    padding-top: 5px;\r\n    padding-bottom: 20px;\r\n  }\r\n\r\n  .bg-img-orgnal.avtar45 {\r\n    left: 0px;\r\n    top: 0px;\r\n  }\r\n  .post-box .btn-post {\r\n    height: 40px;\r\n    padding: 0 0px;\r\n  }\r\n  .post-box .btn-post .icon-library {\r\n    left: 0;\r\n  }\r\n  .post-box .post-report ul .dropdown-item {\r\n    font-size: 14px;\r\n  }\r\n  .cont-center .cntry-news,\r\n  .cont-center .world-news,\r\n  .mrgt28 {\r\n    margin-top: 10px !important;\r\n  }\r\n  .search-top .icon-search {\r\n    left: 12px;\r\n    top: 8px;\r\n    z-index: 9;\r\n    opacity: 1;\r\n  }\r\n  .search-top input {\r\n    padding-top: 3px;\r\n    padding-bottom: 3px;\r\n  }\r\n  .search-top input {\r\n    padding-left: 33px;\r\n    height: 30px;\r\n  }\r\n  .mkt-price {\r\n    margin-top: 10px !important;\r\n  }\r\n  .nav-mkt-price {\r\n    margin-top: 10px !important;\r\n  }\r\n  .mkt-price .tab-content .row-cols-2 > * {\r\n    width: 50%;\r\n  }\r\n  .mkt-price .tab-content {\r\n    margin-top: 10px;\r\n  }\r\n  .mkt-price .tab-content .tab-pane div .lst-item {\r\n    padding: 10px;\r\n  }\r\n  .mkt-price .tab-content .lst-item .line-clamp-01 {\r\n    max-width: 150px;\r\n  }\r\n  .mkt-price .tab-content .lst-item .prod-price .fs-4 {\r\n    font-size: 1.26rem !important;\r\n  }\r\n  .mkt-price .cate-lst.mb-4 {\r\n    margin-bottom: 15px !important;\r\n  }\r\n\r\n  .nav-mkt-price .nav-item {\r\n    width: 33.333333%;\r\n  }\r\n  .mkt-price-details .pri-detls {\r\n    font-size: 22px;\r\n  }\r\n  .mkt-price-hist .txt {\r\n    font-size: 20px;\r\n  }\r\n  .mkt-price-hist .icon-chart {\r\n    font-size: 28px;\r\n    margin-right: 6px;\r\n  }\r\n  .mkt-price-details .lst-item-detail .line-clamp-02 {\r\n    max-width: 200px;\r\n    font-size: 1.22rem;\r\n  }\r\n  .user-inf .member_rate_in_month.text-end {\r\n    /*text-align: left !important;\r\n    margin-left: 56px;*/\r\n    margin-top: -35px;\r\n  }\r\n  .mkt-price-details .like-price-icon-active:hover {\r\n    color: #fff;\r\n    background-color: #009958;\r\n    border: 1px solid #009958;\r\n  }\r\n  .post-box .post-report ul.dropdown-menu-end {\r\n    margin-top: 8px !important;\r\n  }\r\n  .weather .days-lst .col-sm {\r\n    flex: 1 0 0%;\r\n  }\r\n  .call-expert .row-cols-3 {\r\n    margin-right: calc(-0.5 * var(--bs-gutter-x));\r\n    margin-left: calc(-0.5 * var(--bs-gutter-x));\r\n  }\r\n  .call-expert .row-cols-3 > * {\r\n    padding-left: 15px;\r\n    padding-right: 15px;\r\n    width: 100%;\r\n  }\r\n  .post-box {\r\n    margin-bottom: 13px;\r\n  }\r\n  .npk-frm .choice-lst .row-cols-2 > * {\r\n    width: 100%;\r\n  }\r\n  .cmt-box {\r\n    padding: 0;\r\n  }\r\n  .mkt-price .search-box .btn-box {\r\n    width: 100%;\r\n  }\r\n  .video-sectn .bg-img.thumb-pt {\r\n    height: 126px;\r\n  }\r\n  .cmt-box .cmt-listing .input-box {\r\n    margin-left: 50px;\r\n    width: calc(100% - 50px) !important;\r\n  }\r\n  .FormAddEditProduct.card .card-body .col-2 {\r\n    width: 33.333333%;\r\n  }\r\n  .sub-news-item.mb-3 {\r\n    margin-bottom: 0.6rem !important;\r\n  }\r\n  header .top-sectn .side-r .notify-box li .icon-close {\r\n    display: inline-block;\r\n    color: #858585;\r\n  }\r\n  header .cate-sectn .contain-sidebar-l [class^='icon-'] {\r\n    font-size: 18px;\r\n    margin-right: 5px;\r\n    color: #009a59;\r\n  }\r\n  header .cate-sectn .contain-sidebar-l .icon-weather02 {\r\n    font-size: 21px;\r\n  }\r\n  header .cate-sectn .contain-sidebar-l .icon-present {\r\n    font-size: 16px;\r\n  }\r\n  header .cate-sectn .contain-sidebar-l .icon-farmer-market,\r\n  header .cate-sectn .contain-sidebar-l .icon-gift {\r\n    font-size: 15px;\r\n  }\r\n  header .cate-sectn .contain-sidebar-l span.txt {\r\n    font-weight: 500;\r\n  }\r\n\r\n  footer.footer-sectn {\r\n    text-align: center;\r\n  }\r\n  footer.footer-sectn .d-flex.align-items-center {\r\n    display: block !important;\r\n  }\r\n  footer.footer-sectn .social-ico {\r\n    justify-content: center;\r\n  }\r\n  footer.footer-sectn .row > div {\r\n    margin-bottom: 20px;\r\n  }\r\n  footer.footer-sectn .row > div:last-child {\r\n    margin-bottom: 0;\r\n  }\r\n  .mkt-price .tab-content .box-link .btn-save .icon-tag {\r\n    display: block;\r\n  }\r\n  .inpt-cntn.cmt-box .bg-img-orgnal.avtar40 {\r\n    left: 10px;\r\n  }\r\n  .inpt-cntn .btn-send {\r\n    right: 15px;\r\n  }\r\n  .pro-tech-lst > .position-relative {\r\n    margin-top: calc(15% + 1.5px);\r\n  }\r\n  .pro-tech-lst .arg-type-main .wrap-img .bg-img-orgnal {\r\n    padding-top: 30%;\r\n  }\r\n  .home-wrapper .posts-sectn .inf-post .poster-txt .carousel-caption .line-clamp-02.fs-6 {\r\n    width: 100%;\r\n    font-size: 1.15rem !important;\r\n    line-height: 1.5rem;\r\n  }\r\n  .home-wrapper .posts-sectn .carousel.slide .carousel-control-prev-icon,\r\n  .home-wrapper .posts-sectn .carousel.slide .carousel-control-next-icon {\r\n    display: none;\r\n  }\r\n  .home-wrapper .posts-sectn .inf-post .poster-txt {\r\n    margin-top: 20px;\r\n  }\r\n  .home-wrapper .posts-sectn .inf-post {\r\n    height: 100%;\r\n  }\r\n  .home-wrapper .posts-sectn img.w-100 {\r\n    max-height: 200px !important;\r\n  }\r\n  .btn.contribute {\r\n    padding: 3px 15px;\r\n  }\r\n  .btn.contribute .txt {\r\n    font-size: 0.86rem;\r\n  }\r\n  .btn.contribute img {\r\n    height: 26px;\r\n  }\r\n  .ModalViewContainer .bg-dark button.left-10 svg {\r\n    left: 2px;\r\n    top: 3px;\r\n    position: absolute;\r\n  }\r\n  .ModalViewContainer .bg-dark button.right-10 svg {\r\n    position: absolute;\r\n    top: 3px;\r\n    right: 2px;\r\n    -webkit-top: 5px;\r\n    -webkit-right: 5px;\r\n  }\r\n  .item-lst {\r\n    border: 1px solid #e1e1e1;\r\n  }\r\n}\r\n\r\n@media (min-width: 375px) and (max-width: 767px) {\r\n  .container-sm,\r\n  .container {\r\n    max-width: 750px !important;\r\n  }\r\n  .col-xs-3 {\r\n    flex: 0 0 auto;\r\n    width: 25% !important;\r\n  }\r\n  .col-xs-4 {\r\n    flex: 0 0 auto;\r\n    width: 33.33333333% !important;\r\n  }\r\n  .col-xs-7 {\r\n    flex: 0 0 auto;\r\n    width: 58.33333333% !important;\r\n  }\r\n  .col-xs-8 {\r\n    flex: 0 0 auto;\r\n    width: 66.66666667% !important;\r\n  }\r\n  .order-xs-1 {\r\n    order: 1 !important;\r\n  }\r\n  .order-xs-2 {\r\n    order: 2 !important;\r\n  }\r\n  .order-xs-3 {\r\n    order: 3 !important;\r\n  }\r\n  .order-xs-4 {\r\n    order: 4 !important;\r\n  }\r\n  .order-xs-5 {\r\n    order: 5!.cate-prod .accordion .justify-content-evenly important;\r\n  }\r\n  /*.cate-prod .accordion {display: flex;justify-content: space-around!important;}*/\r\n  .cate-prod {\r\n    margin-top: 10px;\r\n    border-bottom: 1px solid #e1e1e1;\r\n    padding-bottom: 20px;\r\n  }\r\n  .cate-prod .accordion .justify-content-evenly {\r\n    justify-content: flex-start !important;\r\n  }\r\n  .cate-prod .accordion .justify-content-evenly h2.accordion-header {\r\n    margin-right: 20px;\r\n  }\r\n  .cate-prod .accordion .accordion-item {\r\n  }\r\n  .cate-prod .accordion .accordion-item .accordion-body {\r\n    padding: 0;\r\n  }\r\n  .cate-prod .accordion .collapse:not(.show) {\r\n    display: none;\r\n  }\r\n  .cate-prod .accordion .accordion-button {\r\n    background-color: #009a59;\r\n    padding: 5px 20px;\r\n    border-radius: 10px;\r\n    color: #fff;\r\n    display: inline-block;\r\n    margin-bottom: 15px;\r\n    font-weight: 500;\r\n    font-size: 18px;\r\n  }\r\n  .cate-prod .accordion .accordion-button:focus {\r\n    box-shadow: 0 0 0 0.25rem rgb(12 171 107 / 25%);\r\n  }\r\n  .cate-prod .accordion .accordion-button.collapsed {\r\n    background-color: transparent;\r\n    color: #009a59;\r\n    border: 1px solid #009a59;\r\n  }\r\n  .cate-prod .accordion .accordion-body .filter-sectn {\r\n    border-top: none;\r\n    margin-top: 0;\r\n    padding-top: 0;\r\n  }\r\n  .price-inp {\r\n    margin-top: 28px;\r\n  }\r\n  .profile-page.container {\r\n    max-width: 100% !important;\r\n    padding: 0 10px;\r\n  }\r\n  .custom-select {\r\n    margin-bottom: 8px;\r\n  }\r\n  .profile-page.container .btn.btn-danger {\r\n    margin-top: 10px;\r\n  }\r\n  .interve-box.justify-content-between {\r\n    justify-content: flex-start !important;\r\n  }\r\n  .interve-box.justify-content-between .interve-btn {\r\n    margin-right: 20px;\r\n  }\r\n\r\n  .weather-details .lt-side {\r\n    margin-bottom: 10px;\r\n  } /*\r\n  .weather-details .lt-side .wth-main *{color: #fff;}*/\r\n  .weather-details .lt-side .weath-img {\r\n    width: 38%;\r\n    margin-left: 0;\r\n    margin-top: inherit;\r\n    margin-right: 1.5rem;\r\n  }\r\n  .weather-details .lt-side .wth-main .time-today {\r\n    text-align: left;\r\n  }\r\n  .weather-details .lt-side .select-style:after {\r\n    border-top: 6px solid #d9d9d9;\r\n  }\r\n  /*.weather-details .lt-side .wth-main .text-secondary, .weather-details .lt-side .wth-main .icon-weather01, .weather-details .lt-side .wth-main .icon-rainpre{color:#fff!important;}*/\r\n  .weather-details .lt-side .wth-main .inf-cnt {\r\n    display: flex;\r\n    align-items: center;\r\n  }\r\n  .weather-details .lt-side .wth-main .inf-cnt .temp {\r\n    font-size: 3.5rem;\r\n    margin-bottom: -0.28rem;\r\n  }\r\n  .weather-details .lt-side .temp sup {\r\n    ont-size: 1.5rem;\r\n    top: -2rem;\r\n  }\r\n  .weather-details .rt-side .row-cols-3 > * {\r\n    width: 50%;\r\n  }\r\n  .weather-details .rt-side .lst-stt .numb {\r\n    font-size: 1.5rem;\r\n    margin-left: 6px;\r\n  }\r\n  .weather-details .rt-side .lst-stt .unit {\r\n    font-size: 0.9rem;\r\n  }\r\n  .weather-details .rt-side .lst-stt .unit sup {\r\n    top: -0.6rem;\r\n  }\r\n  .weather-details .rt-side .lst-hrs img {\r\n    height: 1.68rem;\r\n  }\r\n  .weather-details .rt-side .lst-hrs .temp .fs-5 {\r\n    font-size: 1.15rem !important;\r\n  }\r\n  .weather-details .rt-side .lst-hrs .temp small {\r\n    font-size: 70% !important;\r\n  }\r\n  .weather-details .rt-side h5.title-line {\r\n    font-size: 1.16rem;\r\n  }\r\n  .weather-details .rt-side .title-line:before {\r\n    height: 1.5rem;\r\n  }\r\n  .weather-details .rt-side .table th {\r\n    padding-left: 0;\r\n    padding-right: 0;\r\n    font-size: 0.9rem;\r\n  }\r\n  .weather-details .rt-side .table .text-secondary small,\r\n  .weather-details .rt-side .table small.text-secondary {\r\n    font-size: 0.8rem;\r\n  }\r\n  .weather-details .rt-side .table .wth-stt {\r\n    font-size: 0.85rem;\r\n    font-weight: 500;\r\n  }\r\n  .weather-details .rt-side .table.table-hover tbody tr img {\r\n    height: 1.8rem;\r\n  }\r\n  .weather-details .rt-side .fs-6 {\r\n    font-size: 0.9rem !important;\r\n  }\r\n  .weather-details .rt-side .lst-hrs .box-cnt,\r\n  .weather-details .rt-side .lst-stt .box-cnt {\r\n    border-radius: 2px;\r\n    padding: 10px 5px;\r\n    margin-bottom: 5px;\r\n  }\r\n  .weather-details .rt-side .lst-stt .box-cnt .align-items-center {\r\n    height: 36px;\r\n  }\r\n  .weather-details .rt-side .lst-hrs .box-cnt .mb-2,\r\n  .weather-details .rt-side .lst-stt .box-cnt .mb-2 {\r\n    margin-bottom: 0.2rem !important;\r\n  }\r\n  .weather-details .rt-side .lst-stt .icon-pinwheel {\r\n    font-size: 1.8rem;\r\n  }\r\n  .weather-details .rt-side .lst-stt img.sunrise {\r\n    width: 2rem;\r\n  }\r\n  .weather-details .rt-side .lst-stt .icon-humidity {\r\n    font-size: 1.8rem;\r\n  }\r\n  .weather-details .rt-side .lst-stt .icon-sunset {\r\n    font-size: 1.45rem;\r\n  }\r\n  .weather-details .rt-side .lst-stt img.high-temp,\r\n  .weather-details .rt-side .lst-stt img.low-temp {\r\n    width: 1.13rem;\r\n  }\r\n  .title-top {\r\n    margin-top: 5px;\r\n  }\r\n  /*.pro-tech-lst .arg-type-step {margin-top: 0px;}*/\r\n  .news-sectn .main-news .img-cover {\r\n    height: 240px !important;\r\n  }\r\n}\r\n\r\n@media (min-width: 326px) and (max-width: 575px) {\r\n  .row > .col-xs-1 {\r\n    flex: 0 0 auto;\r\n    width: 8.33333333%;\r\n  }\r\n  .row > .col-xs-2 {\r\n    flex: 0 0 auto;\r\n    width: 16.66666667%;\r\n  }\r\n  .row > .col-xs-3 {\r\n    flex: 0 0 auto;\r\n    width: 25%;\r\n  }\r\n  .row > .col-xs-4 {\r\n    flex: 0 0 auto;\r\n    width: 33.33333333%;\r\n  }\r\n  .row > .col-xs-5 {\r\n    flex: 0 0 auto;\r\n    width: 41.66666667%;\r\n  }\r\n  .row > .col-xs-6 {\r\n    flex: 0 0 auto;\r\n    width: 50%;\r\n  }\r\n  .row > .col-xs-7 {\r\n    flex: 0 0 auto;\r\n    width: 58.33333333%;\r\n  }\r\n  .row > .col-xs-8 {\r\n    flex: 0 0 auto;\r\n    width: 66.66666667%;\r\n  }\r\n  .row > .col-xs-9 {\r\n    flex: 0 0 auto;\r\n    width: 75%;\r\n  }\r\n  .row > .col-xs-10 {\r\n    flex: 0 0 auto;\r\n    width: 83.33333333%;\r\n  }\r\n  .row > .col-xs-11 {\r\n    flex: 0 0 auto;\r\n    width: 91.66666667%;\r\n  }\r\n  .row > .col-xs-12 {\r\n    flex: 0 0 auto;\r\n    width: 100%;\r\n  }\r\n\r\n  .mkt-price .tab-content .row-cols-2 > * {\r\n    width: 100%;\r\n  }\r\n\r\n  .posted-inf .fw-semibold {\r\n    font-weight: 500 !important;\r\n    font-size: 0.86rem;\r\n  }\r\n  /*.post-box .posted-inf .fav-ctrl [class^=\"icon-\"], .post-box .posted-inf .fav-ctrl [class*=\" icon-\"] {font-size: 18px;}\r\n  .post-box .posted-inf .fav-ctrl .icon-comment-line, .post-box .posted-inf .fav-ctrl .icon-share01{font-size: 15px;}*/\r\n\r\n  .post-box .inpt-cntn textarea {\r\n    height: 77px;\r\n    padding-left: 50px;\r\n    padding-top: 10px;\r\n  }\r\n  .bg-img-orgnal.avtar50 {\r\n    height: 35px;\r\n    width: 35px;\r\n    left: 10px;\r\n    top: 10px;\r\n    padding-top: 35px;\r\n  }\r\n  .cmt-listing {\r\n    padding: 0 6px;\r\n  }\r\n  .cmt-listing .bg-img-orgnal.avtar45 {\r\n    height: 35px;\r\n    width: 35px;\r\n    padding-top: 33px;\r\n  }\r\n\r\n  .user-inf {\r\n    padding: 0px;\r\n  }\r\n  .cmt-listing .img-cmt-box {\r\n    transform: translate(5px, -1px);\r\n  }\r\n  .cmt-listing .user-inf input {\r\n    width: 100%;\r\n  }\r\n  .cmt-listing p.txt-cmt,\r\n  .cmt-listing .actions,\r\n  .cmt-listing .box-child-cmt .text-area-child-cmt-big,\r\n  .cmt-listing .box-child-cmt .text-area-child-cmt,\r\n  .box-child-edit .text-area-child-cmt-big {\r\n    margin-left: 0;\r\n  }\r\n  .cmt-listing [class^='list-sub-comment-'] p.txt-cmt,\r\n  .cmt-listing [class^='list-sub-comment-'] .actions {\r\n    margin-left: 46px;\r\n  }\r\n\r\n  .img-cmt-box {\r\n    transform: translate(8px, -1px);\r\n  }\r\n  .cmt-listing [class^='list-sub-comment-'] .user-inf,\r\n  .cmt-listing [class*=' list-sub-comment-'] .user-inf {\r\n    margin-left: 0px;\r\n  }\r\n  .cmt-listing [class^='list-sub-comment-']:before,\r\n  .cmt-listing [class*=' list-sub-comment-']:before {\r\n    width: calc(100% - 0px);\r\n    left: 0px;\r\n  }\r\n  .cmt-listing .mt-3:first-child {\r\n    margin-top: 0 !important;\r\n  }\r\n  .mkt-price-hist .fs-5 {\r\n    font-size: 1rem !important;\r\n  }\r\n  .mkt-price-hist .table thead th {\r\n    font-size: 0.85rem;\r\n  }\r\n  .mkt-price .btn.contribute,\r\n  .mkt-price .btn.contribute .icon-bonus {\r\n    font-size: 1.15rem;\r\n    min-width: 133px;\r\n  }\r\n  .mkt-price .text-center {\r\n    text-align: left !important;\r\n  }\r\n  .mkt-price .pro-tech-lst .arg-type-main .text-center {\r\n    text-align: center !important;\r\n  }\r\n  .mkt-price button.text-center {\r\n    text-align: center !important;\r\n  }\r\n  .date-picker .react-datepicker-wrapper {\r\n    max-width: 100% !important;\r\n  }\r\n\r\n  .home-wrapper .posts-sectn .inf-post .poster-txt,\r\n  .home-wrapper .posts-sectn .inf-post .user-act {\r\n    padding: 10px;\r\n  }\r\n  /*.home-wrapper .posts-sectn .inf-post .user-act img.avtar{display: none;}*/\r\n  .home-wrapper .posts-sectn .inf-post .user-act .ml-auto .ml-3 {\r\n    margin-left: 9px !important;\r\n  }\r\n  .home-wrapper .posts-sectn .carousel.slide .carousel-indicators button {\r\n    width: 8px;\r\n    height: 8px;\r\n  }\r\n  .home-wrapper .posts-sectn .inf-post .user-act .post-inf.d-flex {\r\n    display: block !important;\r\n  }\r\n  .home-wrapper .posts-sectn .inf-post .user-act img.avtar {\r\n    height: 28px;\r\n    width: 28px;\r\n  }\r\n  .home-wrapper .posts-sectn .inf-post .user-act .name-txt {\r\n    display: block;\r\n  }\r\n  .home-wrapper .posts-sectn .inf-post .user-act.d-flex {\r\n    display: block !important;\r\n    z-index: 9;\r\n    position: relative;\r\n  }\r\n  .home-wrapper .posts-sectn .inf-post .user-act.d-flex .ml-auto {\r\n    margin-left: auto !important;\r\n    margin-top: 5px;\r\n  }\r\n  .title-top div > .text-center {\r\n    margin-bottom: -10px;\r\n  }\r\n  .btn-style {\r\n    margin-bottom: 2px;\r\n    padding-right: 50px;\r\n  }\r\n  .btn-style .btn-txt {\r\n    height: 33px;\r\n    line-height: 33px;\r\n    font-size: 0.9rem;\r\n    padding: 0 0 0 13px;\r\n  }\r\n  .btn-style .arrow {\r\n    width: 13px;\r\n    height: 13px;\r\n    right: 13px;\r\n    top: 11px;\r\n  }\r\n  .title-top .fs-3.second-clr {\r\n    font-size: 1.4rem !important;\r\n  }\r\n  .btn-style span.shape {\r\n    right: -68px;\r\n  }\r\n  h5.title-line-lt,\r\n  h4.title-line-lt {\r\n    font-size: 1.16rem;\r\n  }\r\n  h4.title-line-lt:before {\r\n    height: 25px;\r\n    top: -2px;\r\n  }\r\n  .title-line-lt:before {\r\n    height: 25px;\r\n  }\r\n  .ql-container.ql-snow .ql-tooltip {\r\n    position: static;\r\n    margin-bottom: 10px;\r\n  }\r\n  /*.row > .col{margin-right: -8px;margin-left: -8px;}*/\r\n  .member_rate_in_month.text-end {\r\n    margin-top: -35px;\r\n  }\r\n  .member_rate_in_month.text-end + .post-report.ms-auto {\r\n    position: absolute;\r\n    right: 8px;\r\n    top: -75px;\r\n  }\r\n  .ModalViewContainer .bg-dark button.right-10 svg {\r\n    -webkit-position: relative;\r\n  }\r\n  .ModalViewContainer .bg-dark button.right-10 svg path {\r\n    position: absolute;\r\n    right: 0px;\r\n    top: 3px;\r\n    -webkit-top: 3px;\r\n    -webkit-position: absolute; /* Safari specific prefix */\r\n    -webkit-right: 10px; /* Safari specific prefix */\r\n  }\r\n}\r\n\r\n@media (min-width: 280px) and (max-width: 440px) {\r\n  .row > .col-2xs-1 {\r\n    flex: 0 0 auto;\r\n    width: 8.33333333%;\r\n  }\r\n  .row > .col-2xs-2 {\r\n    flex: 0 0 auto;\r\n    width: 16.66666667%;\r\n  }\r\n  .row > .col-2xs-3 {\r\n    flex: 0 0 auto;\r\n    width: 25%;\r\n  }\r\n  .row > .col-2xs-4 {\r\n    flex: 0 0 auto;\r\n    width: 33.33333333%;\r\n  }\r\n  .row > .col-2xs-5 {\r\n    flex: 0 0 auto;\r\n    width: 41.66666667%;\r\n  }\r\n  .row > .col-2xs-6 {\r\n    flex: 0 0 auto;\r\n    width: 50%;\r\n  }\r\n  .row > .col-2xs-7 {\r\n    flex: 0 0 auto;\r\n    width: 58.33333333%;\r\n  }\r\n  .row > .col-2xs-8 {\r\n    flex: 0 0 auto;\r\n    width: 66.66666667%;\r\n  }\r\n  .row > .col-2xs-9 {\r\n    flex: 0 0 auto;\r\n    width: 75%;\r\n  }\r\n  .row > .col-2xs-10 {\r\n    flex: 0 0 auto;\r\n    width: 83.33333333%;\r\n  }\r\n  .row > .col-2xs-11 {\r\n    flex: 0 0 auto;\r\n    width: 91.66666667%;\r\n  }\r\n  .row > .col-2xs-12 {\r\n    flex: 0 0 auto;\r\n    width: 100% !important;\r\n  }\r\n  .mkt-price-details .location.float-end {\r\n    float: left !important;\r\n    margin-top: 10px;\r\n  }\r\n  .mkt-price-hist > .d-flex.align-items-center,\r\n  .sharing-box.d-flex.justify-content-between {\r\n    display: block !important;\r\n  }\r\n  .mkt-price-hist > .d-flex .ms-auto,\r\n  .sharing-box .list-socials {\r\n    margin-top: 10px;\r\n    margin-bottom: 15px;\r\n  }\r\n  .sharing-box .list_tags {\r\n    width: 100%;\r\n  }\r\n  /*header .cate-sectn [class^=\"icon-\"], header .cate-sectn [class*=\" icon-\"]{height: 30px;}\r\n  header .cate-sectn .active [class^=\"icon-\"], header .cate-sectn .active [class*=\" icon-\"]{position: relative;}\r\n  header .cate-sectn [class^=\"icon-\"] {font-size: 24px;}\r\n  header .cate-sectn .active [class^=\"icon-\"]:after, header .cate-sectn .active [class*=\" icon-\"]:after{position: absolute; bottom: -13px;content: \"\";height: 3px;left: -5px;width: calc(100% + 10px);background-color: orange;}\r\n  header .cate-sectn .icon-menu-main,\r\n  header .cate-sectn .icon-more-menu {font-size: 20px;}\r\n  header .cate-sectn .icon-price-menu {font-size: 32px;}\r\n  header .cate-sectn .icon-news02 {font-size: 30px;}\r\n  header .cate-sectn .icon-price-menu {font-size: 30px;}\r\n  header .cate-sectn .icon-home {font-size: 29px;}\r\n  header .cate-sectn .icon-news02{font-size: 28px;}\r\n  header .cate-sectn .icon-triangle-line{font-size: 24px;}\r\n  header .cate-sectn .icon-farmer-market{font-size: 23px;}*/\r\n  .weather-details .rt-side .lst-hrs .col,\r\n  .weather-details .rt-side .lst-stt .col {\r\n    margin-left: 0;\r\n    margin-right: 0;\r\n  }\r\n  .mkt-price .tab-content .row-cols-2 > * {\r\n    margin-right: 0;\r\n    margin-left: 0;\r\n  }\r\n  .mkt-price .btn.contribute {\r\n    padding: 3px 13px;\r\n  }\r\n  .mkt-price .w-100.text-center h4 {\r\n    font-size: 1.15rem;\r\n  }\r\n  .mkt-price .search-box form {\r\n    width: 100%;\r\n  }\r\n  .mkt-price .search-box .row .btn-pd[class^='col-'],\r\n  .search-box .row .btn-pd[class*=' col-'] {\r\n    padding-right: 4px;\r\n    padding-left: 4px;\r\n  }\r\n  .mkt-price .tab-content .row-cols-2 > * {\r\n    width: 100%;\r\n  }\r\n  .mkt-price .tab-content .lst-item .prod-price .fs-4 {\r\n    font-size: 1.1rem !important;\r\n    font-weight: 600 !important;\r\n  }\r\n  .mkt-price .search-box {\r\n    padding: 15px;\r\n  }\r\n  .saved-items .nav-tabs .nav-item .nav-link,\r\n  .nav-mkt-price .nav-item .nav-link {\r\n    padding: 5px 0px;\r\n    font-size: 0.95rem;\r\n    font-weight: 600;\r\n  }\r\n\r\n  .mkt-price-details .share-txt {\r\n    display: none;\r\n  }\r\n  .mkt-price-details .share-txt {\r\n    display: block;\r\n  }\r\n  /*.mkt-price-details h4.title-line-lt{display: none;}*/\r\n  .mkt-price-details .d-flex.align-items-center {\r\n    display: block !important;\r\n  }\r\n  .mkt-price-details .title-line-lt.text-uppercase {\r\n    margin-bottom: 10px;\r\n  }\r\n  .mkt-price-details .prod-gctt-inf {\r\n    padding: 12px 0 15px !important;\r\n  }\r\n  .mkt-price-details .prod-gctt-inf .img-inf {\r\n    display: none;\r\n  }\r\n  .mkt-price-details .prod-gctt-inf .img-inf img {\r\n    height: 70px;\r\n    width: 80px;\r\n  }\r\n  .mkt-price-details .prod-gctt-inf .img-inf.me-3 {\r\n    margin-right: 10px !important;\r\n  }\r\n  .mkt-price-details .prod-gctt-inf .lst-item-detail {\r\n    align-items: center;\r\n  }\r\n  .mkt-price-details .prod-gctt-inf .lst-item-detail .like-price-icon,\r\n  .prod-gctt-inf .lst-item-detail .like-price-icon-active {\r\n    margin-top: 12px;\r\n    font-size: 16px;\r\n    padding: 5px 13px;\r\n  }\r\n  .weather-details .rt-side .table.table-hover tbody td:nth-of-type(1) {\r\n    display: none;\r\n  }\r\n  .weather-details .rt-side .table.table-hover tbody td .icon-temp.fs-5 {\r\n    font-size: 1.1rem !important;\r\n  }\r\n\r\n  .search-top input {\r\n    width: calc(100% - 20px);\r\n  }\r\n  .FormAddEditProduct.card .card-body .col-2 {\r\n    width: 50%;\r\n  }\r\n  .NewFeedActions .NewFeedActionButton span {\r\n    display: inline-block;\r\n  }\r\n  .NewFeedActions .NewFeedActionButton:hover {\r\n    background-color: transparent;\r\n  }\r\n  .news-sectn .main-news .img-cover {\r\n    height: 190px !important;\r\n  }\r\n  .post-box .text-end {\r\n    text-align: left !important;\r\n    margin-top: 5px;\r\n  }\r\n  .post-box .pin_droplist {\r\n    position: absolute;\r\n    top: -72px;\r\n    right: 10px;\r\n  }\r\n  .post-box .pin_droplist .pin-icon {\r\n    width: 20px;\r\n  }\r\n}\r\n@media (max-width: 374px) {\r\n  header .cate-sectn [class^='icon-'] {\r\n    font-size: 23px;\r\n  }\r\n  header .cate-sectn .icon-price-menu {\r\n    font-size: 27px;\r\n  }\r\n  header .cate-sectn .icon-home,\r\n  header .cate-sectn .icon-news02 {\r\n    font-size: 28px;\r\n  }\r\n  header .cate-sectn .icon-triangle-line,\r\n  header .cate-sectn .icon-farmer-market {\r\n    font-size: 24px;\r\n  }\r\n  .post-box .posted-inf .fav-ctrl {\r\n    height: 68px;\r\n  }\r\n  .post-box .posted-inf .fav-ctrl div.d-flex.align-items-center {\r\n    display: block !important;\r\n    text-align: center;\r\n    margin-top: 8px;\r\n  }\r\n  .post-box .posted-inf .fav-ctrl div.d-flex.align-items-center span {\r\n    display: block;\r\n    height: 26px;\r\n  }\r\n  .post-box .posted-inf .fav-ctrl div.d-flex.align-items-center span.txt {\r\n    font-size: 13px;\r\n  }\r\n  .post-box .posted-inf .fav-ctrl .share .dropdown button {\r\n    padding: 0;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
